// Vendor
(self.webpackChunkrollie = self.webpackChunkrollie || []).push([
    [4736],
    {
        1106: function (t, e, r) {
            "use strict";
            r.d(e, {
                J8: function () {
                    return c;
                },
                tM: function () {
                    return i.Z;
                },
                Zf: function () {
                    return h;
                },
                X4: function () {
                    return n;
                },
                Yp: function () {
                    return l;
                },
                oW: function () {
                    return s;
                },
                Vs: function () {
                    return a;
                },
                Lt: function () {
                    return o;
                },
            });
            var i = r(6783);
            const n = "contact_information",
                a = "shipping_method",
                s = "payment_method",
                o = "thank_you",
                l = "order_status",
                h = [n, a, s, "review", o, l];
            class c {
                constructor(t) {
                    this.modules = t;
                }
                init(t, e, r = {}) {
                    (this.$ = t), (this.step = e), (this.options = r), this.initializeModules(), this.callBeforeInit(), this.registerEventListeners();
                }
                initializeModules() {
                    this.modules = this.modules
                        .map((t) => {
                            if (void 0 === t.id) {
                                t = new t(this.options);
                            }
                            return (t.$ = this.$), (t.step = this.step), (t.options = Object.assign(this.options, t.options)), t;
                        })
                        .filter((t) => null !== t);
                }
                callBeforeInit() {
                    this.modules.forEach((t) => {
                        t.steps().includes(this.step) && "function" == typeof t.beforeInit && t.beforeInit();
                    });
                }
                registerEventListeners() {
                    this.$(document).on("page:load page:change", this.pageChangeHandler.bind(this));
                }
                pageChangeHandler() {
                    this.modules.forEach((t) => {
                        if (t.steps().includes(this.step)) {
                            if (this.step === a && this.isPollRefreshElementPresent()) return;
                            t.init();
                        }
                    });
                }
                isPollRefreshElementPresent() {
                    return this.$("[data-poll-refresh]").length;
                }
            }
        },
        6783: function (t, e, r) {
            "use strict";
            r.d(e, {
                Z: function () {
                    return i;
                },
            });
            class i {
                constructor(t) {
                    (this.options = t), (this.$element = null);
                }
                id() {
                    throw new Error("Not implemented");
                }
                steps() {
                    return [];
                }
                selector() {
                    return "document";
                }
                beforeInit() {}
                init() {
                    (this.$element = this.$(this.selector())), this.$element.hasClass(this.id()) || (this.$element.addClass(this.id()), this.setup());
                }
                setup() {}
            }
        },
        3401: function (t, e, r) {
            "use strict";
            function i(t) {
                return (i =
                    "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                        ? function (t) {
                              return typeof t;
                          }
                        : function (t) {
                              return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                          })(t);
            }
            function n(t, e) {
                for (var r = 0; r < e.length; r++) {
                    var i = e[r];
                    (i.enumerable = i.enumerable || !1), (i.configurable = !0), "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
                }
            }
            function a(t, e, r) {
                return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : (t[e] = r), t;
            }
            function s(t, e) {
                if (null == t) return {};
                var r,
                    i,
                    n = (function (t, e) {
                        if (null == t) return {};
                        var r,
                            i,
                            n = {},
                            a = Object.keys(t);
                        for (i = 0; i < a.length; i++) (r = a[i]), e.indexOf(r) >= 0 || (n[r] = t[r]);
                        return n;
                    })(t, e);
                if (Object.getOwnPropertySymbols) {
                    var a = Object.getOwnPropertySymbols(t);
                    for (i = 0; i < a.length; i++) (r = a[i]), e.indexOf(r) >= 0 || (Object.prototype.propertyIsEnumerable.call(t, r) && (n[r] = t[r]));
                }
                return n;
            }
            function o(t, e) {
                var r = e.get(t);
                if (!r) throw new TypeError("attempted to get private field on non-instance");
                return r.get ? r.get.call(t) : r.value;
            }
            r.d(e, {
                Ue: function () {
                    return D;
                },
            });
            var l = { player: "lottie-player" },
                h = "[lottieInteractivity]:",
                c = (function () {
                    function t() {
                        var e = this,
                            r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : l,
                            n = r.actions,
                            c = r.container,
                            D = r.mode,
                            M = r.player,
                            I = s(r, ["actions", "container", "mode", "player"]);
                        if (
                            ((function (t, e) {
                                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                            })(this, t),
                            p.set(this, {
                                writable: !0,
                                value: function () {
                                    if (e.player) {
                                        var t = function () {
                                                e.player.addEventListener("enterFrame", o(e, E)),
                                                    e.container.addEventListener("mouseenter", o(e, S)),
                                                    e.container.addEventListener("mouseleave", o(e, P)),
                                                    e.container.addEventListener("touchstart", o(e, S), { passive: !0 }),
                                                    e.container.addEventListener("touchend", o(e, P), { passive: !0 });
                                            },
                                            r = function () {
                                                e.container.addEventListener("mouseenter", o(e, S)),
                                                    e.container.addEventListener("mouseleave", o(e, P)),
                                                    e.container.addEventListener("touchstart", o(e, S), { passive: !0 }),
                                                    e.container.addEventListener("touchend", o(e, P), { passive: !0 });
                                            };
                                        e.stateHandler.set("loop", function () {
                                            e.actions[e.interactionIdx].loop ? (e.player.loop = parseInt(e.actions[e.interactionIdx].loop) - 1) : (e.player.loop = !0), (e.player.autoplay = !0);
                                        }),
                                            e.stateHandler.set("autoplay", function () {
                                                (e.player.loop = !1), (e.player.autoplay = !0);
                                            }),
                                            e.stateHandler.set("click", function () {
                                                (e.player.loop = !1), (e.player.autoplay = !1), e.container.addEventListener("click", o(e, u));
                                            }),
                                            e.stateHandler.set("hover", function () {
                                                (e.player.loop = !1), (e.player.autoplay = !1), e.container.addEventListener("mouseenter", o(e, u)), e.container.addEventListener("touchstart", o(e, u), { passive: !0 });
                                            }),
                                            e.stateHandler.set("hold", r),
                                            e.stateHandler.set("pauseHold", r),
                                            e.transitionHandler.set("click", function () {
                                                e.container.addEventListener("click", o(e, d));
                                            }),
                                            e.transitionHandler.set("hover", function () {
                                                e.container.addEventListener("mouseenter", o(e, d)), e.container.addEventListener("touchstart", o(e, d), { passive: !0 });
                                            }),
                                            e.transitionHandler.set("hold", t),
                                            e.transitionHandler.set("pauseHold", t),
                                            e.transitionHandler.set("repeat", function () {
                                                (e.player.loop = !0),
                                                    (e.player.autoplay = !0),
                                                    e.player.addEventListener("loopComplete", function t() {
                                                        o(e, _).call(e, { handler: t });
                                                    });
                                            }),
                                            e.transitionHandler.set("onComplete", function () {
                                                "loop" === e.actions[e.interactionIdx].state ? e.player.addEventListener("loopComplete", o(e, g)) : e.player.addEventListener("complete", o(e, g));
                                            }),
                                            e.transitionHandler.set("seek", function () {
                                                e.player.stop(),
                                                    e.player.addEventListener("enterFrame", o(e, b)),
                                                    e.container.addEventListener("mousemove", o(e, m)),
                                                    e.container.addEventListener("touchmove", o(e, y), { passive: !1 }),
                                                    e.container.addEventListener("mouseout", o(e, v));
                                            });
                                    }
                                },
                            }),
                            u.set(this, {
                                writable: !0,
                                value: function () {
                                    var t = e.actions[e.interactionIdx].forceFlag;
                                    t || !0 !== e.player.isPaused ? t && o(e, x).call(e, !0) : o(e, x).call(e, !0);
                                },
                            }),
                            f.set(this, {
                                writable: !0,
                                value: function () {
                                    0 === e.clickCounter ? (e.player.play(), e.clickCounter++) : (e.clickCounter++, e.player.setDirection(-1 * e.player.playDirection), e.player.play());
                                },
                            }),
                            d.set(this, {
                                writable: !0,
                                value: function () {
                                    var t = e.actions[e.interactionIdx].forceFlag,
                                        r = e.actions[e.interactionIdx].state,
                                        i = e.actions[e.interactionIdx].transition;
                                    if ("chain" === e.mode) {
                                        if (e.actions[e.interactionIdx].count) {
                                            var n = parseInt(e.actions[e.interactionIdx].count);
                                            if (e.clickCounter < n - 1) return void (e.clickCounter += 1);
                                        }
                                        return (
                                            (e.clickCounter = 0),
                                            (!t && "click" === i && "click" === r) || ("hover" === i && "hover" === r) ? e.transitionHandler.get("onComplete").call() : e.nextInteraction(),
                                            e.container.removeEventListener("click", o(e, d)),
                                            void e.container.removeEventListener("mouseenter", o(e, d))
                                        );
                                    }
                                    t || !0 !== e.player.isPaused ? t && e.player.goToAndPlay(0, !0) : e.player.goToAndPlay(0, !0);
                                },
                            }),
                            m.set(this, {
                                writable: !0,
                                value: function (t) {
                                    o(e, T).call(e, t.clientX, t.clientY);
                                },
                            }),
                            y.set(this, {
                                writable: !0,
                                value: function (t) {
                                    t.cancelable && t.preventDefault(), o(e, T).call(e, t.touches[0].clientX, t.touches[0].clientY);
                                },
                            }),
                            v.set(this, {
                                writable: !0,
                                value: function () {
                                    o(e, T).call(e, -1, -1);
                                },
                            }),
                            g.set(this, {
                                writable: !0,
                                value: function () {
                                    "loop" === e.actions[e.interactionIdx].state ? e.player.removeEventListener("loopComplete", o(e, g)) : e.player.removeEventListener("complete", o(e, g)), e.nextInteraction();
                                },
                            }),
                            _.set(this, {
                                writable: !0,
                                value: function (t) {
                                    var r = t.handler,
                                        i = 1;
                                    e.actions[e.interactionIdx].repeat && (i = e.actions[e.interactionIdx].repeat),
                                        e.playCounter >= i - 1 ? ((e.playCounter = 0), e.player.removeEventListener("loopComplete", r), (e.player.loop = !1), (e.player.autoplay = !1), e.nextInteraction()) : (e.playCounter += 1);
                                },
                            }),
                            b.set(this, {
                                writable: !0,
                                value: function () {
                                    var t = e.actions[e.interactionIdx].frames;
                                    t &&
                                        e.player.currentFrame >= parseInt(t[1]) - 1 &&
                                        (e.player.removeEventListener("enterFrame", o(e, b)), e.container.removeEventListener("mousemove", o(e, m)), e.container.removeEventListener("mouseout", o(e, v)), setTimeout(e.nextInteraction, 0));
                                },
                            }),
                            E.set(this, {
                                writable: !0,
                                value: function () {
                                    var t = e.actions[e.interactionIdx].frames;
                                    ((t && e.player.currentFrame >= t[1]) || e.player.currentFrame >= e.player.totalFrames - 1) &&
                                        (e.player.removeEventListener("enterFrame", o(e, E)),
                                        e.container.removeEventListener("mouseenter", o(e, S)),
                                        e.container.removeEventListener("mouseleave", o(e, P)),
                                        e.container.removeEventListener("touchstart", o(e, S), { passive: !0 }),
                                        e.container.removeEventListener("touchend", o(e, P), { passive: !0 }),
                                        e.player.pause(),
                                        (e.holdStatus = !1),
                                        e.nextInteraction()),
                                        -1 === e.player.playDirection && t && e.player.currentFrame < t[0] && e.player.pause();
                                },
                            }),
                            S.set(this, {
                                writable: !0,
                                value: function () {
                                    (-1 !== e.player.playDirection && null !== e.holdStatus && e.holdStatus) || (e.player.setDirection(1), e.player.play(), (e.holdStatus = !0));
                                },
                            }),
                            P.set(this, {
                                writable: !0,
                                value: function () {
                                    "hold" === e.actions[e.interactionIdx].transition || "hold" === e.actions[e.interactionIdx].state || "hold" === e.actions[0].type
                                        ? (e.player.setDirection(-1), e.player.play())
                                        : ("pauseHold" !== e.actions[e.interactionIdx].transition && "pauseHold" !== e.actions[e.interactionIdx].state && "pauseHold" !== e.actions[0].type) || e.player.pause(),
                                        (e.holdStatus = !1);
                                },
                            }),
                            w.set(this, {
                                writable: !0,
                                value: function () {
                                    if (
                                        (e.container.removeEventListener("click", o(e, d)),
                                        e.container.removeEventListener("click", o(e, u)),
                                        e.container.removeEventListener("mouseenter", o(e, d)),
                                        e.container.removeEventListener("touchstart", o(e, d)),
                                        e.container.removeEventListener("touchmove", o(e, y)),
                                        e.container.removeEventListener("mouseenter", o(e, u)),
                                        e.container.removeEventListener("touchstart", o(e, u)),
                                        e.container.removeEventListener("mouseenter", o(e, S)),
                                        e.container.removeEventListener("touchstart", o(e, S)),
                                        e.container.removeEventListener("mouseleave", o(e, P)),
                                        e.container.removeEventListener("mousemove", o(e, m)),
                                        e.container.removeEventListener("mouseout", o(e, v)),
                                        e.container.removeEventListener("touchend", o(e, P)),
                                        e.player)
                                    )
                                        try {
                                            e.player.removeEventListener("loopComplete", o(e, g)),
                                                e.player.removeEventListener("complete", o(e, g)),
                                                e.player.removeEventListener("enterFrame", o(e, b)),
                                                e.player.removeEventListener("enterFrame", o(e, E));
                                        } catch (t) {}
                                },
                            }),
                            a(this, "jumpToInteraction", function (t) {
                                o(e, w).call(e), (e.interactionIdx = t), e.interactionIdx < 0 ? (e.interactionIdx = 0) : e.interactionIdx, e.nextInteraction(!1);
                            }),
                            a(this, "nextInteraction", function () {
                                var t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                                (e.oldInterctionIdx = e.interactionIdx), o(e, w).call(e), (e.player.loop = !1);
                                var r = e.actions[e.interactionIdx].jumpTo;
                                r
                                    ? r >= 0 && r < e.actions.length
                                        ? ((e.interactionIdx = r), o(e, C).call(e, { ignorePath: !1 }))
                                        : ((e.interactionIdx = 0), e.player.goToAndStop(0, !0), o(e, C).call(e, { ignorePath: !1 }))
                                    : (t && e.interactionIdx++,
                                      e.interactionIdx >= e.actions.length
                                          ? e.actions[e.actions.length - 1].reset
                                              ? ((e.interactionIdx = 0),
                                                e.player.resetSegments(!0),
                                                e.actions[e.interactionIdx].frames ? e.player.goToAndStop(e.actions[e.interactionIdx].frames, !0) : e.player.goToAndStop(0, !0),
                                                o(e, C).call(e, { ignorePath: !1 }))
                                              : ((e.interactionIdx = e.actions.length - 1), o(e, C).call(e, { ignorePath: !1 }))
                                          : o(e, C).call(e, { ignorePath: !1 })),
                                    e.container.dispatchEvent(new CustomEvent("transition", { bubbles: !0, composed: !0, detail: { oldIndex: e.oldInterctionIdx, newIndex: e.interactionIdx } }));
                            }),
                            x.set(this, {
                                writable: !0,
                                value: function (t) {
                                    var r = e.actions[e.interactionIdx].frames;
                                    if (!r) return e.player.resetSegments(!0), void e.player.goToAndPlay(0, !0);
                                    "string" == typeof r ? e.player.goToAndPlay(r, t) : e.player.playSegments(r, t);
                                },
                            }),
                            A.set(this, {
                                writable: !0,
                                value: function () {
                                    var t = e.actions[e.interactionIdx].path;
                                    if (!t)
                                        if ("object" === i(e.enteredPlayer) && "AnimationItem" === e.enteredPlayer.constructor.name) {
                                            if (((t = e.enteredPlayer), e.player === t)) return void o(e, C).call(e, { ignorePath: !0 });
                                        } else {
                                            var r = (t = e.loadedAnimation).substr(t.lastIndexOf("/") + 1);
                                            if (((r = r.substr(0, r.lastIndexOf(".json"))), e.player.fileName === r)) return void o(e, C).call(e, { ignorePath: !0 });
                                        }
                                    var n = e.container.getBoundingClientRect(),
                                        a = "width: " + n.width + "px !important; height: " + n.height + "px !important; background: " + e.container.style.background;
                                    if ((e.container.setAttribute("style", a), "object" !== i(e.enteredPlayer) || "AnimationItem" !== e.enteredPlayer.constructor.name)) {
                                        if ("string" == typeof e.enteredPlayer) {
                                            var s = document.querySelector(e.enteredPlayer);
                                            s &&
                                                "LOTTIE-PLAYER" === s.nodeName &&
                                                (e.attachedListeners ||
                                                    (s.addEventListener("ready", function () {
                                                        (e.container.style.width = ""), (e.container.style.height = "");
                                                    }),
                                                    s.addEventListener("load", function () {
                                                        (e.player = s.getLottie()), o(e, C).call(e, { ignorePath: !0 });
                                                    }),
                                                    (e.attachedListeners = !0)),
                                                s.load(t));
                                        } else
                                            e.enteredPlayer instanceof HTMLElement &&
                                                "LOTTIE-PLAYER" === e.enteredPlayer.nodeName &&
                                                (e.attachedListeners ||
                                                    (e.enteredPlayer.addEventListener("ready", function () {
                                                        (e.container.style.width = ""), (e.container.style.height = "");
                                                    }),
                                                    e.enteredPlayer.addEventListener("load", function () {
                                                        (e.player = e.enteredPlayer.getLottie()), o(e, C).call(e, { ignorePath: !0 });
                                                    }),
                                                    (e.attachedListeners = !0)),
                                                e.enteredPlayer.load(t));
                                        if (!e.player) throw new Error("".concat(h, " Specified player is invalid."), e.enteredPlayer);
                                    } else {
                                        if (!window.lottie) throw new Error("".concat(h, " A Lottie player is required."));
                                        e.stop(),
                                            (e.container.innerHTML = ""),
                                            "object" === i(t) && "AnimationItem" === t.constructor.name
                                                ? (e.player = window.lottie.loadAnimation({ loop: !1, autoplay: !1, animationData: t.animationData, container: e.container }))
                                                : (e.player = window.lottie.loadAnimation({ loop: !1, autoplay: !1, path: t, container: e.container })),
                                            e.player.addEventListener("DOMLoaded", function () {
                                                (e.container.style.width = ""), (e.container.style.height = ""), o(e, C).call(e, { ignorePath: !0 });
                                            });
                                    }
                                    (e.clickCounter = 0), (e.playCounter = 0);
                                },
                            }),
                            C.set(this, {
                                writable: !0,
                                value: function (t) {
                                    var r = t.ignorePath,
                                        i = e.actions[e.interactionIdx].frames,
                                        n = e.actions[e.interactionIdx].state,
                                        a = e.actions[e.interactionIdx].transition,
                                        s = e.actions[e.interactionIdx].path,
                                        l = e.stateHandler.get(n),
                                        h = e.transitionHandler.get(a),
                                        c = e.actions[e.interactionIdx].speed ? e.actions[e.interactionIdx].speed : 1,
                                        p = e.actions[e.interactionIdx].delay ? e.actions[e.interactionIdx].delay : 0;
                                    r || !(s || (e.actions[e.actions.length - 1].reset && 0 === e.interactionIdx))
                                        ? setTimeout(function () {
                                              i && ((e.player.autoplay = !1), e.player.resetSegments(!0), e.player.goToAndStop(i[0], !0)),
                                                  l ? l.call() : "none" === n && ((e.player.loop = !1), (e.player.autoplay = !1)),
                                                  h && h.call(),
                                                  e.player.autoplay && (e.player.resetSegments(!0), o(e, x).call(e, !0)),
                                                  e.player.setSpeed(c);
                                          }, p)
                                        : o(e, A).call(e);
                                },
                            }),
                            T.set(this, {
                                writable: !0,
                                value: function (t, r) {
                                    if (-1 !== t && -1 !== r) {
                                        var i = e.getContainerCursorPosition(t, r);
                                        (t = i.x), (r = i.y);
                                    }
                                    var n = e.actions.find(function (e) {
                                        var i = e.position;
                                        if (i) {
                                            if (Array.isArray(i.x) && Array.isArray(i.y)) return t >= i.x[0] && t <= i.x[1] && r >= i.y[0] && r <= i.y[1];
                                            if (!Number.isNaN(i.x) && !Number.isNaN(i.y)) return t === i.x && r === i.y;
                                        }
                                        return !1;
                                    });
                                    if (n)
                                        if ("seek" === n.type || "seek" === n.transition) {
                                            var a = (t - n.position.x[0]) / (n.position.x[1] - n.position.x[0]),
                                                s = (r - n.position.y[0]) / (n.position.y[1] - n.position.y[0]);
                                            e.player.playSegments(n.frames, !0),
                                                n.position.y[0] < 0 && n.position.y[1] > 1 ? e.player.goToAndStop(Math.floor(a * e.player.totalFrames), !0) : e.player.goToAndStop(Math.ceil(((a + s) / 2) * e.player.totalFrames), !0);
                                        } else
                                            "loop" === n.type
                                                ? e.player.playSegments(n.frames, !0)
                                                : "play" === n.type
                                                ? (!0 === e.player.isPaused && e.player.resetSegments(), e.player.playSegments(n.frames))
                                                : "stop" === n.type && (e.player.resetSegments(!0), e.player.goToAndStop(n.frames[0], !0));
                                },
                            }),
                            k.set(this, {
                                writable: !0,
                                value: function () {
                                    var t = e.getContainerVisibility(),
                                        r = e.actions.find(function (e) {
                                            var r = e.visibility;
                                            return t >= r[0] && t <= r[1];
                                        });
                                    if (r)
                                        if ("seek" === r.type) {
                                            var i = r.frames[0],
                                                n = 2 == r.frames.length ? r.frames[1] : e.player.totalFrames - 1;
                                            null !== e.assignedSegment && (e.player.resetSegments(!0), (e.assignedSegment = null)),
                                                e.player.goToAndStop(i + Math.round(((t - r.visibility[0]) / (r.visibility[1] - r.visibility[0])) * (n - i)), !0);
                                        } else if ("loop" === r.type)
                                            (e.player.loop = !0), (null === e.assignedSegment || e.assignedSegment !== r.frames || !0 === e.player.isPaused) && (e.player.playSegments(r.frames, !0), (e.assignedSegment = r.frames));
                                        else if ("play" === r.type || "playOnce" === r.type) {
                                            if ("playOnce" === r.type && !e.scrolledAndPlayed) return (e.scrolledAndPlayed = !0), e.player.resetSegments(!0), void (r.frames ? e.player.playSegments(r.frames, !0) : e.player.play());
                                            "play" === r.type && e.player.isPaused && (e.player.resetSegments(!0), r.frames ? e.player.playSegments(r.frames, !0) : e.player.play());
                                        } else "stop" === r.type && e.player.goToAndStop(r.frames[0], !0);
                                },
                            }),
                            (this.enteredPlayer = M),
                            "object" !== i(M) || "AnimationItem" !== M.constructor.name)
                        ) {
                            if ("string" == typeof M) {
                                var F = document.querySelector(M);
                                F && "LOTTIE-PLAYER" === F.nodeName && (M = F.getLottie());
                            } else M instanceof HTMLElement && "LOTTIE-PLAYER" === M.nodeName && (M = M.getLottie());
                            if (!M) throw new Error(h + "Specified player:" + M + " is invalid.");
                        }
                        "string" == typeof c && (c = document.querySelector(c)),
                            c || (c = M.wrapper),
                            (this.player = M),
                            (this.loadedAnimation = this.player.path + this.player.fileName + ".json"),
                            (this.attachedListeners = !1),
                            (this.container = c),
                            (this.mode = D),
                            (this.actions = n),
                            (this.options = I),
                            (this.assignedSegment = null),
                            (this.scrolledAndPlayed = !1),
                            (this.interactionIdx = 0),
                            (this.oldInterctionIdx = 0),
                            (this.clickCounter = 0),
                            (this.playCounter = 0),
                            (this.stateHandler = new Map()),
                            (this.transitionHandler = new Map());
                    }
                    var e, r;
                    return (
                        (e = t),
                        (r = [
                            {
                                key: "getContainerVisibility",
                                value: function () {
                                    var t = this.container.getBoundingClientRect(),
                                        e = t.top,
                                        r = t.height;
                                    return (window.innerHeight - e) / (window.innerHeight + r);
                                },
                            },
                            {
                                key: "getContainerCursorPosition",
                                value: function (t, e) {
                                    var r = this.container.getBoundingClientRect(),
                                        i = r.top;
                                    return { x: (t - r.left) / r.width, y: (e - i) / r.height };
                                },
                            },
                            {
                                key: "initScrollMode",
                                value: function () {
                                    this.player.stop(), window.addEventListener("scroll", o(this, k), !0);
                                },
                            },
                            {
                                key: "initCursorMode",
                                value: function () {
                                    this.actions && 1 === this.actions.length
                                        ? "click" === this.actions[0].type
                                            ? ((this.player.loop = !1), this.player.stop(), this.container.addEventListener("click", o(this, d)))
                                            : "hover" === this.actions[0].type
                                            ? ((this.player.loop = !1), this.player.stop(), this.container.addEventListener("mouseenter", o(this, d)), this.container.addEventListener("touchstart", o(this, d), { passive: !0 }))
                                            : "toggle" === this.actions[0].type
                                            ? ((this.player.loop = !1), this.player.stop(), this.container.addEventListener("click", o(this, f)))
                                            : "hold" === this.actions[0].type || "pauseHold" === this.actions[0].type
                                            ? (this.container.addEventListener("mouseenter", o(this, S)),
                                              this.container.addEventListener("mouseleave", o(this, P)),
                                              this.container.addEventListener("touchstart", o(this, S), { passive: !0 }),
                                              this.container.addEventListener("touchend", o(this, P), { passive: !0 }))
                                            : "seek" === this.actions[0].type &&
                                              ((this.player.loop = !0),
                                              this.player.stop(),
                                              this.container.addEventListener("mousemove", o(this, m)),
                                              this.container.addEventListener("touchmove", o(this, y), { passive: !1 }),
                                              this.container.addEventListener("mouseout", o(this, v)))
                                        : ((this.player.loop = !0), this.player.stop(), this.container.addEventListener("mousemove", o(this, m)), this.container.addEventListener("mouseleave", o(this, v)), o(this, T).call(this, -1, -1));
                                },
                            },
                            {
                                key: "initChainMode",
                                value: function () {
                                    o(this, p).call(this), (this.player.loop = !1), this.player.stop(), o(this, C).call(this, { ignorePath: !1 });
                                },
                            },
                            {
                                key: "start",
                                value: function () {
                                    var t = this;
                                    "scroll" === this.mode
                                        ? this.player.isLoaded
                                            ? this.initScrollMode()
                                            : this.player.addEventListener("DOMLoaded", function () {
                                                  t.initScrollMode();
                                              })
                                        : "cursor" === this.mode
                                        ? this.player.isLoaded
                                            ? this.initCursorMode()
                                            : this.player.addEventListener("DOMLoaded", function () {
                                                  t.initCursorMode();
                                              })
                                        : "chain" === this.mode &&
                                          (this.player.isLoaded
                                              ? this.initChainMode()
                                              : this.player.addEventListener("DOMLoaded", function () {
                                                    t.initChainMode();
                                                }));
                                },
                            },
                            {
                                key: "redefineOptions",
                                value: function (t) {
                                    var e = t.actions,
                                        r = t.container,
                                        n = t.mode,
                                        a = t.player,
                                        o = s(t, ["actions", "container", "mode", "player"]);
                                    if ((this.stop(), (this.enteredPlayer = a), "object" !== i(a) || "AnimationItem" !== a.constructor.name)) {
                                        if ("string" == typeof a) {
                                            var l = document.querySelector(a);
                                            l && "LOTTIE-PLAYER" === l.nodeName && (a = l.getLottie());
                                        } else a instanceof HTMLElement && "LOTTIE-PLAYER" === a.nodeName && (a = a.getLottie());
                                        if (!a) throw new Error(h + "Specified player:" + a + " is invalid.", a);
                                    }
                                    "string" == typeof r && (r = document.querySelector(r)),
                                        r || (r = a.wrapper),
                                        (this.player = a),
                                        (this.loadedAnimation = this.player.path + this.player.fileName + ".json"),
                                        (this.attachedListeners = !1),
                                        (this.container = r),
                                        (this.mode = n),
                                        (this.actions = e),
                                        (this.options = o),
                                        (this.assignedSegment = null),
                                        (this.scrolledAndPlayed = !1),
                                        (this.interactionIdx = 0),
                                        (this.clickCounter = 0),
                                        (this.playCounter = 0),
                                        (this.holdStatus = null),
                                        (this.stateHandler = new Map()),
                                        (this.transitionHandler = new Map()),
                                        this.start();
                                },
                            },
                            {
                                key: "stop",
                                value: function () {
                                    if (
                                        ("scroll" === this.mode && window.removeEventListener("scroll", o(this, k), !0),
                                        "cursor" === this.mode &&
                                            (this.container.removeEventListener("click", o(this, d)),
                                            this.container.removeEventListener("click", o(this, f)),
                                            this.container.removeEventListener("mouseenter", o(this, d)),
                                            this.container.removeEventListener("touchstart", o(this, d)),
                                            this.container.removeEventListener("touchmove", o(this, y)),
                                            this.container.removeEventListener("mousemove", o(this, m)),
                                            this.container.removeEventListener("mouseleave", o(this, v)),
                                            this.container.removeEventListener("touchstart", o(this, S)),
                                            this.container.removeEventListener("touchend", o(this, P))),
                                        "chain" === this.mode &&
                                            (this.container.removeEventListener("click", o(this, d)),
                                            this.container.removeEventListener("click", o(this, u)),
                                            this.container.removeEventListener("mouseenter", o(this, d)),
                                            this.container.removeEventListener("touchstart", o(this, d)),
                                            this.container.removeEventListener("touchmove", o(this, y)),
                                            this.container.removeEventListener("mouseenter", o(this, u)),
                                            this.container.removeEventListener("touchstart", o(this, u)),
                                            this.container.removeEventListener("mouseenter", o(this, S)),
                                            this.container.removeEventListener("touchstart", o(this, S)),
                                            this.container.removeEventListener("mouseleave", o(this, P)),
                                            this.container.removeEventListener("mousemove", o(this, m)),
                                            this.container.removeEventListener("mouseout", o(this, v)),
                                            this.container.removeEventListener("touchend", o(this, P)),
                                            this.player))
                                    )
                                        try {
                                            this.player.removeEventListener("loopComplete", o(this, g)),
                                                this.player.removeEventListener("complete", o(this, g)),
                                                this.player.removeEventListener("enterFrame", o(this, b)),
                                                this.player.removeEventListener("enterFrame", o(this, E));
                                        } catch (t) {}
                                    this.player && (this.player.destroy(), (this.player = null));
                                },
                            },
                        ]) && n(e.prototype, r),
                        t
                    );
                })(),
                p = new WeakMap(),
                u = new WeakMap(),
                f = new WeakMap(),
                d = new WeakMap(),
                m = new WeakMap(),
                y = new WeakMap(),
                v = new WeakMap(),
                g = new WeakMap(),
                _ = new WeakMap(),
                b = new WeakMap(),
                E = new WeakMap(),
                S = new WeakMap(),
                P = new WeakMap(),
                w = new WeakMap(),
                x = new WeakMap(),
                A = new WeakMap(),
                C = new WeakMap(),
                T = new WeakMap(),
                k = new WeakMap(),
                D = function (t) {
                    var e = new c(t);
                    return e.start(), e;
                };
        },
        886: function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function _asyncIterator(t) {
                var e,
                    r,
                    i,
                    n = 2;
                for ("undefined" != typeof Symbol && ((r = Symbol.asyncIterator), (i = Symbol.iterator)); n--; ) {
                    if (r && null != (e = t[r])) return e.call(t);
                    if (i && null != (e = t[i])) return new AsyncFromSyncIterator(e.call(t));
                    (r = "@@asyncIterator"), (i = "@@iterator");
                }
                throw new TypeError("Object is not async iterable");
            }
            function AsyncFromSyncIterator(t) {
                function e(t) {
                    if (Object(t) !== t) return Promise.reject(new TypeError(t + " is not an object."));
                    var e = t.done;
                    return Promise.resolve(t.value).then(function (t) {
                        return { value: t, done: e };
                    });
                }
                return (
                    (AsyncFromSyncIterator = function (t) {
                        (this.s = t), (this.n = t.next);
                    }),
                    (AsyncFromSyncIterator.prototype = {
                        s: null,
                        n: null,
                        next: function () {
                            return e(this.n.apply(this.s, arguments));
                        },
                        return: function (t) {
                            var r = this.s.return;
                            return void 0 === r ? Promise.resolve({ value: t, done: !0 }) : e(r.apply(this.s, arguments));
                        },
                        throw: function (t) {
                            var r = this.s.return;
                            return void 0 === r ? Promise.reject(t) : e(r.apply(this.s, arguments));
                        },
                    }),
                    new AsyncFromSyncIterator(t)
                );
            }
            var REACT_ELEMENT_TYPE;
            function _jsx(t, e, r, i) {
                REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = ("function" == typeof Symbol && Symbol.for && Symbol.for("react.element")) || 60103);
                var n = t && t.defaultProps,
                    a = arguments.length - 3;
                if ((e || 0 === a || (e = { children: void 0 }), 1 === a)) e.children = i;
                else if (a > 1) {
                    for (var s = new Array(a), o = 0; o < a; o++) s[o] = arguments[o + 3];
                    e.children = s;
                }
                if (e && n) for (var l in n) void 0 === e[l] && (e[l] = n[l]);
                else e || (e = n || {});
                return { $$typeof: REACT_ELEMENT_TYPE, type: t, key: void 0 === r ? null : "" + r, ref: null, props: e, _owner: null };
            }
            function ownKeys(t, e) {
                var r = Object.keys(t);
                if (Object.getOwnPropertySymbols) {
                    var i = Object.getOwnPropertySymbols(t);
                    e &&
                        (i = i.filter(function (e) {
                            return Object.getOwnPropertyDescriptor(t, e).enumerable;
                        })),
                        r.push.apply(r, i);
                }
                return r;
            }
            function _objectSpread2(t) {
                for (var e = 1; e < arguments.length; e++) {
                    var r = null != arguments[e] ? arguments[e] : {};
                    e % 2
                        ? ownKeys(Object(r), !0).forEach(function (e) {
                              _defineProperty(t, e, r[e]);
                          })
                        : Object.getOwnPropertyDescriptors
                        ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r))
                        : ownKeys(Object(r)).forEach(function (e) {
                              Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
                          });
                }
                return t;
            }
            function _typeof(t) {
                return (
                    (_typeof =
                        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                            ? function (t) {
                                  return typeof t;
                              }
                            : function (t) {
                                  return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                              }),
                    _typeof(t)
                );
            }
            function _wrapRegExp() {
                _wrapRegExp = function (t, e) {
                    return new r(t, void 0, e);
                };
                var t = RegExp.prototype,
                    e = new WeakMap();
                function r(t, i, n) {
                    var a = new RegExp(t, i);
                    return e.set(a, n || e.get(t)), _setPrototypeOf(a, r.prototype);
                }
                function i(t, r) {
                    var i = e.get(r);
                    return Object.keys(i).reduce(function (e, r) {
                        return (e[r] = t[i[r]]), e;
                    }, Object.create(null));
                }
                return (
                    _inherits(r, RegExp),
                    (r.prototype.exec = function (e) {
                        var r = t.exec.call(this, e);
                        return r && (r.groups = i(r, this)), r;
                    }),
                    (r.prototype[Symbol.replace] = function (r, n) {
                        if ("string" == typeof n) {
                            var a = e.get(this);
                            return t[Symbol.replace].call(
                                this,
                                r,
                                n.replace(/\$<([^>]+)>/g, function (t, e) {
                                    return "$" + a[e];
                                })
                            );
                        }
                        if ("function" == typeof n) {
                            var s = this;
                            return t[Symbol.replace].call(this, r, function () {
                                var t = arguments;
                                return "object" != typeof t[t.length - 1] && (t = [].slice.call(t)).push(i(t, s)), n.apply(this, t);
                            });
                        }
                        return t[Symbol.replace].call(this, r, n);
                    }),
                    _wrapRegExp.apply(this, arguments)
                );
            }
            function _AwaitValue(t) {
                this.wrapped = t;
            }
            function _AsyncGenerator(t) {
                var e, r;
                function i(e, r) {
                    try {
                        var a = t[e](r),
                            s = a.value,
                            o = s instanceof _AwaitValue;
                        Promise.resolve(o ? s.wrapped : s).then(
                            function (t) {
                                o ? i("return" === e ? "return" : "next", t) : n(a.done ? "return" : "normal", t);
                            },
                            function (t) {
                                i("throw", t);
                            }
                        );
                    } catch (t) {
                        n("throw", t);
                    }
                }
                function n(t, n) {
                    switch (t) {
                        case "return":
                            e.resolve({ value: n, done: !0 });
                            break;
                        case "throw":
                            e.reject(n);
                            break;
                        default:
                            e.resolve({ value: n, done: !1 });
                    }
                    (e = e.next) ? i(e.key, e.arg) : (r = null);
                }
                (this._invoke = function (t, n) {
                    return new Promise(function (a, s) {
                        var o = { key: t, arg: n, resolve: a, reject: s, next: null };
                        r ? (r = r.next = o) : ((e = r = o), i(t, n));
                    });
                }),
                    "function" != typeof t.return && (this.return = void 0);
            }
            function _wrapAsyncGenerator(t) {
                return function () {
                    return new _AsyncGenerator(t.apply(this, arguments));
                };
            }
            function _awaitAsyncGenerator(t) {
                return new _AwaitValue(t);
            }
            function _asyncGeneratorDelegate(t, e) {
                var r = {},
                    i = !1;
                function n(r, n) {
                    return (
                        (i = !0),
                        (n = new Promise(function (e) {
                            e(t[r](n));
                        })),
                        { done: !1, value: e(n) }
                    );
                }
                return (
                    (r[("undefined" != typeof Symbol && Symbol.iterator) || "@@iterator"] = function () {
                        return this;
                    }),
                    (r.next = function (t) {
                        return i ? ((i = !1), t) : n("next", t);
                    }),
                    "function" == typeof t.throw &&
                        (r.throw = function (t) {
                            if (i) throw ((i = !1), t);
                            return n("throw", t);
                        }),
                    "function" == typeof t.return &&
                        (r.return = function (t) {
                            return i ? ((i = !1), t) : n("return", t);
                        }),
                    r
                );
            }
            function asyncGeneratorStep(t, e, r, i, n, a, s) {
                try {
                    var o = t[a](s),
                        l = o.value;
                } catch (t) {
                    return void r(t);
                }
                o.done ? e(l) : Promise.resolve(l).then(i, n);
            }
            function _asyncToGenerator(t) {
                return function () {
                    var e = this,
                        r = arguments;
                    return new Promise(function (i, n) {
                        var a = t.apply(e, r);
                        function s(t) {
                            asyncGeneratorStep(a, i, n, s, o, "next", t);
                        }
                        function o(t) {
                            asyncGeneratorStep(a, i, n, s, o, "throw", t);
                        }
                        s(void 0);
                    });
                };
            }
            function _classCallCheck(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }
            function _defineProperties(t, e) {
                for (var r = 0; r < e.length; r++) {
                    var i = e[r];
                    (i.enumerable = i.enumerable || !1), (i.configurable = !0), "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
                }
            }
            function _createClass(t, e, r) {
                return e && _defineProperties(t.prototype, e), r && _defineProperties(t, r), Object.defineProperty(t, "prototype", { writable: !1 }), t;
            }
            function _defineEnumerableProperties(t, e) {
                for (var r in e) ((a = e[r]).configurable = a.enumerable = !0), "value" in a && (a.writable = !0), Object.defineProperty(t, r, a);
                if (Object.getOwnPropertySymbols)
                    for (var i = Object.getOwnPropertySymbols(e), n = 0; n < i.length; n++) {
                        var a,
                            s = i[n];
                        ((a = e[s]).configurable = a.enumerable = !0), "value" in a && (a.writable = !0), Object.defineProperty(t, s, a);
                    }
                return t;
            }
            function _defaults(t, e) {
                for (var r = Object.getOwnPropertyNames(e), i = 0; i < r.length; i++) {
                    var n = r[i],
                        a = Object.getOwnPropertyDescriptor(e, n);
                    a && a.configurable && void 0 === t[n] && Object.defineProperty(t, n, a);
                }
                return t;
            }
            function _defineProperty(t, e, r) {
                return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : (t[e] = r), t;
            }
            function _extends() {
                return (
                    (_extends =
                        Object.assign ||
                        function (t) {
                            for (var e = 1; e < arguments.length; e++) {
                                var r = arguments[e];
                                for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
                            }
                            return t;
                        }),
                    _extends.apply(this, arguments)
                );
            }
            function _objectSpread(t) {
                for (var e = 1; e < arguments.length; e++) {
                    var r = null != arguments[e] ? Object(arguments[e]) : {},
                        i = Object.keys(r);
                    "function" == typeof Object.getOwnPropertySymbols &&
                        i.push.apply(
                            i,
                            Object.getOwnPropertySymbols(r).filter(function (t) {
                                return Object.getOwnPropertyDescriptor(r, t).enumerable;
                            })
                        ),
                        i.forEach(function (e) {
                            _defineProperty(t, e, r[e]);
                        });
                }
                return t;
            }
            function _inherits(t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e);
            }
            function _inheritsLoose(t, e) {
                (t.prototype = Object.create(e.prototype)), (t.prototype.constructor = t), _setPrototypeOf(t, e);
            }
            function _getPrototypeOf(t) {
                return (
                    (_getPrototypeOf = Object.setPrototypeOf
                        ? Object.getPrototypeOf
                        : function (t) {
                              return t.__proto__ || Object.getPrototypeOf(t);
                          }),
                    _getPrototypeOf(t)
                );
            }
            function _setPrototypeOf(t, e) {
                return (
                    (_setPrototypeOf =
                        Object.setPrototypeOf ||
                        function (t, e) {
                            return (t.__proto__ = e), t;
                        }),
                    _setPrototypeOf(t, e)
                );
            }
            function _isNativeReflectConstruct() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (t) {
                    return !1;
                }
            }
            function _construct(t, e, r) {
                return (
                    (_construct = _isNativeReflectConstruct()
                        ? Reflect.construct
                        : function (t, e, r) {
                              var i = [null];
                              i.push.apply(i, e);
                              var n = new (Function.bind.apply(t, i))();
                              return r && _setPrototypeOf(n, r.prototype), n;
                          }),
                    _construct.apply(null, arguments)
                );
            }
            function _isNativeFunction(t) {
                return -1 !== Function.toString.call(t).indexOf("[native code]");
            }
            function _wrapNativeSuper(t) {
                var e = "function" == typeof Map ? new Map() : void 0;
                return (
                    (_wrapNativeSuper = function (t) {
                        if (null === t || !_isNativeFunction(t)) return t;
                        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
                        if (void 0 !== e) {
                            if (e.has(t)) return e.get(t);
                            e.set(t, r);
                        }
                        function r() {
                            return _construct(t, arguments, _getPrototypeOf(this).constructor);
                        }
                        return (r.prototype = Object.create(t.prototype, { constructor: { value: r, enumerable: !1, writable: !0, configurable: !0 } })), _setPrototypeOf(r, t);
                    }),
                    _wrapNativeSuper(t)
                );
            }
            function _instanceof(t, e) {
                return null != e && "undefined" != typeof Symbol && e[Symbol.hasInstance] ? !!e[Symbol.hasInstance](t) : t instanceof e;
            }
            function _interopRequireDefault(t) {
                return t && t.__esModule ? t : { default: t };
            }
            function _getRequireWildcardCache(t) {
                if ("function" != typeof WeakMap) return null;
                var e = new WeakMap(),
                    r = new WeakMap();
                return (_getRequireWildcardCache = function (t) {
                    return t ? r : e;
                })(t);
            }
            function _interopRequireWildcard(t, e) {
                if (!e && t && t.__esModule) return t;
                if (null === t || ("object" != typeof t && "function" != typeof t)) return { default: t };
                var r = _getRequireWildcardCache(e);
                if (r && r.has(t)) return r.get(t);
                var i = {},
                    n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                for (var a in t)
                    if ("default" !== a && Object.prototype.hasOwnProperty.call(t, a)) {
                        var s = n ? Object.getOwnPropertyDescriptor(t, a) : null;
                        s && (s.get || s.set) ? Object.defineProperty(i, a, s) : (i[a] = t[a]);
                    }
                return (i.default = t), r && r.set(t, i), i;
            }
            function _newArrowCheck(t, e) {
                if (t !== e) throw new TypeError("Cannot instantiate an arrow function");
            }
            function _objectDestructuringEmpty(t) {
                if (null == t) throw new TypeError("Cannot destructure undefined");
            }
            function _objectWithoutPropertiesLoose(t, e) {
                if (null == t) return {};
                var r,
                    i,
                    n = {},
                    a = Object.keys(t);
                for (i = 0; i < a.length; i++) (r = a[i]), e.indexOf(r) >= 0 || (n[r] = t[r]);
                return n;
            }
            function _objectWithoutProperties(t, e) {
                if (null == t) return {};
                var r,
                    i,
                    n = _objectWithoutPropertiesLoose(t, e);
                if (Object.getOwnPropertySymbols) {
                    var a = Object.getOwnPropertySymbols(t);
                    for (i = 0; i < a.length; i++) (r = a[i]), e.indexOf(r) >= 0 || (Object.prototype.propertyIsEnumerable.call(t, r) && (n[r] = t[r]));
                }
                return n;
            }
            function _assertThisInitialized(t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            }
            function _possibleConstructorReturn(t, e) {
                if (e && ("object" == typeof e || "function" == typeof e)) return e;
                if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
                return _assertThisInitialized(t);
            }
            function _createSuper(t) {
                var e = _isNativeReflectConstruct();
                return function () {
                    var r,
                        i = _getPrototypeOf(t);
                    if (e) {
                        var n = _getPrototypeOf(this).constructor;
                        r = Reflect.construct(i, arguments, n);
                    } else r = i.apply(this, arguments);
                    return _possibleConstructorReturn(this, r);
                };
            }
            function _superPropBase(t, e) {
                for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = _getPrototypeOf(t)); );
                return t;
            }
            function _get() {
                return (
                    (_get =
                        "undefined" != typeof Reflect && Reflect.get
                            ? Reflect.get
                            : function (t, e, r) {
                                  var i = _superPropBase(t, e);
                                  if (i) {
                                      var n = Object.getOwnPropertyDescriptor(i, e);
                                      return n.get ? n.get.call(arguments.length < 3 ? t : r) : n.value;
                                  }
                              }),
                    _get.apply(this, arguments)
                );
            }
            function set(t, e, r, i) {
                return (
                    (set =
                        "undefined" != typeof Reflect && Reflect.set
                            ? Reflect.set
                            : function (t, e, r, i) {
                                  var n,
                                      a = _superPropBase(t, e);
                                  if (a) {
                                      if ((n = Object.getOwnPropertyDescriptor(a, e)).set) return n.set.call(i, r), !0;
                                      if (!n.writable) return !1;
                                  }
                                  if ((n = Object.getOwnPropertyDescriptor(i, e))) {
                                      if (!n.writable) return !1;
                                      (n.value = r), Object.defineProperty(i, e, n);
                                  } else _defineProperty(i, e, r);
                                  return !0;
                              }),
                    set(t, e, r, i)
                );
            }
            function _set(t, e, r, i, n) {
                if (!set(t, e, r, i || t) && n) throw new Error("failed to set property");
                return r;
            }
            function _taggedTemplateLiteral(t, e) {
                return e || (e = t.slice(0)), Object.freeze(Object.defineProperties(t, { raw: { value: Object.freeze(e) } }));
            }
            function _taggedTemplateLiteralLoose(t, e) {
                return e || (e = t.slice(0)), (t.raw = e), t;
            }
            function _readOnlyError(t) {
                throw new TypeError('"' + t + '" is read-only');
            }
            function _writeOnlyError(t) {
                throw new TypeError('"' + t + '" is write-only');
            }
            function _classNameTDZError(t) {
                throw new Error('Class "' + t + '" cannot be referenced in computed property keys.');
            }
            function _temporalUndefined() {}
            function _tdz(t) {
                throw new ReferenceError(t + " is not defined - temporal dead zone");
            }
            function _temporalRef(t, e) {
                return t === _temporalUndefined ? _tdz(e) : t;
            }
            function _slicedToArray(t, e) {
                return _arrayWithHoles(t) || _iterableToArrayLimit(t, e) || _unsupportedIterableToArray(t, e) || _nonIterableRest();
            }
            function _slicedToArrayLoose(t, e) {
                return _arrayWithHoles(t) || _iterableToArrayLimitLoose(t, e) || _unsupportedIterableToArray(t, e) || _nonIterableRest();
            }
            function _toArray(t) {
                return _arrayWithHoles(t) || _iterableToArray(t) || _unsupportedIterableToArray(t) || _nonIterableRest();
            }
            function _toConsumableArray(t) {
                return _arrayWithoutHoles(t) || _iterableToArray(t) || _unsupportedIterableToArray(t) || _nonIterableSpread();
            }
            function _arrayWithoutHoles(t) {
                if (Array.isArray(t)) return _arrayLikeToArray(t);
            }
            function _arrayWithHoles(t) {
                if (Array.isArray(t)) return t;
            }
            function _maybeArrayLike(t, e, r) {
                if (e && !Array.isArray(e) && "number" == typeof e.length) {
                    var i = e.length;
                    return _arrayLikeToArray(e, void 0 !== r && r < i ? r : i);
                }
                return t(e, r);
            }
            function _iterableToArray(t) {
                if (("undefined" != typeof Symbol && null != t[Symbol.iterator]) || null != t["@@iterator"]) return Array.from(t);
            }
            function _iterableToArrayLimit(t, e) {
                var r = null == t ? null : ("undefined" != typeof Symbol && t[Symbol.iterator]) || t["@@iterator"];
                if (null != r) {
                    var i,
                        n,
                        a = [],
                        s = !0,
                        o = !1;
                    try {
                        for (r = r.call(t); !(s = (i = r.next()).done) && (a.push(i.value), !e || a.length !== e); s = !0);
                    } catch (t) {
                        (o = !0), (n = t);
                    } finally {
                        try {
                            s || null == r.return || r.return();
                        } finally {
                            if (o) throw n;
                        }
                    }
                    return a;
                }
            }
            function _iterableToArrayLimitLoose(t, e) {
                var r = t && (("undefined" != typeof Symbol && t[Symbol.iterator]) || t["@@iterator"]);
                if (null != r) {
                    var i = [];
                    for (r = r.call(t), _step; !(_step = r.next()).done && (i.push(_step.value), !e || i.length !== e); );
                    return i;
                }
            }
            function _unsupportedIterableToArray(t, e) {
                if (t) {
                    if ("string" == typeof t) return _arrayLikeToArray(t, e);
                    var r = Object.prototype.toString.call(t).slice(8, -1);
                    return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? _arrayLikeToArray(t, e) : void 0;
                }
            }
            function _arrayLikeToArray(t, e) {
                (null == e || e > t.length) && (e = t.length);
                for (var r = 0, i = new Array(e); r < e; r++) i[r] = t[r];
                return i;
            }
            function _nonIterableSpread() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _nonIterableRest() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _createForOfIteratorHelper(t, e) {
                var r = ("undefined" != typeof Symbol && t[Symbol.iterator]) || t["@@iterator"];
                if (!r) {
                    if (Array.isArray(t) || (r = _unsupportedIterableToArray(t)) || (e && t && "number" == typeof t.length)) {
                        r && (t = r);
                        var i = 0,
                            n = function () {};
                        return {
                            s: n,
                            n: function () {
                                return i >= t.length ? { done: !0 } : { done: !1, value: t[i++] };
                            },
                            e: function (t) {
                                throw t;
                            },
                            f: n,
                        };
                    }
                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                var a,
                    s = !0,
                    o = !1;
                return {
                    s: function () {
                        r = r.call(t);
                    },
                    n: function () {
                        var t = r.next();
                        return (s = t.done), t;
                    },
                    e: function (t) {
                        (o = !0), (a = t);
                    },
                    f: function () {
                        try {
                            s || null == r.return || r.return();
                        } finally {
                            if (o) throw a;
                        }
                    },
                };
            }
            function _createForOfIteratorHelperLoose(t, e) {
                var r = ("undefined" != typeof Symbol && t[Symbol.iterator]) || t["@@iterator"];
                if (r) return (r = r.call(t)).next.bind(r);
                if (Array.isArray(t) || (r = _unsupportedIterableToArray(t)) || (e && t && "number" == typeof t.length)) {
                    r && (t = r);
                    var i = 0;
                    return function () {
                        return i >= t.length ? { done: !0 } : { done: !1, value: t[i++] };
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _skipFirstGeneratorNext(t) {
                return function () {
                    var e = t.apply(this, arguments);
                    return e.next(), e;
                };
            }
            function _toPrimitive(t, e) {
                if ("object" != typeof t || null === t) return t;
                var r = t[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var i = r.call(t, e || "default");
                    if ("object" != typeof i) return i;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === e ? String : Number)(t);
            }
            function _toPropertyKey(t) {
                var e = _toPrimitive(t, "string");
                return "symbol" == typeof e ? e : String(e);
            }
            function _initializerWarningHelper(t, e) {
                throw new Error("Decorating class property failed. Please ensure that proposal-class-properties is enabled and runs after the decorators transform.");
            }
            function _initializerDefineProperty(t, e, r, i) {
                r && Object.defineProperty(t, e, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(i) : void 0 });
            }
            function _applyDecoratedDescriptor(t, e, r, i, n) {
                var a = {};
                return (
                    Object.keys(i).forEach(function (t) {
                        a[t] = i[t];
                    }),
                    (a.enumerable = !!a.enumerable),
                    (a.configurable = !!a.configurable),
                    ("value" in a || a.initializer) && (a.writable = !0),
                    (a = r
                        .slice()
                        .reverse()
                        .reduce(function (r, i) {
                            return i(t, e, r) || r;
                        }, a)),
                    n && void 0 !== a.initializer && ((a.value = a.initializer ? a.initializer.call(n) : void 0), (a.initializer = void 0)),
                    void 0 === a.initializer && (Object.defineProperty(t, e, a), (a = null)),
                    a
                );
            }
            (_AsyncGenerator.prototype[("function" == typeof Symbol && Symbol.asyncIterator) || "@@asyncIterator"] = function () {
                return this;
            }),
                (_AsyncGenerator.prototype.next = function (t) {
                    return this._invoke("next", t);
                }),
                (_AsyncGenerator.prototype.throw = function (t) {
                    return this._invoke("throw", t);
                }),
                (_AsyncGenerator.prototype.return = function (t) {
                    return this._invoke("return", t);
                });
            var id = 0;
            function _classPrivateFieldLooseKey(t) {
                return "__private_" + id++ + "_" + t;
            }
            function _classPrivateFieldLooseBase(t, e) {
                if (!Object.prototype.hasOwnProperty.call(t, e)) throw new TypeError("attempted to use private field on non-instance");
                return t;
            }
            function _classPrivateFieldGet(t, e) {
                return _classApplyDescriptorGet(t, _classExtractFieldDescriptor(t, e, "get"));
            }
            function _classPrivateFieldSet(t, e, r) {
                return _classApplyDescriptorSet(t, _classExtractFieldDescriptor(t, e, "set"), r), r;
            }
            function _classPrivateFieldDestructureSet(t, e) {
                return _classApplyDescriptorDestructureSet(t, _classExtractFieldDescriptor(t, e, "set"));
            }
            function _classExtractFieldDescriptor(t, e, r) {
                if (!e.has(t)) throw new TypeError("attempted to " + r + " private field on non-instance");
                return e.get(t);
            }
            function _classStaticPrivateFieldSpecGet(t, e, r) {
                return _classCheckPrivateStaticAccess(t, e), _classCheckPrivateStaticFieldDescriptor(r, "get"), _classApplyDescriptorGet(t, r);
            }
            function _classStaticPrivateFieldSpecSet(t, e, r, i) {
                return _classCheckPrivateStaticAccess(t, e), _classCheckPrivateStaticFieldDescriptor(r, "set"), _classApplyDescriptorSet(t, r, i), i;
            }
            function _classStaticPrivateMethodGet(t, e, r) {
                return _classCheckPrivateStaticAccess(t, e), r;
            }
            function _classStaticPrivateMethodSet() {
                throw new TypeError("attempted to set read only static private field");
            }
            function _classApplyDescriptorGet(t, e) {
                return e.get ? e.get.call(t) : e.value;
            }
            function _classApplyDescriptorSet(t, e, r) {
                if (e.set) e.set.call(t, r);
                else {
                    if (!e.writable) throw new TypeError("attempted to set read only private field");
                    e.value = r;
                }
            }
            function _classApplyDescriptorDestructureSet(t, e) {
                if (e.set)
                    return (
                        "__destrObj" in e ||
                            (e.__destrObj = {
                                set value(r) {
                                    e.set.call(t, r);
                                },
                            }),
                        e.__destrObj
                    );
                if (!e.writable) throw new TypeError("attempted to set read only private field");
                return e;
            }
            function _classStaticPrivateFieldDestructureSet(t, e, r) {
                return _classCheckPrivateStaticAccess(t, e), _classCheckPrivateStaticFieldDescriptor(r, "set"), _classApplyDescriptorDestructureSet(t, r);
            }
            function _classCheckPrivateStaticAccess(t, e) {
                if (t !== e) throw new TypeError("Private static access of wrong provenance");
            }
            function _classCheckPrivateStaticFieldDescriptor(t, e) {
                if (void 0 === t) throw new TypeError("attempted to " + e + " private static field before its declaration");
            }
            function _decorate(t, e, r, i) {
                var n = _getDecoratorsApi();
                if (i) for (var a = 0; a < i.length; a++) n = i[a](n);
                var s = e(function (t) {
                        n.initializeInstanceElements(t, o.elements);
                    }, r),
                    o = n.decorateClass(_coalesceClassElements(s.d.map(_createElementDescriptor)), t);
                return n.initializeClassElements(s.F, o.elements), n.runClassFinishers(s.F, o.finishers);
            }
            function _getDecoratorsApi() {
                _getDecoratorsApi = function () {
                    return t;
                };
                var t = {
                    elementsDefinitionOrder: [["method"], ["field"]],
                    initializeInstanceElements: function (t, e) {
                        ["method", "field"].forEach(function (r) {
                            e.forEach(function (e) {
                                e.kind === r && "own" === e.placement && this.defineClassElement(t, e);
                            }, this);
                        }, this);
                    },
                    initializeClassElements: function (t, e) {
                        var r = t.prototype;
                        ["method", "field"].forEach(function (i) {
                            e.forEach(function (e) {
                                var n = e.placement;
                                if (e.kind === i && ("static" === n || "prototype" === n)) {
                                    var a = "static" === n ? t : r;
                                    this.defineClassElement(a, e);
                                }
                            }, this);
                        }, this);
                    },
                    defineClassElement: function (t, e) {
                        var r = e.descriptor;
                        if ("field" === e.kind) {
                            var i = e.initializer;
                            r = { enumerable: r.enumerable, writable: r.writable, configurable: r.configurable, value: void 0 === i ? void 0 : i.call(t) };
                        }
                        Object.defineProperty(t, e.key, r);
                    },
                    decorateClass: function (t, e) {
                        var r = [],
                            i = [],
                            n = { static: [], prototype: [], own: [] };
                        if (
                            (t.forEach(function (t) {
                                this.addElementPlacement(t, n);
                            }, this),
                            t.forEach(function (t) {
                                if (!_hasDecorators(t)) return r.push(t);
                                var e = this.decorateElement(t, n);
                                r.push(e.element), r.push.apply(r, e.extras), i.push.apply(i, e.finishers);
                            }, this),
                            !e)
                        )
                            return { elements: r, finishers: i };
                        var a = this.decorateConstructor(r, e);
                        return i.push.apply(i, a.finishers), (a.finishers = i), a;
                    },
                    addElementPlacement: function (t, e, r) {
                        var i = e[t.placement];
                        if (!r && -1 !== i.indexOf(t.key)) throw new TypeError("Duplicated element (" + t.key + ")");
                        i.push(t.key);
                    },
                    decorateElement: function (t, e) {
                        for (var r = [], i = [], n = t.decorators, a = n.length - 1; a >= 0; a--) {
                            var s = e[t.placement];
                            s.splice(s.indexOf(t.key), 1);
                            var o = this.fromElementDescriptor(t),
                                l = this.toElementFinisherExtras((0, n[a])(o) || o);
                            (t = l.element), this.addElementPlacement(t, e), l.finisher && i.push(l.finisher);
                            var h = l.extras;
                            if (h) {
                                for (var c = 0; c < h.length; c++) this.addElementPlacement(h[c], e);
                                r.push.apply(r, h);
                            }
                        }
                        return { element: t, finishers: i, extras: r };
                    },
                    decorateConstructor: function (t, e) {
                        for (var r = [], i = e.length - 1; i >= 0; i--) {
                            var n = this.fromClassDescriptor(t),
                                a = this.toClassDescriptor((0, e[i])(n) || n);
                            if ((void 0 !== a.finisher && r.push(a.finisher), void 0 !== a.elements)) {
                                t = a.elements;
                                for (var s = 0; s < t.length - 1; s++) for (var o = s + 1; o < t.length; o++) if (t[s].key === t[o].key && t[s].placement === t[o].placement) throw new TypeError("Duplicated element (" + t[s].key + ")");
                            }
                        }
                        return { elements: t, finishers: r };
                    },
                    fromElementDescriptor: function (t) {
                        var e = { kind: t.kind, key: t.key, placement: t.placement, descriptor: t.descriptor };
                        return Object.defineProperty(e, Symbol.toStringTag, { value: "Descriptor", configurable: !0 }), "field" === t.kind && (e.initializer = t.initializer), e;
                    },
                    toElementDescriptors: function (t) {
                        if (void 0 !== t)
                            return _toArray(t).map(function (t) {
                                var e = this.toElementDescriptor(t);
                                return this.disallowProperty(t, "finisher", "An element descriptor"), this.disallowProperty(t, "extras", "An element descriptor"), e;
                            }, this);
                    },
                    toElementDescriptor: function (t) {
                        var e = String(t.kind);
                        if ("method" !== e && "field" !== e) throw new TypeError('An element descriptor\'s .kind property must be either "method" or "field", but a decorator created an element descriptor with .kind "' + e + '"');
                        var r = _toPropertyKey(t.key),
                            i = String(t.placement);
                        if ("static" !== i && "prototype" !== i && "own" !== i)
                            throw new TypeError('An element descriptor\'s .placement property must be one of "static", "prototype" or "own", but a decorator created an element descriptor with .placement "' + i + '"');
                        var n = t.descriptor;
                        this.disallowProperty(t, "elements", "An element descriptor");
                        var a = { kind: e, key: r, placement: i, descriptor: Object.assign({}, n) };
                        return (
                            "field" !== e
                                ? this.disallowProperty(t, "initializer", "A method descriptor")
                                : (this.disallowProperty(n, "get", "The property descriptor of a field descriptor"),
                                  this.disallowProperty(n, "set", "The property descriptor of a field descriptor"),
                                  this.disallowProperty(n, "value", "The property descriptor of a field descriptor"),
                                  (a.initializer = t.initializer)),
                            a
                        );
                    },
                    toElementFinisherExtras: function (t) {
                        return { element: this.toElementDescriptor(t), finisher: _optionalCallableProperty(t, "finisher"), extras: this.toElementDescriptors(t.extras) };
                    },
                    fromClassDescriptor: function (t) {
                        var e = { kind: "class", elements: t.map(this.fromElementDescriptor, this) };
                        return Object.defineProperty(e, Symbol.toStringTag, { value: "Descriptor", configurable: !0 }), e;
                    },
                    toClassDescriptor: function (t) {
                        var e = String(t.kind);
                        if ("class" !== e) throw new TypeError('A class descriptor\'s .kind property must be "class", but a decorator created a class descriptor with .kind "' + e + '"');
                        this.disallowProperty(t, "key", "A class descriptor"),
                            this.disallowProperty(t, "placement", "A class descriptor"),
                            this.disallowProperty(t, "descriptor", "A class descriptor"),
                            this.disallowProperty(t, "initializer", "A class descriptor"),
                            this.disallowProperty(t, "extras", "A class descriptor");
                        var r = _optionalCallableProperty(t, "finisher");
                        return { elements: this.toElementDescriptors(t.elements), finisher: r };
                    },
                    runClassFinishers: function (t, e) {
                        for (var r = 0; r < e.length; r++) {
                            var i = (0, e[r])(t);
                            if (void 0 !== i) {
                                if ("function" != typeof i) throw new TypeError("Finishers must return a constructor.");
                                t = i;
                            }
                        }
                        return t;
                    },
                    disallowProperty: function (t, e, r) {
                        if (void 0 !== t[e]) throw new TypeError(r + " can't have a ." + e + " property.");
                    },
                };
                return t;
            }
            function _createElementDescriptor(t) {
                var e,
                    r = _toPropertyKey(t.key);
                "method" === t.kind
                    ? (e = { value: t.value, writable: !0, configurable: !0, enumerable: !1 })
                    : "get" === t.kind
                    ? (e = { get: t.value, configurable: !0, enumerable: !1 })
                    : "set" === t.kind
                    ? (e = { set: t.value, configurable: !0, enumerable: !1 })
                    : "field" === t.kind && (e = { configurable: !0, writable: !0, enumerable: !0 });
                var i = { kind: "field" === t.kind ? "field" : "method", key: r, placement: t.static ? "static" : "field" === t.kind ? "own" : "prototype", descriptor: e };
                return t.decorators && (i.decorators = t.decorators), "field" === t.kind && (i.initializer = t.value), i;
            }
            function _coalesceGetterSetter(t, e) {
                void 0 !== t.descriptor.get ? (e.descriptor.get = t.descriptor.get) : (e.descriptor.set = t.descriptor.set);
            }
            function _coalesceClassElements(t) {
                for (
                    var e = [],
                        r = function (t) {
                            return "method" === t.kind && t.key === a.key && t.placement === a.placement;
                        },
                        i = 0;
                    i < t.length;
                    i++
                ) {
                    var n,
                        a = t[i];
                    if ("method" === a.kind && (n = e.find(r)))
                        if (_isDataDescriptor(a.descriptor) || _isDataDescriptor(n.descriptor)) {
                            if (_hasDecorators(a) || _hasDecorators(n)) throw new ReferenceError("Duplicated methods (" + a.key + ") can't be decorated.");
                            n.descriptor = a.descriptor;
                        } else {
                            if (_hasDecorators(a)) {
                                if (_hasDecorators(n)) throw new ReferenceError("Decorators can't be placed on different accessors with for the same property (" + a.key + ").");
                                n.decorators = a.decorators;
                            }
                            _coalesceGetterSetter(a, n);
                        }
                    else e.push(a);
                }
                return e;
            }
            function _hasDecorators(t) {
                return t.decorators && t.decorators.length;
            }
            function _isDataDescriptor(t) {
                return void 0 !== t && !(void 0 === t.value && void 0 === t.writable);
            }
            function _optionalCallableProperty(t, e) {
                var r = t[e];
                if (void 0 !== r && "function" != typeof r) throw new TypeError("Expected '" + e + "' to be a function");
                return r;
            }
            function _classPrivateMethodGet(t, e, r) {
                if (!e.has(t)) throw new TypeError("attempted to get private field on non-instance");
                return r;
            }
            function _checkPrivateRedeclaration(t, e) {
                if (e.has(t)) throw new TypeError("Cannot initialize the same private elements twice on an object");
            }
            function _classPrivateFieldInitSpec(t, e, r) {
                _checkPrivateRedeclaration(t, e), e.set(t, r);
            }
            function _classPrivateMethodInitSpec(t, e) {
                _checkPrivateRedeclaration(t, e), e.add(t);
            }
            function _classPrivateMethodSet() {
                throw new TypeError("attempted to reassign private method");
            }
            var _extendStatics = function (t, e) {
                return (
                    (_extendStatics =
                        Object.setPrototypeOf ||
                        ({ __proto__: [] } instanceof Array &&
                            function (t, e) {
                                t.__proto__ = e;
                            }) ||
                        function (t, e) {
                            for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
                        }),
                    _extendStatics(t, e)
                );
            };
            function __extends(t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
                function r() {
                    this.constructor = t;
                }
                _extendStatics(t, e), (t.prototype = null === e ? Object.create(e) : ((r.prototype = e.prototype), new r()));
            }
            var _assign = function () {
                return (
                    (_assign =
                        Object.assign ||
                        function (t) {
                            for (var e, r = 1, i = arguments.length; r < i; r++) for (var n in (e = arguments[r])) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
                            return t;
                        }),
                    _assign.apply(this, arguments)
                );
            };
            function __rest(t, e) {
                var r = {};
                for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (r[i] = t[i]);
                if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
                    var n = 0;
                    for (i = Object.getOwnPropertySymbols(t); n < i.length; n++) e.indexOf(i[n]) < 0 && Object.prototype.propertyIsEnumerable.call(t, i[n]) && (r[i[n]] = t[i[n]]);
                }
                return r;
            }
            function __decorate(t, e, r, i) {
                var n,
                    a = arguments.length,
                    s = a < 3 ? e : null === i ? (i = Object.getOwnPropertyDescriptor(e, r)) : i;
                if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(t, e, r, i);
                else for (var o = t.length - 1; o >= 0; o--) (n = t[o]) && (s = (a < 3 ? n(s) : a > 3 ? n(e, r, s) : n(e, r)) || s);
                return a > 3 && s && Object.defineProperty(e, r, s), s;
            }
            function __param(t, e) {
                return function (r, i) {
                    e(r, i, t);
                };
            }
            function __metadata(t, e) {
                if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(t, e);
            }
            function __awaiter(t, e, r, i) {
                return new (r || (r = Promise))(function (n, a) {
                    function s(t) {
                        try {
                            l(i.next(t));
                        } catch (t) {
                            a(t);
                        }
                    }
                    function o(t) {
                        try {
                            l(i.throw(t));
                        } catch (t) {
                            a(t);
                        }
                    }
                    function l(t) {
                        var e;
                        t.done
                            ? n(t.value)
                            : ((e = t.value),
                              e instanceof r
                                  ? e
                                  : new r(function (t) {
                                        t(e);
                                    })).then(s, o);
                    }
                    l((i = i.apply(t, e || [])).next());
                });
            }
            function __generator(t, e) {
                var r,
                    i,
                    n,
                    a,
                    s = {
                        label: 0,
                        sent: function () {
                            if (1 & n[0]) throw n[1];
                            return n[1];
                        },
                        trys: [],
                        ops: [],
                    };
                return (
                    (a = { next: o(0), throw: o(1), return: o(2) }),
                    "function" == typeof Symbol &&
                        (a[Symbol.iterator] = function () {
                            return this;
                        }),
                    a
                );
                function o(a) {
                    return function (o) {
                        return (function (a) {
                            if (r) throw new TypeError("Generator is already executing.");
                            for (; s; )
                                try {
                                    if (((r = 1), i && (n = 2 & a[0] ? i.return : a[0] ? i.throw || ((n = i.return) && n.call(i), 0) : i.next) && !(n = n.call(i, a[1])).done)) return n;
                                    switch (((i = 0), n && (a = [2 & a[0], n.value]), a[0])) {
                                        case 0:
                                        case 1:
                                            n = a;
                                            break;
                                        case 4:
                                            return s.label++, { value: a[1], done: !1 };
                                        case 5:
                                            s.label++, (i = a[1]), (a = [0]);
                                            continue;
                                        case 7:
                                            (a = s.ops.pop()), s.trys.pop();
                                            continue;
                                        default:
                                            if (!((n = (n = s.trys).length > 0 && n[n.length - 1]) || (6 !== a[0] && 2 !== a[0]))) {
                                                s = 0;
                                                continue;
                                            }
                                            if (3 === a[0] && (!n || (a[1] > n[0] && a[1] < n[3]))) {
                                                s.label = a[1];
                                                break;
                                            }
                                            if (6 === a[0] && s.label < n[1]) {
                                                (s.label = n[1]), (n = a);
                                                break;
                                            }
                                            if (n && s.label < n[2]) {
                                                (s.label = n[2]), s.ops.push(a);
                                                break;
                                            }
                                            n[2] && s.ops.pop(), s.trys.pop();
                                            continue;
                                    }
                                    a = e.call(t, s);
                                } catch (t) {
                                    (a = [6, t]), (i = 0);
                                } finally {
                                    r = n = 0;
                                }
                            if (5 & a[0]) throw a[1];
                            return { value: a[0] ? a[1] : void 0, done: !0 };
                        })([a, o]);
                    };
                }
            }
            var __createBinding = Object.create
                ? function (t, e, r, i) {
                      void 0 === i && (i = r),
                          Object.defineProperty(t, i, {
                              enumerable: !0,
                              get: function () {
                                  return e[r];
                              },
                          });
                  }
                : function (t, e, r, i) {
                      void 0 === i && (i = r), (t[i] = e[r]);
                  };
            function __exportStar(t, e) {
                for (var r in t) "default" === r || Object.prototype.hasOwnProperty.call(e, r) || __createBinding(e, t, r);
            }
            function __values(t) {
                var e = "function" == typeof Symbol && Symbol.iterator,
                    r = e && t[e],
                    i = 0;
                if (r) return r.call(t);
                if (t && "number" == typeof t.length)
                    return {
                        next: function () {
                            return t && i >= t.length && (t = void 0), { value: t && t[i++], done: !t };
                        },
                    };
                throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }
            function __read(t, e) {
                var r = "function" == typeof Symbol && t[Symbol.iterator];
                if (!r) return t;
                var i,
                    n,
                    a = r.call(t),
                    s = [];
                try {
                    for (; (void 0 === e || e-- > 0) && !(i = a.next()).done; ) s.push(i.value);
                } catch (t) {
                    n = { error: t };
                } finally {
                    try {
                        i && !i.done && (r = a.return) && r.call(a);
                    } finally {
                        if (n) throw n.error;
                    }
                }
                return s;
            }
            function __spread() {
                for (var t = [], e = 0; e < arguments.length; e++) t = t.concat(__read(arguments[e]));
                return t;
            }
            function __spreadArrays() {
                for (var t = 0, e = 0, r = arguments.length; e < r; e++) t += arguments[e].length;
                var i = Array(t),
                    n = 0;
                for (e = 0; e < r; e++) for (var a = arguments[e], s = 0, o = a.length; s < o; s++, n++) i[n] = a[s];
                return i;
            }
            function __spreadArray(t, e, r) {
                if (r || 2 === arguments.length) for (var i, n = 0, a = e.length; n < a; n++) (!i && n in e) || (i || (i = Array.prototype.slice.call(e, 0, n)), (i[n] = e[n]));
                return t.concat(i || Array.prototype.slice.call(e));
            }
            function __await(t) {
                return this instanceof __await ? ((this.v = t), this) : new __await(t);
            }
            function __asyncGenerator(t, e, r) {
                if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
                var i,
                    n = r.apply(t, e || []),
                    a = [];
                return (
                    (i = {}),
                    s("next"),
                    s("throw"),
                    s("return"),
                    (i[Symbol.asyncIterator] = function () {
                        return this;
                    }),
                    i
                );
                function s(t) {
                    n[t] &&
                        (i[t] = function (e) {
                            return new Promise(function (r, i) {
                                a.push([t, e, r, i]) > 1 || o(t, e);
                            });
                        });
                }
                function o(t, e) {
                    try {
                        !(function (t) {
                            t.value instanceof __await ? Promise.resolve(t.value.v).then(l, h) : c(a[0][2], t);
                        })(n[t](e));
                    } catch (t) {
                        c(a[0][3], t);
                    }
                }
                function l(t) {
                    o("next", t);
                }
                function h(t) {
                    o("throw", t);
                }
                function c(t, e) {
                    t(e), a.shift(), a.length && o(a[0][0], a[0][1]);
                }
            }
            function __asyncDelegator(t) {
                var e, r;
                return (
                    (e = {}),
                    i("next"),
                    i("throw", function (t) {
                        throw t;
                    }),
                    i("return"),
                    (e[Symbol.iterator] = function () {
                        return this;
                    }),
                    e
                );
                function i(i, n) {
                    e[i] = t[i]
                        ? function (e) {
                              return (r = !r) ? { value: __await(t[i](e)), done: "return" === i } : n ? n(e) : e;
                          }
                        : n;
                }
            }
            function __asyncValues(t) {
                if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
                var e,
                    r = t[Symbol.asyncIterator];
                return r
                    ? r.call(t)
                    : ((t = "function" == typeof __values ? __values(t) : t[Symbol.iterator]()),
                      (e = {}),
                      i("next"),
                      i("throw"),
                      i("return"),
                      (e[Symbol.asyncIterator] = function () {
                          return this;
                      }),
                      e);
                function i(r) {
                    e[r] =
                        t[r] &&
                        function (e) {
                            return new Promise(function (i, n) {
                                !(function (t, e, r, i) {
                                    Promise.resolve(i).then(function (e) {
                                        t({ value: e, done: r });
                                    }, e);
                                })(i, n, (e = t[r](e)).done, e.value);
                            });
                        };
                }
            }
            function __makeTemplateObject(t, e) {
                return Object.defineProperty ? Object.defineProperty(t, "raw", { value: e }) : (t.raw = e), t;
            }
            var __setModuleDefault = Object.create
                ? function (t, e) {
                      Object.defineProperty(t, "default", { enumerable: !0, value: e });
                  }
                : function (t, e) {
                      t.default = e;
                  };
            function __importStar(t) {
                if (t && t.__esModule) return t;
                var e = {};
                if (null != t) for (var r in t) "default" !== r && Object.prototype.hasOwnProperty.call(t, r) && __createBinding(e, t, r);
                return __setModuleDefault(e, t), e;
            }
            function __importDefault(t) {
                return t && t.__esModule ? t : { default: t };
            }
            function __classPrivateFieldGet(t, e, r, i) {
                if ("a" === r && !i) throw new TypeError("Private accessor was defined without a getter");
                if ("function" == typeof e ? t !== e || !i : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
                return "m" === r ? i : "a" === r ? i.call(t) : i ? i.value : e.get(t);
            }
            function __classPrivateFieldSet(t, e, r, i, n) {
                if ("m" === i) throw new TypeError("Private method is not writable");
                if ("a" === i && !n) throw new TypeError("Private accessor was defined without a setter");
                if ("function" == typeof e ? t !== e || !n : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
                return "a" === i ? n.call(t, r) : n ? (n.value = r) : e.set(t, r), r;
            }
            var t$3 = window.ShadowRoot && (void 0 === window.ShadyCSS || window.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype,
                e$8 = Symbol(),
                n$5 = new Map();
            class s$3 {
                constructor(t, e) {
                    if (((this._$cssResult$ = !0), e !== e$8)) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
                    this.cssText = t;
                }
                get styleSheet() {
                    var t = n$5.get(this.cssText);
                    return t$3 && void 0 === t && (n$5.set(this.cssText, (t = new CSSStyleSheet())), t.replaceSync(this.cssText)), t;
                }
                toString() {
                    return this.cssText;
                }
            }
            var o$5 = (t) => new s$3("string" == typeof t ? t : t + "", e$8),
                r$3 = function (t) {
                    for (var e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), i = 1; i < e; i++) r[i - 1] = arguments[i];
                    var n =
                        1 === t.length
                            ? t[0]
                            : r.reduce(
                                  (e, r, i) =>
                                      e +
                                      ((t) => {
                                          if (!0 === t._$cssResult$) return t.cssText;
                                          if ("number" == typeof t) return t;
                                          throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
                                      })(r) +
                                      t[i + 1],
                                  t[0]
                              );
                    return new s$3(n, e$8);
                },
                i$3 = (t, e) => {
                    t$3
                        ? (t.adoptedStyleSheets = e.map((t) => (t instanceof CSSStyleSheet ? t : t.styleSheet)))
                        : e.forEach((e) => {
                              var r = document.createElement("style"),
                                  i = window.litNonce;
                              void 0 !== i && r.setAttribute("nonce", i), (r.textContent = e.cssText), t.appendChild(r);
                          });
                },
                S$1 = t$3
                    ? (t) => t
                    : (t) =>
                          t instanceof CSSStyleSheet
                              ? ((t) => {
                                    var e = "";
                                    for (var r of t.cssRules) e += r.cssText;
                                    return o$5(e);
                                })(t)
                              : t,
                s$2,
                e$7 = window.trustedTypes,
                r$2 = e$7 ? e$7.emptyScript : "",
                h$2 = window.reactiveElementPolyfillSupport,
                o$4 = {
                    toAttribute(t, e) {
                        switch (e) {
                            case Boolean:
                                t = t ? r$2 : null;
                                break;
                            case Object:
                            case Array:
                                t = null == t ? t : JSON.stringify(t);
                        }
                        return t;
                    },
                    fromAttribute(t, e) {
                        var r = t;
                        switch (e) {
                            case Boolean:
                                r = null !== t;
                                break;
                            case Number:
                                r = null === t ? null : Number(t);
                                break;
                            case Object:
                            case Array:
                                try {
                                    r = JSON.parse(t);
                                } catch (t) {
                                    r = null;
                                }
                        }
                        return r;
                    },
                },
                n$4 = (t, e) => e !== t && (e == e || t == t),
                l$3 = { attribute: !0, type: String, converter: o$4, reflect: !1, hasChanged: n$4 },
                t$2;
            class a$1 extends HTMLElement {
                constructor() {
                    super(), (this._$Et = new Map()), (this.isUpdatePending = !1), (this.hasUpdated = !1), (this._$Ei = null), this.o();
                }
                static addInitializer(t) {
                    var e;
                    (null !== (e = this.l) && void 0 !== e) || (this.l = []), this.l.push(t);
                }
                static get observedAttributes() {
                    this.finalize();
                    var t = [];
                    return (
                        this.elementProperties.forEach((e, r) => {
                            var i = this._$Eh(r, e);
                            void 0 !== i && (this._$Eu.set(i, r), t.push(i));
                        }),
                        t
                    );
                }
                static createProperty(t) {
                    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : l$3;
                    if ((e.state && (e.attribute = !1), this.finalize(), this.elementProperties.set(t, e), !e.noAccessor && !this.prototype.hasOwnProperty(t))) {
                        var r = "symbol" == typeof t ? Symbol() : "__" + t,
                            i = this.getPropertyDescriptor(t, r, e);
                        void 0 !== i && Object.defineProperty(this.prototype, t, i);
                    }
                }
                static getPropertyDescriptor(t, e, r) {
                    return {
                        get() {
                            return this[e];
                        },
                        set(i) {
                            var n = this[t];
                            (this[e] = i), this.requestUpdate(t, n, r);
                        },
                        configurable: !0,
                        enumerable: !0,
                    };
                }
                static getPropertyOptions(t) {
                    return this.elementProperties.get(t) || l$3;
                }
                static finalize() {
                    if (this.hasOwnProperty("finalized")) return !1;
                    this.finalized = !0;
                    var t = Object.getPrototypeOf(this);
                    if ((t.finalize(), (this.elementProperties = new Map(t.elementProperties)), (this._$Eu = new Map()), this.hasOwnProperty("properties"))) {
                        var e = this.properties,
                            r = [...Object.getOwnPropertyNames(e), ...Object.getOwnPropertySymbols(e)];
                        for (var i of r) this.createProperty(i, e[i]);
                    }
                    return (this.elementStyles = this.finalizeStyles(this.styles)), !0;
                }
                static finalizeStyles(t) {
                    var e = [];
                    if (Array.isArray(t)) {
                        var r = new Set(t.flat(1 / 0).reverse());
                        for (var i of r) e.unshift(S$1(i));
                    } else void 0 !== t && e.push(S$1(t));
                    return e;
                }
                static _$Eh(t, e) {
                    var r = e.attribute;
                    return !1 === r ? void 0 : "string" == typeof r ? r : "string" == typeof t ? t.toLowerCase() : void 0;
                }
                o() {
                    var t;
                    (this._$Ep = new Promise((t) => (this.enableUpdating = t))), (this._$AL = new Map()), this._$Em(), this.requestUpdate(), null === (t = this.constructor.l) || void 0 === t || t.forEach((t) => t(this));
                }
                addController(t) {
                    var e, r;
                    (null !== (e = this._$Eg) && void 0 !== e ? e : (this._$Eg = [])).push(t), void 0 !== this.renderRoot && this.isConnected && (null === (r = t.hostConnected) || void 0 === r || r.call(t));
                }
                removeController(t) {
                    var e;
                    null === (e = this._$Eg) || void 0 === e || e.splice(this._$Eg.indexOf(t) >>> 0, 1);
                }
                _$Em() {
                    this.constructor.elementProperties.forEach((t, e) => {
                        this.hasOwnProperty(e) && (this._$Et.set(e, this[e]), delete this[e]);
                    });
                }
                createRenderRoot() {
                    var t,
                        e = null !== (t = this.shadowRoot) && void 0 !== t ? t : this.attachShadow(this.constructor.shadowRootOptions);
                    return i$3(e, this.constructor.elementStyles), e;
                }
                connectedCallback() {
                    var t;
                    void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()),
                        this.enableUpdating(!0),
                        null === (t = this._$Eg) ||
                            void 0 === t ||
                            t.forEach((t) => {
                                var e;
                                return null === (e = t.hostConnected) || void 0 === e ? void 0 : e.call(t);
                            });
                }
                enableUpdating(t) {}
                disconnectedCallback() {
                    var t;
                    null === (t = this._$Eg) ||
                        void 0 === t ||
                        t.forEach((t) => {
                            var e;
                            return null === (e = t.hostDisconnected) || void 0 === e ? void 0 : e.call(t);
                        });
                }
                attributeChangedCallback(t, e, r) {
                    this._$AK(t, r);
                }
                _$ES(t, e) {
                    var r,
                        i,
                        n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : l$3,
                        a = this.constructor._$Eh(t, n);
                    if (void 0 !== a && !0 === n.reflect) {
                        var s = (null !== (i = null === (r = n.converter) || void 0 === r ? void 0 : r.toAttribute) && void 0 !== i ? i : o$4.toAttribute)(e, n.type);
                        (this._$Ei = t), null == s ? this.removeAttribute(a) : this.setAttribute(a, s), (this._$Ei = null);
                    }
                }
                _$AK(t, e) {
                    var r,
                        i,
                        n,
                        a = this.constructor,
                        s = a._$Eu.get(t);
                    if (void 0 !== s && this._$Ei !== s) {
                        var o = a.getPropertyOptions(s),
                            l = o.converter,
                            h = null !== (n = null !== (i = null === (r = l) || void 0 === r ? void 0 : r.fromAttribute) && void 0 !== i ? i : "function" == typeof l ? l : null) && void 0 !== n ? n : o$4.fromAttribute;
                        (this._$Ei = s), (this[s] = h(e, o.type)), (this._$Ei = null);
                    }
                }
                requestUpdate(t, e, r) {
                    var i = !0;
                    void 0 !== t &&
                        (((r = r || this.constructor.getPropertyOptions(t)).hasChanged || n$4)(this[t], e)
                            ? (this._$AL.has(t) || this._$AL.set(t, e), !0 === r.reflect && this._$Ei !== t && (void 0 === this._$E_ && (this._$E_ = new Map()), this._$E_.set(t, r)))
                            : (i = !1)),
                        !this.isUpdatePending && i && (this._$Ep = this._$EC());
                }
                _$EC() {
                    var t = this;
                    return _asyncToGenerator(function* () {
                        t.isUpdatePending = !0;
                        try {
                            yield t._$Ep;
                        } catch (e) {
                            Promise.reject(e);
                        }
                        var e = t.scheduleUpdate();
                        return null != e && (yield e), !t.isUpdatePending;
                    })();
                }
                scheduleUpdate() {
                    return this.performUpdate();
                }
                performUpdate() {
                    var t;
                    if (this.isUpdatePending) {
                        this.hasUpdated, this._$Et && (this._$Et.forEach((t, e) => (this[e] = t)), (this._$Et = void 0));
                        var e = !1,
                            r = this._$AL;
                        try {
                            (e = this.shouldUpdate(r))
                                ? (this.willUpdate(r),
                                  null === (t = this._$Eg) ||
                                      void 0 === t ||
                                      t.forEach((t) => {
                                          var e;
                                          return null === (e = t.hostUpdate) || void 0 === e ? void 0 : e.call(t);
                                      }),
                                  this.update(r))
                                : this._$EU();
                        } catch (t) {
                            throw ((e = !1), this._$EU(), t);
                        }
                        e && this._$AE(r);
                    }
                }
                willUpdate(t) {}
                _$AE(t) {
                    var e;
                    null === (e = this._$Eg) ||
                        void 0 === e ||
                        e.forEach((t) => {
                            var e;
                            return null === (e = t.hostUpdated) || void 0 === e ? void 0 : e.call(t);
                        }),
                        this.hasUpdated || ((this.hasUpdated = !0), this.firstUpdated(t)),
                        this.updated(t);
                }
                _$EU() {
                    (this._$AL = new Map()), (this.isUpdatePending = !1);
                }
                get updateComplete() {
                    return this.getUpdateComplete();
                }
                getUpdateComplete() {
                    return this._$Ep;
                }
                shouldUpdate(t) {
                    return !0;
                }
                update(t) {
                    void 0 !== this._$E_ && (this._$E_.forEach((t, e) => this._$ES(e, this[e], t)), (this._$E_ = void 0)), this._$EU();
                }
                updated(t) {}
                firstUpdated(t) {}
            }
            (a$1.finalized = !0),
                (a$1.elementProperties = new Map()),
                (a$1.elementStyles = []),
                (a$1.shadowRootOptions = { mode: "open" }),
                null == h$2 || h$2({ ReactiveElement: a$1 }),
                (null !== (s$2 = globalThis.reactiveElementVersions) && void 0 !== s$2 ? s$2 : (globalThis.reactiveElementVersions = [])).push("1.2.1");
            var i$2 = globalThis.trustedTypes,
                s$1 = i$2 ? i$2.createPolicy("lit-html", { createHTML: (t) => t }) : void 0,
                e$6 = "lit$".concat((Math.random() + "").slice(9), "$"),
                o$3 = "?" + e$6,
                n$3 = "<".concat(o$3, ">"),
                l$2 = document,
                h$1 = function () {
                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
                    return l$2.createComment(t);
                },
                r$1 = (t) => null === t || ("object" != typeof t && "function" != typeof t),
                d = Array.isArray,
                u = (t) => {
                    var e;
                    return d(t) || "function" == typeof (null === (e = t) || void 0 === e ? void 0 : e[Symbol.iterator]);
                },
                c = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g,
                v = /-->/g,
                a = />/g,
                f = />|[ 	\n\r](?:([^\s"'>=/]+)([ 	\n\r]*=[ 	\n\r]*(?:[^ 	\n\r"'`<>=]|("|')|))|$)/g,
                _ = /'/g,
                m = /"/g,
                g = /^(?:script|style|textarea)$/i,
                p = (t) =>
                    function (e) {
                        for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++) i[n - 1] = arguments[n];
                        return { _$litType$: t, strings: e, values: i };
                    },
                $ = p(1),
                y = p(2),
                b = Symbol.for("lit-noChange"),
                w = Symbol.for("lit-nothing"),
                T = new WeakMap(),
                x = (t, e, r) => {
                    var i,
                        n,
                        a = null !== (i = null == r ? void 0 : r.renderBefore) && void 0 !== i ? i : e,
                        s = a._$litPart$;
                    if (void 0 === s) {
                        var o = null !== (n = null == r ? void 0 : r.renderBefore) && void 0 !== n ? n : null;
                        a._$litPart$ = s = new N(e.insertBefore(h$1(), o), o, void 0, null != r ? r : {});
                    }
                    return s._$AI(t), s;
                },
                A = l$2.createTreeWalker(l$2, 129, null, !1),
                C = (t, e) => {
                    for (var r, i = t.length - 1, n = [], s = 2 === e ? "<svg>" : "", o = c, l = 0; l < i; l++) {
                        for (var h = t[l], p = void 0, u = void 0, d = -1, y = 0; y < h.length && ((o.lastIndex = y), null !== (u = o.exec(h))); )
                            (y = o.lastIndex),
                                o === c
                                    ? "!--" === u[1]
                                        ? (o = v)
                                        : void 0 !== u[1]
                                        ? (o = a)
                                        : void 0 !== u[2]
                                        ? (g.test(u[2]) && (r = RegExp("</" + u[2], "g")), (o = f))
                                        : void 0 !== u[3] && (o = f)
                                    : o === f
                                    ? ">" === u[0]
                                        ? ((o = null != r ? r : c), (d = -1))
                                        : void 0 === u[1]
                                        ? (d = -2)
                                        : ((d = o.lastIndex - u[2].length), (p = u[1]), (o = void 0 === u[3] ? f : '"' === u[3] ? m : _))
                                    : o === m || o === _
                                    ? (o = f)
                                    : o === v || o === a
                                    ? (o = c)
                                    : ((o = f), (r = void 0));
                        var b = o === f && t[l + 1].startsWith("/>") ? " " : "";
                        s += o === c ? h + n$3 : d >= 0 ? (n.push(p), h.slice(0, d) + "$lit$" + h.slice(d) + e$6 + b) : h + e$6 + (-2 === d ? (n.push(void 0), l) : b);
                    }
                    var E = s + (t[i] || "<?>") + (2 === e ? "</svg>" : "");
                    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
                    return [void 0 !== s$1 ? s$1.createHTML(E) : E, n];
                };
            class E {
                constructor(t, e) {
                    var r,
                        { strings: i, _$litType$: n } = t;
                    this.parts = [];
                    var a = 0,
                        s = 0,
                        o = i.length - 1,
                        l = this.parts,
                        [h, c] = C(i, n);
                    if (((this.el = E.createElement(h, e)), (A.currentNode = this.el.content), 2 === n)) {
                        var p = this.el.content,
                            u = p.firstChild;
                        u.remove(), p.append(...u.childNodes);
                    }
                    for (; null !== (r = A.nextNode()) && l.length < o; ) {
                        if (1 === r.nodeType) {
                            if (r.hasAttributes()) {
                                var f = [];
                                for (var d of r.getAttributeNames())
                                    if (d.endsWith("$lit$") || d.startsWith(e$6)) {
                                        var m = c[s++];
                                        if ((f.push(d), void 0 !== m)) {
                                            var y = r.getAttribute(m.toLowerCase() + "$lit$").split(e$6),
                                                v = /([.?@])?(.*)/.exec(m);
                                            l.push({ type: 1, index: a, name: v[2], strings: y, ctor: "." === v[1] ? M : "?" === v[1] ? H : "@" === v[1] ? I : S });
                                        } else l.push({ type: 6, index: a });
                                    }
                                for (var _ of f) r.removeAttribute(_);
                            }
                            if (g.test(r.tagName)) {
                                var b = r.textContent.split(e$6),
                                    P = b.length - 1;
                                if (P > 0) {
                                    r.textContent = i$2 ? i$2.emptyScript : "";
                                    for (var w = 0; w < P; w++) r.append(b[w], h$1()), A.nextNode(), l.push({ type: 2, index: ++a });
                                    r.append(b[P], h$1());
                                }
                            }
                        } else if (8 === r.nodeType)
                            if (r.data === o$3) l.push({ type: 2, index: a });
                            else for (var x = -1; -1 !== (x = r.data.indexOf(e$6, x + 1)); ) l.push({ type: 7, index: a }), (x += e$6.length - 1);
                        a++;
                    }
                }
                static createElement(t, e) {
                    var r = l$2.createElement("template");
                    return (r.innerHTML = t), r;
                }
            }
            function P(t, e) {
                var r,
                    i,
                    n,
                    a,
                    s = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t,
                    o = arguments.length > 3 ? arguments[3] : void 0;
                if (e === b) return e;
                var l = void 0 !== o ? (null === (r = s._$Cl) || void 0 === r ? void 0 : r[o]) : s._$Cu,
                    h = r$1(e) ? void 0 : e._$litDirective$;
                return (
                    (null == l ? void 0 : l.constructor) !== h &&
                        (null === (i = null == l ? void 0 : l._$AO) || void 0 === i || i.call(l, !1),
                        void 0 === h ? (l = void 0) : (l = new h(t))._$AT(t, s, o),
                        void 0 !== o ? ((null !== (n = (a = s)._$Cl) && void 0 !== n ? n : (a._$Cl = []))[o] = l) : (s._$Cu = l)),
                    void 0 !== l && (e = P(t, l._$AS(t, e.values), l, o)),
                    e
                );
            }
            class V {
                constructor(t, e) {
                    (this.v = []), (this._$AN = void 0), (this._$AD = t), (this._$AM = e);
                }
                get parentNode() {
                    return this._$AM.parentNode;
                }
                get _$AU() {
                    return this._$AM._$AU;
                }
                p(t) {
                    var e,
                        {
                            el: { content: r },
                            parts: i,
                        } = this._$AD,
                        n = (null !== (e = null == t ? void 0 : t.creationScope) && void 0 !== e ? e : l$2).importNode(r, !0);
                    A.currentNode = n;
                    for (var a = A.nextNode(), s = 0, o = 0, l = i[0]; void 0 !== l; ) {
                        if (s === l.index) {
                            var h = void 0;
                            2 === l.type ? (h = new N(a, a.nextSibling, this, t)) : 1 === l.type ? (h = new l.ctor(a, l.name, l.strings, this, t)) : 6 === l.type && (h = new L(a, this, t)), this.v.push(h), (l = i[++o]);
                        }
                        s !== (null == l ? void 0 : l.index) && ((a = A.nextNode()), s++);
                    }
                    return n;
                }
                m(t) {
                    var e = 0;
                    for (var r of this.v) void 0 !== r && (void 0 !== r.strings ? (r._$AI(t, r, e), (e += r.strings.length - 2)) : r._$AI(t[e])), e++;
                }
            }
            class N {
                constructor(t, e, r, i) {
                    var n;
                    (this.type = 2), (this._$AH = w), (this._$AN = void 0), (this._$AA = t), (this._$AB = e), (this._$AM = r), (this.options = i), (this._$Cg = null === (n = null == i ? void 0 : i.isConnected) || void 0 === n || n);
                }
                get _$AU() {
                    var t, e;
                    return null !== (e = null === (t = this._$AM) || void 0 === t ? void 0 : t._$AU) && void 0 !== e ? e : this._$Cg;
                }
                get parentNode() {
                    var t = this._$AA.parentNode,
                        e = this._$AM;
                    return void 0 !== e && 11 === t.nodeType && (t = e.parentNode), t;
                }
                get startNode() {
                    return this._$AA;
                }
                get endNode() {
                    return this._$AB;
                }
                _$AI(t) {
                    (t = P(this, t, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this)),
                        r$1(t)
                            ? t === w || null == t || "" === t
                                ? (this._$AH !== w && this._$AR(), (this._$AH = w))
                                : t !== this._$AH && t !== b && this.$(t)
                            : void 0 !== t._$litType$
                            ? this.T(t)
                            : void 0 !== t.nodeType
                            ? this.S(t)
                            : u(t)
                            ? this.A(t)
                            : this.$(t);
                }
                M(t) {
                    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this._$AB;
                    return this._$AA.parentNode.insertBefore(t, e);
                }
                S(t) {
                    this._$AH !== t && (this._$AR(), (this._$AH = this.M(t)));
                }
                $(t) {
                    this._$AH !== w && r$1(this._$AH) ? (this._$AA.nextSibling.data = t) : this.S(l$2.createTextNode(t)), (this._$AH = t);
                }
                T(t) {
                    var e,
                        { values: r, _$litType$: i } = t,
                        n = "number" == typeof i ? this._$AC(t) : (void 0 === i.el && (i.el = E.createElement(i.h, this.options)), i);
                    if ((null === (e = this._$AH) || void 0 === e ? void 0 : e._$AD) === n) this._$AH.m(r);
                    else {
                        var a = new V(n, this),
                            s = a.p(this.options);
                        a.m(r), this.S(s), (this._$AH = a);
                    }
                }
                _$AC(t) {
                    var e = T.get(t.strings);
                    return void 0 === e && T.set(t.strings, (e = new E(t))), e;
                }
                A(t) {
                    d(this._$AH) || ((this._$AH = []), this._$AR());
                    var e,
                        r = this._$AH,
                        i = 0;
                    for (var n of t) i === r.length ? r.push((e = new N(this.M(h$1()), this.M(h$1()), this, this.options))) : (e = r[i]), e._$AI(n), i++;
                    i < r.length && (this._$AR(e && e._$AB.nextSibling, i), (r.length = i));
                }
                _$AR() {
                    var t,
                        e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this._$AA.nextSibling,
                        r = arguments.length > 1 ? arguments[1] : void 0;
                    for (null === (t = this._$AP) || void 0 === t || t.call(this, !1, !0, r); e && e !== this._$AB; ) {
                        var i = e.nextSibling;
                        e.remove(), (e = i);
                    }
                }
                setConnected(t) {
                    var e;
                    void 0 === this._$AM && ((this._$Cg = t), null === (e = this._$AP) || void 0 === e || e.call(this, t));
                }
            }
            class S {
                constructor(t, e, r, i, n) {
                    (this.type = 1),
                        (this._$AH = w),
                        (this._$AN = void 0),
                        (this.element = t),
                        (this.name = e),
                        (this._$AM = i),
                        (this.options = n),
                        r.length > 2 || "" !== r[0] || "" !== r[1] ? ((this._$AH = Array(r.length - 1).fill(new String())), (this.strings = r)) : (this._$AH = w);
                }
                get tagName() {
                    return this.element.tagName;
                }
                get _$AU() {
                    return this._$AM._$AU;
                }
                _$AI(t) {
                    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this,
                        r = arguments.length > 2 ? arguments[2] : void 0,
                        i = arguments.length > 3 ? arguments[3] : void 0,
                        n = this.strings,
                        a = !1;
                    if (void 0 === n) (t = P(this, t, e, 0)), (a = !r$1(t) || (t !== this._$AH && t !== b)) && (this._$AH = t);
                    else {
                        var s,
                            o,
                            l = t;
                        for (t = n[0], s = 0; s < n.length - 1; s++)
                            (o = P(this, l[r + s], e, s)) === b && (o = this._$AH[s]), a || (a = !r$1(o) || o !== this._$AH[s]), o === w ? (t = w) : t !== w && (t += (null != o ? o : "") + n[s + 1]), (this._$AH[s] = o);
                    }
                    a && !i && this.k(t);
                }
                k(t) {
                    t === w ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t ? t : "");
                }
            }
            class M extends S {
                constructor() {
                    super(...arguments), (this.type = 3);
                }
                k(t) {
                    this.element[this.name] = t === w ? void 0 : t;
                }
            }
            var k = i$2 ? i$2.emptyScript : "";
            class H extends S {
                constructor() {
                    super(...arguments), (this.type = 4);
                }
                k(t) {
                    t && t !== w ? this.element.setAttribute(this.name, k) : this.element.removeAttribute(this.name);
                }
            }
            class I extends S {
                constructor(t, e, r, i, n) {
                    super(t, e, r, i, n), (this.type = 5);
                }
                _$AI(t) {
                    var e;
                    if ((t = null !== (e = P(this, t, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this, 0)) && void 0 !== e ? e : w) !== b) {
                        var r = this._$AH,
                            i = (t === w && r !== w) || t.capture !== r.capture || t.once !== r.once || t.passive !== r.passive,
                            n = t !== w && (r === w || i);
                        i && this.element.removeEventListener(this.name, this, r), n && this.element.addEventListener(this.name, this, t), (this._$AH = t);
                    }
                }
                handleEvent(t) {
                    var e, r;
                    "function" == typeof this._$AH ? this._$AH.call(null !== (r = null === (e = this.options) || void 0 === e ? void 0 : e.host) && void 0 !== r ? r : this.element, t) : this._$AH.handleEvent(t);
                }
            }
            class L {
                constructor(t, e, r) {
                    (this.element = t), (this.type = 6), (this._$AN = void 0), (this._$AM = e), (this.options = r);
                }
                get _$AU() {
                    return this._$AM._$AU;
                }
                _$AI(t) {
                    P(this, t);
                }
            }
            var R = { P: "$lit$", V: e$6, L: o$3, I: 1, N: C, R: V, D: u, j: P, H: N, O: S, F: H, B: I, W: M, Z: L },
                z = window.litHtmlPolyfillSupport,
                l$1,
                o$2;
            null == z || z(E, N), (null !== (t$2 = globalThis.litHtmlVersions) && void 0 !== t$2 ? t$2 : (globalThis.litHtmlVersions = [])).push("2.1.2");
            var r = a$1;
            class s extends a$1 {
                constructor() {
                    super(...arguments), (this.renderOptions = { host: this }), (this._$Dt = void 0);
                }
                createRenderRoot() {
                    var t,
                        e,
                        r = super.createRenderRoot();
                    return (null !== (t = (e = this.renderOptions).renderBefore) && void 0 !== t) || (e.renderBefore = r.firstChild), r;
                }
                update(t) {
                    var e = this.render();
                    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), (this._$Dt = x(e, this.renderRoot, this.renderOptions));
                }
                connectedCallback() {
                    var t;
                    super.connectedCallback(), null === (t = this._$Dt) || void 0 === t || t.setConnected(!0);
                }
                disconnectedCallback() {
                    var t;
                    super.disconnectedCallback(), null === (t = this._$Dt) || void 0 === t || t.setConnected(!1);
                }
                render() {
                    return b;
                }
            }
            (s.finalized = !0), (s._$litElement$ = !0), null === (l$1 = globalThis.litElementHydrateSupport) || void 0 === l$1 || l$1.call(globalThis, { LitElement: s });
            var n$2 = globalThis.litElementPolyfillSupport;
            null == n$2 || n$2({ LitElement: s });
            var h = {
                _$AK: (t, e, r) => {
                    t._$AK(e, r);
                },
                _$AL: (t) => t._$AL,
            };
            (null !== (o$2 = globalThis.litElementVersions) && void 0 !== o$2 ? o$2 : (globalThis.litElementVersions = [])).push("3.1.2");
            var n$1 = (t) => (e) =>
                    "function" == typeof e
                        ? ((t, e) => (window.customElements.define(t, e), e))(t, e)
                        : ((t, e) => {
                              var { kind: r, elements: i } = e;
                              return {
                                  kind: r,
                                  elements: i,
                                  finisher(e) {
                                      window.customElements.define(t, e);
                                  },
                              };
                          })(t, e),
                i$1 = (t, e) =>
                    "method" === e.kind && e.descriptor && !("value" in e.descriptor)
                        ? _objectSpread2(
                              _objectSpread2({}, e),
                              {},
                              {
                                  finisher(r) {
                                      r.createProperty(e.key, t);
                                  },
                              }
                          )
                        : {
                              kind: "field",
                              key: Symbol(),
                              placement: "own",
                              descriptor: {},
                              originalKey: e.key,
                              initializer() {
                                  "function" == typeof e.initializer && (this[e.key] = e.initializer.call(this));
                              },
                              finisher(r) {
                                  r.createProperty(e.key, t);
                              },
                          };
            function e$5(t) {
                return (e, r) =>
                    void 0 !== r
                        ? ((t, e, r) => {
                              e.constructor.createProperty(r, t);
                          })(t, e, r)
                        : i$1(t, e);
            }
            function t$1(t) {
                return e$5(_objectSpread2(_objectSpread2({}, t), {}, { state: !0 }));
            }
            var e$4 = (t, e, r) => {
                    Object.defineProperty(e, r, t);
                },
                t = (t, e) => ({ kind: "method", placement: "prototype", key: e.key, descriptor: t }),
                o$1 = (t) => {
                    var { finisher: e, descriptor: r } = t;
                    return (t, i) => {
                        var n;
                        if (void 0 === i) {
                            var a = null !== (n = t.originalKey) && void 0 !== n ? n : t.key,
                                s = null != r ? { kind: "method", placement: "prototype", key: a, descriptor: r(t.key) } : _objectSpread2(_objectSpread2({}, t), {}, { key: a });
                            return (
                                null != e &&
                                    (s.finisher = function (t) {
                                        e(t, a);
                                    }),
                                s
                            );
                        }
                        var o = t.constructor;
                        void 0 !== r && Object.defineProperty(t, i, r(i)), null == e || e(o, i);
                    };
                },
                n;
            function e$3(t) {
                return o$1({
                    finisher: (e, r) => {
                        Object.assign(e.prototype[r], t);
                    },
                });
            }
            function i(t, e) {
                return o$1({
                    descriptor: (r) => {
                        var i = {
                            get() {
                                var e, r;
                                return null !== (r = null === (e = this.renderRoot) || void 0 === e ? void 0 : e.querySelector(t)) && void 0 !== r ? r : null;
                            },
                            enumerable: !0,
                            configurable: !0,
                        };
                        if (e) {
                            var n = "symbol" == typeof r ? Symbol() : "__" + r;
                            i.get = function () {
                                var e, r;
                                return void 0 === this[n] && (this[n] = null !== (r = null === (e = this.renderRoot) || void 0 === e ? void 0 : e.querySelector(t)) && void 0 !== r ? r : null), this[n];
                            };
                        }
                        return i;
                    },
                });
            }
            function e$2(t) {
                return o$1({
                    descriptor: (e) => ({
                        get() {
                            var e, r;
                            return null !== (r = null === (e = this.renderRoot) || void 0 === e ? void 0 : e.querySelectorAll(t)) && void 0 !== r ? r : [];
                        },
                        enumerable: !0,
                        configurable: !0,
                    }),
                });
            }
            function e$1(t) {
                return o$1({
                    descriptor: (e) => ({
                        get() {
                            var e = this;
                            return _asyncToGenerator(function* () {
                                var r;
                                return yield e.updateComplete, null === (r = e.renderRoot) || void 0 === r ? void 0 : r.querySelector(t);
                            })();
                        },
                        enumerable: !0,
                        configurable: !0,
                    }),
                });
            }
            var e = null != (null === (n = window.HTMLSlotElement) || void 0 === n ? void 0 : n.prototype.assignedElements) ? (t, e) => t.assignedElements(e) : (t, e) => t.assignedNodes(e).filter((t) => t.nodeType === Node.ELEMENT_NODE);
            function l(t) {
                var { slot: r, selector: i } = null != t ? t : {};
                return o$1({
                    descriptor: (n) => ({
                        get() {
                            var n,
                                a = "slot" + (r ? "[name=".concat(r, "]") : ":not([name])"),
                                s = null === (n = this.renderRoot) || void 0 === n ? void 0 : n.querySelector(a),
                                o = null != s ? e(s, t) : [];
                            return i ? o.filter((t) => t.matches(i)) : o;
                        },
                        enumerable: !0,
                        configurable: !0,
                    }),
                });
            }
            function o(t, e, r) {
                var i,
                    n = t;
                return (
                    "object" == typeof t ? ((n = t.slot), (i = t)) : (i = { flatten: e }),
                    r
                        ? l({ slot: n, flatten: e, selector: r })
                        : o$1({
                              descriptor: (t) => ({
                                  get() {
                                      var t,
                                          e,
                                          r = "slot" + (n ? "[name=".concat(n, "]") : ":not([name])"),
                                          a = null === (t = this.renderRoot) || void 0 === t ? void 0 : t.querySelector(r);
                                      return null !== (e = null == a ? void 0 : a.assignedNodes(i)) && void 0 !== e ? e : [];
                                  },
                                  enumerable: !0,
                                  configurable: !0,
                              }),
                          })
                );
            }
            var commonjsGlobal = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : void 0 !== __webpack_require__.g ? __webpack_require__.g : "undefined" != typeof self ? self : {};
            function getDefaultExportFromCjs(t) {
                return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
            }
            function getDefaultExportFromNamespaceIfPresent(t) {
                return t && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
            }
            function getDefaultExportFromNamespaceIfNotNamed(t) {
                return t && Object.prototype.hasOwnProperty.call(t, "default") && 1 === Object.keys(t).length ? t.default : t;
            }
            function getAugmentedNamespace(t) {
                if (t.__esModule) return t;
                var e = Object.defineProperty({}, "__esModule", { value: !0 });
                return (
                    Object.keys(t).forEach(function (r) {
                        var i = Object.getOwnPropertyDescriptor(t, r);
                        Object.defineProperty(
                            e,
                            r,
                            i.get
                                ? i
                                : {
                                      enumerable: !0,
                                      get: function () {
                                          return t[r];
                                      },
                                  }
                        );
                    }),
                    e
                );
            }
            function commonjsRequire(t) {
                throw new Error('Could not dynamically require "' + t + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
            }
            var lottie$1 = { exports: {} };
            (function (module, exports) {
                var factory;
                "undefined" != typeof navigator &&
                    ((factory = function () {
                        var svgNS = "http://www.w3.org/2000/svg",
                            locationHref = "",
                            _useWebWorker = !1,
                            initialDefaultFrame = -999999,
                            setWebWorker = function (t) {
                                _useWebWorker = !!t;
                            },
                            getWebWorker = function () {
                                return _useWebWorker;
                            },
                            setLocationHref = function (t) {
                                locationHref = t;
                            },
                            getLocationHref = function () {
                                return locationHref;
                            };
                        function createTag(t) {
                            return document.createElement(t);
                        }
                        function extendPrototype(t, e) {
                            var r,
                                i,
                                n = t.length;
                            for (r = 0; r < n; r += 1) for (var a in (i = t[r].prototype)) Object.prototype.hasOwnProperty.call(i, a) && (e.prototype[a] = i[a]);
                        }
                        function getDescriptor(t, e) {
                            return Object.getOwnPropertyDescriptor(t, e);
                        }
                        function createProxyFunction(t) {
                            function e() {}
                            return (e.prototype = t), e;
                        }
                        var audioControllerFactory = (function () {
                                function t(t) {
                                    (this.audios = []), (this.audioFactory = t), (this._volume = 1), (this._isMuted = !1);
                                }
                                return (
                                    (t.prototype = {
                                        addAudio: function (t) {
                                            this.audios.push(t);
                                        },
                                        pause: function () {
                                            var t,
                                                e = this.audios.length;
                                            for (t = 0; t < e; t += 1) this.audios[t].pause();
                                        },
                                        resume: function () {
                                            var t,
                                                e = this.audios.length;
                                            for (t = 0; t < e; t += 1) this.audios[t].resume();
                                        },
                                        setRate: function (t) {
                                            var e,
                                                r = this.audios.length;
                                            for (e = 0; e < r; e += 1) this.audios[e].setRate(t);
                                        },
                                        createAudio: function (t) {
                                            return this.audioFactory
                                                ? this.audioFactory(t)
                                                : window.Howl
                                                ? new window.Howl({ src: [t] })
                                                : {
                                                      isPlaying: !1,
                                                      play: function () {
                                                          this.isPlaying = !0;
                                                      },
                                                      seek: function () {
                                                          this.isPlaying = !1;
                                                      },
                                                      playing: function () {},
                                                      rate: function () {},
                                                      setVolume: function () {},
                                                  };
                                        },
                                        setAudioFactory: function (t) {
                                            this.audioFactory = t;
                                        },
                                        setVolume: function (t) {
                                            (this._volume = t), this._updateVolume();
                                        },
                                        mute: function () {
                                            (this._isMuted = !0), this._updateVolume();
                                        },
                                        unmute: function () {
                                            (this._isMuted = !1), this._updateVolume();
                                        },
                                        getVolume: function () {
                                            return this._volume;
                                        },
                                        _updateVolume: function () {
                                            var t,
                                                e = this.audios.length;
                                            for (t = 0; t < e; t += 1) this.audios[t].volume(this._volume * (this._isMuted ? 0 : 1));
                                        },
                                    }),
                                    function () {
                                        return new t();
                                    }
                                );
                            })(),
                            createTypedArray = (function () {
                                function t(t, e) {
                                    var r,
                                        i = 0,
                                        n = [];
                                    switch (t) {
                                        case "int16":
                                        case "uint8c":
                                            r = 1;
                                            break;
                                        default:
                                            r = 1.1;
                                    }
                                    for (i = 0; i < e; i += 1) n.push(r);
                                    return n;
                                }
                                return "function" == typeof Uint8ClampedArray && "function" == typeof Float32Array
                                    ? function (e, r) {
                                          return "float32" === e ? new Float32Array(r) : "int16" === e ? new Int16Array(r) : "uint8c" === e ? new Uint8ClampedArray(r) : t(e, r);
                                      }
                                    : t;
                            })();
                        function createSizedArray(t) {
                            return Array.apply(null, { length: t });
                        }
                        function _typeof$6(t) {
                            return (
                                (_typeof$6 =
                                    "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                                        ? function (t) {
                                              return typeof t;
                                          }
                                        : function (t) {
                                              return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                                          }),
                                _typeof$6(t)
                            );
                        }
                        var subframeEnabled = !0,
                            expressionsPlugin = null,
                            expressionsInterfaces = null,
                            idPrefix$1 = "",
                            isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
                            _shouldRoundValues = !1,
                            bmPow = Math.pow,
                            bmSqrt = Math.sqrt,
                            bmFloor = Math.floor,
                            bmMax = Math.max,
                            bmMin = Math.min,
                            BMMath = {};
                        function ProjectInterface$1() {
                            return {};
                        }
                        !(function () {
                            var t,
                                e = [
                                    "abs",
                                    "acos",
                                    "acosh",
                                    "asin",
                                    "asinh",
                                    "atan",
                                    "atanh",
                                    "atan2",
                                    "ceil",
                                    "cbrt",
                                    "expm1",
                                    "clz32",
                                    "cos",
                                    "cosh",
                                    "exp",
                                    "floor",
                                    "fround",
                                    "hypot",
                                    "imul",
                                    "log",
                                    "log1p",
                                    "log2",
                                    "log10",
                                    "max",
                                    "min",
                                    "pow",
                                    "random",
                                    "round",
                                    "sign",
                                    "sin",
                                    "sinh",
                                    "sqrt",
                                    "tan",
                                    "tanh",
                                    "trunc",
                                    "E",
                                    "LN10",
                                    "LN2",
                                    "LOG10E",
                                    "LOG2E",
                                    "PI",
                                    "SQRT1_2",
                                    "SQRT2",
                                ],
                                r = e.length;
                            for (t = 0; t < r; t += 1) BMMath[e[t]] = Math[e[t]];
                        })(),
                            (BMMath.random = Math.random),
                            (BMMath.abs = function (t) {
                                if ("object" === _typeof$6(t) && t.length) {
                                    var e,
                                        r = createSizedArray(t.length),
                                        i = t.length;
                                    for (e = 0; e < i; e += 1) r[e] = Math.abs(t[e]);
                                    return r;
                                }
                                return Math.abs(t);
                            });
                        var defaultCurveSegments = 150,
                            degToRads = Math.PI / 180,
                            roundCorner = 0.5519;
                        function roundValues(t) {
                            _shouldRoundValues = !!t;
                        }
                        function bmRnd(t) {
                            return _shouldRoundValues ? Math.round(t) : t;
                        }
                        function styleDiv(t) {
                            (t.style.position = "absolute"),
                                (t.style.top = 0),
                                (t.style.left = 0),
                                (t.style.display = "block"),
                                (t.style.transformOrigin = "0 0"),
                                (t.style.webkitTransformOrigin = "0 0"),
                                (t.style.backfaceVisibility = "visible"),
                                (t.style.webkitBackfaceVisibility = "visible"),
                                (t.style.transformStyle = "preserve-3d"),
                                (t.style.webkitTransformStyle = "preserve-3d"),
                                (t.style.mozTransformStyle = "preserve-3d");
                        }
                        function BMEnterFrameEvent(t, e, r, i) {
                            (this.type = t), (this.currentTime = e), (this.totalTime = r), (this.direction = i < 0 ? -1 : 1);
                        }
                        function BMCompleteEvent(t, e) {
                            (this.type = t), (this.direction = e < 0 ? -1 : 1);
                        }
                        function BMCompleteLoopEvent(t, e, r, i) {
                            (this.type = t), (this.currentLoop = r), (this.totalLoops = e), (this.direction = i < 0 ? -1 : 1);
                        }
                        function BMSegmentStartEvent(t, e, r) {
                            (this.type = t), (this.firstFrame = e), (this.totalFrames = r);
                        }
                        function BMDestroyEvent(t, e) {
                            (this.type = t), (this.target = e);
                        }
                        function BMRenderFrameErrorEvent(t, e) {
                            (this.type = "renderFrameError"), (this.nativeError = t), (this.currentTime = e);
                        }
                        function BMConfigErrorEvent(t) {
                            (this.type = "configError"), (this.nativeError = t);
                        }
                        function BMAnimationConfigErrorEvent(t, e) {
                            (this.type = t), (this.nativeError = e);
                        }
                        var createElementID =
                                ((_count = 0),
                                function () {
                                    return idPrefix$1 + "__lottie_element_" + (_count += 1);
                                }),
                            _count;
                        function HSVtoRGB(t, e, r) {
                            var i, n, a, s, o, l, h, c;
                            switch (((l = r * (1 - e)), (h = r * (1 - (o = 6 * t - (s = Math.floor(6 * t))) * e)), (c = r * (1 - (1 - o) * e)), s % 6)) {
                                case 0:
                                    (i = r), (n = c), (a = l);
                                    break;
                                case 1:
                                    (i = h), (n = r), (a = l);
                                    break;
                                case 2:
                                    (i = l), (n = r), (a = c);
                                    break;
                                case 3:
                                    (i = l), (n = h), (a = r);
                                    break;
                                case 4:
                                    (i = c), (n = l), (a = r);
                                    break;
                                case 5:
                                    (i = r), (n = l), (a = h);
                            }
                            return [i, n, a];
                        }
                        function RGBtoHSV(t, e, r) {
                            var i,
                                n = Math.max(t, e, r),
                                a = Math.min(t, e, r),
                                s = n - a,
                                o = 0 === n ? 0 : s / n,
                                l = n / 255;
                            switch (n) {
                                case a:
                                    i = 0;
                                    break;
                                case t:
                                    (i = e - r + s * (e < r ? 6 : 0)), (i /= 6 * s);
                                    break;
                                case e:
                                    (i = r - t + 2 * s), (i /= 6 * s);
                                    break;
                                case r:
                                    (i = t - e + 4 * s), (i /= 6 * s);
                            }
                            return [i, o, l];
                        }
                        function addSaturationToRGB(t, e) {
                            var r = RGBtoHSV(255 * t[0], 255 * t[1], 255 * t[2]);
                            return (r[1] += e), r[1] > 1 ? (r[1] = 1) : r[1] <= 0 && (r[1] = 0), HSVtoRGB(r[0], r[1], r[2]);
                        }
                        function addBrightnessToRGB(t, e) {
                            var r = RGBtoHSV(255 * t[0], 255 * t[1], 255 * t[2]);
                            return (r[2] += e), r[2] > 1 ? (r[2] = 1) : r[2] < 0 && (r[2] = 0), HSVtoRGB(r[0], r[1], r[2]);
                        }
                        function addHueToRGB(t, e) {
                            var r = RGBtoHSV(255 * t[0], 255 * t[1], 255 * t[2]);
                            return (r[0] += e / 360), r[0] > 1 ? (r[0] -= 1) : r[0] < 0 && (r[0] += 1), HSVtoRGB(r[0], r[1], r[2]);
                        }
                        var rgbToHex = (function () {
                                var t,
                                    e,
                                    r = [];
                                for (t = 0; t < 256; t += 1) (e = t.toString(16)), (r[t] = 1 === e.length ? "0" + e : e);
                                return function (t, e, i) {
                                    return t < 0 && (t = 0), e < 0 && (e = 0), i < 0 && (i = 0), "#" + r[t] + r[e] + r[i];
                                };
                            })(),
                            setSubframeEnabled = function (t) {
                                subframeEnabled = !!t;
                            },
                            getSubframeEnabled = function () {
                                return subframeEnabled;
                            },
                            setExpressionsPlugin = function (t) {
                                expressionsPlugin = t;
                            },
                            getExpressionsPlugin = function () {
                                return expressionsPlugin;
                            },
                            setExpressionInterfaces = function (t) {
                                expressionsInterfaces = t;
                            },
                            getExpressionInterfaces = function () {
                                return expressionsInterfaces;
                            },
                            setDefaultCurveSegments = function (t) {
                                defaultCurveSegments = t;
                            },
                            getDefaultCurveSegments = function () {
                                return defaultCurveSegments;
                            },
                            setIdPrefix = function (t) {
                                idPrefix$1 = t;
                            },
                            getIdPrefix = function () {
                                return idPrefix$1;
                            };
                        function createNS(t) {
                            return document.createElementNS(svgNS, t);
                        }
                        function _typeof$5(t) {
                            return (
                                (_typeof$5 =
                                    "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                                        ? function (t) {
                                              return typeof t;
                                          }
                                        : function (t) {
                                              return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                                          }),
                                _typeof$5(t)
                            );
                        }
                        var dataManager = (function () {
                                var t,
                                    e,
                                    r = 1,
                                    i = [],
                                    n = {
                                        onmessage: function () {},
                                        postMessage: function (e) {
                                            t({ data: e });
                                        },
                                    },
                                    a = {
                                        postMessage: function (t) {
                                            n.onmessage({ data: t });
                                        },
                                    };
                                function s() {
                                    e ||
                                        ((e = (function (e) {
                                            if (window.Worker && window.Blob && getWebWorker()) {
                                                var r = new Blob(["var _workerSelf = self; self.onmessage = ", e.toString()], { type: "text/javascript" }),
                                                    i = URL.createObjectURL(r);
                                                return new Worker(i);
                                            }
                                            return (t = e), n;
                                        })(function (t) {
                                            if (
                                                (a.dataManager ||
                                                    (a.dataManager = (function () {
                                                        function t(n, a) {
                                                            var s,
                                                                o,
                                                                l,
                                                                h,
                                                                c,
                                                                u,
                                                                f = n.length;
                                                            for (o = 0; o < f; o += 1)
                                                                if ("ks" in (s = n[o]) && !s.completed) {
                                                                    if (((s.completed = !0), s.hasMask)) {
                                                                        var d = s.masksProperties;
                                                                        for (h = d.length, l = 0; l < h; l += 1)
                                                                            if (d[l].pt.k.i) i(d[l].pt.k);
                                                                            else for (u = d[l].pt.k.length, c = 0; c < u; c += 1) d[l].pt.k[c].s && i(d[l].pt.k[c].s[0]), d[l].pt.k[c].e && i(d[l].pt.k[c].e[0]);
                                                                    }
                                                                    0 === s.ty ? ((s.layers = e(s.refId, a)), t(s.layers, a)) : 4 === s.ty ? r(s.shapes) : 5 === s.ty && p(s);
                                                                }
                                                        }
                                                        function e(t, e) {
                                                            var r = (function (t, e) {
                                                                for (var r = 0, i = e.length; r < i; ) {
                                                                    if (e[r].id === t) return e[r];
                                                                    r += 1;
                                                                }
                                                                return null;
                                                            })(t, e);
                                                            return r ? (r.layers.__used ? JSON.parse(JSON.stringify(r.layers)) : ((r.layers.__used = !0), r.layers)) : null;
                                                        }
                                                        function r(t) {
                                                            var e, n, a;
                                                            for (e = t.length - 1; e >= 0; e -= 1)
                                                                if ("sh" === t[e].ty)
                                                                    if (t[e].ks.k.i) i(t[e].ks.k);
                                                                    else for (a = t[e].ks.k.length, n = 0; n < a; n += 1) t[e].ks.k[n].s && i(t[e].ks.k[n].s[0]), t[e].ks.k[n].e && i(t[e].ks.k[n].e[0]);
                                                                else "gr" === t[e].ty && r(t[e].it);
                                                        }
                                                        function i(t) {
                                                            var e,
                                                                r = t.i.length;
                                                            for (e = 0; e < r; e += 1) (t.i[e][0] += t.v[e][0]), (t.i[e][1] += t.v[e][1]), (t.o[e][0] += t.v[e][0]), (t.o[e][1] += t.v[e][1]);
                                                        }
                                                        function n(t, e) {
                                                            var r = e ? e.split(".") : [100, 100, 100];
                                                            return t[0] > r[0] || (!(r[0] > t[0]) && (t[1] > r[1] || (!(r[1] > t[1]) && (t[2] > r[2] || (!(r[2] > t[2]) && null)))));
                                                        }
                                                        var a,
                                                            s = (function () {
                                                                var t = [4, 4, 14];
                                                                function e(t) {
                                                                    var e,
                                                                        r,
                                                                        i,
                                                                        n = t.length;
                                                                    for (e = 0; e < n; e += 1) 5 === t[e].ty && (void 0, (i = (r = t[e]).t.d), (r.t.d = { k: [{ s: i, t: 0 }] }));
                                                                }
                                                                return function (r) {
                                                                    if (n(t, r.v) && (e(r.layers), r.assets)) {
                                                                        var i,
                                                                            a = r.assets.length;
                                                                        for (i = 0; i < a; i += 1) r.assets[i].layers && e(r.assets[i].layers);
                                                                    }
                                                                };
                                                            })(),
                                                            o =
                                                                ((a = [4, 7, 99]),
                                                                function (t) {
                                                                    if (t.chars && !n(a, t.v)) {
                                                                        var e,
                                                                            i = t.chars.length;
                                                                        for (e = 0; e < i; e += 1) {
                                                                            var s = t.chars[e];
                                                                            s.data &&
                                                                                s.data.shapes &&
                                                                                (r(s.data.shapes),
                                                                                (s.data.ip = 0),
                                                                                (s.data.op = 99999),
                                                                                (s.data.st = 0),
                                                                                (s.data.sr = 1),
                                                                                (s.data.ks = { p: { k: [0, 0], a: 0 }, s: { k: [100, 100], a: 0 }, a: { k: [0, 0], a: 0 }, r: { k: 0, a: 0 }, o: { k: 100, a: 0 } }),
                                                                                t.chars[e].t ||
                                                                                    (s.data.shapes.push({ ty: "no" }),
                                                                                    s.data.shapes[0].it.push({
                                                                                        p: { k: [0, 0], a: 0 },
                                                                                        s: { k: [100, 100], a: 0 },
                                                                                        a: { k: [0, 0], a: 0 },
                                                                                        r: { k: 0, a: 0 },
                                                                                        o: { k: 100, a: 0 },
                                                                                        sk: { k: 0, a: 0 },
                                                                                        sa: { k: 0, a: 0 },
                                                                                        ty: "tr",
                                                                                    })));
                                                                        }
                                                                    }
                                                                }),
                                                            l = (function () {
                                                                var t = [5, 7, 15];
                                                                function e(t) {
                                                                    var e,
                                                                        r,
                                                                        i = t.length;
                                                                    for (e = 0; e < i; e += 1)
                                                                        5 === t[e].ty &&
                                                                            ((r = void 0),
                                                                            "number" == typeof (r = t[e].t.p).a && (r.a = { a: 0, k: r.a }),
                                                                            "number" == typeof r.p && (r.p = { a: 0, k: r.p }),
                                                                            "number" == typeof r.r && (r.r = { a: 0, k: r.r }));
                                                                }
                                                                return function (r) {
                                                                    if (n(t, r.v) && (e(r.layers), r.assets)) {
                                                                        var i,
                                                                            a = r.assets.length;
                                                                        for (i = 0; i < a; i += 1) r.assets[i].layers && e(r.assets[i].layers);
                                                                    }
                                                                };
                                                            })(),
                                                            h = (function () {
                                                                var t = [4, 1, 9];
                                                                function e(t) {
                                                                    var r,
                                                                        i,
                                                                        n,
                                                                        a = t.length;
                                                                    for (r = 0; r < a; r += 1)
                                                                        if ("gr" === t[r].ty) e(t[r].it);
                                                                        else if ("fl" === t[r].ty || "st" === t[r].ty)
                                                                            if (t[r].c.k && t[r].c.k[0].i)
                                                                                for (n = t[r].c.k.length, i = 0; i < n; i += 1)
                                                                                    t[r].c.k[i].s && ((t[r].c.k[i].s[0] /= 255), (t[r].c.k[i].s[1] /= 255), (t[r].c.k[i].s[2] /= 255), (t[r].c.k[i].s[3] /= 255)),
                                                                                        t[r].c.k[i].e && ((t[r].c.k[i].e[0] /= 255), (t[r].c.k[i].e[1] /= 255), (t[r].c.k[i].e[2] /= 255), (t[r].c.k[i].e[3] /= 255));
                                                                            else (t[r].c.k[0] /= 255), (t[r].c.k[1] /= 255), (t[r].c.k[2] /= 255), (t[r].c.k[3] /= 255);
                                                                }
                                                                function r(t) {
                                                                    var r,
                                                                        i = t.length;
                                                                    for (r = 0; r < i; r += 1) 4 === t[r].ty && e(t[r].shapes);
                                                                }
                                                                return function (e) {
                                                                    if (n(t, e.v) && (r(e.layers), e.assets)) {
                                                                        var i,
                                                                            a = e.assets.length;
                                                                        for (i = 0; i < a; i += 1) e.assets[i].layers && r(e.assets[i].layers);
                                                                    }
                                                                };
                                                            })(),
                                                            c = (function () {
                                                                var t = [4, 4, 18];
                                                                function e(t) {
                                                                    var r, i, n;
                                                                    for (r = t.length - 1; r >= 0; r -= 1)
                                                                        if ("sh" === t[r].ty)
                                                                            if (t[r].ks.k.i) t[r].ks.k.c = t[r].closed;
                                                                            else for (n = t[r].ks.k.length, i = 0; i < n; i += 1) t[r].ks.k[i].s && (t[r].ks.k[i].s[0].c = t[r].closed), t[r].ks.k[i].e && (t[r].ks.k[i].e[0].c = t[r].closed);
                                                                        else "gr" === t[r].ty && e(t[r].it);
                                                                }
                                                                function r(t) {
                                                                    var r,
                                                                        i,
                                                                        n,
                                                                        a,
                                                                        s,
                                                                        o,
                                                                        l = t.length;
                                                                    for (i = 0; i < l; i += 1) {
                                                                        if ((r = t[i]).hasMask) {
                                                                            var h = r.masksProperties;
                                                                            for (a = h.length, n = 0; n < a; n += 1)
                                                                                if (h[n].pt.k.i) h[n].pt.k.c = h[n].cl;
                                                                                else for (o = h[n].pt.k.length, s = 0; s < o; s += 1) h[n].pt.k[s].s && (h[n].pt.k[s].s[0].c = h[n].cl), h[n].pt.k[s].e && (h[n].pt.k[s].e[0].c = h[n].cl);
                                                                        }
                                                                        4 === r.ty && e(r.shapes);
                                                                    }
                                                                }
                                                                return function (e) {
                                                                    if (n(t, e.v) && (r(e.layers), e.assets)) {
                                                                        var i,
                                                                            a = e.assets.length;
                                                                        for (i = 0; i < a; i += 1) e.assets[i].layers && r(e.assets[i].layers);
                                                                    }
                                                                };
                                                            })();
                                                        function p(t) {
                                                            0 === t.t.a.length && t.t.p;
                                                        }
                                                        var u = {
                                                            completeData: function (r) {
                                                                r.__complete ||
                                                                    (h(r),
                                                                    s(r),
                                                                    o(r),
                                                                    l(r),
                                                                    c(r),
                                                                    t(r.layers, r.assets),
                                                                    (function (r, i) {
                                                                        if (r) {
                                                                            var n = 0,
                                                                                a = r.length;
                                                                            for (n = 0; n < a; n += 1) 1 === r[n].t && ((r[n].data.layers = e(r[n].data.refId, i)), t(r[n].data.layers, i));
                                                                        }
                                                                    })(r.chars, r.assets),
                                                                    (r.__complete = !0));
                                                            },
                                                        };
                                                        return (u.checkColors = h), (u.checkChars = o), (u.checkPathProperties = l), (u.checkShapes = c), (u.completeLayers = t), u;
                                                    })()),
                                                a.assetLoader ||
                                                    (a.assetLoader = (function () {
                                                        function t(t) {
                                                            var e = t.getResponseHeader("content-type");
                                                            return (e && "json" === t.responseType && -1 !== e.indexOf("json")) || (t.response && "object" === _typeof$5(t.response))
                                                                ? t.response
                                                                : t.response && "string" == typeof t.response
                                                                ? JSON.parse(t.response)
                                                                : t.responseText
                                                                ? JSON.parse(t.responseText)
                                                                : null;
                                                        }
                                                        return {
                                                            load: function (e, r, i, n) {
                                                                var a,
                                                                    s = new XMLHttpRequest();
                                                                try {
                                                                    s.responseType = "json";
                                                                } catch (t) {}
                                                                s.onreadystatechange = function () {
                                                                    if (4 === s.readyState)
                                                                        if (200 === s.status) (a = t(s)), i(a);
                                                                        else
                                                                            try {
                                                                                (a = t(s)), i(a);
                                                                            } catch (t) {
                                                                                n && n(t);
                                                                            }
                                                                };
                                                                try {
                                                                    s.open(["G", "E", "T"].join(""), e, !0);
                                                                } catch (t) {
                                                                    s.open(["G", "E", "T"].join(""), r + "/" + e, !0);
                                                                }
                                                                s.send();
                                                            },
                                                        };
                                                    })()),
                                                "loadAnimation" === t.data.type)
                                            )
                                                a.assetLoader.load(
                                                    t.data.path,
                                                    t.data.fullPath,
                                                    function (e) {
                                                        a.dataManager.completeData(e), a.postMessage({ id: t.data.id, payload: e, status: "success" });
                                                    },
                                                    function () {
                                                        a.postMessage({ id: t.data.id, status: "error" });
                                                    }
                                                );
                                            else if ("complete" === t.data.type) {
                                                var e = t.data.animation;
                                                a.dataManager.completeData(e), a.postMessage({ id: t.data.id, payload: e, status: "success" });
                                            } else
                                                "loadData" === t.data.type &&
                                                    a.assetLoader.load(
                                                        t.data.path,
                                                        t.data.fullPath,
                                                        function (e) {
                                                            a.postMessage({ id: t.data.id, payload: e, status: "success" });
                                                        },
                                                        function () {
                                                            a.postMessage({ id: t.data.id, status: "error" });
                                                        }
                                                    );
                                        })),
                                        (e.onmessage = function (t) {
                                            var e = t.data,
                                                r = e.id,
                                                n = i[r];
                                            (i[r] = null), "success" === e.status ? n.onComplete(e.payload) : n.onError && n.onError();
                                        }));
                                }
                                function o(t, e) {
                                    var n = "processId_" + (r += 1);
                                    return (i[n] = { onComplete: t, onError: e }), n;
                                }
                                return {
                                    loadAnimation: function (t, r, i) {
                                        s();
                                        var n = o(r, i);
                                        e.postMessage({ type: "loadAnimation", path: t, fullPath: window.location.origin + window.location.pathname, id: n });
                                    },
                                    loadData: function (t, r, i) {
                                        s();
                                        var n = o(r, i);
                                        e.postMessage({ type: "loadData", path: t, fullPath: window.location.origin + window.location.pathname, id: n });
                                    },
                                    completeAnimation: function (t, r, i) {
                                        s();
                                        var n = o(r, i);
                                        e.postMessage({ type: "complete", animation: t, id: n });
                                    },
                                };
                            })(),
                            ImagePreloader = (function () {
                                var t = (function () {
                                    var t = createTag("canvas");
                                    (t.width = 1), (t.height = 1);
                                    var e = t.getContext("2d");
                                    return (e.fillStyle = "rgba(0,0,0,0)"), e.fillRect(0, 0, 1, 1), t;
                                })();
                                function e() {
                                    (this.loadedAssets += 1), this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
                                }
                                function r() {
                                    (this.loadedFootagesCount += 1), this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
                                }
                                function i(t, e, r) {
                                    var i = "";
                                    if (t.e) i = t.p;
                                    else if (e) {
                                        var n = t.p;
                                        -1 !== n.indexOf("images/") && (n = n.split("/")[1]), (i = e + n);
                                    } else (i = r), (i += t.u ? t.u : ""), (i += t.p);
                                    return i;
                                }
                                function n(t) {
                                    var e = 0,
                                        r = setInterval(
                                            function () {
                                                (t.getBBox().width || e > 500) && (this._imageLoaded(), clearInterval(r)), (e += 1);
                                            }.bind(this),
                                            50
                                        );
                                }
                                function a(t) {
                                    var e = { assetData: t },
                                        r = i(t, this.assetsPath, this.path);
                                    return (
                                        dataManager.loadData(
                                            r,
                                            function (t) {
                                                (e.img = t), this._footageLoaded();
                                            }.bind(this),
                                            function () {
                                                (e.img = {}), this._footageLoaded();
                                            }.bind(this)
                                        ),
                                        e
                                    );
                                }
                                function s() {
                                    (this._imageLoaded = e.bind(this)),
                                        (this._footageLoaded = r.bind(this)),
                                        (this.testImageLoaded = n.bind(this)),
                                        (this.createFootageData = a.bind(this)),
                                        (this.assetsPath = ""),
                                        (this.path = ""),
                                        (this.totalImages = 0),
                                        (this.totalFootages = 0),
                                        (this.loadedAssets = 0),
                                        (this.loadedFootagesCount = 0),
                                        (this.imagesLoadedCb = null),
                                        (this.images = []);
                                }
                                return (
                                    (s.prototype = {
                                        loadAssets: function (t, e) {
                                            var r;
                                            this.imagesLoadedCb = e;
                                            var i = t.length;
                                            for (r = 0; r < i; r += 1)
                                                t[r].layers ||
                                                    (t[r].t && "seq" !== t[r].t
                                                        ? 3 === t[r].t && ((this.totalFootages += 1), this.images.push(this.createFootageData(t[r])))
                                                        : ((this.totalImages += 1), this.images.push(this._createImageData(t[r]))));
                                        },
                                        setAssetsPath: function (t) {
                                            this.assetsPath = t || "";
                                        },
                                        setPath: function (t) {
                                            this.path = t || "";
                                        },
                                        loadedImages: function () {
                                            return this.totalImages === this.loadedAssets;
                                        },
                                        loadedFootages: function () {
                                            return this.totalFootages === this.loadedFootagesCount;
                                        },
                                        destroy: function () {
                                            (this.imagesLoadedCb = null), (this.images.length = 0);
                                        },
                                        getAsset: function (t) {
                                            for (var e = 0, r = this.images.length; e < r; ) {
                                                if (this.images[e].assetData === t) return this.images[e].img;
                                                e += 1;
                                            }
                                            return null;
                                        },
                                        createImgData: function (e) {
                                            var r = i(e, this.assetsPath, this.path),
                                                n = createTag("img");
                                            (n.crossOrigin = "anonymous"),
                                                n.addEventListener("load", this._imageLoaded, !1),
                                                n.addEventListener(
                                                    "error",
                                                    function () {
                                                        (a.img = t), this._imageLoaded();
                                                    }.bind(this),
                                                    !1
                                                ),
                                                (n.src = r);
                                            var a = { img: n, assetData: e };
                                            return a;
                                        },
                                        createImageData: function (e) {
                                            var r = i(e, this.assetsPath, this.path),
                                                n = createNS("image");
                                            isSafari ? this.testImageLoaded(n) : n.addEventListener("load", this._imageLoaded, !1),
                                                n.addEventListener(
                                                    "error",
                                                    function () {
                                                        (a.img = t), this._imageLoaded();
                                                    }.bind(this),
                                                    !1
                                                ),
                                                n.setAttributeNS("http://www.w3.org/1999/xlink", "href", r),
                                                this._elementHelper.append ? this._elementHelper.append(n) : this._elementHelper.appendChild(n);
                                            var a = { img: n, assetData: e };
                                            return a;
                                        },
                                        imageLoaded: e,
                                        footageLoaded: r,
                                        setCacheType: function (t, e) {
                                            "svg" === t ? ((this._elementHelper = e), (this._createImageData = this.createImageData.bind(this))) : (this._createImageData = this.createImgData.bind(this));
                                        },
                                    }),
                                    s
                                );
                            })();
                        function BaseEvent() {}
                        BaseEvent.prototype = {
                            triggerEvent: function (t, e) {
                                if (this._cbs[t]) for (var r = this._cbs[t], i = 0; i < r.length; i += 1) r[i](e);
                            },
                            addEventListener: function (t, e) {
                                return (
                                    this._cbs[t] || (this._cbs[t] = []),
                                    this._cbs[t].push(e),
                                    function () {
                                        this.removeEventListener(t, e);
                                    }.bind(this)
                                );
                            },
                            removeEventListener: function (t, e) {
                                if (e) {
                                    if (this._cbs[t]) {
                                        for (var r = 0, i = this._cbs[t].length; r < i; ) this._cbs[t][r] === e && (this._cbs[t].splice(r, 1), (r -= 1), (i -= 1)), (r += 1);
                                        this._cbs[t].length || (this._cbs[t] = null);
                                    }
                                } else this._cbs[t] = null;
                            },
                        };
                        var markerParser = (function () {
                                function t(t) {
                                    for (var e, r = t.split("\r\n"), i = {}, n = 0, a = 0; a < r.length; a += 1) 2 === (e = r[a].split(":")).length && ((i[e[0]] = e[1].trim()), (n += 1));
                                    if (0 === n) throw new Error();
                                    return i;
                                }
                                return function (e) {
                                    for (var r = [], i = 0; i < e.length; i += 1) {
                                        var n = e[i],
                                            a = { time: n.tm, duration: n.dr };
                                        try {
                                            a.payload = JSON.parse(e[i].cm);
                                        } catch (r) {
                                            try {
                                                a.payload = t(e[i].cm);
                                            } catch (t) {
                                                a.payload = { name: e[i].cm };
                                            }
                                        }
                                        r.push(a);
                                    }
                                    return r;
                                };
                            })(),
                            ProjectInterface = (function () {
                                function t(t) {
                                    this.compositions.push(t);
                                }
                                return function () {
                                    function e(t) {
                                        for (var e = 0, r = this.compositions.length; e < r; ) {
                                            if (this.compositions[e].data && this.compositions[e].data.nm === t)
                                                return this.compositions[e].prepareFrame && this.compositions[e].data.xt && this.compositions[e].prepareFrame(this.currentFrame), this.compositions[e].compInterface;
                                            e += 1;
                                        }
                                        return null;
                                    }
                                    return (e.compositions = []), (e.currentFrame = 0), (e.registerComposition = t), e;
                                };
                            })(),
                            renderers = {},
                            registerRenderer = function (t, e) {
                                renderers[t] = e;
                            };
                        function getRenderer(t) {
                            return renderers[t];
                        }
                        function _typeof$4(t) {
                            return (
                                (_typeof$4 =
                                    "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                                        ? function (t) {
                                              return typeof t;
                                          }
                                        : function (t) {
                                              return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                                          }),
                                _typeof$4(t)
                            );
                        }
                        var AnimationItem = function () {
                            (this._cbs = []),
                                (this.name = ""),
                                (this.path = ""),
                                (this.isLoaded = !1),
                                (this.currentFrame = 0),
                                (this.currentRawFrame = 0),
                                (this.firstFrame = 0),
                                (this.totalFrames = 0),
                                (this.frameRate = 0),
                                (this.frameMult = 0),
                                (this.playSpeed = 1),
                                (this.playDirection = 1),
                                (this.playCount = 0),
                                (this.animationData = {}),
                                (this.assets = []),
                                (this.isPaused = !0),
                                (this.autoplay = !1),
                                (this.loop = !0),
                                (this.renderer = null),
                                (this.animationID = createElementID()),
                                (this.assetsPath = ""),
                                (this.timeCompleted = 0),
                                (this.segmentPos = 0),
                                (this.isSubframeEnabled = getSubframeEnabled()),
                                (this.segments = []),
                                (this._idle = !0),
                                (this._completedLoop = !1),
                                (this.projectInterface = ProjectInterface()),
                                (this.imagePreloader = new ImagePreloader()),
                                (this.audioController = audioControllerFactory()),
                                (this.markers = []),
                                (this.configAnimation = this.configAnimation.bind(this)),
                                (this.onSetupError = this.onSetupError.bind(this)),
                                (this.onSegmentComplete = this.onSegmentComplete.bind(this)),
                                (this.drawnFrameEvent = new BMEnterFrameEvent("drawnFrame", 0, 0, 0));
                        };
                        extendPrototype([BaseEvent], AnimationItem),
                            (AnimationItem.prototype.setParams = function (t) {
                                (t.wrapper || t.container) && (this.wrapper = t.wrapper || t.container);
                                var e = "svg";
                                t.animType ? (e = t.animType) : t.renderer && (e = t.renderer);
                                var r = getRenderer(e);
                                (this.renderer = new r(this, t.rendererSettings)),
                                    this.imagePreloader.setCacheType(e, this.renderer.globalData.defs),
                                    this.renderer.setProjectInterface(this.projectInterface),
                                    (this.animType = e),
                                    "" === t.loop || null === t.loop || void 0 === t.loop || !0 === t.loop ? (this.loop = !0) : !1 === t.loop ? (this.loop = !1) : (this.loop = parseInt(t.loop, 10)),
                                    (this.autoplay = !("autoplay" in t) || t.autoplay),
                                    (this.name = t.name ? t.name : ""),
                                    (this.autoloadSegments = !Object.prototype.hasOwnProperty.call(t, "autoloadSegments") || t.autoloadSegments),
                                    (this.assetsPath = t.assetsPath),
                                    (this.initialSegment = t.initialSegment),
                                    t.audioFactory && this.audioController.setAudioFactory(t.audioFactory),
                                    t.animationData
                                        ? this.setupAnimation(t.animationData)
                                        : t.path &&
                                          (-1 !== t.path.lastIndexOf("\\") ? (this.path = t.path.substr(0, t.path.lastIndexOf("\\") + 1)) : (this.path = t.path.substr(0, t.path.lastIndexOf("/") + 1)),
                                          (this.fileName = t.path.substr(t.path.lastIndexOf("/") + 1)),
                                          (this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf(".json"))),
                                          dataManager.loadAnimation(t.path, this.configAnimation, this.onSetupError));
                            }),
                            (AnimationItem.prototype.onSetupError = function () {
                                this.trigger("data_failed");
                            }),
                            (AnimationItem.prototype.setupAnimation = function (t) {
                                dataManager.completeAnimation(t, this.configAnimation);
                            }),
                            (AnimationItem.prototype.setData = function (t, e) {
                                e && "object" !== _typeof$4(e) && (e = JSON.parse(e));
                                var r = { wrapper: t, animationData: e },
                                    i = t.attributes;
                                (r.path = i.getNamedItem("data-animation-path")
                                    ? i.getNamedItem("data-animation-path").value
                                    : i.getNamedItem("data-bm-path")
                                    ? i.getNamedItem("data-bm-path").value
                                    : i.getNamedItem("bm-path")
                                    ? i.getNamedItem("bm-path").value
                                    : ""),
                                    (r.animType = i.getNamedItem("data-anim-type")
                                        ? i.getNamedItem("data-anim-type").value
                                        : i.getNamedItem("data-bm-type")
                                        ? i.getNamedItem("data-bm-type").value
                                        : i.getNamedItem("bm-type")
                                        ? i.getNamedItem("bm-type").value
                                        : i.getNamedItem("data-bm-renderer")
                                        ? i.getNamedItem("data-bm-renderer").value
                                        : i.getNamedItem("bm-renderer")
                                        ? i.getNamedItem("bm-renderer").value
                                        : "canvas");
                                var n = i.getNamedItem("data-anim-loop")
                                    ? i.getNamedItem("data-anim-loop").value
                                    : i.getNamedItem("data-bm-loop")
                                    ? i.getNamedItem("data-bm-loop").value
                                    : i.getNamedItem("bm-loop")
                                    ? i.getNamedItem("bm-loop").value
                                    : "";
                                "false" === n ? (r.loop = !1) : "true" === n ? (r.loop = !0) : "" !== n && (r.loop = parseInt(n, 10));
                                var a = i.getNamedItem("data-anim-autoplay")
                                    ? i.getNamedItem("data-anim-autoplay").value
                                    : i.getNamedItem("data-bm-autoplay")
                                    ? i.getNamedItem("data-bm-autoplay").value
                                    : !i.getNamedItem("bm-autoplay") || i.getNamedItem("bm-autoplay").value;
                                (r.autoplay = "false" !== a),
                                    (r.name = i.getNamedItem("data-name")
                                        ? i.getNamedItem("data-name").value
                                        : i.getNamedItem("data-bm-name")
                                        ? i.getNamedItem("data-bm-name").value
                                        : i.getNamedItem("bm-name")
                                        ? i.getNamedItem("bm-name").value
                                        : ""),
                                    "false" ===
                                        (i.getNamedItem("data-anim-prerender")
                                            ? i.getNamedItem("data-anim-prerender").value
                                            : i.getNamedItem("data-bm-prerender")
                                            ? i.getNamedItem("data-bm-prerender").value
                                            : i.getNamedItem("bm-prerender")
                                            ? i.getNamedItem("bm-prerender").value
                                            : "") && (r.prerender = !1),
                                    this.setParams(r);
                            }),
                            (AnimationItem.prototype.includeLayers = function (t) {
                                t.op > this.animationData.op && ((this.animationData.op = t.op), (this.totalFrames = Math.floor(t.op - this.animationData.ip)));
                                var e,
                                    r,
                                    i = this.animationData.layers,
                                    n = i.length,
                                    a = t.layers,
                                    s = a.length;
                                for (r = 0; r < s; r += 1)
                                    for (e = 0; e < n; ) {
                                        if (i[e].id === a[r].id) {
                                            i[e] = a[r];
                                            break;
                                        }
                                        e += 1;
                                    }
                                if (((t.chars || t.fonts) && (this.renderer.globalData.fontManager.addChars(t.chars), this.renderer.globalData.fontManager.addFonts(t.fonts, this.renderer.globalData.defs)), t.assets))
                                    for (n = t.assets.length, e = 0; e < n; e += 1) this.animationData.assets.push(t.assets[e]);
                                (this.animationData.__complete = !1), dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
                            }),
                            (AnimationItem.prototype.onSegmentComplete = function (t) {
                                this.animationData = t;
                                var e = getExpressionsPlugin();
                                e && e.initExpressions(this), this.loadNextSegment();
                            }),
                            (AnimationItem.prototype.loadNextSegment = function () {
                                var t = this.animationData.segments;
                                if (!t || 0 === t.length || !this.autoloadSegments) return this.trigger("data_ready"), void (this.timeCompleted = this.totalFrames);
                                var e = t.shift();
                                this.timeCompleted = e.time * this.frameRate;
                                var r = this.path + this.fileName + "_" + this.segmentPos + ".json";
                                (this.segmentPos += 1),
                                    dataManager.loadData(
                                        r,
                                        this.includeLayers.bind(this),
                                        function () {
                                            this.trigger("data_failed");
                                        }.bind(this)
                                    );
                            }),
                            (AnimationItem.prototype.loadSegments = function () {
                                this.animationData.segments || (this.timeCompleted = this.totalFrames), this.loadNextSegment();
                            }),
                            (AnimationItem.prototype.imagesLoaded = function () {
                                this.trigger("loaded_images"), this.checkLoaded();
                            }),
                            (AnimationItem.prototype.preloadImages = function () {
                                this.imagePreloader.setAssetsPath(this.assetsPath), this.imagePreloader.setPath(this.path), this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
                            }),
                            (AnimationItem.prototype.configAnimation = function (t) {
                                if (this.renderer)
                                    try {
                                        (this.animationData = t),
                                            this.initialSegment
                                                ? ((this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0])), (this.firstFrame = Math.round(this.initialSegment[0])))
                                                : ((this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip)), (this.firstFrame = Math.round(this.animationData.ip))),
                                            this.renderer.configAnimation(t),
                                            t.assets || (t.assets = []),
                                            (this.assets = this.animationData.assets),
                                            (this.frameRate = this.animationData.fr),
                                            (this.frameMult = this.animationData.fr / 1e3),
                                            this.renderer.searchExtraCompositions(t.assets),
                                            (this.markers = markerParser(t.markers || [])),
                                            this.trigger("config_ready"),
                                            this.preloadImages(),
                                            this.loadSegments(),
                                            this.updaFrameModifier(),
                                            this.waitForFontsLoaded(),
                                            this.isPaused && this.audioController.pause();
                                    } catch (t) {
                                        this.triggerConfigError(t);
                                    }
                            }),
                            (AnimationItem.prototype.waitForFontsLoaded = function () {
                                this.renderer && (this.renderer.globalData.fontManager.isLoaded ? this.checkLoaded() : setTimeout(this.waitForFontsLoaded.bind(this), 20));
                            }),
                            (AnimationItem.prototype.checkLoaded = function () {
                                if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || "canvas" !== this.renderer.rendererType) && this.imagePreloader.loadedFootages()) {
                                    this.isLoaded = !0;
                                    var t = getExpressionsPlugin();
                                    t && t.initExpressions(this),
                                        this.renderer.initItems(),
                                        setTimeout(
                                            function () {
                                                this.trigger("DOMLoaded");
                                            }.bind(this),
                                            0
                                        ),
                                        this.gotoFrame(),
                                        this.autoplay && this.play();
                                }
                            }),
                            (AnimationItem.prototype.resize = function (t, e) {
                                var r = "number" == typeof t ? t : void 0,
                                    i = "number" == typeof e ? e : void 0;
                                this.renderer.updateContainerSize(r, i);
                            }),
                            (AnimationItem.prototype.setSubframe = function (t) {
                                this.isSubframeEnabled = !!t;
                            }),
                            (AnimationItem.prototype.gotoFrame = function () {
                                (this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame),
                                    this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted && (this.currentFrame = this.timeCompleted),
                                    this.trigger("enterFrame"),
                                    this.renderFrame(),
                                    this.trigger("drawnFrame");
                            }),
                            (AnimationItem.prototype.renderFrame = function () {
                                if (!1 !== this.isLoaded && this.renderer)
                                    try {
                                        this.renderer.renderFrame(this.currentFrame + this.firstFrame);
                                    } catch (t) {
                                        this.triggerRenderFrameError(t);
                                    }
                            }),
                            (AnimationItem.prototype.play = function (t) {
                                (t && this.name !== t) || (!0 === this.isPaused && ((this.isPaused = !1), this.trigger("_pause"), this.audioController.resume(), this._idle && ((this._idle = !1), this.trigger("_active"))));
                            }),
                            (AnimationItem.prototype.pause = function (t) {
                                (t && this.name !== t) || (!1 === this.isPaused && ((this.isPaused = !0), this.trigger("_play"), (this._idle = !0), this.trigger("_idle"), this.audioController.pause()));
                            }),
                            (AnimationItem.prototype.togglePause = function (t) {
                                (t && this.name !== t) || (!0 === this.isPaused ? this.play() : this.pause());
                            }),
                            (AnimationItem.prototype.stop = function (t) {
                                (t && this.name !== t) || (this.pause(), (this.playCount = 0), (this._completedLoop = !1), this.setCurrentRawFrameValue(0));
                            }),
                            (AnimationItem.prototype.getMarkerData = function (t) {
                                for (var e, r = 0; r < this.markers.length; r += 1) if ((e = this.markers[r]).payload && e.payload.name === t) return e;
                                return null;
                            }),
                            (AnimationItem.prototype.goToAndStop = function (t, e, r) {
                                if (!r || this.name === r) {
                                    var i = Number(t);
                                    if (isNaN(i)) {
                                        var n = this.getMarkerData(t);
                                        n && this.goToAndStop(n.time, !0);
                                    } else e ? this.setCurrentRawFrameValue(t) : this.setCurrentRawFrameValue(t * this.frameModifier);
                                    this.pause();
                                }
                            }),
                            (AnimationItem.prototype.goToAndPlay = function (t, e, r) {
                                if (!r || this.name === r) {
                                    var i = Number(t);
                                    if (isNaN(i)) {
                                        var n = this.getMarkerData(t);
                                        n && (n.duration ? this.playSegments([n.time, n.time + n.duration], !0) : this.goToAndStop(n.time, !0));
                                    } else this.goToAndStop(i, e, r);
                                    this.play();
                                }
                            }),
                            (AnimationItem.prototype.advanceTime = function (t) {
                                if (!0 !== this.isPaused && !1 !== this.isLoaded) {
                                    var e = this.currentRawFrame + t * this.frameModifier,
                                        r = !1;
                                    e >= this.totalFrames - 1 && this.frameModifier > 0
                                        ? this.loop && this.playCount !== this.loop
                                            ? e >= this.totalFrames
                                                ? ((this.playCount += 1), this.checkSegments(e % this.totalFrames) || (this.setCurrentRawFrameValue(e % this.totalFrames), (this._completedLoop = !0), this.trigger("loopComplete")))
                                                : this.setCurrentRawFrameValue(e)
                                            : this.checkSegments(e > this.totalFrames ? e % this.totalFrames : 0) || ((r = !0), (e = this.totalFrames - 1))
                                        : e < 0
                                        ? this.checkSegments(e % this.totalFrames) ||
                                          (!this.loop || (this.playCount-- <= 0 && !0 !== this.loop)
                                              ? ((r = !0), (e = 0))
                                              : (this.setCurrentRawFrameValue(this.totalFrames + (e % this.totalFrames)), this._completedLoop ? this.trigger("loopComplete") : (this._completedLoop = !0)))
                                        : this.setCurrentRawFrameValue(e),
                                        r && (this.setCurrentRawFrameValue(e), this.pause(), this.trigger("complete"));
                                }
                            }),
                            (AnimationItem.prototype.adjustSegment = function (t, e) {
                                (this.playCount = 0),
                                    t[1] < t[0]
                                        ? (this.frameModifier > 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(-1)),
                                          (this.totalFrames = t[0] - t[1]),
                                          (this.timeCompleted = this.totalFrames),
                                          (this.firstFrame = t[1]),
                                          this.setCurrentRawFrameValue(this.totalFrames - 0.001 - e))
                                        : t[1] > t[0] &&
                                          (this.frameModifier < 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(1)),
                                          (this.totalFrames = t[1] - t[0]),
                                          (this.timeCompleted = this.totalFrames),
                                          (this.firstFrame = t[0]),
                                          this.setCurrentRawFrameValue(0.001 + e)),
                                    this.trigger("segmentStart");
                            }),
                            (AnimationItem.prototype.setSegment = function (t, e) {
                                var r = -1;
                                this.isPaused && (this.currentRawFrame + this.firstFrame < t ? (r = t) : this.currentRawFrame + this.firstFrame > e && (r = e - t)),
                                    (this.firstFrame = t),
                                    (this.totalFrames = e - t),
                                    (this.timeCompleted = this.totalFrames),
                                    -1 !== r && this.goToAndStop(r, !0);
                            }),
                            (AnimationItem.prototype.playSegments = function (t, e) {
                                if ((e && (this.segments.length = 0), "object" === _typeof$4(t[0]))) {
                                    var r,
                                        i = t.length;
                                    for (r = 0; r < i; r += 1) this.segments.push(t[r]);
                                } else this.segments.push(t);
                                this.segments.length && e && this.adjustSegment(this.segments.shift(), 0), this.isPaused && this.play();
                            }),
                            (AnimationItem.prototype.resetSegments = function (t) {
                                (this.segments.length = 0), this.segments.push([this.animationData.ip, this.animationData.op]), t && this.checkSegments(0);
                            }),
                            (AnimationItem.prototype.checkSegments = function (t) {
                                return !!this.segments.length && (this.adjustSegment(this.segments.shift(), t), !0);
                            }),
                            (AnimationItem.prototype.destroy = function (t) {
                                (t && this.name !== t) ||
                                    !this.renderer ||
                                    (this.renderer.destroy(),
                                    this.imagePreloader.destroy(),
                                    this.trigger("destroy"),
                                    (this._cbs = null),
                                    (this.onEnterFrame = null),
                                    (this.onLoopComplete = null),
                                    (this.onComplete = null),
                                    (this.onSegmentStart = null),
                                    (this.onDestroy = null),
                                    (this.renderer = null),
                                    (this.renderer = null),
                                    (this.imagePreloader = null),
                                    (this.projectInterface = null));
                            }),
                            (AnimationItem.prototype.setCurrentRawFrameValue = function (t) {
                                (this.currentRawFrame = t), this.gotoFrame();
                            }),
                            (AnimationItem.prototype.setSpeed = function (t) {
                                (this.playSpeed = t), this.updaFrameModifier();
                            }),
                            (AnimationItem.prototype.setDirection = function (t) {
                                (this.playDirection = t < 0 ? -1 : 1), this.updaFrameModifier();
                            }),
                            (AnimationItem.prototype.setVolume = function (t, e) {
                                (e && this.name !== e) || this.audioController.setVolume(t);
                            }),
                            (AnimationItem.prototype.getVolume = function () {
                                return this.audioController.getVolume();
                            }),
                            (AnimationItem.prototype.mute = function (t) {
                                (t && this.name !== t) || this.audioController.mute();
                            }),
                            (AnimationItem.prototype.unmute = function (t) {
                                (t && this.name !== t) || this.audioController.unmute();
                            }),
                            (AnimationItem.prototype.updaFrameModifier = function () {
                                (this.frameModifier = this.frameMult * this.playSpeed * this.playDirection), this.audioController.setRate(this.playSpeed * this.playDirection);
                            }),
                            (AnimationItem.prototype.getPath = function () {
                                return this.path;
                            }),
                            (AnimationItem.prototype.getAssetsPath = function (t) {
                                var e = "";
                                if (t.e) e = t.p;
                                else if (this.assetsPath) {
                                    var r = t.p;
                                    -1 !== r.indexOf("images/") && (r = r.split("/")[1]), (e = this.assetsPath + r);
                                } else (e = this.path), (e += t.u ? t.u : ""), (e += t.p);
                                return e;
                            }),
                            (AnimationItem.prototype.getAssetData = function (t) {
                                for (var e = 0, r = this.assets.length; e < r; ) {
                                    if (t === this.assets[e].id) return this.assets[e];
                                    e += 1;
                                }
                                return null;
                            }),
                            (AnimationItem.prototype.hide = function () {
                                this.renderer.hide();
                            }),
                            (AnimationItem.prototype.show = function () {
                                this.renderer.show();
                            }),
                            (AnimationItem.prototype.getDuration = function (t) {
                                return t ? this.totalFrames : this.totalFrames / this.frameRate;
                            }),
                            (AnimationItem.prototype.updateDocumentData = function (t, e, r) {
                                try {
                                    this.renderer.getElementByPath(t).updateDocumentData(e, r);
                                } catch (t) {}
                            }),
                            (AnimationItem.prototype.trigger = function (t) {
                                if (this._cbs && this._cbs[t])
                                    switch (t) {
                                        case "enterFrame":
                                            this.triggerEvent(t, new BMEnterFrameEvent(t, this.currentFrame, this.totalFrames, this.frameModifier));
                                            break;
                                        case "drawnFrame":
                                            (this.drawnFrameEvent.currentTime = this.currentFrame),
                                                (this.drawnFrameEvent.totalTime = this.totalFrames),
                                                (this.drawnFrameEvent.direction = this.frameModifier),
                                                this.triggerEvent(t, this.drawnFrameEvent);
                                            break;
                                        case "loopComplete":
                                            this.triggerEvent(t, new BMCompleteLoopEvent(t, this.loop, this.playCount, this.frameMult));
                                            break;
                                        case "complete":
                                            this.triggerEvent(t, new BMCompleteEvent(t, this.frameMult));
                                            break;
                                        case "segmentStart":
                                            this.triggerEvent(t, new BMSegmentStartEvent(t, this.firstFrame, this.totalFrames));
                                            break;
                                        case "destroy":
                                            this.triggerEvent(t, new BMDestroyEvent(t, this));
                                            break;
                                        default:
                                            this.triggerEvent(t);
                                    }
                                "enterFrame" === t && this.onEnterFrame && this.onEnterFrame.call(this, new BMEnterFrameEvent(t, this.currentFrame, this.totalFrames, this.frameMult)),
                                    "loopComplete" === t && this.onLoopComplete && this.onLoopComplete.call(this, new BMCompleteLoopEvent(t, this.loop, this.playCount, this.frameMult)),
                                    "complete" === t && this.onComplete && this.onComplete.call(this, new BMCompleteEvent(t, this.frameMult)),
                                    "segmentStart" === t && this.onSegmentStart && this.onSegmentStart.call(this, new BMSegmentStartEvent(t, this.firstFrame, this.totalFrames)),
                                    "destroy" === t && this.onDestroy && this.onDestroy.call(this, new BMDestroyEvent(t, this));
                            }),
                            (AnimationItem.prototype.triggerRenderFrameError = function (t) {
                                var e = new BMRenderFrameErrorEvent(t, this.currentFrame);
                                this.triggerEvent("error", e), this.onError && this.onError.call(this, e);
                            }),
                            (AnimationItem.prototype.triggerConfigError = function (t) {
                                var e = new BMConfigErrorEvent(t, this.currentFrame);
                                this.triggerEvent("error", e), this.onError && this.onError.call(this, e);
                            });
                        var animationManager = (function () {
                                var t = {},
                                    e = [],
                                    r = 0,
                                    i = 0,
                                    n = 0,
                                    a = !0,
                                    s = !1;
                                function o(t) {
                                    for (var r = 0, n = t.target; r < i; ) e[r].animation === n && (e.splice(r, 1), (r -= 1), (i -= 1), n.isPaused || c()), (r += 1);
                                }
                                function l(t, r) {
                                    if (!t) return null;
                                    for (var n = 0; n < i; ) {
                                        if (e[n].elem === t && null !== e[n].elem) return e[n].animation;
                                        n += 1;
                                    }
                                    var a = new AnimationItem();
                                    return p(a, t), a.setData(t, r), a;
                                }
                                function h() {
                                    (n += 1), d();
                                }
                                function c() {
                                    n -= 1;
                                }
                                function p(t, r) {
                                    t.addEventListener("destroy", o), t.addEventListener("_active", h), t.addEventListener("_idle", c), e.push({ elem: r, animation: t }), (i += 1);
                                }
                                function u(t) {
                                    var o,
                                        l = t - r;
                                    for (o = 0; o < i; o += 1) e[o].animation.advanceTime(l);
                                    (r = t), n && !s ? window.requestAnimationFrame(u) : (a = !0);
                                }
                                function f(t) {
                                    (r = t), window.requestAnimationFrame(u);
                                }
                                function d() {
                                    !s && n && a && (window.requestAnimationFrame(f), (a = !1));
                                }
                                return (
                                    (t.registerAnimation = l),
                                    (t.loadAnimation = function (t) {
                                        var e = new AnimationItem();
                                        return p(e, null), e.setParams(t), e;
                                    }),
                                    (t.setSpeed = function (t, r) {
                                        var n;
                                        for (n = 0; n < i; n += 1) e[n].animation.setSpeed(t, r);
                                    }),
                                    (t.setDirection = function (t, r) {
                                        var n;
                                        for (n = 0; n < i; n += 1) e[n].animation.setDirection(t, r);
                                    }),
                                    (t.play = function (t) {
                                        var r;
                                        for (r = 0; r < i; r += 1) e[r].animation.play(t);
                                    }),
                                    (t.pause = function (t) {
                                        var r;
                                        for (r = 0; r < i; r += 1) e[r].animation.pause(t);
                                    }),
                                    (t.stop = function (t) {
                                        var r;
                                        for (r = 0; r < i; r += 1) e[r].animation.stop(t);
                                    }),
                                    (t.togglePause = function (t) {
                                        var r;
                                        for (r = 0; r < i; r += 1) e[r].animation.togglePause(t);
                                    }),
                                    (t.searchAnimations = function (t, e, r) {
                                        var i,
                                            n = [].concat([].slice.call(document.getElementsByClassName("lottie")), [].slice.call(document.getElementsByClassName("bodymovin"))),
                                            a = n.length;
                                        for (i = 0; i < a; i += 1) r && n[i].setAttribute("data-bm-type", r), l(n[i], t);
                                        if (e && 0 === a) {
                                            r || (r = "svg");
                                            var s = document.getElementsByTagName("body")[0];
                                            s.innerText = "";
                                            var o = createTag("div");
                                            (o.style.width = "100%"), (o.style.height = "100%"), o.setAttribute("data-bm-type", r), s.appendChild(o), l(o, t);
                                        }
                                    }),
                                    (t.resize = function () {
                                        var t;
                                        for (t = 0; t < i; t += 1) e[t].animation.resize();
                                    }),
                                    (t.goToAndStop = function (t, r, n) {
                                        var a;
                                        for (a = 0; a < i; a += 1) e[a].animation.goToAndStop(t, r, n);
                                    }),
                                    (t.destroy = function (t) {
                                        var r;
                                        for (r = i - 1; r >= 0; r -= 1) e[r].animation.destroy(t);
                                    }),
                                    (t.freeze = function () {
                                        s = !0;
                                    }),
                                    (t.unfreeze = function () {
                                        (s = !1), d();
                                    }),
                                    (t.setVolume = function (t, r) {
                                        var n;
                                        for (n = 0; n < i; n += 1) e[n].animation.setVolume(t, r);
                                    }),
                                    (t.mute = function (t) {
                                        var r;
                                        for (r = 0; r < i; r += 1) e[r].animation.mute(t);
                                    }),
                                    (t.unmute = function (t) {
                                        var r;
                                        for (r = 0; r < i; r += 1) e[r].animation.unmute(t);
                                    }),
                                    (t.getRegisteredAnimations = function () {
                                        var t,
                                            r = e.length,
                                            i = [];
                                        for (t = 0; t < r; t += 1) i.push(e[t].animation);
                                        return i;
                                    }),
                                    t
                                );
                            })(),
                            BezierFactory = (function () {
                                var t = {
                                        getBezierEasing: function (t, r, i, n, a) {
                                            var s = a || ("bez_" + t + "_" + r + "_" + i + "_" + n).replace(/\./g, "p");
                                            if (e[s]) return e[s];
                                            var o = new h([t, r, i, n]);
                                            return (e[s] = o), o;
                                        },
                                    },
                                    e = {},
                                    r = 0.1,
                                    i = "function" == typeof Float32Array;
                                function n(t, e) {
                                    return 1 - 3 * e + 3 * t;
                                }
                                function a(t, e) {
                                    return 3 * e - 6 * t;
                                }
                                function s(t) {
                                    return 3 * t;
                                }
                                function o(t, e, r) {
                                    return ((n(e, r) * t + a(e, r)) * t + s(e)) * t;
                                }
                                function l(t, e, r) {
                                    return 3 * n(e, r) * t * t + 2 * a(e, r) * t + s(e);
                                }
                                function h(t) {
                                    (this._p = t), (this._mSampleValues = i ? new Float32Array(11) : new Array(11)), (this._precomputed = !1), (this.get = this.get.bind(this));
                                }
                                return (
                                    (h.prototype = {
                                        get: function (t) {
                                            var e = this._p[0],
                                                r = this._p[1],
                                                i = this._p[2],
                                                n = this._p[3];
                                            return this._precomputed || this._precompute(), e === r && i === n ? t : 0 === t ? 0 : 1 === t ? 1 : o(this._getTForX(t), r, n);
                                        },
                                        _precompute: function () {
                                            var t = this._p[0],
                                                e = this._p[1],
                                                r = this._p[2],
                                                i = this._p[3];
                                            (this._precomputed = !0), (t === e && r === i) || this._calcSampleValues();
                                        },
                                        _calcSampleValues: function () {
                                            for (var t = this._p[0], e = this._p[2], i = 0; i < 11; ++i) this._mSampleValues[i] = o(i * r, t, e);
                                        },
                                        _getTForX: function (t) {
                                            for (var e = this._p[0], i = this._p[2], n = this._mSampleValues, a = 0, s = 1; 10 !== s && n[s] <= t; ++s) a += r;
                                            var h = a + ((t - n[--s]) / (n[s + 1] - n[s])) * r,
                                                c = l(h, e, i);
                                            return c >= 0.001
                                                ? (function (t, e, r, i) {
                                                      for (var n = 0; n < 4; ++n) {
                                                          var a = l(e, r, i);
                                                          if (0 === a) return e;
                                                          e -= (o(e, r, i) - t) / a;
                                                      }
                                                      return e;
                                                  })(t, h, e, i)
                                                : 0 === c
                                                ? h
                                                : (function (t, e, r, i, n) {
                                                      var a,
                                                          s,
                                                          l = 0;
                                                      do {
                                                          (a = o((s = e + (r - e) / 2), i, n) - t) > 0 ? (r = s) : (e = s);
                                                      } while (Math.abs(a) > 1e-7 && ++l < 10);
                                                      return s;
                                                  })(t, a, a + r, e, i);
                                        },
                                    }),
                                    t
                                );
                            })(),
                            pooling = {
                                double: function (t) {
                                    return t.concat(createSizedArray(t.length));
                                },
                            },
                            poolFactory = function (t, e, r) {
                                var i = 0,
                                    n = t,
                                    a = createSizedArray(n);
                                return {
                                    newElement: function () {
                                        return i ? a[(i -= 1)] : e();
                                    },
                                    release: function (t) {
                                        i === n && ((a = pooling.double(a)), (n *= 2)), r && r(t), (a[i] = t), (i += 1);
                                    },
                                };
                            },
                            bezierLengthPool = poolFactory(8, function () {
                                return { addedLength: 0, percents: createTypedArray("float32", getDefaultCurveSegments()), lengths: createTypedArray("float32", getDefaultCurveSegments()) };
                            }),
                            segmentsLengthPool = poolFactory(
                                8,
                                function () {
                                    return { lengths: [], totalLength: 0 };
                                },
                                function (t) {
                                    var e,
                                        r = t.lengths.length;
                                    for (e = 0; e < r; e += 1) bezierLengthPool.release(t.lengths[e]);
                                    t.lengths.length = 0;
                                }
                            );
                        function bezFunction() {
                            var t = Math;
                            function e(t, e, r, i, n, a) {
                                var s = t * i + e * n + r * a - n * i - a * t - r * e;
                                return s > -0.001 && s < 0.001;
                            }
                            var r = function (t, e, r, i) {
                                var n,
                                    a,
                                    s,
                                    o,
                                    l,
                                    h,
                                    c = getDefaultCurveSegments(),
                                    p = 0,
                                    u = [],
                                    f = [],
                                    d = bezierLengthPool.newElement();
                                for (s = r.length, n = 0; n < c; n += 1) {
                                    for (l = n / (c - 1), h = 0, a = 0; a < s; a += 1)
                                        (o = bmPow(1 - l, 3) * t[a] + 3 * bmPow(1 - l, 2) * l * r[a] + 3 * (1 - l) * bmPow(l, 2) * i[a] + bmPow(l, 3) * e[a]), (u[a] = o), null !== f[a] && (h += bmPow(u[a] - f[a], 2)), (f[a] = u[a]);
                                    h && (p += h = bmSqrt(h)), (d.percents[n] = l), (d.lengths[n] = p);
                                }
                                return (d.addedLength = p), d;
                            };
                            function i(t) {
                                (this.segmentLength = 0), (this.points = new Array(t));
                            }
                            function n(t, e) {
                                (this.partialLength = t), (this.point = e);
                            }
                            var a,
                                s =
                                    ((a = {}),
                                    function (t, r, s, o) {
                                        var l = (t[0] + "_" + t[1] + "_" + r[0] + "_" + r[1] + "_" + s[0] + "_" + s[1] + "_" + o[0] + "_" + o[1]).replace(/\./g, "p");
                                        if (!a[l]) {
                                            var h,
                                                c,
                                                p,
                                                u,
                                                f,
                                                d,
                                                m,
                                                y = getDefaultCurveSegments(),
                                                v = 0,
                                                g = null;
                                            2 === t.length && (t[0] !== r[0] || t[1] !== r[1]) && e(t[0], t[1], r[0], r[1], t[0] + s[0], t[1] + s[1]) && e(t[0], t[1], r[0], r[1], r[0] + o[0], r[1] + o[1]) && (y = 2);
                                            var _ = new i(y);
                                            for (p = s.length, h = 0; h < y; h += 1) {
                                                for (m = createSizedArray(p), f = h / (y - 1), d = 0, c = 0; c < p; c += 1)
                                                    (u = bmPow(1 - f, 3) * t[c] + 3 * bmPow(1 - f, 2) * f * (t[c] + s[c]) + 3 * (1 - f) * bmPow(f, 2) * (r[c] + o[c]) + bmPow(f, 3) * r[c]),
                                                        (m[c] = u),
                                                        null !== g && (d += bmPow(m[c] - g[c], 2));
                                                (v += d = bmSqrt(d)), (_.points[h] = new n(d, m)), (g = m);
                                            }
                                            (_.segmentLength = v), (a[l] = _);
                                        }
                                        return a[l];
                                    });
                            function o(t, e) {
                                var r = e.percents,
                                    i = e.lengths,
                                    n = r.length,
                                    a = bmFloor((n - 1) * t),
                                    s = t * e.addedLength,
                                    o = 0;
                                if (a === n - 1 || 0 === a || s === i[a]) return r[a];
                                for (var l = i[a] > s ? -1 : 1, h = !0; h; )
                                    if ((i[a] <= s && i[a + 1] > s ? ((o = (s - i[a]) / (i[a + 1] - i[a])), (h = !1)) : (a += l), a < 0 || a >= n - 1)) {
                                        if (a === n - 1) return r[a];
                                        h = !1;
                                    }
                                return r[a] + (r[a + 1] - r[a]) * o;
                            }
                            var l = createTypedArray("float32", 8);
                            return {
                                getSegmentsLength: function (t) {
                                    var e,
                                        i = segmentsLengthPool.newElement(),
                                        n = t.c,
                                        a = t.v,
                                        s = t.o,
                                        o = t.i,
                                        l = t._length,
                                        h = i.lengths,
                                        c = 0;
                                    for (e = 0; e < l - 1; e += 1) (h[e] = r(a[e], a[e + 1], s[e], o[e + 1])), (c += h[e].addedLength);
                                    return n && l && ((h[e] = r(a[e], a[0], s[e], o[0])), (c += h[e].addedLength)), (i.totalLength = c), i;
                                },
                                getNewSegment: function (e, r, i, n, a, s, h) {
                                    a < 0 ? (a = 0) : a > 1 && (a = 1);
                                    var c,
                                        p = o(a, h),
                                        u = o((s = s > 1 ? 1 : s), h),
                                        f = e.length,
                                        d = 1 - p,
                                        m = 1 - u,
                                        y = d * d * d,
                                        v = p * d * d * 3,
                                        g = p * p * d * 3,
                                        _ = p * p * p,
                                        b = d * d * m,
                                        E = p * d * m + d * p * m + d * d * u,
                                        S = p * p * m + d * p * u + p * d * u,
                                        P = p * p * u,
                                        w = d * m * m,
                                        x = p * m * m + d * u * m + d * m * u,
                                        A = p * u * m + d * u * u + p * m * u,
                                        C = p * u * u,
                                        T = m * m * m,
                                        k = u * m * m + m * u * m + m * m * u,
                                        D = u * u * m + m * u * u + u * m * u,
                                        M = u * u * u;
                                    for (c = 0; c < f; c += 1)
                                        (l[4 * c] = t.round(1e3 * (y * e[c] + v * i[c] + g * n[c] + _ * r[c])) / 1e3),
                                            (l[4 * c + 1] = t.round(1e3 * (b * e[c] + E * i[c] + S * n[c] + P * r[c])) / 1e3),
                                            (l[4 * c + 2] = t.round(1e3 * (w * e[c] + x * i[c] + A * n[c] + C * r[c])) / 1e3),
                                            (l[4 * c + 3] = t.round(1e3 * (T * e[c] + k * i[c] + D * n[c] + M * r[c])) / 1e3);
                                    return l;
                                },
                                getPointInSegment: function (e, r, i, n, a, s) {
                                    var l = o(a, s),
                                        h = 1 - l;
                                    return [
                                        t.round(1e3 * (h * h * h * e[0] + (l * h * h + h * l * h + h * h * l) * i[0] + (l * l * h + h * l * l + l * h * l) * n[0] + l * l * l * r[0])) / 1e3,
                                        t.round(1e3 * (h * h * h * e[1] + (l * h * h + h * l * h + h * h * l) * i[1] + (l * l * h + h * l * l + l * h * l) * n[1] + l * l * l * r[1])) / 1e3,
                                    ];
                                },
                                buildBezierData: s,
                                pointOnLine2D: e,
                                pointOnLine3D: function (r, i, n, a, s, o, l, h, c) {
                                    if (0 === n && 0 === o && 0 === c) return e(r, i, a, s, l, h);
                                    var p,
                                        u = t.sqrt(t.pow(a - r, 2) + t.pow(s - i, 2) + t.pow(o - n, 2)),
                                        f = t.sqrt(t.pow(l - r, 2) + t.pow(h - i, 2) + t.pow(c - n, 2)),
                                        d = t.sqrt(t.pow(l - a, 2) + t.pow(h - s, 2) + t.pow(c - o, 2));
                                    return (p = u > f ? (u > d ? u - f - d : d - f - u) : d > f ? d - f - u : f - u - d) > -1e-4 && p < 1e-4;
                                },
                            };
                        }
                        var bez = bezFunction(),
                            PropertyFactory = (function () {
                                var t = initialDefaultFrame,
                                    e = Math.abs;
                                function r(t, e) {
                                    var r,
                                        n = this.offsetTime;
                                    "multidimensional" === this.propType && (r = createTypedArray("float32", this.pv.length));
                                    for (var a, s, o, l, h, c, p, u, f, d = e.lastIndex, m = d, y = this.keyframes.length - 1, v = !0; v; ) {
                                        if (((a = this.keyframes[m]), (s = this.keyframes[m + 1]), m === y - 1 && t >= s.t - n)) {
                                            a.h && (a = s), (d = 0);
                                            break;
                                        }
                                        if (s.t - n > t) {
                                            d = m;
                                            break;
                                        }
                                        m < y - 1 ? (m += 1) : ((d = 0), (v = !1));
                                    }
                                    o = this.keyframesMetadata[m] || {};
                                    var g,
                                        _,
                                        b,
                                        E,
                                        S,
                                        P,
                                        w,
                                        x,
                                        A,
                                        C,
                                        T = s.t - n,
                                        k = a.t - n;
                                    if (a.to) {
                                        o.bezierData || (o.bezierData = bez.buildBezierData(a.s, s.s || a.e, a.to, a.ti));
                                        var D = o.bezierData;
                                        if (t >= T || t < k) {
                                            var M = t >= T ? D.points.length - 1 : 0;
                                            for (h = D.points[M].point.length, l = 0; l < h; l += 1) r[l] = D.points[M].point[l];
                                        } else {
                                            o.__fnct ? (f = o.__fnct) : ((f = BezierFactory.getBezierEasing(a.o.x, a.o.y, a.i.x, a.i.y, a.n).get), (o.__fnct = f)), (c = f((t - k) / (T - k)));
                                            var I,
                                                F = D.segmentLength * c,
                                                L = e.lastFrame < t && e._lastKeyframeIndex === m ? e._lastAddedLength : 0;
                                            for (u = e.lastFrame < t && e._lastKeyframeIndex === m ? e._lastPoint : 0, v = !0, p = D.points.length; v; ) {
                                                if (((L += D.points[u].partialLength), 0 === F || 0 === c || u === D.points.length - 1)) {
                                                    for (h = D.points[u].point.length, l = 0; l < h; l += 1) r[l] = D.points[u].point[l];
                                                    break;
                                                }
                                                if (F >= L && F < L + D.points[u + 1].partialLength) {
                                                    for (I = (F - L) / D.points[u + 1].partialLength, h = D.points[u].point.length, l = 0; l < h; l += 1) r[l] = D.points[u].point[l] + (D.points[u + 1].point[l] - D.points[u].point[l]) * I;
                                                    break;
                                                }
                                                u < p - 1 ? (u += 1) : (v = !1);
                                            }
                                            (e._lastPoint = u), (e._lastAddedLength = L - D.points[u].partialLength), (e._lastKeyframeIndex = m);
                                        }
                                    } else {
                                        var O, R, B, G, V;
                                        if (((y = a.s.length), (g = s.s || a.e), this.sh && 1 !== a.h))
                                            if (t >= T) (r[0] = g[0]), (r[1] = g[1]), (r[2] = g[2]);
                                            else if (t <= k) (r[0] = a.s[0]), (r[1] = a.s[1]), (r[2] = a.s[2]);
                                            else {
                                                (_ = r),
                                                    (b = (function (t, e, r) {
                                                        var i,
                                                            n,
                                                            a,
                                                            s,
                                                            o,
                                                            l = [],
                                                            h = t[0],
                                                            c = t[1],
                                                            p = t[2],
                                                            u = t[3],
                                                            f = e[0],
                                                            d = e[1],
                                                            m = e[2],
                                                            y = e[3];
                                                        return (
                                                            (n = h * f + c * d + p * m + u * y) < 0 && ((n = -n), (f = -f), (d = -d), (m = -m), (y = -y)),
                                                            1 - n > 1e-6 ? ((i = Math.acos(n)), (a = Math.sin(i)), (s = Math.sin((1 - r) * i) / a), (o = Math.sin(r * i) / a)) : ((s = 1 - r), (o = r)),
                                                            (l[0] = s * h + o * f),
                                                            (l[1] = s * c + o * d),
                                                            (l[2] = s * p + o * m),
                                                            (l[3] = s * u + o * y),
                                                            l
                                                        );
                                                    })(i(a.s), i(g), (t - k) / (T - k))),
                                                    (E = b[0]),
                                                    (S = b[1]),
                                                    (P = b[2]),
                                                    (w = b[3]),
                                                    (x = Math.atan2(2 * S * w - 2 * E * P, 1 - 2 * S * S - 2 * P * P)),
                                                    (A = Math.asin(2 * E * S + 2 * P * w)),
                                                    (C = Math.atan2(2 * E * w - 2 * S * P, 1 - 2 * E * E - 2 * P * P)),
                                                    (_[0] = x / degToRads),
                                                    (_[1] = A / degToRads),
                                                    (_[2] = C / degToRads);
                                            }
                                        else
                                            for (m = 0; m < y; m += 1)
                                                1 !== a.h &&
                                                    (t >= T
                                                        ? (c = 1)
                                                        : t < k
                                                        ? (c = 0)
                                                        : (a.o.x.constructor === Array
                                                              ? (o.__fnct || (o.__fnct = []),
                                                                o.__fnct[m]
                                                                    ? (f = o.__fnct[m])
                                                                    : ((O = void 0 === a.o.x[m] ? a.o.x[0] : a.o.x[m]),
                                                                      (R = void 0 === a.o.y[m] ? a.o.y[0] : a.o.y[m]),
                                                                      (B = void 0 === a.i.x[m] ? a.i.x[0] : a.i.x[m]),
                                                                      (G = void 0 === a.i.y[m] ? a.i.y[0] : a.i.y[m]),
                                                                      (f = BezierFactory.getBezierEasing(O, R, B, G).get),
                                                                      (o.__fnct[m] = f)))
                                                              : o.__fnct
                                                              ? (f = o.__fnct)
                                                              : ((O = a.o.x), (R = a.o.y), (B = a.i.x), (G = a.i.y), (f = BezierFactory.getBezierEasing(O, R, B, G).get), (a.keyframeMetadata = f)),
                                                          (c = f((t - k) / (T - k))))),
                                                    (g = s.s || a.e),
                                                    (V = 1 === a.h ? a.s[m] : a.s[m] + (g[m] - a.s[m]) * c),
                                                    "multidimensional" === this.propType ? (r[m] = V) : (r = V);
                                    }
                                    return (e.lastIndex = d), r;
                                }
                                function i(t) {
                                    var e = t[0] * degToRads,
                                        r = t[1] * degToRads,
                                        i = t[2] * degToRads,
                                        n = Math.cos(e / 2),
                                        a = Math.cos(r / 2),
                                        s = Math.cos(i / 2),
                                        o = Math.sin(e / 2),
                                        l = Math.sin(r / 2),
                                        h = Math.sin(i / 2);
                                    return [o * l * s + n * a * h, o * a * s + n * l * h, n * l * s - o * a * h, n * a * s - o * l * h];
                                }
                                function n() {
                                    var e = this.comp.renderedFrame - this.offsetTime,
                                        r = this.keyframes[0].t - this.offsetTime,
                                        i = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
                                    if (!(e === this._caching.lastFrame || (this._caching.lastFrame !== t && ((this._caching.lastFrame >= i && e >= i) || (this._caching.lastFrame < r && e < r))))) {
                                        this._caching.lastFrame >= e && ((this._caching._lastKeyframeIndex = -1), (this._caching.lastIndex = 0));
                                        var n = this.interpolateValue(e, this._caching);
                                        this.pv = n;
                                    }
                                    return (this._caching.lastFrame = e), this.pv;
                                }
                                function a(t) {
                                    var r;
                                    if ("unidimensional" === this.propType) (r = t * this.mult), e(this.v - r) > 1e-5 && ((this.v = r), (this._mdf = !0));
                                    else for (var i = 0, n = this.v.length; i < n; ) (r = t[i] * this.mult), e(this.v[i] - r) > 1e-5 && ((this.v[i] = r), (this._mdf = !0)), (i += 1);
                                }
                                function s() {
                                    if (this.elem.globalData.frameId !== this.frameId && this.effectsSequence.length)
                                        if (this.lock) this.setVValue(this.pv);
                                        else {
                                            var t;
                                            (this.lock = !0), (this._mdf = this._isFirstFrame);
                                            var e = this.effectsSequence.length,
                                                r = this.kf ? this.pv : this.data.k;
                                            for (t = 0; t < e; t += 1) r = this.effectsSequence[t](r);
                                            this.setVValue(r), (this._isFirstFrame = !1), (this.lock = !1), (this.frameId = this.elem.globalData.frameId);
                                        }
                                }
                                function o(t) {
                                    this.effectsSequence.push(t), this.container.addDynamicProperty(this);
                                }
                                function l(t, e, r, i) {
                                    (this.propType = "unidimensional"),
                                        (this.mult = r || 1),
                                        (this.data = e),
                                        (this.v = r ? e.k * r : e.k),
                                        (this.pv = e.k),
                                        (this._mdf = !1),
                                        (this.elem = t),
                                        (this.container = i),
                                        (this.comp = t.comp),
                                        (this.k = !1),
                                        (this.kf = !1),
                                        (this.vel = 0),
                                        (this.effectsSequence = []),
                                        (this._isFirstFrame = !0),
                                        (this.getValue = s),
                                        (this.setVValue = a),
                                        (this.addEffect = o);
                                }
                                function h(t, e, r, i) {
                                    var n;
                                    (this.propType = "multidimensional"),
                                        (this.mult = r || 1),
                                        (this.data = e),
                                        (this._mdf = !1),
                                        (this.elem = t),
                                        (this.container = i),
                                        (this.comp = t.comp),
                                        (this.k = !1),
                                        (this.kf = !1),
                                        (this.frameId = -1);
                                    var l = e.k.length;
                                    for (this.v = createTypedArray("float32", l), this.pv = createTypedArray("float32", l), this.vel = createTypedArray("float32", l), n = 0; n < l; n += 1)
                                        (this.v[n] = e.k[n] * this.mult), (this.pv[n] = e.k[n]);
                                    (this._isFirstFrame = !0), (this.effectsSequence = []), (this.getValue = s), (this.setVValue = a), (this.addEffect = o);
                                }
                                function c(e, i, l, h) {
                                    (this.propType = "unidimensional"),
                                        (this.keyframes = i.k),
                                        (this.keyframesMetadata = []),
                                        (this.offsetTime = e.data.st),
                                        (this.frameId = -1),
                                        (this._caching = { lastFrame: t, lastIndex: 0, value: 0, _lastKeyframeIndex: -1 }),
                                        (this.k = !0),
                                        (this.kf = !0),
                                        (this.data = i),
                                        (this.mult = l || 1),
                                        (this.elem = e),
                                        (this.container = h),
                                        (this.comp = e.comp),
                                        (this.v = t),
                                        (this.pv = t),
                                        (this._isFirstFrame = !0),
                                        (this.getValue = s),
                                        (this.setVValue = a),
                                        (this.interpolateValue = r),
                                        (this.effectsSequence = [n.bind(this)]),
                                        (this.addEffect = o);
                                }
                                function p(e, i, l, h) {
                                    var c;
                                    this.propType = "multidimensional";
                                    var p,
                                        u,
                                        f,
                                        d,
                                        m = i.k.length;
                                    for (c = 0; c < m - 1; c += 1)
                                        i.k[c].to &&
                                            i.k[c].s &&
                                            i.k[c + 1] &&
                                            i.k[c + 1].s &&
                                            ((p = i.k[c].s),
                                            (u = i.k[c + 1].s),
                                            (f = i.k[c].to),
                                            (d = i.k[c].ti),
                                            ((2 === p.length &&
                                                (p[0] !== u[0] || p[1] !== u[1]) &&
                                                bez.pointOnLine2D(p[0], p[1], u[0], u[1], p[0] + f[0], p[1] + f[1]) &&
                                                bez.pointOnLine2D(p[0], p[1], u[0], u[1], u[0] + d[0], u[1] + d[1])) ||
                                                (3 === p.length &&
                                                    (p[0] !== u[0] || p[1] !== u[1] || p[2] !== u[2]) &&
                                                    bez.pointOnLine3D(p[0], p[1], p[2], u[0], u[1], u[2], p[0] + f[0], p[1] + f[1], p[2] + f[2]) &&
                                                    bez.pointOnLine3D(p[0], p[1], p[2], u[0], u[1], u[2], u[0] + d[0], u[1] + d[1], u[2] + d[2]))) &&
                                                ((i.k[c].to = null), (i.k[c].ti = null)),
                                            p[0] === u[0] &&
                                                p[1] === u[1] &&
                                                0 === f[0] &&
                                                0 === f[1] &&
                                                0 === d[0] &&
                                                0 === d[1] &&
                                                (2 === p.length || (p[2] === u[2] && 0 === f[2] && 0 === d[2])) &&
                                                ((i.k[c].to = null), (i.k[c].ti = null)));
                                    (this.effectsSequence = [n.bind(this)]),
                                        (this.data = i),
                                        (this.keyframes = i.k),
                                        (this.keyframesMetadata = []),
                                        (this.offsetTime = e.data.st),
                                        (this.k = !0),
                                        (this.kf = !0),
                                        (this._isFirstFrame = !0),
                                        (this.mult = l || 1),
                                        (this.elem = e),
                                        (this.container = h),
                                        (this.comp = e.comp),
                                        (this.getValue = s),
                                        (this.setVValue = a),
                                        (this.interpolateValue = r),
                                        (this.frameId = -1);
                                    var y = i.k[0].s.length;
                                    for (this.v = createTypedArray("float32", y), this.pv = createTypedArray("float32", y), c = 0; c < y; c += 1) (this.v[c] = t), (this.pv[c] = t);
                                    (this._caching = { lastFrame: t, lastIndex: 0, value: createTypedArray("float32", y) }), (this.addEffect = o);
                                }
                                var u = {
                                    getProp: function (t, e, r, i, n) {
                                        var a;
                                        if (e.k.length)
                                            if ("number" == typeof e.k[0]) a = new h(t, e, i, n);
                                            else
                                                switch (r) {
                                                    case 0:
                                                        a = new c(t, e, i, n);
                                                        break;
                                                    case 1:
                                                        a = new p(t, e, i, n);
                                                }
                                        else a = new l(t, e, i, n);
                                        return a.effectsSequence.length && n.addDynamicProperty(a), a;
                                    },
                                };
                                return u;
                            })();
                        function DynamicPropertyContainer() {}
                        DynamicPropertyContainer.prototype = {
                            addDynamicProperty: function (t) {
                                -1 === this.dynamicProperties.indexOf(t) && (this.dynamicProperties.push(t), this.container.addDynamicProperty(this), (this._isAnimated = !0));
                            },
                            iterateDynamicProperties: function () {
                                var t;
                                this._mdf = !1;
                                var e = this.dynamicProperties.length;
                                for (t = 0; t < e; t += 1) this.dynamicProperties[t].getValue(), this.dynamicProperties[t]._mdf && (this._mdf = !0);
                            },
                            initDynamicPropertyContainer: function (t) {
                                (this.container = t), (this.dynamicProperties = []), (this._mdf = !1), (this._isAnimated = !1);
                            },
                        };
                        var pointPool = poolFactory(8, function () {
                            return createTypedArray("float32", 2);
                        });
                        function ShapePath() {
                            (this.c = !1), (this._length = 0), (this._maxLength = 8), (this.v = createSizedArray(this._maxLength)), (this.o = createSizedArray(this._maxLength)), (this.i = createSizedArray(this._maxLength));
                        }
                        (ShapePath.prototype.setPathData = function (t, e) {
                            (this.c = t), this.setLength(e);
                            for (var r = 0; r < e; ) (this.v[r] = pointPool.newElement()), (this.o[r] = pointPool.newElement()), (this.i[r] = pointPool.newElement()), (r += 1);
                        }),
                            (ShapePath.prototype.setLength = function (t) {
                                for (; this._maxLength < t; ) this.doubleArrayLength();
                                this._length = t;
                            }),
                            (ShapePath.prototype.doubleArrayLength = function () {
                                (this.v = this.v.concat(createSizedArray(this._maxLength))), (this.i = this.i.concat(createSizedArray(this._maxLength))), (this.o = this.o.concat(createSizedArray(this._maxLength))), (this._maxLength *= 2);
                            }),
                            (ShapePath.prototype.setXYAt = function (t, e, r, i, n) {
                                var a;
                                switch (((this._length = Math.max(this._length, i + 1)), this._length >= this._maxLength && this.doubleArrayLength(), r)) {
                                    case "v":
                                        a = this.v;
                                        break;
                                    case "i":
                                        a = this.i;
                                        break;
                                    case "o":
                                        a = this.o;
                                        break;
                                    default:
                                        a = [];
                                }
                                (!a[i] || (a[i] && !n)) && (a[i] = pointPool.newElement()), (a[i][0] = t), (a[i][1] = e);
                            }),
                            (ShapePath.prototype.setTripleAt = function (t, e, r, i, n, a, s, o) {
                                this.setXYAt(t, e, "v", s, o), this.setXYAt(r, i, "o", s, o), this.setXYAt(n, a, "i", s, o);
                            }),
                            (ShapePath.prototype.reverse = function () {
                                var t = new ShapePath();
                                t.setPathData(this.c, this._length);
                                var e = this.v,
                                    r = this.o,
                                    i = this.i,
                                    n = 0;
                                this.c && (t.setTripleAt(e[0][0], e[0][1], i[0][0], i[0][1], r[0][0], r[0][1], 0, !1), (n = 1));
                                var a,
                                    s = this._length - 1,
                                    o = this._length;
                                for (a = n; a < o; a += 1) t.setTripleAt(e[s][0], e[s][1], i[s][0], i[s][1], r[s][0], r[s][1], a, !1), (s -= 1);
                                return t;
                            }),
                            (ShapePath.prototype.length = function () {
                                return this._length;
                            });
                        var shapePool =
                                ((factory = poolFactory(
                                    4,
                                    function () {
                                        return new ShapePath();
                                    },
                                    function (t) {
                                        var e,
                                            r = t._length;
                                        for (e = 0; e < r; e += 1) pointPool.release(t.v[e]), pointPool.release(t.i[e]), pointPool.release(t.o[e]), (t.v[e] = null), (t.i[e] = null), (t.o[e] = null);
                                        (t._length = 0), (t.c = !1);
                                    }
                                )),
                                (factory.clone = function (t) {
                                    var e,
                                        r = factory.newElement(),
                                        i = void 0 === t._length ? t.v.length : t._length;
                                    for (r.setLength(i), r.c = t.c, e = 0; e < i; e += 1) r.setTripleAt(t.v[e][0], t.v[e][1], t.o[e][0], t.o[e][1], t.i[e][0], t.i[e][1], e);
                                    return r;
                                }),
                                factory),
                            factory;
                        function ShapeCollection() {
                            (this._length = 0), (this._maxLength = 4), (this.shapes = createSizedArray(this._maxLength));
                        }
                        (ShapeCollection.prototype.addShape = function (t) {
                            this._length === this._maxLength && ((this.shapes = this.shapes.concat(createSizedArray(this._maxLength))), (this._maxLength *= 2)), (this.shapes[this._length] = t), (this._length += 1);
                        }),
                            (ShapeCollection.prototype.releaseShapes = function () {
                                var t;
                                for (t = 0; t < this._length; t += 1) shapePool.release(this.shapes[t]);
                                this._length = 0;
                            });
                        var shapeCollectionPool =
                                ((ob = {
                                    newShapeCollection: function () {
                                        return _length ? pool[(_length -= 1)] : new ShapeCollection();
                                    },
                                    release: function (t) {
                                        var e,
                                            r = t._length;
                                        for (e = 0; e < r; e += 1) shapePool.release(t.shapes[e]);
                                        (t._length = 0), _length === _maxLength && ((pool = pooling.double(pool)), (_maxLength *= 2)), (pool[_length] = t), (_length += 1);
                                    },
                                }),
                                (_length = 0),
                                (_maxLength = 4),
                                (pool = createSizedArray(_maxLength)),
                                ob),
                            ob,
                            _length,
                            _maxLength,
                            pool,
                            ShapePropertyFactory = (function () {
                                var t = -999999;
                                function e(t, e, r) {
                                    var i,
                                        n,
                                        a,
                                        s,
                                        o,
                                        l,
                                        h,
                                        c,
                                        p,
                                        u = r.lastIndex,
                                        f = this.keyframes;
                                    if (t < f[0].t - this.offsetTime) (i = f[0].s[0]), (a = !0), (u = 0);
                                    else if (t >= f[f.length - 1].t - this.offsetTime) (i = f[f.length - 1].s ? f[f.length - 1].s[0] : f[f.length - 2].e[0]), (a = !0);
                                    else {
                                        for (var d, m, y, v = u, g = f.length - 1, _ = !0; _ && ((d = f[v]), !((m = f[v + 1]).t - this.offsetTime > t)); ) v < g - 1 ? (v += 1) : (_ = !1);
                                        if (((y = this.keyframesMetadata[v] || {}), (u = v), !(a = 1 === d.h))) {
                                            if (t >= m.t - this.offsetTime) c = 1;
                                            else if (t < d.t - this.offsetTime) c = 0;
                                            else {
                                                var b;
                                                y.__fnct ? (b = y.__fnct) : ((b = BezierFactory.getBezierEasing(d.o.x, d.o.y, d.i.x, d.i.y).get), (y.__fnct = b)),
                                                    (c = b((t - (d.t - this.offsetTime)) / (m.t - this.offsetTime - (d.t - this.offsetTime))));
                                            }
                                            n = m.s ? m.s[0] : d.e[0];
                                        }
                                        i = d.s[0];
                                    }
                                    for (l = e._length, h = i.i[0].length, r.lastIndex = u, s = 0; s < l; s += 1)
                                        for (o = 0; o < h; o += 1)
                                            (p = a ? i.i[s][o] : i.i[s][o] + (n.i[s][o] - i.i[s][o]) * c),
                                                (e.i[s][o] = p),
                                                (p = a ? i.o[s][o] : i.o[s][o] + (n.o[s][o] - i.o[s][o]) * c),
                                                (e.o[s][o] = p),
                                                (p = a ? i.v[s][o] : i.v[s][o] + (n.v[s][o] - i.v[s][o]) * c),
                                                (e.v[s][o] = p);
                                }
                                function r() {
                                    var e = this.comp.renderedFrame - this.offsetTime,
                                        r = this.keyframes[0].t - this.offsetTime,
                                        i = this.keyframes[this.keyframes.length - 1].t - this.offsetTime,
                                        n = this._caching.lastFrame;
                                    return (
                                        (n !== t && ((n < r && e < r) || (n > i && e > i))) || ((this._caching.lastIndex = n < e ? this._caching.lastIndex : 0), this.interpolateShape(e, this.pv, this._caching)),
                                        (this._caching.lastFrame = e),
                                        this.pv
                                    );
                                }
                                function i() {
                                    this.paths = this.localShapeCollection;
                                }
                                function n(t) {
                                    (function (t, e) {
                                        if (t._length !== e._length || t.c !== e.c) return !1;
                                        var r,
                                            i = t._length;
                                        for (r = 0; r < i; r += 1)
                                            if (t.v[r][0] !== e.v[r][0] || t.v[r][1] !== e.v[r][1] || t.o[r][0] !== e.o[r][0] || t.o[r][1] !== e.o[r][1] || t.i[r][0] !== e.i[r][0] || t.i[r][1] !== e.i[r][1]) return !1;
                                        return !0;
                                    })(this.v, t) || ((this.v = shapePool.clone(t)), this.localShapeCollection.releaseShapes(), this.localShapeCollection.addShape(this.v), (this._mdf = !0), (this.paths = this.localShapeCollection));
                                }
                                function a() {
                                    if (this.elem.globalData.frameId !== this.frameId)
                                        if (this.effectsSequence.length)
                                            if (this.lock) this.setVValue(this.pv);
                                            else {
                                                var t, e;
                                                (this.lock = !0), (this._mdf = !1), (t = this.kf ? this.pv : this.data.ks ? this.data.ks.k : this.data.pt.k);
                                                var r = this.effectsSequence.length;
                                                for (e = 0; e < r; e += 1) t = this.effectsSequence[e](t);
                                                this.setVValue(t), (this.lock = !1), (this.frameId = this.elem.globalData.frameId);
                                            }
                                        else this._mdf = !1;
                                }
                                function s(t, e, r) {
                                    (this.propType = "shape"), (this.comp = t.comp), (this.container = t), (this.elem = t), (this.data = e), (this.k = !1), (this.kf = !1), (this._mdf = !1);
                                    var n = 3 === r ? e.pt.k : e.ks.k;
                                    (this.v = shapePool.clone(n)),
                                        (this.pv = shapePool.clone(this.v)),
                                        (this.localShapeCollection = shapeCollectionPool.newShapeCollection()),
                                        (this.paths = this.localShapeCollection),
                                        this.paths.addShape(this.v),
                                        (this.reset = i),
                                        (this.effectsSequence = []);
                                }
                                function o(t) {
                                    this.effectsSequence.push(t), this.container.addDynamicProperty(this);
                                }
                                function l(e, n, a) {
                                    (this.propType = "shape"),
                                        (this.comp = e.comp),
                                        (this.elem = e),
                                        (this.container = e),
                                        (this.offsetTime = e.data.st),
                                        (this.keyframes = 3 === a ? n.pt.k : n.ks.k),
                                        (this.keyframesMetadata = []),
                                        (this.k = !0),
                                        (this.kf = !0);
                                    var s = this.keyframes[0].s[0].i.length;
                                    (this.v = shapePool.newElement()),
                                        this.v.setPathData(this.keyframes[0].s[0].c, s),
                                        (this.pv = shapePool.clone(this.v)),
                                        (this.localShapeCollection = shapeCollectionPool.newShapeCollection()),
                                        (this.paths = this.localShapeCollection),
                                        this.paths.addShape(this.v),
                                        (this.lastFrame = t),
                                        (this.reset = i),
                                        (this._caching = { lastFrame: t, lastIndex: 0 }),
                                        (this.effectsSequence = [r.bind(this)]);
                                }
                                (s.prototype.interpolateShape = e),
                                    (s.prototype.getValue = a),
                                    (s.prototype.setVValue = n),
                                    (s.prototype.addEffect = o),
                                    (l.prototype.getValue = a),
                                    (l.prototype.interpolateShape = e),
                                    (l.prototype.setVValue = n),
                                    (l.prototype.addEffect = o);
                                var h = (function () {
                                        var t = roundCorner;
                                        function e(t, e) {
                                            (this.v = shapePool.newElement()),
                                                this.v.setPathData(!0, 4),
                                                (this.localShapeCollection = shapeCollectionPool.newShapeCollection()),
                                                (this.paths = this.localShapeCollection),
                                                this.localShapeCollection.addShape(this.v),
                                                (this.d = e.d),
                                                (this.elem = t),
                                                (this.comp = t.comp),
                                                (this.frameId = -1),
                                                this.initDynamicPropertyContainer(t),
                                                (this.p = PropertyFactory.getProp(t, e.p, 1, 0, this)),
                                                (this.s = PropertyFactory.getProp(t, e.s, 1, 0, this)),
                                                this.dynamicProperties.length ? (this.k = !0) : ((this.k = !1), this.convertEllToPath());
                                        }
                                        return (
                                            (e.prototype = {
                                                reset: i,
                                                getValue: function () {
                                                    this.elem.globalData.frameId !== this.frameId && ((this.frameId = this.elem.globalData.frameId), this.iterateDynamicProperties(), this._mdf && this.convertEllToPath());
                                                },
                                                convertEllToPath: function () {
                                                    var e = this.p.v[0],
                                                        r = this.p.v[1],
                                                        i = this.s.v[0] / 2,
                                                        n = this.s.v[1] / 2,
                                                        a = 3 !== this.d,
                                                        s = this.v;
                                                    (s.v[0][0] = e),
                                                        (s.v[0][1] = r - n),
                                                        (s.v[1][0] = a ? e + i : e - i),
                                                        (s.v[1][1] = r),
                                                        (s.v[2][0] = e),
                                                        (s.v[2][1] = r + n),
                                                        (s.v[3][0] = a ? e - i : e + i),
                                                        (s.v[3][1] = r),
                                                        (s.i[0][0] = a ? e - i * t : e + i * t),
                                                        (s.i[0][1] = r - n),
                                                        (s.i[1][0] = a ? e + i : e - i),
                                                        (s.i[1][1] = r - n * t),
                                                        (s.i[2][0] = a ? e + i * t : e - i * t),
                                                        (s.i[2][1] = r + n),
                                                        (s.i[3][0] = a ? e - i : e + i),
                                                        (s.i[3][1] = r + n * t),
                                                        (s.o[0][0] = a ? e + i * t : e - i * t),
                                                        (s.o[0][1] = r - n),
                                                        (s.o[1][0] = a ? e + i : e - i),
                                                        (s.o[1][1] = r + n * t),
                                                        (s.o[2][0] = a ? e - i * t : e + i * t),
                                                        (s.o[2][1] = r + n),
                                                        (s.o[3][0] = a ? e - i : e + i),
                                                        (s.o[3][1] = r - n * t);
                                                },
                                            }),
                                            extendPrototype([DynamicPropertyContainer], e),
                                            e
                                        );
                                    })(),
                                    c = (function () {
                                        function t(t, e) {
                                            (this.v = shapePool.newElement()),
                                                this.v.setPathData(!0, 0),
                                                (this.elem = t),
                                                (this.comp = t.comp),
                                                (this.data = e),
                                                (this.frameId = -1),
                                                (this.d = e.d),
                                                this.initDynamicPropertyContainer(t),
                                                1 === e.sy
                                                    ? ((this.ir = PropertyFactory.getProp(t, e.ir, 0, 0, this)), (this.is = PropertyFactory.getProp(t, e.is, 0, 0.01, this)), (this.convertToPath = this.convertStarToPath))
                                                    : (this.convertToPath = this.convertPolygonToPath),
                                                (this.pt = PropertyFactory.getProp(t, e.pt, 0, 0, this)),
                                                (this.p = PropertyFactory.getProp(t, e.p, 1, 0, this)),
                                                (this.r = PropertyFactory.getProp(t, e.r, 0, degToRads, this)),
                                                (this.or = PropertyFactory.getProp(t, e.or, 0, 0, this)),
                                                (this.os = PropertyFactory.getProp(t, e.os, 0, 0.01, this)),
                                                (this.localShapeCollection = shapeCollectionPool.newShapeCollection()),
                                                this.localShapeCollection.addShape(this.v),
                                                (this.paths = this.localShapeCollection),
                                                this.dynamicProperties.length ? (this.k = !0) : ((this.k = !1), this.convertToPath());
                                        }
                                        return (
                                            (t.prototype = {
                                                reset: i,
                                                getValue: function () {
                                                    this.elem.globalData.frameId !== this.frameId && ((this.frameId = this.elem.globalData.frameId), this.iterateDynamicProperties(), this._mdf && this.convertToPath());
                                                },
                                                convertStarToPath: function () {
                                                    var t,
                                                        e,
                                                        r,
                                                        i,
                                                        n = 2 * Math.floor(this.pt.v),
                                                        a = (2 * Math.PI) / n,
                                                        s = !0,
                                                        o = this.or.v,
                                                        l = this.ir.v,
                                                        h = this.os.v,
                                                        c = this.is.v,
                                                        p = (2 * Math.PI * o) / (2 * n),
                                                        u = (2 * Math.PI * l) / (2 * n),
                                                        f = -Math.PI / 2;
                                                    f += this.r.v;
                                                    var d = 3 === this.data.d ? -1 : 1;
                                                    for (this.v._length = 0, t = 0; t < n; t += 1) {
                                                        (r = s ? h : c), (i = s ? p : u);
                                                        var m = (e = s ? o : l) * Math.cos(f),
                                                            y = e * Math.sin(f),
                                                            v = 0 === m && 0 === y ? 0 : y / Math.sqrt(m * m + y * y),
                                                            g = 0 === m && 0 === y ? 0 : -m / Math.sqrt(m * m + y * y);
                                                        (m += +this.p.v[0]), (y += +this.p.v[1]), this.v.setTripleAt(m, y, m - v * i * r * d, y - g * i * r * d, m + v * i * r * d, y + g * i * r * d, t, !0), (s = !s), (f += a * d);
                                                    }
                                                },
                                                convertPolygonToPath: function () {
                                                    var t,
                                                        e = Math.floor(this.pt.v),
                                                        r = (2 * Math.PI) / e,
                                                        i = this.or.v,
                                                        n = this.os.v,
                                                        a = (2 * Math.PI * i) / (4 * e),
                                                        s = 0.5 * -Math.PI,
                                                        o = 3 === this.data.d ? -1 : 1;
                                                    for (s += this.r.v, this.v._length = 0, t = 0; t < e; t += 1) {
                                                        var l = i * Math.cos(s),
                                                            h = i * Math.sin(s),
                                                            c = 0 === l && 0 === h ? 0 : h / Math.sqrt(l * l + h * h),
                                                            p = 0 === l && 0 === h ? 0 : -l / Math.sqrt(l * l + h * h);
                                                        (l += +this.p.v[0]), (h += +this.p.v[1]), this.v.setTripleAt(l, h, l - c * a * n * o, h - p * a * n * o, l + c * a * n * o, h + p * a * n * o, t, !0), (s += r * o);
                                                    }
                                                    (this.paths.length = 0), (this.paths[0] = this.v);
                                                },
                                            }),
                                            extendPrototype([DynamicPropertyContainer], t),
                                            t
                                        );
                                    })(),
                                    p = (function () {
                                        function t(t, e) {
                                            (this.v = shapePool.newElement()),
                                                (this.v.c = !0),
                                                (this.localShapeCollection = shapeCollectionPool.newShapeCollection()),
                                                this.localShapeCollection.addShape(this.v),
                                                (this.paths = this.localShapeCollection),
                                                (this.elem = t),
                                                (this.comp = t.comp),
                                                (this.frameId = -1),
                                                (this.d = e.d),
                                                this.initDynamicPropertyContainer(t),
                                                (this.p = PropertyFactory.getProp(t, e.p, 1, 0, this)),
                                                (this.s = PropertyFactory.getProp(t, e.s, 1, 0, this)),
                                                (this.r = PropertyFactory.getProp(t, e.r, 0, 0, this)),
                                                this.dynamicProperties.length ? (this.k = !0) : ((this.k = !1), this.convertRectToPath());
                                        }
                                        return (
                                            (t.prototype = {
                                                convertRectToPath: function () {
                                                    var t = this.p.v[0],
                                                        e = this.p.v[1],
                                                        r = this.s.v[0] / 2,
                                                        i = this.s.v[1] / 2,
                                                        n = bmMin(r, i, this.r.v),
                                                        a = n * (1 - roundCorner);
                                                    (this.v._length = 0),
                                                        2 === this.d || 1 === this.d
                                                            ? (this.v.setTripleAt(t + r, e - i + n, t + r, e - i + n, t + r, e - i + a, 0, !0),
                                                              this.v.setTripleAt(t + r, e + i - n, t + r, e + i - a, t + r, e + i - n, 1, !0),
                                                              0 !== n
                                                                  ? (this.v.setTripleAt(t + r - n, e + i, t + r - n, e + i, t + r - a, e + i, 2, !0),
                                                                    this.v.setTripleAt(t - r + n, e + i, t - r + a, e + i, t - r + n, e + i, 3, !0),
                                                                    this.v.setTripleAt(t - r, e + i - n, t - r, e + i - n, t - r, e + i - a, 4, !0),
                                                                    this.v.setTripleAt(t - r, e - i + n, t - r, e - i + a, t - r, e - i + n, 5, !0),
                                                                    this.v.setTripleAt(t - r + n, e - i, t - r + n, e - i, t - r + a, e - i, 6, !0),
                                                                    this.v.setTripleAt(t + r - n, e - i, t + r - a, e - i, t + r - n, e - i, 7, !0))
                                                                  : (this.v.setTripleAt(t - r, e + i, t - r + a, e + i, t - r, e + i, 2), this.v.setTripleAt(t - r, e - i, t - r, e - i + a, t - r, e - i, 3)))
                                                            : (this.v.setTripleAt(t + r, e - i + n, t + r, e - i + a, t + r, e - i + n, 0, !0),
                                                              0 !== n
                                                                  ? (this.v.setTripleAt(t + r - n, e - i, t + r - n, e - i, t + r - a, e - i, 1, !0),
                                                                    this.v.setTripleAt(t - r + n, e - i, t - r + a, e - i, t - r + n, e - i, 2, !0),
                                                                    this.v.setTripleAt(t - r, e - i + n, t - r, e - i + n, t - r, e - i + a, 3, !0),
                                                                    this.v.setTripleAt(t - r, e + i - n, t - r, e + i - a, t - r, e + i - n, 4, !0),
                                                                    this.v.setTripleAt(t - r + n, e + i, t - r + n, e + i, t - r + a, e + i, 5, !0),
                                                                    this.v.setTripleAt(t + r - n, e + i, t + r - a, e + i, t + r - n, e + i, 6, !0),
                                                                    this.v.setTripleAt(t + r, e + i - n, t + r, e + i - n, t + r, e + i - a, 7, !0))
                                                                  : (this.v.setTripleAt(t - r, e - i, t - r + a, e - i, t - r, e - i, 1, !0),
                                                                    this.v.setTripleAt(t - r, e + i, t - r, e + i - a, t - r, e + i, 2, !0),
                                                                    this.v.setTripleAt(t + r, e + i, t + r - a, e + i, t + r, e + i, 3, !0)));
                                                },
                                                getValue: function () {
                                                    this.elem.globalData.frameId !== this.frameId && ((this.frameId = this.elem.globalData.frameId), this.iterateDynamicProperties(), this._mdf && this.convertRectToPath());
                                                },
                                                reset: i,
                                            }),
                                            extendPrototype([DynamicPropertyContainer], t),
                                            t
                                        );
                                    })(),
                                    u = {
                                        getShapeProp: function (t, e, r) {
                                            var i;
                                            return (
                                                3 === r || 4 === r ? (i = (3 === r ? e.pt : e.ks).k.length ? new l(t, e, r) : new s(t, e, r)) : 5 === r ? (i = new p(t, e)) : 6 === r ? (i = new h(t, e)) : 7 === r && (i = new c(t, e)),
                                                i.k && t.addDynamicProperty(i),
                                                i
                                            );
                                        },
                                        getConstructorFunction: function () {
                                            return s;
                                        },
                                        getKeyframedConstructorFunction: function () {
                                            return l;
                                        },
                                    };
                                return u;
                            })(),
                            Matrix = (function () {
                                var t = Math.cos,
                                    e = Math.sin,
                                    r = Math.tan,
                                    i = Math.round;
                                function n() {
                                    return (
                                        (this.props[0] = 1),
                                        (this.props[1] = 0),
                                        (this.props[2] = 0),
                                        (this.props[3] = 0),
                                        (this.props[4] = 0),
                                        (this.props[5] = 1),
                                        (this.props[6] = 0),
                                        (this.props[7] = 0),
                                        (this.props[8] = 0),
                                        (this.props[9] = 0),
                                        (this.props[10] = 1),
                                        (this.props[11] = 0),
                                        (this.props[12] = 0),
                                        (this.props[13] = 0),
                                        (this.props[14] = 0),
                                        (this.props[15] = 1),
                                        this
                                    );
                                }
                                function a(r) {
                                    if (0 === r) return this;
                                    var i = t(r),
                                        n = e(r);
                                    return this._t(i, -n, 0, 0, n, i, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
                                }
                                function s(r) {
                                    if (0 === r) return this;
                                    var i = t(r),
                                        n = e(r);
                                    return this._t(1, 0, 0, 0, 0, i, -n, 0, 0, n, i, 0, 0, 0, 0, 1);
                                }
                                function o(r) {
                                    if (0 === r) return this;
                                    var i = t(r),
                                        n = e(r);
                                    return this._t(i, 0, n, 0, 0, 1, 0, 0, -n, 0, i, 0, 0, 0, 0, 1);
                                }
                                function l(r) {
                                    if (0 === r) return this;
                                    var i = t(r),
                                        n = e(r);
                                    return this._t(i, -n, 0, 0, n, i, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
                                }
                                function h(t, e) {
                                    return this._t(1, e, t, 1, 0, 0);
                                }
                                function c(t, e) {
                                    return this.shear(r(t), r(e));
                                }
                                function p(i, n) {
                                    var a = t(n),
                                        s = e(n);
                                    return this._t(a, s, 0, 0, -s, a, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, r(i), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(a, -s, 0, 0, s, a, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
                                }
                                function u(t, e, r) {
                                    return r || 0 === r || (r = 1), 1 === t && 1 === e && 1 === r ? this : this._t(t, 0, 0, 0, 0, e, 0, 0, 0, 0, r, 0, 0, 0, 0, 1);
                                }
                                function f(t, e, r, i, n, a, s, o, l, h, c, p, u, f, d, m) {
                                    return (
                                        (this.props[0] = t),
                                        (this.props[1] = e),
                                        (this.props[2] = r),
                                        (this.props[3] = i),
                                        (this.props[4] = n),
                                        (this.props[5] = a),
                                        (this.props[6] = s),
                                        (this.props[7] = o),
                                        (this.props[8] = l),
                                        (this.props[9] = h),
                                        (this.props[10] = c),
                                        (this.props[11] = p),
                                        (this.props[12] = u),
                                        (this.props[13] = f),
                                        (this.props[14] = d),
                                        (this.props[15] = m),
                                        this
                                    );
                                }
                                function d(t, e, r) {
                                    return (r = r || 0), 0 !== t || 0 !== e || 0 !== r ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, t, e, r, 1) : this;
                                }
                                function m(t, e, r, i, n, a, s, o, l, h, c, p, u, f, d, m) {
                                    var y = this.props;
                                    if (1 === t && 0 === e && 0 === r && 0 === i && 0 === n && 1 === a && 0 === s && 0 === o && 0 === l && 0 === h && 1 === c && 0 === p)
                                        return (y[12] = y[12] * t + y[15] * u), (y[13] = y[13] * a + y[15] * f), (y[14] = y[14] * c + y[15] * d), (y[15] *= m), (this._identityCalculated = !1), this;
                                    var v = y[0],
                                        g = y[1],
                                        _ = y[2],
                                        b = y[3],
                                        E = y[4],
                                        S = y[5],
                                        P = y[6],
                                        w = y[7],
                                        x = y[8],
                                        A = y[9],
                                        C = y[10],
                                        T = y[11],
                                        k = y[12],
                                        D = y[13],
                                        M = y[14],
                                        I = y[15];
                                    return (
                                        (y[0] = v * t + g * n + _ * l + b * u),
                                        (y[1] = v * e + g * a + _ * h + b * f),
                                        (y[2] = v * r + g * s + _ * c + b * d),
                                        (y[3] = v * i + g * o + _ * p + b * m),
                                        (y[4] = E * t + S * n + P * l + w * u),
                                        (y[5] = E * e + S * a + P * h + w * f),
                                        (y[6] = E * r + S * s + P * c + w * d),
                                        (y[7] = E * i + S * o + P * p + w * m),
                                        (y[8] = x * t + A * n + C * l + T * u),
                                        (y[9] = x * e + A * a + C * h + T * f),
                                        (y[10] = x * r + A * s + C * c + T * d),
                                        (y[11] = x * i + A * o + C * p + T * m),
                                        (y[12] = k * t + D * n + M * l + I * u),
                                        (y[13] = k * e + D * a + M * h + I * f),
                                        (y[14] = k * r + D * s + M * c + I * d),
                                        (y[15] = k * i + D * o + M * p + I * m),
                                        (this._identityCalculated = !1),
                                        this
                                    );
                                }
                                function y() {
                                    return (
                                        this._identityCalculated ||
                                            ((this._identity = !(
                                                1 !== this.props[0] ||
                                                0 !== this.props[1] ||
                                                0 !== this.props[2] ||
                                                0 !== this.props[3] ||
                                                0 !== this.props[4] ||
                                                1 !== this.props[5] ||
                                                0 !== this.props[6] ||
                                                0 !== this.props[7] ||
                                                0 !== this.props[8] ||
                                                0 !== this.props[9] ||
                                                1 !== this.props[10] ||
                                                0 !== this.props[11] ||
                                                0 !== this.props[12] ||
                                                0 !== this.props[13] ||
                                                0 !== this.props[14] ||
                                                1 !== this.props[15]
                                            )),
                                            (this._identityCalculated = !0)),
                                        this._identity
                                    );
                                }
                                function v(t) {
                                    for (var e = 0; e < 16; ) {
                                        if (t.props[e] !== this.props[e]) return !1;
                                        e += 1;
                                    }
                                    return !0;
                                }
                                function g(t) {
                                    var e;
                                    for (e = 0; e < 16; e += 1) t.props[e] = this.props[e];
                                    return t;
                                }
                                function _(t) {
                                    var e;
                                    for (e = 0; e < 16; e += 1) this.props[e] = t[e];
                                }
                                function b(t, e, r) {
                                    return {
                                        x: t * this.props[0] + e * this.props[4] + r * this.props[8] + this.props[12],
                                        y: t * this.props[1] + e * this.props[5] + r * this.props[9] + this.props[13],
                                        z: t * this.props[2] + e * this.props[6] + r * this.props[10] + this.props[14],
                                    };
                                }
                                function E(t, e, r) {
                                    return t * this.props[0] + e * this.props[4] + r * this.props[8] + this.props[12];
                                }
                                function S(t, e, r) {
                                    return t * this.props[1] + e * this.props[5] + r * this.props[9] + this.props[13];
                                }
                                function P(t, e, r) {
                                    return t * this.props[2] + e * this.props[6] + r * this.props[10] + this.props[14];
                                }
                                function w() {
                                    var t = this.props[0] * this.props[5] - this.props[1] * this.props[4],
                                        e = this.props[5] / t,
                                        r = -this.props[1] / t,
                                        i = -this.props[4] / t,
                                        n = this.props[0] / t,
                                        a = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / t,
                                        s = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / t,
                                        o = new Matrix();
                                    return (o.props[0] = e), (o.props[1] = r), (o.props[4] = i), (o.props[5] = n), (o.props[12] = a), (o.props[13] = s), o;
                                }
                                function x(t) {
                                    return this.getInverseMatrix().applyToPointArray(t[0], t[1], t[2] || 0);
                                }
                                function A(t) {
                                    var e,
                                        r = t.length,
                                        i = [];
                                    for (e = 0; e < r; e += 1) i[e] = x(t[e]);
                                    return i;
                                }
                                function C(t, e, r) {
                                    var i = createTypedArray("float32", 6);
                                    if (this.isIdentity()) (i[0] = t[0]), (i[1] = t[1]), (i[2] = e[0]), (i[3] = e[1]), (i[4] = r[0]), (i[5] = r[1]);
                                    else {
                                        var n = this.props[0],
                                            a = this.props[1],
                                            s = this.props[4],
                                            o = this.props[5],
                                            l = this.props[12],
                                            h = this.props[13];
                                        (i[0] = t[0] * n + t[1] * s + l),
                                            (i[1] = t[0] * a + t[1] * o + h),
                                            (i[2] = e[0] * n + e[1] * s + l),
                                            (i[3] = e[0] * a + e[1] * o + h),
                                            (i[4] = r[0] * n + r[1] * s + l),
                                            (i[5] = r[0] * a + r[1] * o + h);
                                    }
                                    return i;
                                }
                                function T(t, e, r) {
                                    return this.isIdentity()
                                        ? [t, e, r]
                                        : [
                                              t * this.props[0] + e * this.props[4] + r * this.props[8] + this.props[12],
                                              t * this.props[1] + e * this.props[5] + r * this.props[9] + this.props[13],
                                              t * this.props[2] + e * this.props[6] + r * this.props[10] + this.props[14],
                                          ];
                                }
                                function k(t, e) {
                                    if (this.isIdentity()) return t + "," + e;
                                    var r = this.props;
                                    return Math.round(100 * (t * r[0] + e * r[4] + r[12])) / 100 + "," + Math.round(100 * (t * r[1] + e * r[5] + r[13])) / 100;
                                }
                                function D() {
                                    for (var t = 0, e = this.props, r = "matrix3d("; t < 16; ) (r += i(1e4 * e[t]) / 1e4), (r += 15 === t ? ")" : ","), (t += 1);
                                    return r;
                                }
                                function M(t) {
                                    return (t < 1e-6 && t > 0) || (t > -1e-6 && t < 0) ? i(1e4 * t) / 1e4 : t;
                                }
                                function I() {
                                    var t = this.props;
                                    return "matrix(" + M(t[0]) + "," + M(t[1]) + "," + M(t[4]) + "," + M(t[5]) + "," + M(t[12]) + "," + M(t[13]) + ")";
                                }
                                return function () {
                                    (this.reset = n),
                                        (this.rotate = a),
                                        (this.rotateX = s),
                                        (this.rotateY = o),
                                        (this.rotateZ = l),
                                        (this.skew = c),
                                        (this.skewFromAxis = p),
                                        (this.shear = h),
                                        (this.scale = u),
                                        (this.setTransform = f),
                                        (this.translate = d),
                                        (this.transform = m),
                                        (this.applyToPoint = b),
                                        (this.applyToX = E),
                                        (this.applyToY = S),
                                        (this.applyToZ = P),
                                        (this.applyToPointArray = T),
                                        (this.applyToTriplePoints = C),
                                        (this.applyToPointStringified = k),
                                        (this.toCSS = D),
                                        (this.to2dCSS = I),
                                        (this.clone = g),
                                        (this.cloneFromProps = _),
                                        (this.equals = v),
                                        (this.inversePoints = A),
                                        (this.inversePoint = x),
                                        (this.getInverseMatrix = w),
                                        (this._t = this.transform),
                                        (this.isIdentity = y),
                                        (this._identity = !0),
                                        (this._identityCalculated = !1),
                                        (this.props = createTypedArray("float32", 16)),
                                        this.reset();
                                };
                            })();
                        function _typeof$3(t) {
                            return (
                                (_typeof$3 =
                                    "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                                        ? function (t) {
                                              return typeof t;
                                          }
                                        : function (t) {
                                              return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                                          }),
                                _typeof$3(t)
                            );
                        }
                        var lottie = {},
                            standalone = "__[STANDALONE]__",
                            animationData = "__[ANIMATIONDATA]__",
                            renderer = "";
                        function setLocation(t) {
                            setLocationHref(t);
                        }
                        function searchAnimations() {
                            !0 === standalone ? animationManager.searchAnimations(animationData, standalone, renderer) : animationManager.searchAnimations();
                        }
                        function setSubframeRendering(t) {
                            setSubframeEnabled(t);
                        }
                        function setPrefix(t) {
                            setIdPrefix(t);
                        }
                        function loadAnimation(t) {
                            return !0 === standalone && (t.animationData = JSON.parse(animationData)), animationManager.loadAnimation(t);
                        }
                        function setQuality(t) {
                            if ("string" == typeof t)
                                switch (t) {
                                    case "high":
                                        setDefaultCurveSegments(200);
                                        break;
                                    default:
                                    case "medium":
                                        setDefaultCurveSegments(50);
                                        break;
                                    case "low":
                                        setDefaultCurveSegments(10);
                                }
                            else !isNaN(t) && t > 1 && setDefaultCurveSegments(t);
                            getDefaultCurveSegments() >= 50 ? roundValues(!1) : roundValues(!0);
                        }
                        function inBrowser() {
                            return "undefined" != typeof navigator;
                        }
                        function installPlugin(t, e) {
                            "expressions" === t && setExpressionsPlugin(e);
                        }
                        function getFactory(t) {
                            switch (t) {
                                case "propertyFactory":
                                    return PropertyFactory;
                                case "shapePropertyFactory":
                                    return ShapePropertyFactory;
                                case "matrix":
                                    return Matrix;
                                default:
                                    return null;
                            }
                        }
                        function checkReady() {
                            "complete" === document.readyState && (clearInterval(readyStateCheckInterval), searchAnimations());
                        }
                        function getQueryVariable(t) {
                            for (var e = queryString.split("&"), r = 0; r < e.length; r += 1) {
                                var i = e[r].split("=");
                                if (decodeURIComponent(i[0]) == t) return decodeURIComponent(i[1]);
                            }
                            return null;
                        }
                        (lottie.play = animationManager.play),
                            (lottie.pause = animationManager.pause),
                            (lottie.setLocationHref = setLocation),
                            (lottie.togglePause = animationManager.togglePause),
                            (lottie.setSpeed = animationManager.setSpeed),
                            (lottie.setDirection = animationManager.setDirection),
                            (lottie.stop = animationManager.stop),
                            (lottie.searchAnimations = searchAnimations),
                            (lottie.registerAnimation = animationManager.registerAnimation),
                            (lottie.loadAnimation = loadAnimation),
                            (lottie.setSubframeRendering = setSubframeRendering),
                            (lottie.resize = animationManager.resize),
                            (lottie.goToAndStop = animationManager.goToAndStop),
                            (lottie.destroy = animationManager.destroy),
                            (lottie.setQuality = setQuality),
                            (lottie.inBrowser = inBrowser),
                            (lottie.installPlugin = installPlugin),
                            (lottie.freeze = animationManager.freeze),
                            (lottie.unfreeze = animationManager.unfreeze),
                            (lottie.setVolume = animationManager.setVolume),
                            (lottie.mute = animationManager.mute),
                            (lottie.unmute = animationManager.unmute),
                            (lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations),
                            (lottie.useWebWorker = setWebWorker),
                            (lottie.setIDPrefix = setPrefix),
                            (lottie.__getFactory = getFactory),
                            (lottie.version = "5.10.0");
                        var queryString = "";
                        if (standalone) {
                            var scripts = document.getElementsByTagName("script"),
                                index = scripts.length - 1,
                                myScript = scripts[index] || { src: "" };
                            (queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, "") : ""), (renderer = getQueryVariable("renderer"));
                        }
                        var readyStateCheckInterval = setInterval(checkReady, 100);
                        try {
                            "object" !== _typeof$3(exports) && (window.bodymovin = lottie);
                        } catch (t) {}
                        var ShapeModifiers = (function () {
                            var t = {},
                                e = {};
                            return (
                                (t.registerModifier = function (t, r) {
                                    e[t] || (e[t] = r);
                                }),
                                (t.getModifier = function (t, r, i) {
                                    return new e[t](r, i);
                                }),
                                t
                            );
                        })();
                        function ShapeModifier() {}
                        function TrimModifier() {}
                        function PuckerAndBloatModifier() {}
                        (ShapeModifier.prototype.initModifierProperties = function () {}),
                            (ShapeModifier.prototype.addShapeToModifier = function () {}),
                            (ShapeModifier.prototype.addShape = function (t) {
                                if (!this.closed) {
                                    t.sh.container.addDynamicProperty(t.sh);
                                    var e = { shape: t.sh, data: t, localShapeCollection: shapeCollectionPool.newShapeCollection() };
                                    this.shapes.push(e), this.addShapeToModifier(e), this._isAnimated && t.setAsAnimated();
                                }
                            }),
                            (ShapeModifier.prototype.init = function (t, e) {
                                (this.shapes = []),
                                    (this.elem = t),
                                    this.initDynamicPropertyContainer(t),
                                    this.initModifierProperties(t, e),
                                    (this.frameId = initialDefaultFrame),
                                    (this.closed = !1),
                                    (this.k = !1),
                                    this.dynamicProperties.length ? (this.k = !0) : this.getValue(!0);
                            }),
                            (ShapeModifier.prototype.processKeys = function () {
                                this.elem.globalData.frameId !== this.frameId && ((this.frameId = this.elem.globalData.frameId), this.iterateDynamicProperties());
                            }),
                            extendPrototype([DynamicPropertyContainer], ShapeModifier),
                            extendPrototype([ShapeModifier], TrimModifier),
                            (TrimModifier.prototype.initModifierProperties = function (t, e) {
                                (this.s = PropertyFactory.getProp(t, e.s, 0, 0.01, this)),
                                    (this.e = PropertyFactory.getProp(t, e.e, 0, 0.01, this)),
                                    (this.o = PropertyFactory.getProp(t, e.o, 0, 0, this)),
                                    (this.sValue = 0),
                                    (this.eValue = 0),
                                    (this.getValue = this.processKeys),
                                    (this.m = e.m),
                                    (this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length);
                            }),
                            (TrimModifier.prototype.addShapeToModifier = function (t) {
                                t.pathsData = [];
                            }),
                            (TrimModifier.prototype.calculateShapeEdges = function (t, e, r, i, n) {
                                var a = [];
                                e <= 1 ? a.push({ s: t, e: e }) : t >= 1 ? a.push({ s: t - 1, e: e - 1 }) : (a.push({ s: t, e: 1 }), a.push({ s: 0, e: e - 1 }));
                                var s,
                                    o,
                                    l = [],
                                    h = a.length;
                                for (s = 0; s < h; s += 1) {
                                    var c, p;
                                    (o = a[s]).e * n < i || o.s * n > i + r || ((c = o.s * n <= i ? 0 : (o.s * n - i) / r), (p = o.e * n >= i + r ? 1 : (o.e * n - i) / r), l.push([c, p]));
                                }
                                return l.length || l.push([0, 0]), l;
                            }),
                            (TrimModifier.prototype.releasePathsData = function (t) {
                                var e,
                                    r = t.length;
                                for (e = 0; e < r; e += 1) segmentsLengthPool.release(t[e]);
                                return (t.length = 0), t;
                            }),
                            (TrimModifier.prototype.processShapes = function (t) {
                                var e, r, i, n;
                                if (this._mdf || t) {
                                    var a = (this.o.v % 360) / 360;
                                    if ((a < 0 && (a += 1), (e = this.s.v > 1 ? 1 + a : this.s.v < 0 ? 0 + a : this.s.v + a) > (r = this.e.v > 1 ? 1 + a : this.e.v < 0 ? 0 + a : this.e.v + a))) {
                                        var s = e;
                                        (e = r), (r = s);
                                    }
                                    (e = 1e-4 * Math.round(1e4 * e)), (r = 1e-4 * Math.round(1e4 * r)), (this.sValue = e), (this.eValue = r);
                                } else (e = this.sValue), (r = this.eValue);
                                var o,
                                    l,
                                    h,
                                    c,
                                    p,
                                    u = this.shapes.length,
                                    f = 0;
                                if (r === e)
                                    for (n = 0; n < u; n += 1)
                                        this.shapes[n].localShapeCollection.releaseShapes(),
                                            (this.shapes[n].shape._mdf = !0),
                                            (this.shapes[n].shape.paths = this.shapes[n].localShapeCollection),
                                            this._mdf && (this.shapes[n].pathsData.length = 0);
                                else if ((1 === r && 0 === e) || (0 === r && 1 === e)) {
                                    if (this._mdf) for (n = 0; n < u; n += 1) (this.shapes[n].pathsData.length = 0), (this.shapes[n].shape._mdf = !0);
                                } else {
                                    var d,
                                        m,
                                        y = [];
                                    for (n = 0; n < u; n += 1)
                                        if ((d = this.shapes[n]).shape._mdf || this._mdf || t || 2 === this.m) {
                                            if (((l = (i = d.shape.paths)._length), (p = 0), !d.shape._mdf && d.pathsData.length)) p = d.totalShapeLength;
                                            else {
                                                for (h = this.releasePathsData(d.pathsData), o = 0; o < l; o += 1) (c = bez.getSegmentsLength(i.shapes[o])), h.push(c), (p += c.totalLength);
                                                (d.totalShapeLength = p), (d.pathsData = h);
                                            }
                                            (f += p), (d.shape._mdf = !0);
                                        } else d.shape.paths = d.localShapeCollection;
                                    var v,
                                        g = e,
                                        _ = r,
                                        b = 0;
                                    for (n = u - 1; n >= 0; n -= 1)
                                        if ((d = this.shapes[n]).shape._mdf) {
                                            for (
                                                (m = d.localShapeCollection).releaseShapes(),
                                                    2 === this.m && u > 1 ? ((v = this.calculateShapeEdges(e, r, d.totalShapeLength, b, f)), (b += d.totalShapeLength)) : (v = [[g, _]]),
                                                    l = v.length,
                                                    o = 0;
                                                o < l;
                                                o += 1
                                            ) {
                                                (g = v[o][0]),
                                                    (_ = v[o][1]),
                                                    (y.length = 0),
                                                    _ <= 1
                                                        ? y.push({ s: d.totalShapeLength * g, e: d.totalShapeLength * _ })
                                                        : g >= 1
                                                        ? y.push({ s: d.totalShapeLength * (g - 1), e: d.totalShapeLength * (_ - 1) })
                                                        : (y.push({ s: d.totalShapeLength * g, e: d.totalShapeLength }), y.push({ s: 0, e: d.totalShapeLength * (_ - 1) }));
                                                var E = this.addShapes(d, y[0]);
                                                if (y[0].s !== y[0].e) {
                                                    if (y.length > 1)
                                                        if (d.shape.paths.shapes[d.shape.paths._length - 1].c) {
                                                            var S = E.pop();
                                                            this.addPaths(E, m), (E = this.addShapes(d, y[1], S));
                                                        } else this.addPaths(E, m), (E = this.addShapes(d, y[1]));
                                                    this.addPaths(E, m);
                                                }
                                            }
                                            d.shape.paths = m;
                                        }
                                }
                            }),
                            (TrimModifier.prototype.addPaths = function (t, e) {
                                var r,
                                    i = t.length;
                                for (r = 0; r < i; r += 1) e.addShape(t[r]);
                            }),
                            (TrimModifier.prototype.addSegment = function (t, e, r, i, n, a, s) {
                                n.setXYAt(e[0], e[1], "o", a), n.setXYAt(r[0], r[1], "i", a + 1), s && n.setXYAt(t[0], t[1], "v", a), n.setXYAt(i[0], i[1], "v", a + 1);
                            }),
                            (TrimModifier.prototype.addSegmentFromArray = function (t, e, r, i) {
                                e.setXYAt(t[1], t[5], "o", r), e.setXYAt(t[2], t[6], "i", r + 1), i && e.setXYAt(t[0], t[4], "v", r), e.setXYAt(t[3], t[7], "v", r + 1);
                            }),
                            (TrimModifier.prototype.addShapes = function (t, e, r) {
                                var i,
                                    n,
                                    a,
                                    s,
                                    o,
                                    l,
                                    h,
                                    c,
                                    p = t.pathsData,
                                    u = t.shape.paths.shapes,
                                    f = t.shape.paths._length,
                                    d = 0,
                                    m = [],
                                    y = !0;
                                for (r ? ((o = r._length), (c = r._length)) : ((r = shapePool.newElement()), (o = 0), (c = 0)), m.push(r), i = 0; i < f; i += 1) {
                                    for (l = p[i].lengths, r.c = u[i].c, a = u[i].c ? l.length : l.length + 1, n = 1; n < a; n += 1)
                                        if (d + (s = l[n - 1]).addedLength < e.s) (d += s.addedLength), (r.c = !1);
                                        else {
                                            if (d > e.e) {
                                                r.c = !1;
                                                break;
                                            }
                                            e.s <= d && e.e >= d + s.addedLength
                                                ? (this.addSegment(u[i].v[n - 1], u[i].o[n - 1], u[i].i[n], u[i].v[n], r, o, y), (y = !1))
                                                : ((h = bez.getNewSegment(u[i].v[n - 1], u[i].v[n], u[i].o[n - 1], u[i].i[n], (e.s - d) / s.addedLength, (e.e - d) / s.addedLength, l[n - 1])),
                                                  this.addSegmentFromArray(h, r, o, y),
                                                  (y = !1),
                                                  (r.c = !1)),
                                                (d += s.addedLength),
                                                (o += 1);
                                        }
                                    if (u[i].c && l.length) {
                                        if (((s = l[n - 1]), d <= e.e)) {
                                            var v = l[n - 1].addedLength;
                                            e.s <= d && e.e >= d + v
                                                ? (this.addSegment(u[i].v[n - 1], u[i].o[n - 1], u[i].i[0], u[i].v[0], r, o, y), (y = !1))
                                                : ((h = bez.getNewSegment(u[i].v[n - 1], u[i].v[0], u[i].o[n - 1], u[i].i[0], (e.s - d) / v, (e.e - d) / v, l[n - 1])), this.addSegmentFromArray(h, r, o, y), (y = !1), (r.c = !1));
                                        } else r.c = !1;
                                        (d += s.addedLength), (o += 1);
                                    }
                                    if ((r._length && (r.setXYAt(r.v[c][0], r.v[c][1], "i", c), r.setXYAt(r.v[r._length - 1][0], r.v[r._length - 1][1], "o", r._length - 1)), d > e.e)) break;
                                    i < f - 1 && ((r = shapePool.newElement()), (y = !0), m.push(r), (o = 0));
                                }
                                return m;
                            }),
                            extendPrototype([ShapeModifier], PuckerAndBloatModifier),
                            (PuckerAndBloatModifier.prototype.initModifierProperties = function (t, e) {
                                (this.getValue = this.processKeys), (this.amount = PropertyFactory.getProp(t, e.a, 0, null, this)), (this._isAnimated = !!this.amount.effectsSequence.length);
                            }),
                            (PuckerAndBloatModifier.prototype.processPath = function (t, e) {
                                var r = e / 100,
                                    i = [0, 0],
                                    n = t._length,
                                    a = 0;
                                for (a = 0; a < n; a += 1) (i[0] += t.v[a][0]), (i[1] += t.v[a][1]);
                                (i[0] /= n), (i[1] /= n);
                                var s,
                                    o,
                                    l,
                                    h,
                                    c,
                                    p,
                                    u = shapePool.newElement();
                                for (u.c = t.c, a = 0; a < n; a += 1)
                                    (s = t.v[a][0] + (i[0] - t.v[a][0]) * r),
                                        (o = t.v[a][1] + (i[1] - t.v[a][1]) * r),
                                        (l = t.o[a][0] + (i[0] - t.o[a][0]) * -r),
                                        (h = t.o[a][1] + (i[1] - t.o[a][1]) * -r),
                                        (c = t.i[a][0] + (i[0] - t.i[a][0]) * -r),
                                        (p = t.i[a][1] + (i[1] - t.i[a][1]) * -r),
                                        u.setTripleAt(s, o, l, h, c, p, a);
                                return u;
                            }),
                            (PuckerAndBloatModifier.prototype.processShapes = function (t) {
                                var e,
                                    r,
                                    i,
                                    n,
                                    a,
                                    s,
                                    o = this.shapes.length,
                                    l = this.amount.v;
                                if (0 !== l)
                                    for (r = 0; r < o; r += 1) {
                                        if (((s = (a = this.shapes[r]).localShapeCollection), a.shape._mdf || this._mdf || t))
                                            for (s.releaseShapes(), a.shape._mdf = !0, e = a.shape.paths.shapes, n = a.shape.paths._length, i = 0; i < n; i += 1) s.addShape(this.processPath(e[i], l));
                                        a.shape.paths = a.localShapeCollection;
                                    }
                                this.dynamicProperties.length || (this._mdf = !1);
                            });
                        var TransformPropertyFactory = (function () {
                            var t = [0, 0];
                            function e(t, e, r) {
                                if (
                                    ((this.elem = t),
                                    (this.frameId = -1),
                                    (this.propType = "transform"),
                                    (this.data = e),
                                    (this.v = new Matrix()),
                                    (this.pre = new Matrix()),
                                    (this.appliedTransformations = 0),
                                    this.initDynamicPropertyContainer(r || t),
                                    e.p && e.p.s
                                        ? ((this.px = PropertyFactory.getProp(t, e.p.x, 0, 0, this)), (this.py = PropertyFactory.getProp(t, e.p.y, 0, 0, this)), e.p.z && (this.pz = PropertyFactory.getProp(t, e.p.z, 0, 0, this)))
                                        : (this.p = PropertyFactory.getProp(t, e.p || { k: [0, 0, 0] }, 1, 0, this)),
                                    e.rx)
                                ) {
                                    if (
                                        ((this.rx = PropertyFactory.getProp(t, e.rx, 0, degToRads, this)),
                                        (this.ry = PropertyFactory.getProp(t, e.ry, 0, degToRads, this)),
                                        (this.rz = PropertyFactory.getProp(t, e.rz, 0, degToRads, this)),
                                        e.or.k[0].ti)
                                    ) {
                                        var i,
                                            n = e.or.k.length;
                                        for (i = 0; i < n; i += 1) (e.or.k[i].to = null), (e.or.k[i].ti = null);
                                    }
                                    (this.or = PropertyFactory.getProp(t, e.or, 1, degToRads, this)), (this.or.sh = !0);
                                } else this.r = PropertyFactory.getProp(t, e.r || { k: 0 }, 0, degToRads, this);
                                e.sk && ((this.sk = PropertyFactory.getProp(t, e.sk, 0, degToRads, this)), (this.sa = PropertyFactory.getProp(t, e.sa, 0, degToRads, this))),
                                    (this.a = PropertyFactory.getProp(t, e.a || { k: [0, 0, 0] }, 1, 0, this)),
                                    (this.s = PropertyFactory.getProp(t, e.s || { k: [100, 100, 100] }, 1, 0.01, this)),
                                    e.o ? (this.o = PropertyFactory.getProp(t, e.o, 0, 0.01, t)) : (this.o = { _mdf: !1, v: 1 }),
                                    (this._isDirty = !0),
                                    this.dynamicProperties.length || this.getValue(!0);
                            }
                            return (
                                (e.prototype = {
                                    applyToMatrix: function (t) {
                                        var e = this._mdf;
                                        this.iterateDynamicProperties(),
                                            (this._mdf = this._mdf || e),
                                            this.a && t.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]),
                                            this.s && t.scale(this.s.v[0], this.s.v[1], this.s.v[2]),
                                            this.sk && t.skewFromAxis(-this.sk.v, this.sa.v),
                                            this.r ? t.rotate(-this.r.v) : t.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]),
                                            this.data.p.s ? (this.data.p.z ? t.translate(this.px.v, this.py.v, -this.pz.v) : t.translate(this.px.v, this.py.v, 0)) : t.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
                                    },
                                    getValue: function (e) {
                                        if (this.elem.globalData.frameId !== this.frameId) {
                                            if ((this._isDirty && (this.precalculateMatrix(), (this._isDirty = !1)), this.iterateDynamicProperties(), this._mdf || e)) {
                                                var r;
                                                if (
                                                    (this.v.cloneFromProps(this.pre.props),
                                                    this.appliedTransformations < 1 && this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]),
                                                    this.appliedTransformations < 2 && this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]),
                                                    this.sk && this.appliedTransformations < 3 && this.v.skewFromAxis(-this.sk.v, this.sa.v),
                                                    this.r && this.appliedTransformations < 4
                                                        ? this.v.rotate(-this.r.v)
                                                        : !this.r && this.appliedTransformations < 4 && this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]),
                                                    this.autoOriented)
                                                ) {
                                                    var i, n;
                                                    if (((r = this.elem.globalData.frameRate), this.p && this.p.keyframes && this.p.getValueAtTime))
                                                        this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t
                                                            ? ((i = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / r, 0)), (n = this.p.getValueAtTime(this.p.keyframes[0].t / r, 0)))
                                                            : this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t
                                                            ? ((i = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / r, 0)),
                                                              (n = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / r, 0)))
                                                            : ((i = this.p.pv), (n = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / r, this.p.offsetTime)));
                                                    else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                                                        (i = []), (n = []);
                                                        var a = this.px,
                                                            s = this.py;
                                                        a._caching.lastFrame + a.offsetTime <= a.keyframes[0].t
                                                            ? ((i[0] = a.getValueAtTime((a.keyframes[0].t + 0.01) / r, 0)),
                                                              (i[1] = s.getValueAtTime((s.keyframes[0].t + 0.01) / r, 0)),
                                                              (n[0] = a.getValueAtTime(a.keyframes[0].t / r, 0)),
                                                              (n[1] = s.getValueAtTime(s.keyframes[0].t / r, 0)))
                                                            : a._caching.lastFrame + a.offsetTime >= a.keyframes[a.keyframes.length - 1].t
                                                            ? ((i[0] = a.getValueAtTime(a.keyframes[a.keyframes.length - 1].t / r, 0)),
                                                              (i[1] = s.getValueAtTime(s.keyframes[s.keyframes.length - 1].t / r, 0)),
                                                              (n[0] = a.getValueAtTime((a.keyframes[a.keyframes.length - 1].t - 0.01) / r, 0)),
                                                              (n[1] = s.getValueAtTime((s.keyframes[s.keyframes.length - 1].t - 0.01) / r, 0)))
                                                            : ((i = [a.pv, s.pv]),
                                                              (n[0] = a.getValueAtTime((a._caching.lastFrame + a.offsetTime - 0.01) / r, a.offsetTime)),
                                                              (n[1] = s.getValueAtTime((s._caching.lastFrame + s.offsetTime - 0.01) / r, s.offsetTime)));
                                                    } else i = n = t;
                                                    this.v.rotate(-Math.atan2(i[1] - n[1], i[0] - n[0]));
                                                }
                                                this.data.p && this.data.p.s
                                                    ? this.data.p.z
                                                        ? this.v.translate(this.px.v, this.py.v, -this.pz.v)
                                                        : this.v.translate(this.px.v, this.py.v, 0)
                                                    : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
                                            }
                                            this.frameId = this.elem.globalData.frameId;
                                        }
                                    },
                                    precalculateMatrix: function () {
                                        if (!this.a.k && (this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), (this.appliedTransformations = 1), !this.s.effectsSequence.length)) {
                                            if ((this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]), (this.appliedTransformations = 2), this.sk)) {
                                                if (this.sk.effectsSequence.length || this.sa.effectsSequence.length) return;
                                                this.pre.skewFromAxis(-this.sk.v, this.sa.v), (this.appliedTransformations = 3);
                                            }
                                            this.r
                                                ? this.r.effectsSequence.length || (this.pre.rotate(-this.r.v), (this.appliedTransformations = 4))
                                                : this.rz.effectsSequence.length ||
                                                  this.ry.effectsSequence.length ||
                                                  this.rx.effectsSequence.length ||
                                                  this.or.effectsSequence.length ||
                                                  (this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), (this.appliedTransformations = 4));
                                        }
                                    },
                                    autoOrient: function () {},
                                }),
                                extendPrototype([DynamicPropertyContainer], e),
                                (e.prototype.addDynamicProperty = function (t) {
                                    this._addDynamicProperty(t), this.elem.addDynamicProperty(t), (this._isDirty = !0);
                                }),
                                (e.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty),
                                {
                                    getTransformProperty: function (t, r, i) {
                                        return new e(t, r, i);
                                    },
                                }
                            );
                        })();
                        function RepeaterModifier() {}
                        function RoundCornersModifier() {}
                        function floatEqual(t, e) {
                            return 1e5 * Math.abs(t - e) <= Math.min(Math.abs(t), Math.abs(e));
                        }
                        function floatZero(t) {
                            return Math.abs(t) <= 1e-5;
                        }
                        function lerp(t, e, r) {
                            return t * (1 - r) + e * r;
                        }
                        function lerpPoint(t, e, r) {
                            return [lerp(t[0], e[0], r), lerp(t[1], e[1], r)];
                        }
                        function quadRoots(t, e, r) {
                            if (0 === t) return [];
                            var i = e * e - 4 * t * r;
                            if (i < 0) return [];
                            var n = -e / (2 * t);
                            if (0 === i) return [n];
                            var a = Math.sqrt(i) / (2 * t);
                            return [n - a, n + a];
                        }
                        function polynomialCoefficients(t, e, r, i) {
                            return [3 * e - t - 3 * r + i, 3 * t - 6 * e + 3 * r, -3 * t + 3 * e, t];
                        }
                        function singlePoint(t) {
                            return new PolynomialBezier(t, t, t, t, !1);
                        }
                        function PolynomialBezier(t, e, r, i, n) {
                            n && pointEqual(t, e) && (e = lerpPoint(t, i, 1 / 3)), n && pointEqual(r, i) && (r = lerpPoint(t, i, 2 / 3));
                            var a = polynomialCoefficients(t[0], e[0], r[0], i[0]),
                                s = polynomialCoefficients(t[1], e[1], r[1], i[1]);
                            (this.a = [a[0], s[0]]), (this.b = [a[1], s[1]]), (this.c = [a[2], s[2]]), (this.d = [a[3], s[3]]), (this.points = [t, e, r, i]);
                        }
                        function extrema(t, e) {
                            var r = t.points[0][e],
                                i = t.points[t.points.length - 1][e];
                            if (r > i) {
                                var n = i;
                                (i = r), (r = n);
                            }
                            for (var a = quadRoots(3 * t.a[e], 2 * t.b[e], t.c[e]), s = 0; s < a.length; s += 1)
                                if (a[s] > 0 && a[s] < 1) {
                                    var o = t.point(a[s])[e];
                                    o < r ? (r = o) : o > i && (i = o);
                                }
                            return { min: r, max: i };
                        }
                        function intersectData(t, e, r) {
                            var i = t.boundingBox();
                            return { cx: i.cx, cy: i.cy, width: i.width, height: i.height, bez: t, t: (e + r) / 2, t1: e, t2: r };
                        }
                        function splitData(t) {
                            var e = t.bez.split(0.5);
                            return [intersectData(e[0], t.t1, t.t), intersectData(e[1], t.t, t.t2)];
                        }
                        function boxIntersect(t, e) {
                            return 2 * Math.abs(t.cx - e.cx) < t.width + e.width && 2 * Math.abs(t.cy - e.cy) < t.height + e.height;
                        }
                        function intersectsImpl(t, e, r, i, n, a) {
                            if (boxIntersect(t, e))
                                if (r >= a || (t.width <= i && t.height <= i && e.width <= i && e.height <= i)) n.push([t.t, e.t]);
                                else {
                                    var s = splitData(t),
                                        o = splitData(e);
                                    intersectsImpl(s[0], o[0], r + 1, i, n, a), intersectsImpl(s[0], o[1], r + 1, i, n, a), intersectsImpl(s[1], o[0], r + 1, i, n, a), intersectsImpl(s[1], o[1], r + 1, i, n, a);
                                }
                        }
                        function crossProduct(t, e) {
                            return [t[1] * e[2] - t[2] * e[1], t[2] * e[0] - t[0] * e[2], t[0] * e[1] - t[1] * e[0]];
                        }
                        function lineIntersection(t, e, r, i) {
                            var n = [t[0], t[1], 1],
                                a = [e[0], e[1], 1],
                                s = [r[0], r[1], 1],
                                o = [i[0], i[1], 1],
                                l = crossProduct(crossProduct(n, a), crossProduct(s, o));
                            return floatZero(l[2]) ? null : [l[0] / l[2], l[1] / l[2]];
                        }
                        function polarOffset(t, e, r) {
                            return [t[0] + Math.cos(e) * r, t[1] - Math.sin(e) * r];
                        }
                        function pointDistance(t, e) {
                            return Math.hypot(t[0] - e[0], t[1] - e[1]);
                        }
                        function pointEqual(t, e) {
                            return floatEqual(t[0], e[0]) && floatEqual(t[1], e[1]);
                        }
                        function ZigZagModifier() {}
                        function setPoint(t, e, r, i, n, a, s) {
                            var o = r - Math.PI / 2,
                                l = r + Math.PI / 2,
                                h = e[0] + Math.cos(r) * i * n,
                                c = e[1] - Math.sin(r) * i * n;
                            t.setTripleAt(h, c, h + Math.cos(o) * a, c - Math.sin(o) * a, h + Math.cos(l) * s, c - Math.sin(l) * s, t.length());
                        }
                        function getPerpendicularVector(t, e) {
                            var r = [e[0] - t[0], e[1] - t[1]],
                                i = 0.5 * -Math.PI;
                            return [Math.cos(i) * r[0] - Math.sin(i) * r[1], Math.sin(i) * r[0] + Math.cos(i) * r[1]];
                        }
                        function getProjectingAngle(t, e) {
                            var r = 0 === e ? t.length() - 1 : e - 1,
                                i = (e + 1) % t.length(),
                                n = getPerpendicularVector(t.v[r], t.v[i]);
                            return Math.atan2(0, 1) - Math.atan2(n[1], n[0]);
                        }
                        function zigZagCorner(t, e, r, i, n, a, s) {
                            var o = getProjectingAngle(e, r),
                                l = e.v[r % e._length],
                                h = e.v[0 === r ? e._length - 1 : r - 1],
                                c = e.v[(r + 1) % e._length],
                                p = 2 === a ? Math.sqrt(Math.pow(l[0] - h[0], 2) + Math.pow(l[1] - h[1], 2)) : 0,
                                u = 2 === a ? Math.sqrt(Math.pow(l[0] - c[0], 2) + Math.pow(l[1] - c[1], 2)) : 0;
                            setPoint(t, e.v[r % e._length], o, s, i, u / (2 * (n + 1)), p / (2 * (n + 1)), a);
                        }
                        function zigZagSegment(t, e, r, i, n, a) {
                            for (var s = 0; s < i; s += 1) {
                                var o = (s + 1) / (i + 1),
                                    l = 2 === n ? Math.sqrt(Math.pow(e.points[3][0] - e.points[0][0], 2) + Math.pow(e.points[3][1] - e.points[0][1], 2)) : 0,
                                    h = e.normalAngle(o);
                                setPoint(t, e.point(o), h, a, r, l / (2 * (i + 1)), l / (2 * (i + 1)), n), (a = -a);
                            }
                            return a;
                        }
                        function linearOffset(t, e, r) {
                            var i = Math.atan2(e[0] - t[0], e[1] - t[1]);
                            return [polarOffset(t, i, r), polarOffset(e, i, r)];
                        }
                        function offsetSegment(t, e) {
                            var r, i, n, a, s, o, l;
                            (r = (l = linearOffset(t.points[0], t.points[1], e))[0]), (i = l[1]), (n = (l = linearOffset(t.points[1], t.points[2], e))[0]), (a = l[1]), (s = (l = linearOffset(t.points[2], t.points[3], e))[0]), (o = l[1]);
                            var h = lineIntersection(r, i, n, a);
                            null === h && (h = i);
                            var c = lineIntersection(s, o, n, a);
                            return null === c && (c = s), new PolynomialBezier(r, h, c, o);
                        }
                        function joinLines(t, e, r, i, n) {
                            var a = e.points[3],
                                s = r.points[0];
                            if (3 === i) return a;
                            if (pointEqual(a, s)) return a;
                            if (2 === i) {
                                var o = -e.tangentAngle(1),
                                    l = -r.tangentAngle(0) + Math.PI,
                                    h = lineIntersection(a, polarOffset(a, o + Math.PI / 2, 100), s, polarOffset(s, o + Math.PI / 2, 100)),
                                    c = h ? pointDistance(h, a) : pointDistance(a, s) / 2,
                                    p = polarOffset(a, o, 2 * c * roundCorner);
                                return t.setXYAt(p[0], p[1], "o", t.length() - 1), (p = polarOffset(s, l, 2 * c * roundCorner)), t.setTripleAt(s[0], s[1], s[0], s[1], p[0], p[1], t.length()), s;
                            }
                            var u = lineIntersection(pointEqual(a, e.points[2]) ? e.points[0] : e.points[2], a, s, pointEqual(s, r.points[1]) ? r.points[3] : r.points[1]);
                            return u && pointDistance(u, a) < n ? (t.setTripleAt(u[0], u[1], u[0], u[1], u[0], u[1], t.length()), u) : a;
                        }
                        function getIntersection(t, e) {
                            var r = t.intersections(e);
                            return r.length && floatEqual(r[0][0], 1) && r.shift(), r.length ? r[0] : null;
                        }
                        function pruneSegmentIntersection(t, e) {
                            var r = t.slice(),
                                i = e.slice(),
                                n = getIntersection(t[t.length - 1], e[0]);
                            return (
                                n && ((r[t.length - 1] = t[t.length - 1].split(n[0])[0]), (i[0] = e[0].split(n[1])[1])),
                                t.length > 1 && e.length > 1 && (n = getIntersection(t[0], e[e.length - 1])) ? [[t[0].split(n[0])[0]], [e[e.length - 1].split(n[1])[1]]] : [r, i]
                            );
                        }
                        function pruneIntersections(t) {
                            for (var e, r = 1; r < t.length; r += 1) (e = pruneSegmentIntersection(t[r - 1], t[r])), (t[r - 1] = e[0]), (t[r] = e[1]);
                            return t.length > 1 && ((e = pruneSegmentIntersection(t[t.length - 1], t[0])), (t[t.length - 1] = e[0]), (t[0] = e[1])), t;
                        }
                        function offsetSegmentSplit(t, e) {
                            var r,
                                i,
                                n,
                                a,
                                s = t.inflectionPoints();
                            if (0 === s.length) return [offsetSegment(t, e)];
                            if (1 === s.length || floatEqual(s[1], 1)) return (r = (n = t.split(s[0]))[0]), (i = n[1]), [offsetSegment(r, e), offsetSegment(i, e)];
                            r = (n = t.split(s[0]))[0];
                            var o = (s[1] - s[0]) / (1 - s[0]);
                            return (a = (n = n[1].split(o))[0]), (i = n[1]), [offsetSegment(r, e), offsetSegment(a, e), offsetSegment(i, e)];
                        }
                        function OffsetPathModifier() {}
                        function getFontProperties(t) {
                            for (var e = t.fStyle ? t.fStyle.split(" ") : [], r = "normal", i = "normal", n = e.length, a = 0; a < n; a += 1)
                                switch (e[a].toLowerCase()) {
                                    case "italic":
                                        i = "italic";
                                        break;
                                    case "bold":
                                        r = "700";
                                        break;
                                    case "black":
                                        r = "900";
                                        break;
                                    case "medium":
                                        r = "500";
                                        break;
                                    case "regular":
                                    case "normal":
                                        r = "400";
                                        break;
                                    case "light":
                                    case "thin":
                                        r = "200";
                                }
                            return { style: i, weight: t.fWeight || r };
                        }
                        extendPrototype([ShapeModifier], RepeaterModifier),
                            (RepeaterModifier.prototype.initModifierProperties = function (t, e) {
                                (this.getValue = this.processKeys),
                                    (this.c = PropertyFactory.getProp(t, e.c, 0, null, this)),
                                    (this.o = PropertyFactory.getProp(t, e.o, 0, null, this)),
                                    (this.tr = TransformPropertyFactory.getTransformProperty(t, e.tr, this)),
                                    (this.so = PropertyFactory.getProp(t, e.tr.so, 0, 0.01, this)),
                                    (this.eo = PropertyFactory.getProp(t, e.tr.eo, 0, 0.01, this)),
                                    (this.data = e),
                                    this.dynamicProperties.length || this.getValue(!0),
                                    (this._isAnimated = !!this.dynamicProperties.length),
                                    (this.pMatrix = new Matrix()),
                                    (this.rMatrix = new Matrix()),
                                    (this.sMatrix = new Matrix()),
                                    (this.tMatrix = new Matrix()),
                                    (this.matrix = new Matrix());
                            }),
                            (RepeaterModifier.prototype.applyTransforms = function (t, e, r, i, n, a) {
                                var s = a ? -1 : 1,
                                    o = i.s.v[0] + (1 - i.s.v[0]) * (1 - n),
                                    l = i.s.v[1] + (1 - i.s.v[1]) * (1 - n);
                                t.translate(i.p.v[0] * s * n, i.p.v[1] * s * n, i.p.v[2]),
                                    e.translate(-i.a.v[0], -i.a.v[1], i.a.v[2]),
                                    e.rotate(-i.r.v * s * n),
                                    e.translate(i.a.v[0], i.a.v[1], i.a.v[2]),
                                    r.translate(-i.a.v[0], -i.a.v[1], i.a.v[2]),
                                    r.scale(a ? 1 / o : o, a ? 1 / l : l),
                                    r.translate(i.a.v[0], i.a.v[1], i.a.v[2]);
                            }),
                            (RepeaterModifier.prototype.init = function (t, e, r, i) {
                                for (
                                    this.elem = t,
                                        this.arr = e,
                                        this.pos = r,
                                        this.elemsData = i,
                                        this._currentCopies = 0,
                                        this._elements = [],
                                        this._groups = [],
                                        this.frameId = -1,
                                        this.initDynamicPropertyContainer(t),
                                        this.initModifierProperties(t, e[r]);
                                    r > 0;

                                )
                                    (r -= 1), this._elements.unshift(e[r]);
                                this.dynamicProperties.length ? (this.k = !0) : this.getValue(!0);
                            }),
                            (RepeaterModifier.prototype.resetElements = function (t) {
                                var e,
                                    r = t.length;
                                for (e = 0; e < r; e += 1) (t[e]._processed = !1), "gr" === t[e].ty && this.resetElements(t[e].it);
                            }),
                            (RepeaterModifier.prototype.cloneElements = function (t) {
                                var e = JSON.parse(JSON.stringify(t));
                                return this.resetElements(e), e;
                            }),
                            (RepeaterModifier.prototype.changeGroupRender = function (t, e) {
                                var r,
                                    i = t.length;
                                for (r = 0; r < i; r += 1) (t[r]._render = e), "gr" === t[r].ty && this.changeGroupRender(t[r].it, e);
                            }),
                            (RepeaterModifier.prototype.processShapes = function (t) {
                                var e,
                                    r,
                                    i,
                                    n,
                                    a,
                                    s = !1;
                                if (this._mdf || t) {
                                    var o,
                                        l = Math.ceil(this.c.v);
                                    if (this._groups.length < l) {
                                        for (; this._groups.length < l; ) {
                                            var h = { it: this.cloneElements(this._elements), ty: "gr" };
                                            h.it.push({
                                                a: { a: 0, ix: 1, k: [0, 0] },
                                                nm: "Transform",
                                                o: { a: 0, ix: 7, k: 100 },
                                                p: { a: 0, ix: 2, k: [0, 0] },
                                                r: {
                                                    a: 1,
                                                    ix: 6,
                                                    k: [
                                                        { s: 0, e: 0, t: 0 },
                                                        { s: 0, e: 0, t: 1 },
                                                    ],
                                                },
                                                s: { a: 0, ix: 3, k: [100, 100] },
                                                sa: { a: 0, ix: 5, k: 0 },
                                                sk: { a: 0, ix: 4, k: 0 },
                                                ty: "tr",
                                            }),
                                                this.arr.splice(0, 0, h),
                                                this._groups.splice(0, 0, h),
                                                (this._currentCopies += 1);
                                        }
                                        this.elem.reloadShapes(), (s = !0);
                                    }
                                    for (a = 0, i = 0; i <= this._groups.length - 1; i += 1) {
                                        if (((o = a < l), (this._groups[i]._render = o), this.changeGroupRender(this._groups[i].it, o), !o)) {
                                            var c = this.elemsData[i].it,
                                                p = c[c.length - 1];
                                            0 !== p.transform.op.v ? ((p.transform.op._mdf = !0), (p.transform.op.v = 0)) : (p.transform.op._mdf = !1);
                                        }
                                        a += 1;
                                    }
                                    this._currentCopies = l;
                                    var u = this.o.v,
                                        f = u % 1,
                                        d = u > 0 ? Math.floor(u) : Math.ceil(u),
                                        m = this.pMatrix.props,
                                        y = this.rMatrix.props,
                                        v = this.sMatrix.props;
                                    this.pMatrix.reset(), this.rMatrix.reset(), this.sMatrix.reset(), this.tMatrix.reset(), this.matrix.reset();
                                    var g,
                                        _,
                                        b = 0;
                                    if (u > 0) {
                                        for (; b < d; ) this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), (b += 1);
                                        f && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, f, !1), (b += f));
                                    } else if (u < 0) {
                                        for (; b > d; ) this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !0), (b -= 1);
                                        f && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -f, !0), (b -= f));
                                    }
                                    for (i = 1 === this.data.m ? 0 : this._currentCopies - 1, n = 1 === this.data.m ? 1 : -1, a = this._currentCopies; a; ) {
                                        if (
                                            ((_ = (r = (e = this.elemsData[i].it)[e.length - 1].transform.mProps.v.props).length),
                                            (e[e.length - 1].transform.mProps._mdf = !0),
                                            (e[e.length - 1].transform.op._mdf = !0),
                                            (e[e.length - 1].transform.op.v = 1 === this._currentCopies ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (i / (this._currentCopies - 1))),
                                            0 !== b)
                                        ) {
                                            for (
                                                ((0 !== i && 1 === n) || (i !== this._currentCopies - 1 && -1 === n)) && this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1),
                                                    this.matrix.transform(y[0], y[1], y[2], y[3], y[4], y[5], y[6], y[7], y[8], y[9], y[10], y[11], y[12], y[13], y[14], y[15]),
                                                    this.matrix.transform(v[0], v[1], v[2], v[3], v[4], v[5], v[6], v[7], v[8], v[9], v[10], v[11], v[12], v[13], v[14], v[15]),
                                                    this.matrix.transform(m[0], m[1], m[2], m[3], m[4], m[5], m[6], m[7], m[8], m[9], m[10], m[11], m[12], m[13], m[14], m[15]),
                                                    g = 0;
                                                g < _;
                                                g += 1
                                            )
                                                r[g] = this.matrix.props[g];
                                            this.matrix.reset();
                                        } else for (this.matrix.reset(), g = 0; g < _; g += 1) r[g] = this.matrix.props[g];
                                        (b += 1), (a -= 1), (i += n);
                                    }
                                } else
                                    for (a = this._currentCopies, i = 0, n = 1; a; )
                                        (r = (e = this.elemsData[i].it)[e.length - 1].transform.mProps.v.props), (e[e.length - 1].transform.mProps._mdf = !1), (e[e.length - 1].transform.op._mdf = !1), (a -= 1), (i += n);
                                return s;
                            }),
                            (RepeaterModifier.prototype.addShape = function () {}),
                            extendPrototype([ShapeModifier], RoundCornersModifier),
                            (RoundCornersModifier.prototype.initModifierProperties = function (t, e) {
                                (this.getValue = this.processKeys), (this.rd = PropertyFactory.getProp(t, e.r, 0, null, this)), (this._isAnimated = !!this.rd.effectsSequence.length);
                            }),
                            (RoundCornersModifier.prototype.processPath = function (t, e) {
                                var r,
                                    i = shapePool.newElement();
                                i.c = t.c;
                                var n,
                                    a,
                                    s,
                                    o,
                                    l,
                                    h,
                                    c,
                                    p,
                                    u,
                                    f,
                                    d,
                                    m,
                                    y = t._length,
                                    v = 0;
                                for (r = 0; r < y; r += 1)
                                    (n = t.v[r]),
                                        (s = t.o[r]),
                                        (a = t.i[r]),
                                        n[0] === s[0] && n[1] === s[1] && n[0] === a[0] && n[1] === a[1]
                                            ? (0 !== r && r !== y - 1) || t.c
                                                ? ((o = 0 === r ? t.v[y - 1] : t.v[r - 1]),
                                                  (h = (l = Math.sqrt(Math.pow(n[0] - o[0], 2) + Math.pow(n[1] - o[1], 2))) ? Math.min(l / 2, e) / l : 0),
                                                  (c = d = n[0] + (o[0] - n[0]) * h),
                                                  (p = m = n[1] - (n[1] - o[1]) * h),
                                                  (u = c - (c - n[0]) * roundCorner),
                                                  (f = p - (p - n[1]) * roundCorner),
                                                  i.setTripleAt(c, p, u, f, d, m, v),
                                                  (v += 1),
                                                  (o = r === y - 1 ? t.v[0] : t.v[r + 1]),
                                                  (h = (l = Math.sqrt(Math.pow(n[0] - o[0], 2) + Math.pow(n[1] - o[1], 2))) ? Math.min(l / 2, e) / l : 0),
                                                  (c = u = n[0] + (o[0] - n[0]) * h),
                                                  (p = f = n[1] + (o[1] - n[1]) * h),
                                                  (d = c - (c - n[0]) * roundCorner),
                                                  (m = p - (p - n[1]) * roundCorner),
                                                  i.setTripleAt(c, p, u, f, d, m, v),
                                                  (v += 1))
                                                : (i.setTripleAt(n[0], n[1], s[0], s[1], a[0], a[1], v), (v += 1))
                                            : (i.setTripleAt(t.v[r][0], t.v[r][1], t.o[r][0], t.o[r][1], t.i[r][0], t.i[r][1], v), (v += 1));
                                return i;
                            }),
                            (RoundCornersModifier.prototype.processShapes = function (t) {
                                var e,
                                    r,
                                    i,
                                    n,
                                    a,
                                    s,
                                    o = this.shapes.length,
                                    l = this.rd.v;
                                if (0 !== l)
                                    for (r = 0; r < o; r += 1) {
                                        if (((s = (a = this.shapes[r]).localShapeCollection), a.shape._mdf || this._mdf || t))
                                            for (s.releaseShapes(), a.shape._mdf = !0, e = a.shape.paths.shapes, n = a.shape.paths._length, i = 0; i < n; i += 1) s.addShape(this.processPath(e[i], l));
                                        a.shape.paths = a.localShapeCollection;
                                    }
                                this.dynamicProperties.length || (this._mdf = !1);
                            }),
                            (PolynomialBezier.prototype.point = function (t) {
                                return [((this.a[0] * t + this.b[0]) * t + this.c[0]) * t + this.d[0], ((this.a[1] * t + this.b[1]) * t + this.c[1]) * t + this.d[1]];
                            }),
                            (PolynomialBezier.prototype.derivative = function (t) {
                                return [(3 * t * this.a[0] + 2 * this.b[0]) * t + this.c[0], (3 * t * this.a[1] + 2 * this.b[1]) * t + this.c[1]];
                            }),
                            (PolynomialBezier.prototype.tangentAngle = function (t) {
                                var e = this.derivative(t);
                                return Math.atan2(e[1], e[0]);
                            }),
                            (PolynomialBezier.prototype.normalAngle = function (t) {
                                var e = this.derivative(t);
                                return Math.atan2(e[0], e[1]);
                            }),
                            (PolynomialBezier.prototype.inflectionPoints = function () {
                                var t = this.a[1] * this.b[0] - this.a[0] * this.b[1];
                                if (floatZero(t)) return [];
                                var e = (-0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1])) / t,
                                    r = e * e - ((1 / 3) * (this.b[1] * this.c[0] - this.b[0] * this.c[1])) / t;
                                if (r < 0) return [];
                                var i = Math.sqrt(r);
                                return floatZero(i)
                                    ? i > 0 && i < 1
                                        ? [e]
                                        : []
                                    : [e - i, e + i].filter(function (t) {
                                          return t > 0 && t < 1;
                                      });
                            }),
                            (PolynomialBezier.prototype.split = function (t) {
                                if (t <= 0) return [singlePoint(this.points[0]), this];
                                if (t >= 1) return [this, singlePoint(this.points[this.points.length - 1])];
                                var e = lerpPoint(this.points[0], this.points[1], t),
                                    r = lerpPoint(this.points[1], this.points[2], t),
                                    i = lerpPoint(this.points[2], this.points[3], t),
                                    n = lerpPoint(e, r, t),
                                    a = lerpPoint(r, i, t),
                                    s = lerpPoint(n, a, t);
                                return [new PolynomialBezier(this.points[0], e, n, s, !0), new PolynomialBezier(s, a, i, this.points[3], !0)];
                            }),
                            (PolynomialBezier.prototype.bounds = function () {
                                return { x: extrema(this, 0), y: extrema(this, 1) };
                            }),
                            (PolynomialBezier.prototype.boundingBox = function () {
                                var t = this.bounds();
                                return { left: t.x.min, right: t.x.max, top: t.y.min, bottom: t.y.max, width: t.x.max - t.x.min, height: t.y.max - t.y.min, cx: (t.x.max + t.x.min) / 2, cy: (t.y.max + t.y.min) / 2 };
                            }),
                            (PolynomialBezier.prototype.intersections = function (t, e, r) {
                                void 0 === e && (e = 2), void 0 === r && (r = 7);
                                var i = [];
                                return intersectsImpl(intersectData(this, 0, 1), intersectData(t, 0, 1), 0, e, i, r), i;
                            }),
                            (PolynomialBezier.shapeSegment = function (t, e) {
                                var r = (e + 1) % t.length();
                                return new PolynomialBezier(t.v[e], t.o[e], t.i[r], t.v[r], !0);
                            }),
                            (PolynomialBezier.shapeSegmentInverted = function (t, e) {
                                var r = (e + 1) % t.length();
                                return new PolynomialBezier(t.v[r], t.i[r], t.o[e], t.v[e], !0);
                            }),
                            extendPrototype([ShapeModifier], ZigZagModifier),
                            (ZigZagModifier.prototype.initModifierProperties = function (t, e) {
                                (this.getValue = this.processKeys),
                                    (this.amplitude = PropertyFactory.getProp(t, e.s, 0, null, this)),
                                    (this.frequency = PropertyFactory.getProp(t, e.r, 0, null, this)),
                                    (this.pointsType = PropertyFactory.getProp(t, e.pt, 0, null, this)),
                                    (this._isAnimated = 0 !== this.amplitude.effectsSequence.length || 0 !== this.frequency.effectsSequence.length || 0 !== this.pointsType.effectsSequence.length);
                            }),
                            (ZigZagModifier.prototype.processPath = function (t, e, r, i) {
                                var n = t._length,
                                    a = shapePool.newElement();
                                if (((a.c = t.c), t.c || (n -= 1), 0 === n)) return a;
                                var s = -1,
                                    o = PolynomialBezier.shapeSegment(t, 0);
                                zigZagCorner(a, t, 0, e, r, i, s);
                                for (var l = 0; l < n; l += 1) (s = zigZagSegment(a, o, e, r, i, -s)), (o = l !== n - 1 || t.c ? PolynomialBezier.shapeSegment(t, (l + 1) % n) : null), zigZagCorner(a, t, l + 1, e, r, i, s);
                                return a;
                            }),
                            (ZigZagModifier.prototype.processShapes = function (t) {
                                var e,
                                    r,
                                    i,
                                    n,
                                    a,
                                    s,
                                    o = this.shapes.length,
                                    l = this.amplitude.v,
                                    h = Math.max(0, Math.round(this.frequency.v)),
                                    c = this.pointsType.v;
                                if (0 !== l)
                                    for (r = 0; r < o; r += 1) {
                                        if (((s = (a = this.shapes[r]).localShapeCollection), a.shape._mdf || this._mdf || t))
                                            for (s.releaseShapes(), a.shape._mdf = !0, e = a.shape.paths.shapes, n = a.shape.paths._length, i = 0; i < n; i += 1) s.addShape(this.processPath(e[i], l, h, c));
                                        a.shape.paths = a.localShapeCollection;
                                    }
                                this.dynamicProperties.length || (this._mdf = !1);
                            }),
                            extendPrototype([ShapeModifier], OffsetPathModifier),
                            (OffsetPathModifier.prototype.initModifierProperties = function (t, e) {
                                (this.getValue = this.processKeys),
                                    (this.amount = PropertyFactory.getProp(t, e.a, 0, null, this)),
                                    (this.miterLimit = PropertyFactory.getProp(t, e.ml, 0, null, this)),
                                    (this.lineJoin = e.lj),
                                    (this._isAnimated = 0 !== this.amount.effectsSequence.length);
                            }),
                            (OffsetPathModifier.prototype.processPath = function (t, e, r, i) {
                                var n = shapePool.newElement();
                                n.c = t.c;
                                var a,
                                    s,
                                    o,
                                    l = t.length();
                                t.c || (l -= 1);
                                var h = [];
                                for (a = 0; a < l; a += 1) (o = PolynomialBezier.shapeSegment(t, a)), h.push(offsetSegmentSplit(o, e));
                                if (!t.c) for (a = l - 1; a >= 0; a -= 1) (o = PolynomialBezier.shapeSegmentInverted(t, a)), h.push(offsetSegmentSplit(o, e));
                                h = pruneIntersections(h);
                                var c = null,
                                    p = null;
                                for (a = 0; a < h.length; a += 1) {
                                    var u = h[a];
                                    for (p && (c = joinLines(n, p, u[0], r, i)), p = u[u.length - 1], s = 0; s < u.length; s += 1)
                                        (o = u[s]),
                                            c && pointEqual(o.points[0], c)
                                                ? n.setXYAt(o.points[1][0], o.points[1][1], "o", n.length() - 1)
                                                : n.setTripleAt(o.points[0][0], o.points[0][1], o.points[1][0], o.points[1][1], o.points[0][0], o.points[0][1], n.length()),
                                            n.setTripleAt(o.points[3][0], o.points[3][1], o.points[3][0], o.points[3][1], o.points[2][0], o.points[2][1], n.length()),
                                            (c = o.points[3]);
                                }
                                return h.length && joinLines(n, p, h[0][0], r, i), n;
                            }),
                            (OffsetPathModifier.prototype.processShapes = function (t) {
                                var e,
                                    r,
                                    i,
                                    n,
                                    a,
                                    s,
                                    o = this.shapes.length,
                                    l = this.amount.v,
                                    h = this.miterLimit.v,
                                    c = this.lineJoin;
                                if (0 !== l)
                                    for (r = 0; r < o; r += 1) {
                                        if (((s = (a = this.shapes[r]).localShapeCollection), a.shape._mdf || this._mdf || t))
                                            for (s.releaseShapes(), a.shape._mdf = !0, e = a.shape.paths.shapes, n = a.shape.paths._length, i = 0; i < n; i += 1) s.addShape(this.processPath(e[i], l, c, h));
                                        a.shape.paths = a.localShapeCollection;
                                    }
                                this.dynamicProperties.length || (this._mdf = !1);
                            });
                        var FontManager = (function () {
                            var t = { w: 0, size: 0, shapes: [], data: { shapes: [] } },
                                e = [];
                            e = e.concat([
                                2304,
                                2305,
                                2306,
                                2307,
                                2362,
                                2363,
                                2364,
                                2364,
                                2366,
                                2367,
                                2368,
                                2369,
                                2370,
                                2371,
                                2372,
                                2373,
                                2374,
                                2375,
                                2376,
                                2377,
                                2378,
                                2379,
                                2380,
                                2381,
                                2382,
                                2383,
                                2387,
                                2388,
                                2389,
                                2390,
                                2391,
                                2402,
                                2403,
                            ]);
                            var r = ["d83cdffb", "d83cdffc", "d83cdffd", "d83cdffe", "d83cdfff"],
                                i = [65039, 8205];
                            function n(t, e) {
                                var r = createTag("span");
                                r.setAttribute("aria-hidden", !0), (r.style.fontFamily = e);
                                var i = createTag("span");
                                (i.innerText = "giItT1WQy@!-/#"),
                                    (r.style.position = "absolute"),
                                    (r.style.left = "-10000px"),
                                    (r.style.top = "-10000px"),
                                    (r.style.fontSize = "300px"),
                                    (r.style.fontVariant = "normal"),
                                    (r.style.fontStyle = "normal"),
                                    (r.style.fontWeight = "normal"),
                                    (r.style.letterSpacing = "0"),
                                    r.appendChild(i),
                                    document.body.appendChild(r);
                                var n = i.offsetWidth;
                                return (
                                    (i.style.fontFamily =
                                        (function (t) {
                                            var e,
                                                r = t.split(","),
                                                i = r.length,
                                                n = [];
                                            for (e = 0; e < i; e += 1) "sans-serif" !== r[e] && "monospace" !== r[e] && n.push(r[e]);
                                            return n.join(",");
                                        })(t) +
                                        ", " +
                                        e),
                                    { node: i, w: n, parent: r }
                                );
                            }
                            function a(t, e) {
                                var r,
                                    i = document.body && e ? "svg" : "canvas",
                                    n = getFontProperties(t);
                                if ("svg" === i) {
                                    var a = createNS("text");
                                    (a.style.fontSize = "100px"),
                                        a.setAttribute("font-family", t.fFamily),
                                        a.setAttribute("font-style", n.style),
                                        a.setAttribute("font-weight", n.weight),
                                        (a.textContent = "1"),
                                        t.fClass ? ((a.style.fontFamily = "inherit"), a.setAttribute("class", t.fClass)) : (a.style.fontFamily = t.fFamily),
                                        e.appendChild(a),
                                        (r = a);
                                } else {
                                    var s = new OffscreenCanvas(500, 500).getContext("2d");
                                    (s.font = n.style + " " + n.weight + " 100px " + t.fFamily), (r = s);
                                }
                                return {
                                    measureText: function (t) {
                                        return "svg" === i ? ((r.textContent = t), r.getComputedTextLength()) : r.measureText(t).width;
                                    },
                                };
                            }
                            var s = function () {
                                (this.fonts = []),
                                    (this.chars = null),
                                    (this.typekitLoaded = 0),
                                    (this.isLoaded = !1),
                                    (this._warned = !1),
                                    (this.initTime = Date.now()),
                                    (this.setIsLoadedBinded = this.setIsLoaded.bind(this)),
                                    (this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this));
                            };
                            (s.isModifier = function (t, e) {
                                var i = t.toString(16) + e.toString(16);
                                return -1 !== r.indexOf(i);
                            }),
                                (s.isZeroWidthJoiner = function (t, e) {
                                    return e ? t === i[0] && e === i[1] : t === i[1];
                                }),
                                (s.isCombinedCharacter = function (t) {
                                    return -1 !== e.indexOf(t);
                                });
                            var o = {
                                addChars: function (t) {
                                    if (t) {
                                        var e;
                                        this.chars || (this.chars = []);
                                        var r,
                                            i,
                                            n = t.length,
                                            a = this.chars.length;
                                        for (e = 0; e < n; e += 1) {
                                            for (r = 0, i = !1; r < a; ) this.chars[r].style === t[e].style && this.chars[r].fFamily === t[e].fFamily && this.chars[r].ch === t[e].ch && (i = !0), (r += 1);
                                            i || (this.chars.push(t[e]), (a += 1));
                                        }
                                    }
                                },
                                addFonts: function (t, e) {
                                    if (t) {
                                        if (this.chars) return (this.isLoaded = !0), void (this.fonts = t.list);
                                        if (!document.body)
                                            return (
                                                (this.isLoaded = !0),
                                                t.list.forEach(function (t) {
                                                    (t.helper = a(t)), (t.cache = {});
                                                }),
                                                void (this.fonts = t.list)
                                            );
                                        var r,
                                            i = t.list,
                                            s = i.length,
                                            o = s;
                                        for (r = 0; r < s; r += 1) {
                                            var l,
                                                h,
                                                c = !0;
                                            if (((i[r].loaded = !1), (i[r].monoCase = n(i[r].fFamily, "monospace")), (i[r].sansCase = n(i[r].fFamily, "sans-serif")), i[r].fPath)) {
                                                if ("p" === i[r].fOrigin || 3 === i[r].origin) {
                                                    if (((l = document.querySelectorAll('style[f-forigin="p"][f-family="' + i[r].fFamily + '"], style[f-origin="3"][f-family="' + i[r].fFamily + '"]')).length > 0 && (c = !1), c)) {
                                                        var p = createTag("style");
                                                        p.setAttribute("f-forigin", i[r].fOrigin),
                                                            p.setAttribute("f-origin", i[r].origin),
                                                            p.setAttribute("f-family", i[r].fFamily),
                                                            (p.type = "text/css"),
                                                            (p.innerText = "@font-face {font-family: " + i[r].fFamily + "; font-style: normal; src: url('" + i[r].fPath + "');}"),
                                                            e.appendChild(p);
                                                    }
                                                } else if ("g" === i[r].fOrigin || 1 === i[r].origin) {
                                                    for (l = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]'), h = 0; h < l.length; h += 1) -1 !== l[h].href.indexOf(i[r].fPath) && (c = !1);
                                                    if (c) {
                                                        var u = createTag("link");
                                                        u.setAttribute("f-forigin", i[r].fOrigin), u.setAttribute("f-origin", i[r].origin), (u.type = "text/css"), (u.rel = "stylesheet"), (u.href = i[r].fPath), document.body.appendChild(u);
                                                    }
                                                } else if ("t" === i[r].fOrigin || 2 === i[r].origin) {
                                                    for (l = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]'), h = 0; h < l.length; h += 1) i[r].fPath === l[h].src && (c = !1);
                                                    if (c) {
                                                        var f = createTag("link");
                                                        f.setAttribute("f-forigin", i[r].fOrigin), f.setAttribute("f-origin", i[r].origin), f.setAttribute("rel", "stylesheet"), f.setAttribute("href", i[r].fPath), e.appendChild(f);
                                                    }
                                                }
                                            } else (i[r].loaded = !0), (o -= 1);
                                            (i[r].helper = a(i[r], e)), (i[r].cache = {}), this.fonts.push(i[r]);
                                        }
                                        0 === o ? (this.isLoaded = !0) : setTimeout(this.checkLoadedFonts.bind(this), 100);
                                    } else this.isLoaded = !0;
                                },
                                getCharData: function (e, r, i) {
                                    for (var n = 0, a = this.chars.length; n < a; ) {
                                        if (this.chars[n].ch === e && this.chars[n].style === r && this.chars[n].fFamily === i) return this.chars[n];
                                        n += 1;
                                    }
                                    return (
                                        (("string" == typeof e && 13 !== e.charCodeAt(0)) || !e) &&
                                            console &&
                                            console.warn &&
                                            !this._warned &&
                                            ((this._warned = !0), console.warn("Missing character from exported characters list: ", e, r, i)),
                                        t
                                    );
                                },
                                getFontByName: function (t) {
                                    for (var e = 0, r = this.fonts.length; e < r; ) {
                                        if (this.fonts[e].fName === t) return this.fonts[e];
                                        e += 1;
                                    }
                                    return this.fonts[0];
                                },
                                measureText: function (t, e, r) {
                                    var i = this.getFontByName(e),
                                        n = t.charCodeAt(0);
                                    if (!i.cache[n + 1]) {
                                        var a = i.helper;
                                        if (" " === t) {
                                            var s = a.measureText("|" + t + "|"),
                                                o = a.measureText("||");
                                            i.cache[n + 1] = (s - o) / 100;
                                        } else i.cache[n + 1] = a.measureText(t) / 100;
                                    }
                                    return i.cache[n + 1] * r;
                                },
                                checkLoadedFonts: function () {
                                    var t,
                                        e,
                                        r,
                                        i = this.fonts.length,
                                        n = i;
                                    for (t = 0; t < i; t += 1)
                                        this.fonts[t].loaded
                                            ? (n -= 1)
                                            : "n" === this.fonts[t].fOrigin || 0 === this.fonts[t].origin
                                            ? (this.fonts[t].loaded = !0)
                                            : ((e = this.fonts[t].monoCase.node),
                                              (r = this.fonts[t].monoCase.w),
                                              e.offsetWidth !== r
                                                  ? ((n -= 1), (this.fonts[t].loaded = !0))
                                                  : ((e = this.fonts[t].sansCase.node), (r = this.fonts[t].sansCase.w), e.offsetWidth !== r && ((n -= 1), (this.fonts[t].loaded = !0))),
                                              this.fonts[t].loaded &&
                                                  (this.fonts[t].sansCase.parent.parentNode.removeChild(this.fonts[t].sansCase.parent), this.fonts[t].monoCase.parent.parentNode.removeChild(this.fonts[t].monoCase.parent)));
                                    0 !== n && Date.now() - this.initTime < 5e3 ? setTimeout(this.checkLoadedFontsBinded, 20) : setTimeout(this.setIsLoadedBinded, 10);
                                },
                                setIsLoaded: function () {
                                    this.isLoaded = !0;
                                },
                            };
                            return (s.prototype = o), s;
                        })();
                        function RenderableElement() {}
                        RenderableElement.prototype = {
                            initRenderable: function () {
                                (this.isInRange = !1), (this.hidden = !1), (this.isTransparent = !1), (this.renderableComponents = []);
                            },
                            addRenderableComponent: function (t) {
                                -1 === this.renderableComponents.indexOf(t) && this.renderableComponents.push(t);
                            },
                            removeRenderableComponent: function (t) {
                                -1 !== this.renderableComponents.indexOf(t) && this.renderableComponents.splice(this.renderableComponents.indexOf(t), 1);
                            },
                            prepareRenderableFrame: function (t) {
                                this.checkLayerLimits(t);
                            },
                            checkTransparency: function () {
                                this.finalTransform.mProp.o.v <= 0
                                    ? !this.isTransparent && this.globalData.renderConfig.hideOnTransparent && ((this.isTransparent = !0), this.hide())
                                    : this.isTransparent && ((this.isTransparent = !1), this.show());
                            },
                            checkLayerLimits: function (t) {
                                this.data.ip - this.data.st <= t && this.data.op - this.data.st > t
                                    ? !0 !== this.isInRange && ((this.globalData._mdf = !0), (this._mdf = !0), (this.isInRange = !0), this.show())
                                    : !1 !== this.isInRange && ((this.globalData._mdf = !0), (this.isInRange = !1), this.hide());
                            },
                            renderRenderable: function () {
                                var t,
                                    e = this.renderableComponents.length;
                                for (t = 0; t < e; t += 1) this.renderableComponents[t].renderFrame(this._isFirstFrame);
                            },
                            sourceRectAtTime: function () {
                                return { top: 0, left: 0, width: 100, height: 100 };
                            },
                            getLayerSize: function () {
                                return 5 === this.data.ty ? { w: this.data.textData.width, h: this.data.textData.height } : { w: this.data.width, h: this.data.height };
                            },
                        };
                        var getBlendMode =
                                ((blendModeEnums = {
                                    0: "source-over",
                                    1: "multiply",
                                    2: "screen",
                                    3: "overlay",
                                    4: "darken",
                                    5: "lighten",
                                    6: "color-dodge",
                                    7: "color-burn",
                                    8: "hard-light",
                                    9: "soft-light",
                                    10: "difference",
                                    11: "exclusion",
                                    12: "hue",
                                    13: "saturation",
                                    14: "color",
                                    15: "luminosity",
                                }),
                                function (t) {
                                    return blendModeEnums[t] || "";
                                }),
                            blendModeEnums;
                        function SliderEffect(t, e, r) {
                            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
                        }
                        function AngleEffect(t, e, r) {
                            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
                        }
                        function ColorEffect(t, e, r) {
                            this.p = PropertyFactory.getProp(e, t.v, 1, 0, r);
                        }
                        function PointEffect(t, e, r) {
                            this.p = PropertyFactory.getProp(e, t.v, 1, 0, r);
                        }
                        function LayerIndexEffect(t, e, r) {
                            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
                        }
                        function MaskIndexEffect(t, e, r) {
                            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
                        }
                        function CheckboxEffect(t, e, r) {
                            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
                        }
                        function NoValueEffect() {
                            this.p = {};
                        }
                        function EffectsManager(t, e) {
                            var r,
                                i = t.ef || [];
                            this.effectElements = [];
                            var n,
                                a = i.length;
                            for (r = 0; r < a; r += 1) (n = new GroupEffect(i[r], e)), this.effectElements.push(n);
                        }
                        function GroupEffect(t, e) {
                            this.init(t, e);
                        }
                        function BaseElement() {}
                        function FrameElement() {}
                        function FootageElement(t, e, r) {
                            this.initFrame(), this.initRenderable(), (this.assetData = e.getAssetData(t.refId)), (this.footageData = e.imageLoader.getAsset(this.assetData)), this.initBaseData(t, e, r);
                        }
                        function AudioElement(t, e, r) {
                            this.initFrame(), this.initRenderable(), (this.assetData = e.getAssetData(t.refId)), this.initBaseData(t, e, r), (this._isPlaying = !1), (this._canPlay = !1);
                            var i = this.globalData.getAssetsPath(this.assetData);
                            (this.audio = this.globalData.audioController.createAudio(i)),
                                (this._currentTime = 0),
                                this.globalData.audioController.addAudio(this),
                                (this._volumeMultiplier = 1),
                                (this._volume = 1),
                                (this._previousVolume = null),
                                (this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this) : { _placeholder: !0 }),
                                (this.lv = PropertyFactory.getProp(this, t.au && t.au.lv ? t.au.lv : { k: [100] }, 1, 0.01, this));
                        }
                        function BaseRenderer() {}
                        function TransformElement() {}
                        function MaskElement(t, e, r) {
                            (this.data = t), (this.element = e), (this.globalData = r), (this.storedData = []), (this.masksProperties = this.data.masksProperties || []), (this.maskElement = null);
                            var i,
                                n,
                                a = this.globalData.defs,
                                s = this.masksProperties ? this.masksProperties.length : 0;
                            (this.viewData = createSizedArray(s)), (this.solidPath = "");
                            var o,
                                l,
                                h,
                                c,
                                p,
                                u,
                                f = this.masksProperties,
                                d = 0,
                                m = [],
                                y = createElementID(),
                                v = "clipPath",
                                g = "clip-path";
                            for (i = 0; i < s; i += 1)
                                if (
                                    ((("a" !== f[i].mode && "n" !== f[i].mode) || f[i].inv || 100 !== f[i].o.k || f[i].o.x) && ((v = "mask"), (g = "mask")),
                                    ("s" !== f[i].mode && "i" !== f[i].mode) || 0 !== d
                                        ? (h = null)
                                        : ((h = createNS("rect")).setAttribute("fill", "#ffffff"), h.setAttribute("width", this.element.comp.data.w || 0), h.setAttribute("height", this.element.comp.data.h || 0), m.push(h)),
                                    (n = createNS("path")),
                                    "n" === f[i].mode)
                                )
                                    (this.viewData[i] = { op: PropertyFactory.getProp(this.element, f[i].o, 0, 0.01, this.element), prop: ShapePropertyFactory.getShapeProp(this.element, f[i], 3), elem: n, lastPath: "" }), a.appendChild(n);
                                else {
                                    var _;
                                    if (
                                        ((d += 1),
                                        n.setAttribute("fill", "s" === f[i].mode ? "#000000" : "#ffffff"),
                                        n.setAttribute("clip-rule", "nonzero"),
                                        0 !== f[i].x.k
                                            ? ((v = "mask"),
                                              (g = "mask"),
                                              (u = PropertyFactory.getProp(this.element, f[i].x, 0, null, this.element)),
                                              (_ = createElementID()),
                                              (c = createNS("filter")).setAttribute("id", _),
                                              (p = createNS("feMorphology")).setAttribute("operator", "erode"),
                                              p.setAttribute("in", "SourceGraphic"),
                                              p.setAttribute("radius", "0"),
                                              c.appendChild(p),
                                              a.appendChild(c),
                                              n.setAttribute("stroke", "s" === f[i].mode ? "#000000" : "#ffffff"))
                                            : ((p = null), (u = null)),
                                        (this.storedData[i] = { elem: n, x: u, expan: p, lastPath: "", lastOperator: "", filterId: _, lastRadius: 0 }),
                                        "i" === f[i].mode)
                                    ) {
                                        l = m.length;
                                        var b = createNS("g");
                                        for (o = 0; o < l; o += 1) b.appendChild(m[o]);
                                        var E = createNS("mask");
                                        E.setAttribute("mask-type", "alpha"),
                                            E.setAttribute("id", y + "_" + d),
                                            E.appendChild(n),
                                            a.appendChild(E),
                                            b.setAttribute("mask", "url(" + getLocationHref() + "#" + y + "_" + d + ")"),
                                            (m.length = 0),
                                            m.push(b);
                                    } else m.push(n);
                                    f[i].inv && !this.solidPath && (this.solidPath = this.createLayerSolidPath()),
                                        (this.viewData[i] = { elem: n, lastPath: "", op: PropertyFactory.getProp(this.element, f[i].o, 0, 0.01, this.element), prop: ShapePropertyFactory.getShapeProp(this.element, f[i], 3), invRect: h }),
                                        this.viewData[i].prop.k || this.drawPath(f[i], this.viewData[i].prop.v, this.viewData[i]);
                                }
                            for (this.maskElement = createNS(v), s = m.length, i = 0; i < s; i += 1) this.maskElement.appendChild(m[i]);
                            d > 0 && (this.maskElement.setAttribute("id", y), this.element.maskedElement.setAttribute(g, "url(" + getLocationHref() + "#" + y + ")"), a.appendChild(this.maskElement)),
                                this.viewData.length && this.element.addRenderableComponent(this);
                        }
                        extendPrototype([DynamicPropertyContainer], GroupEffect),
                            (GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties),
                            (GroupEffect.prototype.init = function (t, e) {
                                var r;
                                (this.data = t), (this.effectElements = []), this.initDynamicPropertyContainer(e);
                                var i,
                                    n = this.data.ef.length,
                                    a = this.data.ef;
                                for (r = 0; r < n; r += 1) {
                                    switch (((i = null), a[r].ty)) {
                                        case 0:
                                            i = new SliderEffect(a[r], e, this);
                                            break;
                                        case 1:
                                            i = new AngleEffect(a[r], e, this);
                                            break;
                                        case 2:
                                            i = new ColorEffect(a[r], e, this);
                                            break;
                                        case 3:
                                            i = new PointEffect(a[r], e, this);
                                            break;
                                        case 4:
                                        case 7:
                                            i = new CheckboxEffect(a[r], e, this);
                                            break;
                                        case 10:
                                            i = new LayerIndexEffect(a[r], e, this);
                                            break;
                                        case 11:
                                            i = new MaskIndexEffect(a[r], e, this);
                                            break;
                                        case 5:
                                            i = new EffectsManager(a[r], e, this);
                                            break;
                                        default:
                                            i = new NoValueEffect(a[r], e, this);
                                    }
                                    i && this.effectElements.push(i);
                                }
                            }),
                            (BaseElement.prototype = {
                                checkMasks: function () {
                                    if (!this.data.hasMask) return !1;
                                    for (var t = 0, e = this.data.masksProperties.length; t < e; ) {
                                        if ("n" !== this.data.masksProperties[t].mode && !1 !== this.data.masksProperties[t].cl) return !0;
                                        t += 1;
                                    }
                                    return !1;
                                },
                                initExpressions: function () {
                                    var t = getExpressionInterfaces();
                                    if (t) {
                                        var e = t("layer"),
                                            r = t("effects"),
                                            i = t("shape"),
                                            n = t("text"),
                                            a = t("comp");
                                        (this.layerInterface = e(this)), this.data.hasMask && this.maskManager && this.layerInterface.registerMaskInterface(this.maskManager);
                                        var s = r.createEffectsInterface(this, this.layerInterface);
                                        this.layerInterface.registerEffectsInterface(s),
                                            0 === this.data.ty || this.data.xt
                                                ? (this.compInterface = a(this))
                                                : 4 === this.data.ty
                                                ? ((this.layerInterface.shapeInterface = i(this.shapesData, this.itemsData, this.layerInterface)), (this.layerInterface.content = this.layerInterface.shapeInterface))
                                                : 5 === this.data.ty && ((this.layerInterface.textInterface = n(this)), (this.layerInterface.text = this.layerInterface.textInterface));
                                    }
                                },
                                setBlendMode: function () {
                                    var t = getBlendMode(this.data.bm);
                                    (this.baseElement || this.layerElement).style["mix-blend-mode"] = t;
                                },
                                initBaseData: function (t, e, r) {
                                    (this.globalData = e),
                                        (this.comp = r),
                                        (this.data = t),
                                        (this.layerId = createElementID()),
                                        this.data.sr || (this.data.sr = 1),
                                        (this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties));
                                },
                                getType: function () {
                                    return this.type;
                                },
                                sourceRectAtTime: function () {},
                            }),
                            (FrameElement.prototype = {
                                initFrame: function () {
                                    (this._isFirstFrame = !1), (this.dynamicProperties = []), (this._mdf = !1);
                                },
                                prepareProperties: function (t, e) {
                                    var r,
                                        i = this.dynamicProperties.length;
                                    for (r = 0; r < i; r += 1)
                                        (e || (this._isParent && "transform" === this.dynamicProperties[r].propType)) &&
                                            (this.dynamicProperties[r].getValue(), this.dynamicProperties[r]._mdf && ((this.globalData._mdf = !0), (this._mdf = !0)));
                                },
                                addDynamicProperty: function (t) {
                                    -1 === this.dynamicProperties.indexOf(t) && this.dynamicProperties.push(t);
                                },
                            }),
                            (FootageElement.prototype.prepareFrame = function () {}),
                            extendPrototype([RenderableElement, BaseElement, FrameElement], FootageElement),
                            (FootageElement.prototype.getBaseElement = function () {
                                return null;
                            }),
                            (FootageElement.prototype.renderFrame = function () {}),
                            (FootageElement.prototype.destroy = function () {}),
                            (FootageElement.prototype.initExpressions = function () {
                                var t = getExpressionInterfaces();
                                if (t) {
                                    var e = t("footage");
                                    this.layerInterface = e(this);
                                }
                            }),
                            (FootageElement.prototype.getFootageData = function () {
                                return this.footageData;
                            }),
                            (AudioElement.prototype.prepareFrame = function (t) {
                                if ((this.prepareRenderableFrame(t, !0), this.prepareProperties(t, !0), this.tm._placeholder)) this._currentTime = t / this.data.sr;
                                else {
                                    var e = this.tm.v;
                                    this._currentTime = e;
                                }
                                this._volume = this.lv.v[0];
                                var r = this._volume * this._volumeMultiplier;
                                this._previousVolume !== r && ((this._previousVolume = r), this.audio.volume(r));
                            }),
                            extendPrototype([RenderableElement, BaseElement, FrameElement], AudioElement),
                            (AudioElement.prototype.renderFrame = function () {
                                this.isInRange &&
                                    this._canPlay &&
                                    (this._isPlaying
                                        ? (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) && this.audio.seek(this._currentTime / this.globalData.frameRate)
                                        : (this.audio.play(), this.audio.seek(this._currentTime / this.globalData.frameRate), (this._isPlaying = !0)));
                            }),
                            (AudioElement.prototype.show = function () {}),
                            (AudioElement.prototype.hide = function () {
                                this.audio.pause(), (this._isPlaying = !1);
                            }),
                            (AudioElement.prototype.pause = function () {
                                this.audio.pause(), (this._isPlaying = !1), (this._canPlay = !1);
                            }),
                            (AudioElement.prototype.resume = function () {
                                this._canPlay = !0;
                            }),
                            (AudioElement.prototype.setRate = function (t) {
                                this.audio.rate(t);
                            }),
                            (AudioElement.prototype.volume = function (t) {
                                (this._volumeMultiplier = t), (this._previousVolume = t * this._volume), this.audio.volume(this._previousVolume);
                            }),
                            (AudioElement.prototype.getBaseElement = function () {
                                return null;
                            }),
                            (AudioElement.prototype.destroy = function () {}),
                            (AudioElement.prototype.sourceRectAtTime = function () {}),
                            (AudioElement.prototype.initExpressions = function () {}),
                            (BaseRenderer.prototype.checkLayers = function (t) {
                                var e,
                                    r,
                                    i = this.layers.length;
                                for (this.completeLayers = !0, e = i - 1; e >= 0; e -= 1)
                                    this.elements[e] || ((r = this.layers[e]).ip - r.st <= t - this.layers[e].st && r.op - r.st > t - this.layers[e].st && this.buildItem(e)),
                                        (this.completeLayers = !!this.elements[e] && this.completeLayers);
                                this.checkPendingElements();
                            }),
                            (BaseRenderer.prototype.createItem = function (t) {
                                switch (t.ty) {
                                    case 2:
                                        return this.createImage(t);
                                    case 0:
                                        return this.createComp(t);
                                    case 1:
                                        return this.createSolid(t);
                                    case 3:
                                    default:
                                        return this.createNull(t);
                                    case 4:
                                        return this.createShape(t);
                                    case 5:
                                        return this.createText(t);
                                    case 6:
                                        return this.createAudio(t);
                                    case 13:
                                        return this.createCamera(t);
                                    case 15:
                                        return this.createFootage(t);
                                }
                            }),
                            (BaseRenderer.prototype.createCamera = function () {
                                throw new Error("You're using a 3d camera. Try the html renderer.");
                            }),
                            (BaseRenderer.prototype.createAudio = function (t) {
                                return new AudioElement(t, this.globalData, this);
                            }),
                            (BaseRenderer.prototype.createFootage = function (t) {
                                return new FootageElement(t, this.globalData, this);
                            }),
                            (BaseRenderer.prototype.buildAllItems = function () {
                                var t,
                                    e = this.layers.length;
                                for (t = 0; t < e; t += 1) this.buildItem(t);
                                this.checkPendingElements();
                            }),
                            (BaseRenderer.prototype.includeLayers = function (t) {
                                var e;
                                this.completeLayers = !1;
                                var r,
                                    i = t.length,
                                    n = this.layers.length;
                                for (e = 0; e < i; e += 1)
                                    for (r = 0; r < n; ) {
                                        if (this.layers[r].id === t[e].id) {
                                            this.layers[r] = t[e];
                                            break;
                                        }
                                        r += 1;
                                    }
                            }),
                            (BaseRenderer.prototype.setProjectInterface = function (t) {
                                this.globalData.projectInterface = t;
                            }),
                            (BaseRenderer.prototype.initItems = function () {
                                this.globalData.progressiveLoad || this.buildAllItems();
                            }),
                            (BaseRenderer.prototype.buildElementParenting = function (t, e, r) {
                                for (var i = this.elements, n = this.layers, a = 0, s = n.length; a < s; )
                                    n[a].ind == e &&
                                        (i[a] && !0 !== i[a] ? (r.push(i[a]), i[a].setAsParent(), void 0 !== n[a].parent ? this.buildElementParenting(t, n[a].parent, r) : t.setHierarchy(r)) : (this.buildItem(a), this.addPendingElement(t))),
                                        (a += 1);
                            }),
                            (BaseRenderer.prototype.addPendingElement = function (t) {
                                this.pendingElements.push(t);
                            }),
                            (BaseRenderer.prototype.searchExtraCompositions = function (t) {
                                var e,
                                    r = t.length;
                                for (e = 0; e < r; e += 1)
                                    if (t[e].xt) {
                                        var i = this.createComp(t[e]);
                                        i.initExpressions(), this.globalData.projectInterface.registerComposition(i);
                                    }
                            }),
                            (BaseRenderer.prototype.getElementByPath = function (t) {
                                var e,
                                    r = t.shift();
                                if ("number" == typeof r) e = this.elements[r];
                                else {
                                    var i,
                                        n = this.elements.length;
                                    for (i = 0; i < n; i += 1)
                                        if (this.elements[i].data.nm === r) {
                                            e = this.elements[i];
                                            break;
                                        }
                                }
                                return 0 === t.length ? e : e.getElementByPath(t);
                            }),
                            (BaseRenderer.prototype.setupGlobalData = function (t, e) {
                                (this.globalData.fontManager = new FontManager()),
                                    this.globalData.fontManager.addChars(t.chars),
                                    this.globalData.fontManager.addFonts(t.fonts, e),
                                    (this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem)),
                                    (this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem)),
                                    (this.globalData.imageLoader = this.animationItem.imagePreloader),
                                    (this.globalData.audioController = this.animationItem.audioController),
                                    (this.globalData.frameId = 0),
                                    (this.globalData.frameRate = t.fr),
                                    (this.globalData.nm = t.nm),
                                    (this.globalData.compSize = { w: t.w, h: t.h });
                            }),
                            (TransformElement.prototype = {
                                initTransform: function () {
                                    (this.finalTransform = { mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : { o: 0 }, _matMdf: !1, _opMdf: !1, mat: new Matrix() }),
                                        this.data.ao && (this.finalTransform.mProp.autoOriented = !0),
                                        this.data.ty;
                                },
                                renderTransform: function () {
                                    if (((this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame), (this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame), this.hierarchy)) {
                                        var t,
                                            e = this.finalTransform.mat,
                                            r = 0,
                                            i = this.hierarchy.length;
                                        if (!this.finalTransform._matMdf)
                                            for (; r < i; ) {
                                                if (this.hierarchy[r].finalTransform.mProp._mdf) {
                                                    this.finalTransform._matMdf = !0;
                                                    break;
                                                }
                                                r += 1;
                                            }
                                        if (this.finalTransform._matMdf)
                                            for (t = this.finalTransform.mProp.v.props, e.cloneFromProps(t), r = 0; r < i; r += 1)
                                                (t = this.hierarchy[r].finalTransform.mProp.v.props), e.transform(t[0], t[1], t[2], t[3], t[4], t[5], t[6], t[7], t[8], t[9], t[10], t[11], t[12], t[13], t[14], t[15]);
                                    }
                                },
                                globalToLocal: function (t) {
                                    var e = [];
                                    e.push(this.finalTransform);
                                    for (var r, i = !0, n = this.comp; i; ) n.finalTransform ? (n.data.hasMask && e.splice(0, 0, n.finalTransform), (n = n.comp)) : (i = !1);
                                    var a,
                                        s = e.length;
                                    for (r = 0; r < s; r += 1) (a = e[r].mat.applyToPointArray(0, 0, 0)), (t = [t[0] - a[0], t[1] - a[1], 0]);
                                    return t;
                                },
                                mHelper: new Matrix(),
                            }),
                            (MaskElement.prototype.getMaskProperty = function (t) {
                                return this.viewData[t].prop;
                            }),
                            (MaskElement.prototype.renderFrame = function (t) {
                                var e,
                                    r = this.element.finalTransform.mat,
                                    i = this.masksProperties.length;
                                for (e = 0; e < i; e += 1)
                                    if (
                                        ((this.viewData[e].prop._mdf || t) && this.drawPath(this.masksProperties[e], this.viewData[e].prop.v, this.viewData[e]),
                                        (this.viewData[e].op._mdf || t) && this.viewData[e].elem.setAttribute("fill-opacity", this.viewData[e].op.v),
                                        "n" !== this.masksProperties[e].mode &&
                                            (this.viewData[e].invRect && (this.element.finalTransform.mProp._mdf || t) && this.viewData[e].invRect.setAttribute("transform", r.getInverseMatrix().to2dCSS()),
                                            this.storedData[e].x && (this.storedData[e].x._mdf || t)))
                                    ) {
                                        var n = this.storedData[e].expan;
                                        this.storedData[e].x.v < 0
                                            ? ("erode" !== this.storedData[e].lastOperator &&
                                                  ((this.storedData[e].lastOperator = "erode"), this.storedData[e].elem.setAttribute("filter", "url(" + getLocationHref() + "#" + this.storedData[e].filterId + ")")),
                                              n.setAttribute("radius", -this.storedData[e].x.v))
                                            : ("dilate" !== this.storedData[e].lastOperator && ((this.storedData[e].lastOperator = "dilate"), this.storedData[e].elem.setAttribute("filter", null)),
                                              this.storedData[e].elem.setAttribute("stroke-width", 2 * this.storedData[e].x.v));
                                    }
                            }),
                            (MaskElement.prototype.getMaskelement = function () {
                                return this.maskElement;
                            }),
                            (MaskElement.prototype.createLayerSolidPath = function () {
                                var t = "M0,0 ";
                                return (t += " h" + this.globalData.compSize.w), (t += " v" + this.globalData.compSize.h), (t += " h-" + this.globalData.compSize.w) + " v-" + this.globalData.compSize.h + " ";
                            }),
                            (MaskElement.prototype.drawPath = function (t, e, r) {
                                var i,
                                    n,
                                    a = " M" + e.v[0][0] + "," + e.v[0][1];
                                for (n = e._length, i = 1; i < n; i += 1) a += " C" + e.o[i - 1][0] + "," + e.o[i - 1][1] + " " + e.i[i][0] + "," + e.i[i][1] + " " + e.v[i][0] + "," + e.v[i][1];
                                if ((e.c && n > 1 && (a += " C" + e.o[i - 1][0] + "," + e.o[i - 1][1] + " " + e.i[0][0] + "," + e.i[0][1] + " " + e.v[0][0] + "," + e.v[0][1]), r.lastPath !== a)) {
                                    var s = "";
                                    r.elem && (e.c && (s = t.inv ? this.solidPath + a : a), r.elem.setAttribute("d", s)), (r.lastPath = a);
                                }
                            }),
                            (MaskElement.prototype.destroy = function () {
                                (this.element = null), (this.globalData = null), (this.maskElement = null), (this.data = null), (this.masksProperties = null);
                            });
                        var filtersFactory = (function () {
                                var t = {
                                    createFilter: function (t, e) {
                                        var r = createNS("filter");
                                        return (
                                            r.setAttribute("id", t),
                                            !0 !== e && (r.setAttribute("filterUnits", "objectBoundingBox"), r.setAttribute("x", "0%"), r.setAttribute("y", "0%"), r.setAttribute("width", "100%"), r.setAttribute("height", "100%")),
                                            r
                                        );
                                    },
                                    createAlphaToLuminanceFilter: function () {
                                        var t = createNS("feColorMatrix");
                                        return t.setAttribute("type", "matrix"), t.setAttribute("color-interpolation-filters", "sRGB"), t.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1"), t;
                                    },
                                };
                                return t;
                            })(),
                            featureSupport = (function () {
                                var t = { maskType: !0 };
                                return (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) && (t.maskType = !1), t;
                            })(),
                            registeredEffects = {},
                            idPrefix = "filter_result_";
                        function SVGEffects(t) {
                            var e,
                                r,
                                i = "SourceGraphic",
                                n = t.data.ef ? t.data.ef.length : 0,
                                a = createElementID(),
                                s = filtersFactory.createFilter(a, !0),
                                o = 0;
                            for (this.filters = [], e = 0; e < n; e += 1) {
                                r = null;
                                var l = t.data.ef[e].ty;
                                registeredEffects[l] && ((r = new (0, registeredEffects[l].effect)(s, t.effectsManager.effectElements[e], t, idPrefix + o, i)), (i = idPrefix + o), registeredEffects[l].countsAsEffect && (o += 1)),
                                    r && this.filters.push(r);
                            }
                            o && (t.globalData.defs.appendChild(s), t.layerElement.setAttribute("filter", "url(" + getLocationHref() + "#" + a + ")")), this.filters.length && t.addRenderableComponent(this);
                        }
                        function registerEffect(t, e, r) {
                            registeredEffects[t] = { effect: e, countsAsEffect: r };
                        }
                        function SVGBaseElement() {}
                        function HierarchyElement() {}
                        function RenderableDOMElement() {}
                        function IImageElement(t, e, r) {
                            (this.assetData = e.getAssetData(t.refId)), this.initElement(t, e, r), (this.sourceRect = { top: 0, left: 0, width: this.assetData.w, height: this.assetData.h });
                        }
                        function ProcessedElement(t, e) {
                            (this.elem = t), (this.pos = e);
                        }
                        function IShapeElement() {}
                        (SVGEffects.prototype.renderFrame = function (t) {
                            var e,
                                r = this.filters.length;
                            for (e = 0; e < r; e += 1) this.filters[e].renderFrame(t);
                        }),
                            (SVGBaseElement.prototype = {
                                initRendererElement: function () {
                                    this.layerElement = createNS("g");
                                },
                                createContainerElements: function () {
                                    (this.matteElement = createNS("g")), (this.transformedElement = this.layerElement), (this.maskedElement = this.layerElement), (this._sizeChanged = !1);
                                    var t = null;
                                    if (this.data.td) {
                                        this.matteMasks = {};
                                        var e = createNS("symbol");
                                        e.setAttribute("id", this.layerId);
                                        var r = createNS("g");
                                        r.appendChild(this.layerElement), e.appendChild(r), (t = r), this.globalData.defs.appendChild(e);
                                    } else this.data.tt ? (this.matteElement.appendChild(this.layerElement), (t = this.matteElement), (this.baseElement = this.matteElement)) : (this.baseElement = this.layerElement);
                                    if ((this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), 0 === this.data.ty && !this.data.hd)) {
                                        var i = createNS("clipPath"),
                                            n = createNS("path");
                                        n.setAttribute("d", "M0,0 L" + this.data.w + ",0 L" + this.data.w + "," + this.data.h + " L0," + this.data.h + "z");
                                        var a = createElementID();
                                        if ((i.setAttribute("id", a), i.appendChild(n), this.globalData.defs.appendChild(i), this.checkMasks())) {
                                            var s = createNS("g");
                                            s.setAttribute("clip-path", "url(" + getLocationHref() + "#" + a + ")"),
                                                s.appendChild(this.layerElement),
                                                (this.transformedElement = s),
                                                t ? t.appendChild(this.transformedElement) : (this.baseElement = this.transformedElement);
                                        } else this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + a + ")");
                                    }
                                    0 !== this.data.bm && this.setBlendMode();
                                },
                                renderElement: function () {
                                    this.finalTransform._matMdf && this.transformedElement.setAttribute("transform", this.finalTransform.mat.to2dCSS()),
                                        this.finalTransform._opMdf && this.transformedElement.setAttribute("opacity", this.finalTransform.mProp.o.v);
                                },
                                destroyBaseElement: function () {
                                    (this.layerElement = null), (this.matteElement = null), this.maskManager.destroy();
                                },
                                getBaseElement: function () {
                                    return this.data.hd ? null : this.baseElement;
                                },
                                createRenderableComponents: function () {
                                    (this.maskManager = new MaskElement(this.data, this, this.globalData)), (this.renderableEffectsManager = new SVGEffects(this));
                                },
                                getMatte: function (t) {
                                    if (!this.matteMasks[t]) {
                                        var e,
                                            r,
                                            i,
                                            n,
                                            a = this.layerId + "_" + t;
                                        if (1 === t || 3 === t) {
                                            var s = createNS("mask");
                                            s.setAttribute("id", a),
                                                s.setAttribute("mask-type", 3 === t ? "luminance" : "alpha"),
                                                (i = createNS("use")).setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId),
                                                s.appendChild(i),
                                                this.globalData.defs.appendChild(s),
                                                featureSupport.maskType ||
                                                    1 !== t ||
                                                    (s.setAttribute("mask-type", "luminance"),
                                                    (e = createElementID()),
                                                    (r = filtersFactory.createFilter(e)),
                                                    this.globalData.defs.appendChild(r),
                                                    r.appendChild(filtersFactory.createAlphaToLuminanceFilter()),
                                                    (n = createNS("g")).appendChild(i),
                                                    s.appendChild(n),
                                                    n.setAttribute("filter", "url(" + getLocationHref() + "#" + e + ")"));
                                        } else if (2 === t) {
                                            var o = createNS("mask");
                                            o.setAttribute("id", a), o.setAttribute("mask-type", "alpha");
                                            var l = createNS("g");
                                            o.appendChild(l), (e = createElementID()), (r = filtersFactory.createFilter(e));
                                            var h = createNS("feComponentTransfer");
                                            h.setAttribute("in", "SourceGraphic"), r.appendChild(h);
                                            var c = createNS("feFuncA");
                                            c.setAttribute("type", "table"), c.setAttribute("tableValues", "1.0 0.0"), h.appendChild(c), this.globalData.defs.appendChild(r);
                                            var p = createNS("rect");
                                            p.setAttribute("width", this.comp.data.w),
                                                p.setAttribute("height", this.comp.data.h),
                                                p.setAttribute("x", "0"),
                                                p.setAttribute("y", "0"),
                                                p.setAttribute("fill", "#ffffff"),
                                                p.setAttribute("opacity", "0"),
                                                l.setAttribute("filter", "url(" + getLocationHref() + "#" + e + ")"),
                                                l.appendChild(p),
                                                (i = createNS("use")).setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId),
                                                l.appendChild(i),
                                                featureSupport.maskType ||
                                                    (o.setAttribute("mask-type", "luminance"),
                                                    r.appendChild(filtersFactory.createAlphaToLuminanceFilter()),
                                                    (n = createNS("g")),
                                                    l.appendChild(p),
                                                    n.appendChild(this.layerElement),
                                                    l.appendChild(n)),
                                                this.globalData.defs.appendChild(o);
                                        }
                                        this.matteMasks[t] = a;
                                    }
                                    return this.matteMasks[t];
                                },
                                setMatte: function (t) {
                                    this.matteElement && this.matteElement.setAttribute("mask", "url(" + getLocationHref() + "#" + t + ")");
                                },
                            }),
                            (HierarchyElement.prototype = {
                                initHierarchy: function () {
                                    (this.hierarchy = []), (this._isParent = !1), this.checkParenting();
                                },
                                setHierarchy: function (t) {
                                    this.hierarchy = t;
                                },
                                setAsParent: function () {
                                    this._isParent = !0;
                                },
                                checkParenting: function () {
                                    void 0 !== this.data.parent && this.comp.buildElementParenting(this, this.data.parent, []);
                                },
                            }),
                            extendPrototype(
                                [
                                    RenderableElement,
                                    createProxyFunction({
                                        initElement: function (t, e, r) {
                                            this.initFrame(),
                                                this.initBaseData(t, e, r),
                                                this.initTransform(t, e, r),
                                                this.initHierarchy(),
                                                this.initRenderable(),
                                                this.initRendererElement(),
                                                this.createContainerElements(),
                                                this.createRenderableComponents(),
                                                this.createContent(),
                                                this.hide();
                                        },
                                        hide: function () {
                                            this.hidden || (this.isInRange && !this.isTransparent) || (((this.baseElement || this.layerElement).style.display = "none"), (this.hidden = !0));
                                        },
                                        show: function () {
                                            this.isInRange && !this.isTransparent && (this.data.hd || ((this.baseElement || this.layerElement).style.display = "block"), (this.hidden = !1), (this._isFirstFrame = !0));
                                        },
                                        renderFrame: function () {
                                            this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
                                        },
                                        renderInnerContent: function () {},
                                        prepareFrame: function (t) {
                                            (this._mdf = !1), this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange), this.checkTransparency();
                                        },
                                        destroy: function () {
                                            (this.innerElem = null), this.destroyBaseElement();
                                        },
                                    }),
                                ],
                                RenderableDOMElement
                            ),
                            extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], IImageElement),
                            (IImageElement.prototype.createContent = function () {
                                var t = this.globalData.getAssetsPath(this.assetData);
                                (this.innerElem = createNS("image")),
                                    this.innerElem.setAttribute("width", this.assetData.w + "px"),
                                    this.innerElem.setAttribute("height", this.assetData.h + "px"),
                                    this.innerElem.setAttribute("preserveAspectRatio", this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio),
                                    this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", t),
                                    this.layerElement.appendChild(this.innerElem);
                            }),
                            (IImageElement.prototype.sourceRectAtTime = function () {
                                return this.sourceRect;
                            }),
                            (IShapeElement.prototype = {
                                addShapeToModifiers: function (t) {
                                    var e,
                                        r = this.shapeModifiers.length;
                                    for (e = 0; e < r; e += 1) this.shapeModifiers[e].addShape(t);
                                },
                                isShapeInAnimatedModifiers: function (t) {
                                    for (var e = this.shapeModifiers.length; 0 < e; ) if (this.shapeModifiers[0].isAnimatedWithShape(t)) return !0;
                                    return !1;
                                },
                                renderModifiers: function () {
                                    if (this.shapeModifiers.length) {
                                        var t,
                                            e = this.shapes.length;
                                        for (t = 0; t < e; t += 1) this.shapes[t].sh.reset();
                                        for (t = (e = this.shapeModifiers.length) - 1; t >= 0 && !this.shapeModifiers[t].processShapes(this._isFirstFrame); t -= 1);
                                    }
                                },
                                searchProcessedElement: function (t) {
                                    for (var e = this.processedElements, r = 0, i = e.length; r < i; ) {
                                        if (e[r].elem === t) return e[r].pos;
                                        r += 1;
                                    }
                                    return 0;
                                },
                                addProcessedElement: function (t, e) {
                                    for (var r = this.processedElements, i = r.length; i; ) if (r[(i -= 1)].elem === t) return void (r[i].pos = e);
                                    r.push(new ProcessedElement(t, e));
                                },
                                prepareFrame: function (t) {
                                    this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange);
                                },
                            });
                        var lineCapEnum = { 1: "butt", 2: "round", 3: "square" },
                            lineJoinEnum = { 1: "miter", 2: "round", 3: "bevel" };
                        function SVGShapeData(t, e, r) {
                            (this.caches = []), (this.styles = []), (this.transformers = t), (this.lStr = ""), (this.sh = r), (this.lvl = e), (this._isAnimated = !!r.k);
                            for (var i = 0, n = t.length; i < n; ) {
                                if (t[i].mProps.dynamicProperties.length) {
                                    this._isAnimated = !0;
                                    break;
                                }
                                i += 1;
                            }
                        }
                        function SVGStyleData(t, e) {
                            (this.data = t), (this.type = t.ty), (this.d = ""), (this.lvl = e), (this._mdf = !1), (this.closed = !0 === t.hd), (this.pElem = createNS("path")), (this.msElem = null);
                        }
                        function DashProperty(t, e, r, i) {
                            var n;
                            (this.elem = t),
                                (this.frameId = -1),
                                (this.dataProps = createSizedArray(e.length)),
                                (this.renderer = r),
                                (this.k = !1),
                                (this.dashStr = ""),
                                (this.dashArray = createTypedArray("float32", e.length ? e.length - 1 : 0)),
                                (this.dashoffset = createTypedArray("float32", 1)),
                                this.initDynamicPropertyContainer(i);
                            var a,
                                s = e.length || 0;
                            for (n = 0; n < s; n += 1) (a = PropertyFactory.getProp(t, e[n].v, 0, 0, this)), (this.k = a.k || this.k), (this.dataProps[n] = { n: e[n].n, p: a });
                            this.k || this.getValue(!0), (this._isAnimated = this.k);
                        }
                        function SVGStrokeStyleData(t, e, r) {
                            this.initDynamicPropertyContainer(t),
                                (this.getValue = this.iterateDynamicProperties),
                                (this.o = PropertyFactory.getProp(t, e.o, 0, 0.01, this)),
                                (this.w = PropertyFactory.getProp(t, e.w, 0, null, this)),
                                (this.d = new DashProperty(t, e.d || {}, "svg", this)),
                                (this.c = PropertyFactory.getProp(t, e.c, 1, 255, this)),
                                (this.style = r),
                                (this._isAnimated = !!this._isAnimated);
                        }
                        function SVGFillStyleData(t, e, r) {
                            this.initDynamicPropertyContainer(t),
                                (this.getValue = this.iterateDynamicProperties),
                                (this.o = PropertyFactory.getProp(t, e.o, 0, 0.01, this)),
                                (this.c = PropertyFactory.getProp(t, e.c, 1, 255, this)),
                                (this.style = r);
                        }
                        function SVGNoStyleData(t, e, r) {
                            this.initDynamicPropertyContainer(t), (this.getValue = this.iterateDynamicProperties), (this.style = r);
                        }
                        function GradientProperty(t, e, r) {
                            (this.data = e), (this.c = createTypedArray("uint8c", 4 * e.p));
                            var i = e.k.k[0].s ? e.k.k[0].s.length - 4 * e.p : e.k.k.length - 4 * e.p;
                            (this.o = createTypedArray("float32", i)),
                                (this._cmdf = !1),
                                (this._omdf = !1),
                                (this._collapsable = this.checkCollapsable()),
                                (this._hasOpacity = i),
                                this.initDynamicPropertyContainer(r),
                                (this.prop = PropertyFactory.getProp(t, e.k, 1, null, this)),
                                (this.k = this.prop.k),
                                this.getValue(!0);
                        }
                        function SVGGradientFillStyleData(t, e, r) {
                            this.initDynamicPropertyContainer(t), (this.getValue = this.iterateDynamicProperties), this.initGradientData(t, e, r);
                        }
                        function SVGGradientStrokeStyleData(t, e, r) {
                            this.initDynamicPropertyContainer(t),
                                (this.getValue = this.iterateDynamicProperties),
                                (this.w = PropertyFactory.getProp(t, e.w, 0, null, this)),
                                (this.d = new DashProperty(t, e.d || {}, "svg", this)),
                                this.initGradientData(t, e, r),
                                (this._isAnimated = !!this._isAnimated);
                        }
                        function ShapeGroupData() {
                            (this.it = []), (this.prevViewData = []), (this.gr = createNS("g"));
                        }
                        function SVGTransformData(t, e, r) {
                            (this.transform = { mProps: t, op: e, container: r }), (this.elements = []), (this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length);
                        }
                        (SVGShapeData.prototype.setAsAnimated = function () {
                            this._isAnimated = !0;
                        }),
                            (SVGStyleData.prototype.reset = function () {
                                (this.d = ""), (this._mdf = !1);
                            }),
                            (DashProperty.prototype.getValue = function (t) {
                                if ((this.elem.globalData.frameId !== this.frameId || t) && ((this.frameId = this.elem.globalData.frameId), this.iterateDynamicProperties(), (this._mdf = this._mdf || t), this._mdf)) {
                                    var e = 0,
                                        r = this.dataProps.length;
                                    for ("svg" === this.renderer && (this.dashStr = ""), e = 0; e < r; e += 1)
                                        "o" !== this.dataProps[e].n ? ("svg" === this.renderer ? (this.dashStr += " " + this.dataProps[e].p.v) : (this.dashArray[e] = this.dataProps[e].p.v)) : (this.dashoffset[0] = this.dataProps[e].p.v);
                                }
                            }),
                            extendPrototype([DynamicPropertyContainer], DashProperty),
                            extendPrototype([DynamicPropertyContainer], SVGStrokeStyleData),
                            extendPrototype([DynamicPropertyContainer], SVGFillStyleData),
                            extendPrototype([DynamicPropertyContainer], SVGNoStyleData),
                            (GradientProperty.prototype.comparePoints = function (t, e) {
                                for (var r = 0, i = this.o.length / 2; r < i; ) {
                                    if (Math.abs(t[4 * r] - t[4 * e + 2 * r]) > 0.01) return !1;
                                    r += 1;
                                }
                                return !0;
                            }),
                            (GradientProperty.prototype.checkCollapsable = function () {
                                if (this.o.length / 2 != this.c.length / 4) return !1;
                                if (this.data.k.k[0].s)
                                    for (var t = 0, e = this.data.k.k.length; t < e; ) {
                                        if (!this.comparePoints(this.data.k.k[t].s, this.data.p)) return !1;
                                        t += 1;
                                    }
                                else if (!this.comparePoints(this.data.k.k, this.data.p)) return !1;
                                return !0;
                            }),
                            (GradientProperty.prototype.getValue = function (t) {
                                if ((this.prop.getValue(), (this._mdf = !1), (this._cmdf = !1), (this._omdf = !1), this.prop._mdf || t)) {
                                    var e,
                                        r,
                                        i,
                                        n = 4 * this.data.p;
                                    for (e = 0; e < n; e += 1) (r = e % 4 == 0 ? 100 : 255), (i = Math.round(this.prop.v[e] * r)), this.c[e] !== i && ((this.c[e] = i), (this._cmdf = !t));
                                    if (this.o.length)
                                        for (n = this.prop.v.length, e = 4 * this.data.p; e < n; e += 1)
                                            (r = e % 2 == 0 ? 100 : 1), (i = e % 2 == 0 ? Math.round(100 * this.prop.v[e]) : this.prop.v[e]), this.o[e - 4 * this.data.p] !== i && ((this.o[e - 4 * this.data.p] = i), (this._omdf = !t));
                                    this._mdf = !t;
                                }
                            }),
                            extendPrototype([DynamicPropertyContainer], GradientProperty),
                            (SVGGradientFillStyleData.prototype.initGradientData = function (t, e, r) {
                                (this.o = PropertyFactory.getProp(t, e.o, 0, 0.01, this)),
                                    (this.s = PropertyFactory.getProp(t, e.s, 1, null, this)),
                                    (this.e = PropertyFactory.getProp(t, e.e, 1, null, this)),
                                    (this.h = PropertyFactory.getProp(t, e.h || { k: 0 }, 0, 0.01, this)),
                                    (this.a = PropertyFactory.getProp(t, e.a || { k: 0 }, 0, degToRads, this)),
                                    (this.g = new GradientProperty(t, e.g, this)),
                                    (this.style = r),
                                    (this.stops = []),
                                    this.setGradientData(r.pElem, e),
                                    this.setGradientOpacity(e, r),
                                    (this._isAnimated = !!this._isAnimated);
                            }),
                            (SVGGradientFillStyleData.prototype.setGradientData = function (t, e) {
                                var r = createElementID(),
                                    i = createNS(1 === e.t ? "linearGradient" : "radialGradient");
                                i.setAttribute("id", r), i.setAttribute("spreadMethod", "pad"), i.setAttribute("gradientUnits", "userSpaceOnUse");
                                var n,
                                    a,
                                    s,
                                    o = [];
                                for (s = 4 * e.g.p, a = 0; a < s; a += 4) (n = createNS("stop")), i.appendChild(n), o.push(n);
                                t.setAttribute("gf" === e.ty ? "fill" : "stroke", "url(" + getLocationHref() + "#" + r + ")"), (this.gf = i), (this.cst = o);
                            }),
                            (SVGGradientFillStyleData.prototype.setGradientOpacity = function (t, e) {
                                if (this.g._hasOpacity && !this.g._collapsable) {
                                    var r,
                                        i,
                                        n,
                                        a = createNS("mask"),
                                        s = createNS("path");
                                    a.appendChild(s);
                                    var o = createElementID(),
                                        l = createElementID();
                                    a.setAttribute("id", l);
                                    var h = createNS(1 === t.t ? "linearGradient" : "radialGradient");
                                    h.setAttribute("id", o), h.setAttribute("spreadMethod", "pad"), h.setAttribute("gradientUnits", "userSpaceOnUse"), (n = t.g.k.k[0].s ? t.g.k.k[0].s.length : t.g.k.k.length);
                                    var c = this.stops;
                                    for (i = 4 * t.g.p; i < n; i += 2) (r = createNS("stop")).setAttribute("stop-color", "rgb(255,255,255)"), h.appendChild(r), c.push(r);
                                    s.setAttribute("gf" === t.ty ? "fill" : "stroke", "url(" + getLocationHref() + "#" + o + ")"),
                                        "gs" === t.ty && (s.setAttribute("stroke-linecap", lineCapEnum[t.lc || 2]), s.setAttribute("stroke-linejoin", lineJoinEnum[t.lj || 2]), 1 === t.lj && s.setAttribute("stroke-miterlimit", t.ml)),
                                        (this.of = h),
                                        (this.ms = a),
                                        (this.ost = c),
                                        (this.maskId = l),
                                        (e.msElem = s);
                                }
                            }),
                            extendPrototype([DynamicPropertyContainer], SVGGradientFillStyleData),
                            extendPrototype([SVGGradientFillStyleData, DynamicPropertyContainer], SVGGradientStrokeStyleData);
                        var buildShapeString = function (t, e, r, i) {
                                if (0 === e) return "";
                                var n,
                                    a = t.o,
                                    s = t.i,
                                    o = t.v,
                                    l = " M" + i.applyToPointStringified(o[0][0], o[0][1]);
                                for (n = 1; n < e; n += 1) l += " C" + i.applyToPointStringified(a[n - 1][0], a[n - 1][1]) + " " + i.applyToPointStringified(s[n][0], s[n][1]) + " " + i.applyToPointStringified(o[n][0], o[n][1]);
                                return r && e && ((l += " C" + i.applyToPointStringified(a[n - 1][0], a[n - 1][1]) + " " + i.applyToPointStringified(s[0][0], s[0][1]) + " " + i.applyToPointStringified(o[0][0], o[0][1])), (l += "z")), l;
                            },
                            SVGElementsRenderer = (function () {
                                var t = new Matrix(),
                                    e = new Matrix();
                                function r(t, e, r) {
                                    (r || e.transform.op._mdf) && e.transform.container.setAttribute("opacity", e.transform.op.v),
                                        (r || e.transform.mProps._mdf) && e.transform.container.setAttribute("transform", e.transform.mProps.v.to2dCSS());
                                }
                                function i() {}
                                function n(r, i, n) {
                                    var a,
                                        s,
                                        o,
                                        l,
                                        h,
                                        c,
                                        p,
                                        u,
                                        f,
                                        d,
                                        m,
                                        y = i.styles.length,
                                        v = i.lvl;
                                    for (c = 0; c < y; c += 1) {
                                        if (((l = i.sh._mdf || n), i.styles[c].lvl < v)) {
                                            for (u = e.reset(), d = v - i.styles[c].lvl, m = i.transformers.length - 1; !l && d > 0; ) (l = i.transformers[m].mProps._mdf || l), (d -= 1), (m -= 1);
                                            if (l)
                                                for (d = v - i.styles[c].lvl, m = i.transformers.length - 1; d > 0; )
                                                    (f = i.transformers[m].mProps.v.props), u.transform(f[0], f[1], f[2], f[3], f[4], f[5], f[6], f[7], f[8], f[9], f[10], f[11], f[12], f[13], f[14], f[15]), (d -= 1), (m -= 1);
                                        } else u = t;
                                        if (((s = (p = i.sh.paths)._length), l)) {
                                            for (o = "", a = 0; a < s; a += 1) (h = p.shapes[a]) && h._length && (o += buildShapeString(h, h._length, h.c, u));
                                            i.caches[c] = o;
                                        } else o = i.caches[c];
                                        (i.styles[c].d += !0 === r.hd ? "" : o), (i.styles[c]._mdf = l || i.styles[c]._mdf);
                                    }
                                }
                                function a(t, e, r) {
                                    var i = e.style;
                                    (e.c._mdf || r) && i.pElem.setAttribute("fill", "rgb(" + bmFloor(e.c.v[0]) + "," + bmFloor(e.c.v[1]) + "," + bmFloor(e.c.v[2]) + ")"), (e.o._mdf || r) && i.pElem.setAttribute("fill-opacity", e.o.v);
                                }
                                function s(t, e, r) {
                                    o(t, e, r), l(0, e, r);
                                }
                                function o(t, e, r) {
                                    var i,
                                        n,
                                        a,
                                        s,
                                        o,
                                        l = e.gf,
                                        h = e.g._hasOpacity,
                                        c = e.s.v,
                                        p = e.e.v;
                                    if (e.o._mdf || r) {
                                        var u = "gf" === t.ty ? "fill-opacity" : "stroke-opacity";
                                        e.style.pElem.setAttribute(u, e.o.v);
                                    }
                                    if (e.s._mdf || r) {
                                        var f = 1 === t.t ? "x1" : "cx",
                                            d = "x1" === f ? "y1" : "cy";
                                        l.setAttribute(f, c[0]), l.setAttribute(d, c[1]), h && !e.g._collapsable && (e.of.setAttribute(f, c[0]), e.of.setAttribute(d, c[1]));
                                    }
                                    if (e.g._cmdf || r) {
                                        i = e.cst;
                                        var m = e.g.c;
                                        for (a = i.length, n = 0; n < a; n += 1) (s = i[n]).setAttribute("offset", m[4 * n] + "%"), s.setAttribute("stop-color", "rgb(" + m[4 * n + 1] + "," + m[4 * n + 2] + "," + m[4 * n + 3] + ")");
                                    }
                                    if (h && (e.g._omdf || r)) {
                                        var y = e.g.o;
                                        for (a = (i = e.g._collapsable ? e.cst : e.ost).length, n = 0; n < a; n += 1) (s = i[n]), e.g._collapsable || s.setAttribute("offset", y[2 * n] + "%"), s.setAttribute("stop-opacity", y[2 * n + 1]);
                                    }
                                    if (1 === t.t) (e.e._mdf || r) && (l.setAttribute("x2", p[0]), l.setAttribute("y2", p[1]), h && !e.g._collapsable && (e.of.setAttribute("x2", p[0]), e.of.setAttribute("y2", p[1])));
                                    else if (
                                        ((e.s._mdf || e.e._mdf || r) && ((o = Math.sqrt(Math.pow(c[0] - p[0], 2) + Math.pow(c[1] - p[1], 2))), l.setAttribute("r", o), h && !e.g._collapsable && e.of.setAttribute("r", o)),
                                        e.e._mdf || e.h._mdf || e.a._mdf || r)
                                    ) {
                                        o || (o = Math.sqrt(Math.pow(c[0] - p[0], 2) + Math.pow(c[1] - p[1], 2)));
                                        var v = Math.atan2(p[1] - c[1], p[0] - c[0]),
                                            g = e.h.v;
                                        g >= 1 ? (g = 0.99) : g <= -1 && (g = -0.99);
                                        var _ = o * g,
                                            b = Math.cos(v + e.a.v) * _ + c[0],
                                            E = Math.sin(v + e.a.v) * _ + c[1];
                                        l.setAttribute("fx", b), l.setAttribute("fy", E), h && !e.g._collapsable && (e.of.setAttribute("fx", b), e.of.setAttribute("fy", E));
                                    }
                                }
                                function l(t, e, r) {
                                    var i = e.style,
                                        n = e.d;
                                    n && (n._mdf || r) && n.dashStr && (i.pElem.setAttribute("stroke-dasharray", n.dashStr), i.pElem.setAttribute("stroke-dashoffset", n.dashoffset[0])),
                                        e.c && (e.c._mdf || r) && i.pElem.setAttribute("stroke", "rgb(" + bmFloor(e.c.v[0]) + "," + bmFloor(e.c.v[1]) + "," + bmFloor(e.c.v[2]) + ")"),
                                        (e.o._mdf || r) && i.pElem.setAttribute("stroke-opacity", e.o.v),
                                        (e.w._mdf || r) && (i.pElem.setAttribute("stroke-width", e.w.v), i.msElem && i.msElem.setAttribute("stroke-width", e.w.v));
                                }
                                return {
                                    createRenderFunction: function (t) {
                                        switch (t.ty) {
                                            case "fl":
                                                return a;
                                            case "gf":
                                                return o;
                                            case "gs":
                                                return s;
                                            case "st":
                                                return l;
                                            case "sh":
                                            case "el":
                                            case "rc":
                                            case "sr":
                                                return n;
                                            case "tr":
                                                return r;
                                            case "no":
                                                return i;
                                            default:
                                                return null;
                                        }
                                    },
                                };
                            })();
                        function SVGShapeElement(t, e, r) {
                            (this.shapes = []),
                                (this.shapesData = t.shapes),
                                (this.stylesList = []),
                                (this.shapeModifiers = []),
                                (this.itemsData = []),
                                (this.processedElements = []),
                                (this.animatedContents = []),
                                this.initElement(t, e, r),
                                (this.prevViewData = []);
                        }
                        function LetterProps(t, e, r, i, n, a) {
                            (this.o = t), (this.sw = e), (this.sc = r), (this.fc = i), (this.m = n), (this.p = a), (this._mdf = { o: !0, sw: !!e, sc: !!r, fc: !!i, m: !0, p: !0 });
                        }
                        function TextProperty(t, e) {
                            (this._frameId = initialDefaultFrame),
                                (this.pv = ""),
                                (this.v = ""),
                                (this.kf = !1),
                                (this._isFirstFrame = !0),
                                (this._mdf = !1),
                                (this.data = e),
                                (this.elem = t),
                                (this.comp = this.elem.comp),
                                (this.keysIndex = 0),
                                (this.canResize = !1),
                                (this.minimumFontSize = 1),
                                (this.effectsSequence = []),
                                (this.currentData = {
                                    ascent: 0,
                                    boxWidth: this.defaultBoxWidth,
                                    f: "",
                                    fStyle: "",
                                    fWeight: "",
                                    fc: "",
                                    j: "",
                                    justifyOffset: "",
                                    l: [],
                                    lh: 0,
                                    lineWidths: [],
                                    ls: "",
                                    of: "",
                                    s: "",
                                    sc: "",
                                    sw: 0,
                                    t: 0,
                                    tr: 0,
                                    sz: 0,
                                    ps: null,
                                    fillColorAnim: !1,
                                    strokeColorAnim: !1,
                                    strokeWidthAnim: !1,
                                    yOffset: 0,
                                    finalSize: 0,
                                    finalText: [],
                                    finalLineHeight: 0,
                                    __complete: !1,
                                }),
                                this.copyData(this.currentData, this.data.d.k[0].s),
                                this.searchProperty() || this.completeTextData(this.currentData);
                        }
                        extendPrototype([BaseElement, TransformElement, SVGBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableDOMElement], SVGShapeElement),
                            (SVGShapeElement.prototype.initSecondaryElement = function () {}),
                            (SVGShapeElement.prototype.identityMatrix = new Matrix()),
                            (SVGShapeElement.prototype.buildExpressionInterface = function () {}),
                            (SVGShapeElement.prototype.createContent = function () {
                                this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes();
                            }),
                            (SVGShapeElement.prototype.filterUniqueShapes = function () {
                                var t,
                                    e,
                                    r,
                                    i,
                                    n = this.shapes.length,
                                    a = this.stylesList.length,
                                    s = [],
                                    o = !1;
                                for (r = 0; r < a; r += 1) {
                                    for (i = this.stylesList[r], o = !1, s.length = 0, t = 0; t < n; t += 1) -1 !== (e = this.shapes[t]).styles.indexOf(i) && (s.push(e), (o = e._isAnimated || o));
                                    s.length > 1 && o && this.setShapesAsAnimated(s);
                                }
                            }),
                            (SVGShapeElement.prototype.setShapesAsAnimated = function (t) {
                                var e,
                                    r = t.length;
                                for (e = 0; e < r; e += 1) t[e].setAsAnimated();
                            }),
                            (SVGShapeElement.prototype.createStyleElement = function (t, e) {
                                var r,
                                    i = new SVGStyleData(t, e),
                                    n = i.pElem;
                                return (
                                    "st" === t.ty
                                        ? (r = new SVGStrokeStyleData(this, t, i))
                                        : "fl" === t.ty
                                        ? (r = new SVGFillStyleData(this, t, i))
                                        : "gf" === t.ty || "gs" === t.ty
                                        ? ((r = new ("gf" === t.ty ? SVGGradientFillStyleData : SVGGradientStrokeStyleData)(this, t, i)),
                                          this.globalData.defs.appendChild(r.gf),
                                          r.maskId && (this.globalData.defs.appendChild(r.ms), this.globalData.defs.appendChild(r.of), n.setAttribute("mask", "url(" + getLocationHref() + "#" + r.maskId + ")")))
                                        : "no" === t.ty && (r = new SVGNoStyleData(this, t, i)),
                                    ("st" !== t.ty && "gs" !== t.ty) ||
                                        (n.setAttribute("stroke-linecap", lineCapEnum[t.lc || 2]),
                                        n.setAttribute("stroke-linejoin", lineJoinEnum[t.lj || 2]),
                                        n.setAttribute("fill-opacity", "0"),
                                        1 === t.lj && n.setAttribute("stroke-miterlimit", t.ml)),
                                    2 === t.r && n.setAttribute("fill-rule", "evenodd"),
                                    t.ln && n.setAttribute("id", t.ln),
                                    t.cl && n.setAttribute("class", t.cl),
                                    t.bm && (n.style["mix-blend-mode"] = getBlendMode(t.bm)),
                                    this.stylesList.push(i),
                                    this.addToAnimatedContents(t, r),
                                    r
                                );
                            }),
                            (SVGShapeElement.prototype.createGroupElement = function (t) {
                                var e = new ShapeGroupData();
                                return t.ln && e.gr.setAttribute("id", t.ln), t.cl && e.gr.setAttribute("class", t.cl), t.bm && (e.gr.style["mix-blend-mode"] = getBlendMode(t.bm)), e;
                            }),
                            (SVGShapeElement.prototype.createTransformElement = function (t, e) {
                                var r = TransformPropertyFactory.getTransformProperty(this, t, this),
                                    i = new SVGTransformData(r, r.o, e);
                                return this.addToAnimatedContents(t, i), i;
                            }),
                            (SVGShapeElement.prototype.createShapeElement = function (t, e, r) {
                                var i = 4;
                                "rc" === t.ty ? (i = 5) : "el" === t.ty ? (i = 6) : "sr" === t.ty && (i = 7);
                                var n = new SVGShapeData(e, r, ShapePropertyFactory.getShapeProp(this, t, i, this));
                                return this.shapes.push(n), this.addShapeToModifiers(n), this.addToAnimatedContents(t, n), n;
                            }),
                            (SVGShapeElement.prototype.addToAnimatedContents = function (t, e) {
                                for (var r = 0, i = this.animatedContents.length; r < i; ) {
                                    if (this.animatedContents[r].element === e) return;
                                    r += 1;
                                }
                                this.animatedContents.push({ fn: SVGElementsRenderer.createRenderFunction(t), element: e, data: t });
                            }),
                            (SVGShapeElement.prototype.setElementStyles = function (t) {
                                var e,
                                    r = t.styles,
                                    i = this.stylesList.length;
                                for (e = 0; e < i; e += 1) this.stylesList[e].closed || r.push(this.stylesList[e]);
                            }),
                            (SVGShapeElement.prototype.reloadShapes = function () {
                                var t;
                                this._isFirstFrame = !0;
                                var e = this.itemsData.length;
                                for (t = 0; t < e; t += 1) this.prevViewData[t] = this.itemsData[t];
                                for (this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes(), e = this.dynamicProperties.length, t = 0; t < e; t += 1)
                                    this.dynamicProperties[t].getValue();
                                this.renderModifiers();
                            }),
                            (SVGShapeElement.prototype.searchShapes = function (t, e, r, i, n, a, s) {
                                var o,
                                    l,
                                    h,
                                    c,
                                    p,
                                    u,
                                    f = [].concat(a),
                                    d = t.length - 1,
                                    m = [],
                                    y = [];
                                for (o = d; o >= 0; o -= 1) {
                                    if (((u = this.searchProcessedElement(t[o])) ? (e[o] = r[u - 1]) : (t[o]._render = s), "fl" === t[o].ty || "st" === t[o].ty || "gf" === t[o].ty || "gs" === t[o].ty || "no" === t[o].ty))
                                        u ? (e[o].style.closed = !1) : (e[o] = this.createStyleElement(t[o], n)), t[o]._render && e[o].style.pElem.parentNode !== i && i.appendChild(e[o].style.pElem), m.push(e[o].style);
                                    else if ("gr" === t[o].ty) {
                                        if (u) for (h = e[o].it.length, l = 0; l < h; l += 1) e[o].prevViewData[l] = e[o].it[l];
                                        else e[o] = this.createGroupElement(t[o]);
                                        this.searchShapes(t[o].it, e[o].it, e[o].prevViewData, e[o].gr, n + 1, f, s), t[o]._render && e[o].gr.parentNode !== i && i.appendChild(e[o].gr);
                                    } else
                                        "tr" === t[o].ty
                                            ? (u || (e[o] = this.createTransformElement(t[o], i)), (c = e[o].transform), f.push(c))
                                            : "sh" === t[o].ty || "rc" === t[o].ty || "el" === t[o].ty || "sr" === t[o].ty
                                            ? (u || (e[o] = this.createShapeElement(t[o], f, n)), this.setElementStyles(e[o]))
                                            : "tm" === t[o].ty || "rd" === t[o].ty || "ms" === t[o].ty || "pb" === t[o].ty || "zz" === t[o].ty || "op" === t[o].ty
                                            ? (u ? ((p = e[o]).closed = !1) : ((p = ShapeModifiers.getModifier(t[o].ty)).init(this, t[o]), (e[o] = p), this.shapeModifiers.push(p)), y.push(p))
                                            : "rp" === t[o].ty && (u ? ((p = e[o]).closed = !0) : ((p = ShapeModifiers.getModifier(t[o].ty)), (e[o] = p), p.init(this, t, o, e), this.shapeModifiers.push(p), (s = !1)), y.push(p));
                                    this.addProcessedElement(t[o], o + 1);
                                }
                                for (d = m.length, o = 0; o < d; o += 1) m[o].closed = !0;
                                for (d = y.length, o = 0; o < d; o += 1) y[o].closed = !0;
                            }),
                            (SVGShapeElement.prototype.renderInnerContent = function () {
                                var t;
                                this.renderModifiers();
                                var e = this.stylesList.length;
                                for (t = 0; t < e; t += 1) this.stylesList[t].reset();
                                for (this.renderShape(), t = 0; t < e; t += 1)
                                    (this.stylesList[t]._mdf || this._isFirstFrame) &&
                                        (this.stylesList[t].msElem && (this.stylesList[t].msElem.setAttribute("d", this.stylesList[t].d), (this.stylesList[t].d = "M0 0" + this.stylesList[t].d)),
                                        this.stylesList[t].pElem.setAttribute("d", this.stylesList[t].d || "M0 0"));
                            }),
                            (SVGShapeElement.prototype.renderShape = function () {
                                var t,
                                    e,
                                    r = this.animatedContents.length;
                                for (t = 0; t < r; t += 1) (e = this.animatedContents[t]), (this._isFirstFrame || e.element._isAnimated) && !0 !== e.data && e.fn(e.data, e.element, this._isFirstFrame);
                            }),
                            (SVGShapeElement.prototype.destroy = function () {
                                this.destroyBaseElement(), (this.shapesData = null), (this.itemsData = null);
                            }),
                            (LetterProps.prototype.update = function (t, e, r, i, n, a) {
                                (this._mdf.o = !1), (this._mdf.sw = !1), (this._mdf.sc = !1), (this._mdf.fc = !1), (this._mdf.m = !1), (this._mdf.p = !1);
                                var s = !1;
                                return (
                                    this.o !== t && ((this.o = t), (this._mdf.o = !0), (s = !0)),
                                    this.sw !== e && ((this.sw = e), (this._mdf.sw = !0), (s = !0)),
                                    this.sc !== r && ((this.sc = r), (this._mdf.sc = !0), (s = !0)),
                                    this.fc !== i && ((this.fc = i), (this._mdf.fc = !0), (s = !0)),
                                    this.m !== n && ((this.m = n), (this._mdf.m = !0), (s = !0)),
                                    !a.length || (this.p[0] === a[0] && this.p[1] === a[1] && this.p[4] === a[4] && this.p[5] === a[5] && this.p[12] === a[12] && this.p[13] === a[13]) || ((this.p = a), (this._mdf.p = !0), (s = !0)),
                                    s
                                );
                            }),
                            (TextProperty.prototype.defaultBoxWidth = [0, 0]),
                            (TextProperty.prototype.copyData = function (t, e) {
                                for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
                                return t;
                            }),
                            (TextProperty.prototype.setCurrentData = function (t) {
                                t.__complete || this.completeTextData(t), (this.currentData = t), (this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth), (this._mdf = !0);
                            }),
                            (TextProperty.prototype.searchProperty = function () {
                                return this.searchKeyframes();
                            }),
                            (TextProperty.prototype.searchKeyframes = function () {
                                return (this.kf = this.data.d.k.length > 1), this.kf && this.addEffect(this.getKeyframeValue.bind(this)), this.kf;
                            }),
                            (TextProperty.prototype.addEffect = function (t) {
                                this.effectsSequence.push(t), this.elem.addDynamicProperty(this);
                            }),
                            (TextProperty.prototype.getValue = function (t) {
                                if ((this.elem.globalData.frameId !== this.frameId && this.effectsSequence.length) || t) {
                                    this.currentData.t = this.data.d.k[this.keysIndex].s.t;
                                    var e = this.currentData,
                                        r = this.keysIndex;
                                    if (this.lock) this.setCurrentData(this.currentData);
                                    else {
                                        var i;
                                        (this.lock = !0), (this._mdf = !1);
                                        var n = this.effectsSequence.length,
                                            a = t || this.data.d.k[this.keysIndex].s;
                                        for (i = 0; i < n; i += 1) a = r !== this.keysIndex ? this.effectsSequence[i](a, a.t) : this.effectsSequence[i](this.currentData, a.t);
                                        e !== a && this.setCurrentData(a), (this.v = this.currentData), (this.pv = this.v), (this.lock = !1), (this.frameId = this.elem.globalData.frameId);
                                    }
                                }
                            }),
                            (TextProperty.prototype.getKeyframeValue = function () {
                                for (var t = this.data.d.k, e = this.elem.comp.renderedFrame, r = 0, i = t.length; r <= i - 1 && !(r === i - 1 || t[r + 1].t > e); ) r += 1;
                                return this.keysIndex !== r && (this.keysIndex = r), this.data.d.k[this.keysIndex].s;
                            }),
                            (TextProperty.prototype.buildFinalText = function (t) {
                                for (var e, r, i = [], n = 0, a = t.length, s = !1; n < a; )
                                    (e = t.charCodeAt(n)),
                                        FontManager.isCombinedCharacter(e)
                                            ? (i[i.length - 1] += t.charAt(n))
                                            : e >= 55296 && e <= 56319
                                            ? (r = t.charCodeAt(n + 1)) >= 56320 && r <= 57343
                                                ? (s || FontManager.isModifier(e, r) ? ((i[i.length - 1] += t.substr(n, 2)), (s = !1)) : i.push(t.substr(n, 2)), (n += 1))
                                                : i.push(t.charAt(n))
                                            : e > 56319
                                            ? ((r = t.charCodeAt(n + 1)), FontManager.isZeroWidthJoiner(e, r) ? ((s = !0), (i[i.length - 1] += t.substr(n, 2)), (n += 1)) : i.push(t.charAt(n)))
                                            : FontManager.isZeroWidthJoiner(e)
                                            ? ((i[i.length - 1] += t.charAt(n)), (s = !0))
                                            : i.push(t.charAt(n)),
                                        (n += 1);
                                return i;
                            }),
                            (TextProperty.prototype.completeTextData = function (t) {
                                t.__complete = !0;
                                var e,
                                    r,
                                    i,
                                    n,
                                    a,
                                    s,
                                    o,
                                    l = this.elem.globalData.fontManager,
                                    h = this.data,
                                    c = [],
                                    p = 0,
                                    u = h.m.g,
                                    f = 0,
                                    d = 0,
                                    m = 0,
                                    y = [],
                                    v = 0,
                                    g = 0,
                                    _ = l.getFontByName(t.f),
                                    b = 0,
                                    E = getFontProperties(_);
                                (t.fWeight = E.weight), (t.fStyle = E.style), (t.finalSize = t.s), (t.finalText = this.buildFinalText(t.t)), (r = t.finalText.length), (t.finalLineHeight = t.lh);
                                var S,
                                    P = (t.tr / 1e3) * t.finalSize;
                                if (t.sz)
                                    for (var w, x, A = !0, C = t.sz[0], T = t.sz[1]; A; ) {
                                        (w = 0), (v = 0), (r = (x = this.buildFinalText(t.t)).length), (P = (t.tr / 1e3) * t.finalSize);
                                        var k = -1;
                                        for (e = 0; e < r; e += 1)
                                            (S = x[e].charCodeAt(0)),
                                                (i = !1),
                                                " " === x[e] ? (k = e) : (13 !== S && 3 !== S) || ((v = 0), (i = !0), (w += t.finalLineHeight || 1.2 * t.finalSize)),
                                                l.chars ? ((o = l.getCharData(x[e], _.fStyle, _.fFamily)), (b = i ? 0 : (o.w * t.finalSize) / 100)) : (b = l.measureText(x[e], t.f, t.finalSize)),
                                                v + b > C && " " !== x[e] ? (-1 === k ? (r += 1) : (e = k), (w += t.finalLineHeight || 1.2 * t.finalSize), x.splice(e, k === e ? 1 : 0, "\r"), (k = -1), (v = 0)) : ((v += b), (v += P));
                                        (w += (_.ascent * t.finalSize) / 100),
                                            this.canResize && t.finalSize > this.minimumFontSize && T < w ? ((t.finalSize -= 1), (t.finalLineHeight = (t.finalSize * t.lh) / t.s)) : ((t.finalText = x), (r = t.finalText.length), (A = !1));
                                    }
                                (v = -P), (b = 0);
                                var D,
                                    M = 0;
                                for (e = 0; e < r; e += 1)
                                    if (
                                        ((i = !1),
                                        13 === (S = (D = t.finalText[e]).charCodeAt(0)) || 3 === S ? ((M = 0), y.push(v), (g = v > g ? v : g), (v = -2 * P), (n = ""), (i = !0), (m += 1)) : (n = D),
                                        l.chars ? ((o = l.getCharData(D, _.fStyle, l.getFontByName(t.f).fFamily)), (b = i ? 0 : (o.w * t.finalSize) / 100)) : (b = l.measureText(n, t.f, t.finalSize)),
                                        " " === D ? (M += b + P) : ((v += b + P + M), (M = 0)),
                                        c.push({ l: b, an: b, add: f, n: i, anIndexes: [], val: n, line: m, animatorJustifyOffset: 0 }),
                                        2 == u)
                                    ) {
                                        if (((f += b), "" === n || " " === n || e === r - 1)) {
                                            for (("" !== n && " " !== n) || (f -= b); d <= e; ) (c[d].an = f), (c[d].ind = p), (c[d].extra = b), (d += 1);
                                            (p += 1), (f = 0);
                                        }
                                    } else if (3 == u) {
                                        if (((f += b), "" === n || e === r - 1)) {
                                            for ("" === n && (f -= b); d <= e; ) (c[d].an = f), (c[d].ind = p), (c[d].extra = b), (d += 1);
                                            (f = 0), (p += 1);
                                        }
                                    } else (c[p].ind = p), (c[p].extra = 0), (p += 1);
                                if (((t.l = c), (g = v > g ? v : g), y.push(v), t.sz)) (t.boxWidth = t.sz[0]), (t.justifyOffset = 0);
                                else
                                    switch (((t.boxWidth = g), t.j)) {
                                        case 1:
                                            t.justifyOffset = -t.boxWidth;
                                            break;
                                        case 2:
                                            t.justifyOffset = -t.boxWidth / 2;
                                            break;
                                        default:
                                            t.justifyOffset = 0;
                                    }
                                t.lineWidths = y;
                                var I,
                                    F,
                                    L,
                                    O,
                                    R = h.a;
                                s = R.length;
                                var B = [];
                                for (a = 0; a < s; a += 1) {
                                    for ((I = R[a]).a.sc && (t.strokeColorAnim = !0), I.a.sw && (t.strokeWidthAnim = !0), (I.a.fc || I.a.fh || I.a.fs || I.a.fb) && (t.fillColorAnim = !0), O = 0, L = I.s.b, e = 0; e < r; e += 1)
                                        ((F = c[e]).anIndexes[a] = O),
                                            ((1 == L && "" !== F.val) || (2 == L && "" !== F.val && " " !== F.val) || (3 == L && (F.n || " " == F.val || e == r - 1)) || (4 == L && (F.n || e == r - 1))) &&
                                                (1 === I.s.rn && B.push(O), (O += 1));
                                    h.a[a].s.totalChars = O;
                                    var G,
                                        V = -1;
                                    if (1 === I.s.rn) for (e = 0; e < r; e += 1) V != (F = c[e]).anIndexes[a] && ((V = F.anIndexes[a]), (G = B.splice(Math.floor(Math.random() * B.length), 1)[0])), (F.anIndexes[a] = G);
                                }
                                (t.yOffset = t.finalLineHeight || 1.2 * t.finalSize), (t.ls = t.ls || 0), (t.ascent = (_.ascent * t.finalSize) / 100);
                            }),
                            (TextProperty.prototype.updateDocumentData = function (t, e) {
                                e = void 0 === e ? this.keysIndex : e;
                                var r = this.copyData({}, this.data.d.k[e].s);
                                (r = this.copyData(r, t)), (this.data.d.k[e].s = r), this.recalculate(e), this.elem.addDynamicProperty(this);
                            }),
                            (TextProperty.prototype.recalculate = function (t) {
                                var e = this.data.d.k[t].s;
                                (e.__complete = !1), (this.keysIndex = 0), (this._isFirstFrame = !0), this.getValue(e);
                            }),
                            (TextProperty.prototype.canResizeFont = function (t) {
                                (this.canResize = t), this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
                            }),
                            (TextProperty.prototype.setMinimumFontSize = function (t) {
                                (this.minimumFontSize = Math.floor(t) || 1), this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
                            });
                        var TextSelectorProp = (function () {
                            var t = Math.max,
                                e = Math.min,
                                r = Math.floor;
                            function i(t, e) {
                                (this._currentTextLength = -1),
                                    (this.k = !1),
                                    (this.data = e),
                                    (this.elem = t),
                                    (this.comp = t.comp),
                                    (this.finalS = 0),
                                    (this.finalE = 0),
                                    this.initDynamicPropertyContainer(t),
                                    (this.s = PropertyFactory.getProp(t, e.s || { k: 0 }, 0, 0, this)),
                                    (this.e = "e" in e ? PropertyFactory.getProp(t, e.e, 0, 0, this) : { v: 100 }),
                                    (this.o = PropertyFactory.getProp(t, e.o || { k: 0 }, 0, 0, this)),
                                    (this.xe = PropertyFactory.getProp(t, e.xe || { k: 0 }, 0, 0, this)),
                                    (this.ne = PropertyFactory.getProp(t, e.ne || { k: 0 }, 0, 0, this)),
                                    (this.sm = PropertyFactory.getProp(t, e.sm || { k: 100 }, 0, 0, this)),
                                    (this.a = PropertyFactory.getProp(t, e.a, 0, 0.01, this)),
                                    this.dynamicProperties.length || this.getValue();
                            }
                            return (
                                (i.prototype = {
                                    getMult: function (i) {
                                        this._currentTextLength !== this.elem.textProperty.currentData.l.length && this.getValue();
                                        var n = 0,
                                            a = 0,
                                            s = 1,
                                            o = 1;
                                        this.ne.v > 0 ? (n = this.ne.v / 100) : (a = -this.ne.v / 100), this.xe.v > 0 ? (s = 1 - this.xe.v / 100) : (o = 1 + this.xe.v / 100);
                                        var l = BezierFactory.getBezierEasing(n, a, s, o).get,
                                            h = 0,
                                            c = this.finalS,
                                            p = this.finalE,
                                            u = this.data.sh;
                                        if (2 === u) h = l((h = p === c ? (i >= p ? 1 : 0) : t(0, e(0.5 / (p - c) + (i - c) / (p - c), 1))));
                                        else if (3 === u) h = l((h = p === c ? (i >= p ? 0 : 1) : 1 - t(0, e(0.5 / (p - c) + (i - c) / (p - c), 1))));
                                        else if (4 === u) p === c ? (h = 0) : (h = t(0, e(0.5 / (p - c) + (i - c) / (p - c), 1))) < 0.5 ? (h *= 2) : (h = 1 - 2 * (h - 0.5)), (h = l(h));
                                        else if (5 === u) {
                                            if (p === c) h = 0;
                                            else {
                                                var f = p - c,
                                                    d = -f / 2 + (i = e(t(0, i + 0.5 - c), p - c)),
                                                    m = f / 2;
                                                h = Math.sqrt(1 - (d * d) / (m * m));
                                            }
                                            h = l(h);
                                        } else
                                            6 === u
                                                ? (p === c ? (h = 0) : ((i = e(t(0, i + 0.5 - c), p - c)), (h = (1 + Math.cos(Math.PI + (2 * Math.PI * i) / (p - c))) / 2)), (h = l(h)))
                                                : (i >= r(c) && (h = t(0, e(i - c < 0 ? e(p, 1) - (c - i) : p - i, 1))), (h = l(h)));
                                        if (100 !== this.sm.v) {
                                            var y = 0.01 * this.sm.v;
                                            0 === y && (y = 1e-8);
                                            var v = 0.5 - 0.5 * y;
                                            h < v ? (h = 0) : (h = (h - v) / y) > 1 && (h = 1);
                                        }
                                        return h * this.a.v;
                                    },
                                    getValue: function (t) {
                                        this.iterateDynamicProperties(),
                                            (this._mdf = t || this._mdf),
                                            (this._currentTextLength = this.elem.textProperty.currentData.l.length || 0),
                                            t && 2 === this.data.r && (this.e.v = this._currentTextLength);
                                        var e = 2 === this.data.r ? 1 : 100 / this.data.totalChars,
                                            r = this.o.v / e,
                                            i = this.s.v / e + r,
                                            n = this.e.v / e + r;
                                        if (i > n) {
                                            var a = i;
                                            (i = n), (n = a);
                                        }
                                        (this.finalS = i), (this.finalE = n);
                                    },
                                }),
                                extendPrototype([DynamicPropertyContainer], i),
                                {
                                    getTextSelectorProp: function (t, e, r) {
                                        return new i(t, e, r);
                                    },
                                }
                            );
                        })();
                        function TextAnimatorDataProperty(t, e, r) {
                            var i = { propType: !1 },
                                n = PropertyFactory.getProp,
                                a = e.a;
                            (this.a = {
                                r: a.r ? n(t, a.r, 0, degToRads, r) : i,
                                rx: a.rx ? n(t, a.rx, 0, degToRads, r) : i,
                                ry: a.ry ? n(t, a.ry, 0, degToRads, r) : i,
                                sk: a.sk ? n(t, a.sk, 0, degToRads, r) : i,
                                sa: a.sa ? n(t, a.sa, 0, degToRads, r) : i,
                                s: a.s ? n(t, a.s, 1, 0.01, r) : i,
                                a: a.a ? n(t, a.a, 1, 0, r) : i,
                                o: a.o ? n(t, a.o, 0, 0.01, r) : i,
                                p: a.p ? n(t, a.p, 1, 0, r) : i,
                                sw: a.sw ? n(t, a.sw, 0, 0, r) : i,
                                sc: a.sc ? n(t, a.sc, 1, 0, r) : i,
                                fc: a.fc ? n(t, a.fc, 1, 0, r) : i,
                                fh: a.fh ? n(t, a.fh, 0, 0, r) : i,
                                fs: a.fs ? n(t, a.fs, 0, 0.01, r) : i,
                                fb: a.fb ? n(t, a.fb, 0, 0.01, r) : i,
                                t: a.t ? n(t, a.t, 0, 0, r) : i,
                            }),
                                (this.s = TextSelectorProp.getTextSelectorProp(t, e.s, r)),
                                (this.s.t = e.s.t);
                        }
                        function TextAnimatorProperty(t, e, r) {
                            (this._isFirstFrame = !0),
                                (this._hasMaskedPath = !1),
                                (this._frameId = -1),
                                (this._textData = t),
                                (this._renderType = e),
                                (this._elem = r),
                                (this._animatorsData = createSizedArray(this._textData.a.length)),
                                (this._pathData = {}),
                                (this._moreOptions = { alignment: {} }),
                                (this.renderedLetters = []),
                                (this.lettersChangedFlag = !1),
                                this.initDynamicPropertyContainer(r);
                        }
                        function ITextElement() {}
                        (TextAnimatorProperty.prototype.searchProperties = function () {
                            var t,
                                e,
                                r = this._textData.a.length,
                                i = PropertyFactory.getProp;
                            for (t = 0; t < r; t += 1) (e = this._textData.a[t]), (this._animatorsData[t] = new TextAnimatorDataProperty(this._elem, e, this));
                            this._textData.p && "m" in this._textData.p
                                ? ((this._pathData = {
                                      a: i(this._elem, this._textData.p.a, 0, 0, this),
                                      f: i(this._elem, this._textData.p.f, 0, 0, this),
                                      l: i(this._elem, this._textData.p.l, 0, 0, this),
                                      r: i(this._elem, this._textData.p.r, 0, 0, this),
                                      p: i(this._elem, this._textData.p.p, 0, 0, this),
                                      m: this._elem.maskManager.getMaskProperty(this._textData.p.m),
                                  }),
                                  (this._hasMaskedPath = !0))
                                : (this._hasMaskedPath = !1),
                                (this._moreOptions.alignment = i(this._elem, this._textData.m.a, 1, 0, this));
                        }),
                            (TextAnimatorProperty.prototype.getMeasures = function (t, e) {
                                if (((this.lettersChangedFlag = e), this._mdf || this._isFirstFrame || e || (this._hasMaskedPath && this._pathData.m._mdf))) {
                                    this._isFirstFrame = !1;
                                    var r,
                                        i,
                                        n,
                                        a,
                                        s,
                                        o,
                                        l,
                                        h,
                                        c,
                                        p,
                                        u,
                                        f,
                                        d,
                                        m,
                                        y,
                                        v,
                                        g,
                                        _,
                                        b,
                                        E = this._moreOptions.alignment.v,
                                        S = this._animatorsData,
                                        P = this._textData,
                                        w = this.mHelper,
                                        x = this._renderType,
                                        A = this.renderedLetters.length,
                                        C = t.l;
                                    if (this._hasMaskedPath) {
                                        if (((b = this._pathData.m), !this._pathData.n || this._pathData._mdf)) {
                                            var T,
                                                k = b.v;
                                            for (this._pathData.r.v && (k = k.reverse()), s = { tLength: 0, segments: [] }, a = k._length - 1, v = 0, n = 0; n < a; n += 1)
                                                (T = bez.buildBezierData(k.v[n], k.v[n + 1], [k.o[n][0] - k.v[n][0], k.o[n][1] - k.v[n][1]], [k.i[n + 1][0] - k.v[n + 1][0], k.i[n + 1][1] - k.v[n + 1][1]])),
                                                    (s.tLength += T.segmentLength),
                                                    s.segments.push(T),
                                                    (v += T.segmentLength);
                                            (n = a),
                                                b.v.c &&
                                                    ((T = bez.buildBezierData(k.v[n], k.v[0], [k.o[n][0] - k.v[n][0], k.o[n][1] - k.v[n][1]], [k.i[0][0] - k.v[0][0], k.i[0][1] - k.v[0][1]])),
                                                    (s.tLength += T.segmentLength),
                                                    s.segments.push(T),
                                                    (v += T.segmentLength)),
                                                (this._pathData.pi = s);
                                        }
                                        if (((s = this._pathData.pi), (o = this._pathData.f.v), (u = 0), (p = 1), (h = 0), (c = !0), (m = s.segments), o < 0 && b.v.c))
                                            for (s.tLength < Math.abs(o) && (o = -Math.abs(o) % s.tLength), p = (d = m[(u = m.length - 1)].points).length - 1; o < 0; )
                                                (o += d[p].partialLength), (p -= 1) < 0 && (p = (d = m[(u -= 1)].points).length - 1);
                                        (f = (d = m[u].points)[p - 1]), (y = (l = d[p]).partialLength);
                                    }
                                    (a = C.length), (r = 0), (i = 0);
                                    var D,
                                        M,
                                        I,
                                        F,
                                        L,
                                        O = 1.2 * t.finalSize * 0.714,
                                        R = !0;
                                    I = S.length;
                                    var B,
                                        G,
                                        V,
                                        N,
                                        $,
                                        j,
                                        z,
                                        H,
                                        q,
                                        U,
                                        W,
                                        Y,
                                        K = -1,
                                        Z = o,
                                        X = u,
                                        Q = p,
                                        J = -1,
                                        tt = "",
                                        et = this.defaultPropsArray;
                                    if (2 === t.j || 1 === t.j) {
                                        var rt = 0,
                                            it = 0,
                                            nt = 2 === t.j ? -0.5 : -1,
                                            at = 0,
                                            st = !0;
                                        for (n = 0; n < a; n += 1)
                                            if (C[n].n) {
                                                for (rt && (rt += it); at < n; ) (C[at].animatorJustifyOffset = rt), (at += 1);
                                                (rt = 0), (st = !0);
                                            } else {
                                                for (M = 0; M < I; M += 1)
                                                    (D = S[M].a).t.propType &&
                                                        (st && 2 === t.j && (it += D.t.v * nt), (L = S[M].s.getMult(C[n].anIndexes[M], P.a[M].s.totalChars)).length ? (rt += D.t.v * L[0] * nt) : (rt += D.t.v * L * nt));
                                                st = !1;
                                            }
                                        for (rt && (rt += it); at < n; ) (C[at].animatorJustifyOffset = rt), (at += 1);
                                    }
                                    for (n = 0; n < a; n += 1) {
                                        if ((w.reset(), (N = 1), C[n].n))
                                            (r = 0),
                                                (i += t.yOffset),
                                                (i += R ? 1 : 0),
                                                (o = Z),
                                                (R = !1),
                                                this._hasMaskedPath && ((p = Q), (f = (d = m[(u = X)].points)[p - 1]), (y = (l = d[p]).partialLength), (h = 0)),
                                                (tt = ""),
                                                (W = ""),
                                                (q = ""),
                                                (Y = ""),
                                                (et = this.defaultPropsArray);
                                        else {
                                            if (this._hasMaskedPath) {
                                                if (J !== C[n].line) {
                                                    switch (t.j) {
                                                        case 1:
                                                            o += v - t.lineWidths[C[n].line];
                                                            break;
                                                        case 2:
                                                            o += (v - t.lineWidths[C[n].line]) / 2;
                                                    }
                                                    J = C[n].line;
                                                }
                                                K !== C[n].ind && (C[K] && (o += C[K].extra), (o += C[n].an / 2), (K = C[n].ind)), (o += E[0] * C[n].an * 0.005);
                                                var ot = 0;
                                                for (M = 0; M < I; M += 1)
                                                    (D = S[M].a).p.propType && ((L = S[M].s.getMult(C[n].anIndexes[M], P.a[M].s.totalChars)).length ? (ot += D.p.v[0] * L[0]) : (ot += D.p.v[0] * L)),
                                                        D.a.propType && ((L = S[M].s.getMult(C[n].anIndexes[M], P.a[M].s.totalChars)).length ? (ot += D.a.v[0] * L[0]) : (ot += D.a.v[0] * L));
                                                for (c = !0, this._pathData.a.v && ((o = 0.5 * C[0].an + ((v - this._pathData.f.v - 0.5 * C[0].an - 0.5 * C[C.length - 1].an) * K) / (a - 1)), (o += this._pathData.f.v)); c; )
                                                    h + y >= o + ot || !d
                                                        ? ((g = (o + ot - h) / l.partialLength),
                                                          (G = f.point[0] + (l.point[0] - f.point[0]) * g),
                                                          (V = f.point[1] + (l.point[1] - f.point[1]) * g),
                                                          w.translate(-E[0] * C[n].an * 0.005, -E[1] * O * 0.01),
                                                          (c = !1))
                                                        : d &&
                                                          ((h += l.partialLength),
                                                          (p += 1) >= d.length && ((p = 0), m[(u += 1)] ? (d = m[u].points) : b.v.c ? ((p = 0), (d = m[(u = 0)].points)) : ((h -= l.partialLength), (d = null))),
                                                          d && ((f = l), (y = (l = d[p]).partialLength)));
                                                (B = C[n].an / 2 - C[n].add), w.translate(-B, 0, 0);
                                            } else (B = C[n].an / 2 - C[n].add), w.translate(-B, 0, 0), w.translate(-E[0] * C[n].an * 0.005, -E[1] * O * 0.01, 0);
                                            for (M = 0; M < I; M += 1)
                                                (D = S[M].a).t.propType &&
                                                    ((L = S[M].s.getMult(C[n].anIndexes[M], P.a[M].s.totalChars)),
                                                    (0 === r && 0 === t.j) || (this._hasMaskedPath ? (L.length ? (o += D.t.v * L[0]) : (o += D.t.v * L)) : L.length ? (r += D.t.v * L[0]) : (r += D.t.v * L)));
                                            for (
                                                t.strokeWidthAnim && (j = t.sw || 0), t.strokeColorAnim && ($ = t.sc ? [t.sc[0], t.sc[1], t.sc[2]] : [0, 0, 0]), t.fillColorAnim && t.fc && (z = [t.fc[0], t.fc[1], t.fc[2]]), M = 0;
                                                M < I;
                                                M += 1
                                            )
                                                (D = S[M].a).a.propType &&
                                                    ((L = S[M].s.getMult(C[n].anIndexes[M], P.a[M].s.totalChars)).length
                                                        ? w.translate(-D.a.v[0] * L[0], -D.a.v[1] * L[1], D.a.v[2] * L[2])
                                                        : w.translate(-D.a.v[0] * L, -D.a.v[1] * L, D.a.v[2] * L));
                                            for (M = 0; M < I; M += 1)
                                                (D = S[M].a).s.propType &&
                                                    ((L = S[M].s.getMult(C[n].anIndexes[M], P.a[M].s.totalChars)).length
                                                        ? w.scale(1 + (D.s.v[0] - 1) * L[0], 1 + (D.s.v[1] - 1) * L[1], 1)
                                                        : w.scale(1 + (D.s.v[0] - 1) * L, 1 + (D.s.v[1] - 1) * L, 1));
                                            for (M = 0; M < I; M += 1) {
                                                if (
                                                    ((D = S[M].a),
                                                    (L = S[M].s.getMult(C[n].anIndexes[M], P.a[M].s.totalChars)),
                                                    D.sk.propType && (L.length ? w.skewFromAxis(-D.sk.v * L[0], D.sa.v * L[1]) : w.skewFromAxis(-D.sk.v * L, D.sa.v * L)),
                                                    D.r.propType && (L.length ? w.rotateZ(-D.r.v * L[2]) : w.rotateZ(-D.r.v * L)),
                                                    D.ry.propType && (L.length ? w.rotateY(D.ry.v * L[1]) : w.rotateY(D.ry.v * L)),
                                                    D.rx.propType && (L.length ? w.rotateX(D.rx.v * L[0]) : w.rotateX(D.rx.v * L)),
                                                    D.o.propType && (L.length ? (N += (D.o.v * L[0] - N) * L[0]) : (N += (D.o.v * L - N) * L)),
                                                    t.strokeWidthAnim && D.sw.propType && (L.length ? (j += D.sw.v * L[0]) : (j += D.sw.v * L)),
                                                    t.strokeColorAnim && D.sc.propType)
                                                )
                                                    for (H = 0; H < 3; H += 1) L.length ? ($[H] += (D.sc.v[H] - $[H]) * L[0]) : ($[H] += (D.sc.v[H] - $[H]) * L);
                                                if (t.fillColorAnim && t.fc) {
                                                    if (D.fc.propType) for (H = 0; H < 3; H += 1) L.length ? (z[H] += (D.fc.v[H] - z[H]) * L[0]) : (z[H] += (D.fc.v[H] - z[H]) * L);
                                                    D.fh.propType && (z = L.length ? addHueToRGB(z, D.fh.v * L[0]) : addHueToRGB(z, D.fh.v * L)),
                                                        D.fs.propType && (z = L.length ? addSaturationToRGB(z, D.fs.v * L[0]) : addSaturationToRGB(z, D.fs.v * L)),
                                                        D.fb.propType && (z = L.length ? addBrightnessToRGB(z, D.fb.v * L[0]) : addBrightnessToRGB(z, D.fb.v * L));
                                                }
                                            }
                                            for (M = 0; M < I; M += 1)
                                                (D = S[M].a).p.propType &&
                                                    ((L = S[M].s.getMult(C[n].anIndexes[M], P.a[M].s.totalChars)),
                                                    this._hasMaskedPath
                                                        ? L.length
                                                            ? w.translate(0, D.p.v[1] * L[0], -D.p.v[2] * L[1])
                                                            : w.translate(0, D.p.v[1] * L, -D.p.v[2] * L)
                                                        : L.length
                                                        ? w.translate(D.p.v[0] * L[0], D.p.v[1] * L[1], -D.p.v[2] * L[2])
                                                        : w.translate(D.p.v[0] * L, D.p.v[1] * L, -D.p.v[2] * L));
                                            if (
                                                (t.strokeWidthAnim && (q = j < 0 ? 0 : j),
                                                t.strokeColorAnim && (U = "rgb(" + Math.round(255 * $[0]) + "," + Math.round(255 * $[1]) + "," + Math.round(255 * $[2]) + ")"),
                                                t.fillColorAnim && t.fc && (W = "rgb(" + Math.round(255 * z[0]) + "," + Math.round(255 * z[1]) + "," + Math.round(255 * z[2]) + ")"),
                                                this._hasMaskedPath)
                                            ) {
                                                if ((w.translate(0, -t.ls), w.translate(0, E[1] * O * 0.01 + i, 0), this._pathData.p.v)) {
                                                    _ = (l.point[1] - f.point[1]) / (l.point[0] - f.point[0]);
                                                    var lt = (180 * Math.atan(_)) / Math.PI;
                                                    l.point[0] < f.point[0] && (lt += 180), w.rotate((-lt * Math.PI) / 180);
                                                }
                                                w.translate(G, V, 0), (o -= E[0] * C[n].an * 0.005), C[n + 1] && K !== C[n + 1].ind && ((o += C[n].an / 2), (o += 0.001 * t.tr * t.finalSize));
                                            } else {
                                                switch ((w.translate(r, i, 0), t.ps && w.translate(t.ps[0], t.ps[1] + t.ascent, 0), t.j)) {
                                                    case 1:
                                                        w.translate(C[n].animatorJustifyOffset + t.justifyOffset + (t.boxWidth - t.lineWidths[C[n].line]), 0, 0);
                                                        break;
                                                    case 2:
                                                        w.translate(C[n].animatorJustifyOffset + t.justifyOffset + (t.boxWidth - t.lineWidths[C[n].line]) / 2, 0, 0);
                                                }
                                                w.translate(0, -t.ls), w.translate(B, 0, 0), w.translate(E[0] * C[n].an * 0.005, E[1] * O * 0.01, 0), (r += C[n].l + 0.001 * t.tr * t.finalSize);
                                            }
                                            "html" === x
                                                ? (tt = w.toCSS())
                                                : "svg" === x
                                                ? (tt = w.to2dCSS())
                                                : (et = [
                                                      w.props[0],
                                                      w.props[1],
                                                      w.props[2],
                                                      w.props[3],
                                                      w.props[4],
                                                      w.props[5],
                                                      w.props[6],
                                                      w.props[7],
                                                      w.props[8],
                                                      w.props[9],
                                                      w.props[10],
                                                      w.props[11],
                                                      w.props[12],
                                                      w.props[13],
                                                      w.props[14],
                                                      w.props[15],
                                                  ]),
                                                (Y = N);
                                        }
                                        A <= n
                                            ? ((F = new LetterProps(Y, q, U, W, tt, et)), this.renderedLetters.push(F), (A += 1), (this.lettersChangedFlag = !0))
                                            : ((F = this.renderedLetters[n]), (this.lettersChangedFlag = F.update(Y, q, U, W, tt, et) || this.lettersChangedFlag));
                                    }
                                }
                            }),
                            (TextAnimatorProperty.prototype.getValue = function () {
                                this._elem.globalData.frameId !== this._frameId && ((this._frameId = this._elem.globalData.frameId), this.iterateDynamicProperties());
                            }),
                            (TextAnimatorProperty.prototype.mHelper = new Matrix()),
                            (TextAnimatorProperty.prototype.defaultPropsArray = []),
                            extendPrototype([DynamicPropertyContainer], TextAnimatorProperty),
                            (ITextElement.prototype.initElement = function (t, e, r) {
                                (this.lettersChangedFlag = !0),
                                    this.initFrame(),
                                    this.initBaseData(t, e, r),
                                    (this.textProperty = new TextProperty(this, t.t, this.dynamicProperties)),
                                    (this.textAnimator = new TextAnimatorProperty(t.t, this.renderType, this)),
                                    this.initTransform(t, e, r),
                                    this.initHierarchy(),
                                    this.initRenderable(),
                                    this.initRendererElement(),
                                    this.createContainerElements(),
                                    this.createRenderableComponents(),
                                    this.createContent(),
                                    this.hide(),
                                    this.textAnimator.searchProperties(this.dynamicProperties);
                            }),
                            (ITextElement.prototype.prepareFrame = function (t) {
                                (this._mdf = !1),
                                    this.prepareRenderableFrame(t),
                                    this.prepareProperties(t, this.isInRange),
                                    (this.textProperty._mdf || this.textProperty._isFirstFrame) && (this.buildNewText(), (this.textProperty._isFirstFrame = !1), (this.textProperty._mdf = !1));
                            }),
                            (ITextElement.prototype.createPathShape = function (t, e) {
                                var r,
                                    i,
                                    n = e.length,
                                    a = "";
                                for (r = 0; r < n; r += 1) "sh" === e[r].ty && ((i = e[r].ks.k), (a += buildShapeString(i, i.i.length, !0, t)));
                                return a;
                            }),
                            (ITextElement.prototype.updateDocumentData = function (t, e) {
                                this.textProperty.updateDocumentData(t, e);
                            }),
                            (ITextElement.prototype.canResizeFont = function (t) {
                                this.textProperty.canResizeFont(t);
                            }),
                            (ITextElement.prototype.setMinimumFontSize = function (t) {
                                this.textProperty.setMinimumFontSize(t);
                            }),
                            (ITextElement.prototype.applyTextPropertiesToMatrix = function (t, e, r, i, n) {
                                switch ((t.ps && e.translate(t.ps[0], t.ps[1] + t.ascent, 0), e.translate(0, -t.ls, 0), t.j)) {
                                    case 1:
                                        e.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[r]), 0, 0);
                                        break;
                                    case 2:
                                        e.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[r]) / 2, 0, 0);
                                }
                                e.translate(i, n, 0);
                            }),
                            (ITextElement.prototype.buildColor = function (t) {
                                return "rgb(" + Math.round(255 * t[0]) + "," + Math.round(255 * t[1]) + "," + Math.round(255 * t[2]) + ")";
                            }),
                            (ITextElement.prototype.emptyProp = new LetterProps()),
                            (ITextElement.prototype.destroy = function () {});
                        var emptyShapeData = { shapes: [] };
                        function SVGTextLottieElement(t, e, r) {
                            (this.textSpans = []), (this.renderType = "svg"), this.initElement(t, e, r);
                        }
                        function ISolidElement(t, e, r) {
                            this.initElement(t, e, r);
                        }
                        function NullElement(t, e, r) {
                            this.initFrame(), this.initBaseData(t, e, r), this.initFrame(), this.initTransform(t, e, r), this.initHierarchy();
                        }
                        function SVGRendererBase() {}
                        function ICompElement() {}
                        function SVGCompElement(t, e, r) {
                            (this.layers = t.layers),
                                (this.supports3d = !0),
                                (this.completeLayers = !1),
                                (this.pendingElements = []),
                                (this.elements = this.layers ? createSizedArray(this.layers.length) : []),
                                this.initElement(t, e, r),
                                (this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this) : { _placeholder: !0 });
                        }
                        function SVGRenderer(t, e) {
                            (this.animationItem = t), (this.layers = null), (this.renderedFrame = -1), (this.svgElement = createNS("svg"));
                            var r = "";
                            if (e && e.title) {
                                var i = createNS("title"),
                                    n = createElementID();
                                i.setAttribute("id", n), (i.textContent = e.title), this.svgElement.appendChild(i), (r += n);
                            }
                            if (e && e.description) {
                                var a = createNS("desc"),
                                    s = createElementID();
                                a.setAttribute("id", s), (a.textContent = e.description), this.svgElement.appendChild(a), (r += " " + s);
                            }
                            r && this.svgElement.setAttribute("aria-labelledby", r);
                            var o = createNS("defs");
                            this.svgElement.appendChild(o);
                            var l = createNS("g");
                            this.svgElement.appendChild(l),
                                (this.layerElement = l),
                                (this.renderConfig = {
                                    preserveAspectRatio: (e && e.preserveAspectRatio) || "xMidYMid meet",
                                    imagePreserveAspectRatio: (e && e.imagePreserveAspectRatio) || "xMidYMid slice",
                                    contentVisibility: (e && e.contentVisibility) || "visible",
                                    progressiveLoad: (e && e.progressiveLoad) || !1,
                                    hideOnTransparent: !(e && !1 === e.hideOnTransparent),
                                    viewBoxOnly: (e && e.viewBoxOnly) || !1,
                                    viewBoxSize: (e && e.viewBoxSize) || !1,
                                    className: (e && e.className) || "",
                                    id: (e && e.id) || "",
                                    focusable: e && e.focusable,
                                    filterSize: {
                                        width: (e && e.filterSize && e.filterSize.width) || "100%",
                                        height: (e && e.filterSize && e.filterSize.height) || "100%",
                                        x: (e && e.filterSize && e.filterSize.x) || "0%",
                                        y: (e && e.filterSize && e.filterSize.y) || "0%",
                                    },
                                    width: e && e.width,
                                    height: e && e.height,
                                    runExpressions: !e || void 0 === e.runExpressions || e.runExpressions,
                                }),
                                (this.globalData = { _mdf: !1, frameNum: -1, defs: o, renderConfig: this.renderConfig }),
                                (this.elements = []),
                                (this.pendingElements = []),
                                (this.destroyed = !1),
                                (this.rendererType = "svg");
                        }
                        function CVContextData() {
                            var t;
                            for (this.saved = [], this.cArrPos = 0, this.cTr = new Matrix(), this.cO = 1, this.savedOp = createTypedArray("float32", 15), t = 0; t < 15; t += 1) this.saved[t] = createTypedArray("float32", 16);
                            this._length = 15;
                        }
                        function ShapeTransformManager() {
                            (this.sequences = {}), (this.sequenceList = []), (this.transform_key_count = 0);
                        }
                        function CVEffects() {}
                        function CVMaskElement(t, e) {
                            var r;
                            (this.data = t), (this.element = e), (this.masksProperties = this.data.masksProperties || []), (this.viewData = createSizedArray(this.masksProperties.length));
                            var i = this.masksProperties.length,
                                n = !1;
                            for (r = 0; r < i; r += 1) "n" !== this.masksProperties[r].mode && (n = !0), (this.viewData[r] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[r], 3));
                            (this.hasMasks = n), n && this.element.addRenderableComponent(this);
                        }
                        function CVBaseElement() {}
                        function CVShapeData(t, e, r, i) {
                            (this.styledShapes = []), (this.tr = [0, 0, 0, 0, 0, 0]);
                            var n,
                                a = 4;
                            "rc" === e.ty ? (a = 5) : "el" === e.ty ? (a = 6) : "sr" === e.ty && (a = 7), (this.sh = ShapePropertyFactory.getShapeProp(t, e, a, t));
                            var s,
                                o = r.length;
                            for (n = 0; n < o; n += 1) r[n].closed || ((s = { transforms: i.addTransformSequence(r[n].transforms), trNodes: [] }), this.styledShapes.push(s), r[n].elements.push(s));
                        }
                        function CVShapeElement(t, e, r) {
                            (this.shapes = []),
                                (this.shapesData = t.shapes),
                                (this.stylesList = []),
                                (this.itemsData = []),
                                (this.prevViewData = []),
                                (this.shapeModifiers = []),
                                (this.processedElements = []),
                                (this.transformsManager = new ShapeTransformManager()),
                                this.initElement(t, e, r);
                        }
                        function CVTextElement(t, e, r) {
                            (this.textSpans = []),
                                (this.yOffset = 0),
                                (this.fillColorAnim = !1),
                                (this.strokeColorAnim = !1),
                                (this.strokeWidthAnim = !1),
                                (this.stroke = !1),
                                (this.fill = !1),
                                (this.justifyOffset = 0),
                                (this.currentRender = null),
                                (this.renderType = "canvas"),
                                (this.values = { fill: "rgba(0,0,0,0)", stroke: "rgba(0,0,0,0)", sWidth: 0, fValue: "" }),
                                this.initElement(t, e, r);
                        }
                        function CVImageElement(t, e, r) {
                            (this.assetData = e.getAssetData(t.refId)), (this.img = e.imageLoader.getAsset(this.assetData)), this.initElement(t, e, r);
                        }
                        function CVSolidElement(t, e, r) {
                            this.initElement(t, e, r);
                        }
                        function CanvasRendererBase(t, e) {
                            (this.animationItem = t),
                                (this.renderConfig = {
                                    clearCanvas: !e || void 0 === e.clearCanvas || e.clearCanvas,
                                    context: (e && e.context) || null,
                                    progressiveLoad: (e && e.progressiveLoad) || !1,
                                    preserveAspectRatio: (e && e.preserveAspectRatio) || "xMidYMid meet",
                                    imagePreserveAspectRatio: (e && e.imagePreserveAspectRatio) || "xMidYMid slice",
                                    contentVisibility: (e && e.contentVisibility) || "visible",
                                    className: (e && e.className) || "",
                                    id: (e && e.id) || "",
                                }),
                                (this.renderConfig.dpr = (e && e.dpr) || 1),
                                this.animationItem.wrapper && (this.renderConfig.dpr = (e && e.dpr) || window.devicePixelRatio || 1),
                                (this.renderedFrame = -1),
                                (this.globalData = { frameNum: -1, _mdf: !1, renderConfig: this.renderConfig, currentGlobalAlpha: -1 }),
                                (this.contextData = new CVContextData()),
                                (this.elements = []),
                                (this.pendingElements = []),
                                (this.transformMat = new Matrix()),
                                (this.completeLayers = !1),
                                (this.rendererType = "canvas");
                        }
                        function CVCompElement(t, e, r) {
                            (this.completeLayers = !1),
                                (this.layers = t.layers),
                                (this.pendingElements = []),
                                (this.elements = createSizedArray(this.layers.length)),
                                this.initElement(t, e, r),
                                (this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this) : { _placeholder: !0 });
                        }
                        function CanvasRenderer(t, e) {
                            (this.animationItem = t),
                                (this.renderConfig = {
                                    clearCanvas: !e || void 0 === e.clearCanvas || e.clearCanvas,
                                    context: (e && e.context) || null,
                                    progressiveLoad: (e && e.progressiveLoad) || !1,
                                    preserveAspectRatio: (e && e.preserveAspectRatio) || "xMidYMid meet",
                                    imagePreserveAspectRatio: (e && e.imagePreserveAspectRatio) || "xMidYMid slice",
                                    contentVisibility: (e && e.contentVisibility) || "visible",
                                    className: (e && e.className) || "",
                                    id: (e && e.id) || "",
                                    runExpressions: !e || void 0 === e.runExpressions || e.runExpressions,
                                }),
                                (this.renderConfig.dpr = (e && e.dpr) || 1),
                                this.animationItem.wrapper && (this.renderConfig.dpr = (e && e.dpr) || window.devicePixelRatio || 1),
                                (this.renderedFrame = -1),
                                (this.globalData = { frameNum: -1, _mdf: !1, renderConfig: this.renderConfig, currentGlobalAlpha: -1 }),
                                (this.contextData = new CVContextData()),
                                (this.elements = []),
                                (this.pendingElements = []),
                                (this.transformMat = new Matrix()),
                                (this.completeLayers = !1),
                                (this.rendererType = "canvas");
                        }
                        function HBaseElement() {}
                        function HSolidElement(t, e, r) {
                            this.initElement(t, e, r);
                        }
                        function HShapeElement(t, e, r) {
                            (this.shapes = []),
                                (this.shapesData = t.shapes),
                                (this.stylesList = []),
                                (this.shapeModifiers = []),
                                (this.itemsData = []),
                                (this.processedElements = []),
                                (this.animatedContents = []),
                                (this.shapesContainer = createNS("g")),
                                this.initElement(t, e, r),
                                (this.prevViewData = []),
                                (this.currentBBox = { x: 999999, y: -999999, h: 0, w: 0 });
                        }
                        function HTextElement(t, e, r) {
                            (this.textSpans = []), (this.textPaths = []), (this.currentBBox = { x: 999999, y: -999999, h: 0, w: 0 }), (this.renderType = "svg"), (this.isMasked = !1), this.initElement(t, e, r);
                        }
                        function HCameraElement(t, e, r) {
                            this.initFrame(), this.initBaseData(t, e, r), this.initHierarchy();
                            var i = PropertyFactory.getProp;
                            if (
                                ((this.pe = i(this, t.pe, 0, 0, this)),
                                t.ks.p.s ? ((this.px = i(this, t.ks.p.x, 1, 0, this)), (this.py = i(this, t.ks.p.y, 1, 0, this)), (this.pz = i(this, t.ks.p.z, 1, 0, this))) : (this.p = i(this, t.ks.p, 1, 0, this)),
                                t.ks.a && (this.a = i(this, t.ks.a, 1, 0, this)),
                                t.ks.or.k.length && t.ks.or.k[0].to)
                            ) {
                                var n,
                                    a = t.ks.or.k.length;
                                for (n = 0; n < a; n += 1) (t.ks.or.k[n].to = null), (t.ks.or.k[n].ti = null);
                            }
                            (this.or = i(this, t.ks.or, 1, degToRads, this)),
                                (this.or.sh = !0),
                                (this.rx = i(this, t.ks.rx, 0, degToRads, this)),
                                (this.ry = i(this, t.ks.ry, 0, degToRads, this)),
                                (this.rz = i(this, t.ks.rz, 0, degToRads, this)),
                                (this.mat = new Matrix()),
                                (this._prevMat = new Matrix()),
                                (this._isFirstFrame = !0),
                                (this.finalTransform = { mProp: this });
                        }
                        function HImageElement(t, e, r) {
                            (this.assetData = e.getAssetData(t.refId)), this.initElement(t, e, r);
                        }
                        function HybridRendererBase(t, e) {
                            (this.animationItem = t),
                                (this.layers = null),
                                (this.renderedFrame = -1),
                                (this.renderConfig = {
                                    className: (e && e.className) || "",
                                    imagePreserveAspectRatio: (e && e.imagePreserveAspectRatio) || "xMidYMid slice",
                                    hideOnTransparent: !(e && !1 === e.hideOnTransparent),
                                    filterSize: {
                                        width: (e && e.filterSize && e.filterSize.width) || "400%",
                                        height: (e && e.filterSize && e.filterSize.height) || "400%",
                                        x: (e && e.filterSize && e.filterSize.x) || "-100%",
                                        y: (e && e.filterSize && e.filterSize.y) || "-100%",
                                    },
                                }),
                                (this.globalData = { _mdf: !1, frameNum: -1, renderConfig: this.renderConfig }),
                                (this.pendingElements = []),
                                (this.elements = []),
                                (this.threeDElements = []),
                                (this.destroyed = !1),
                                (this.camera = null),
                                (this.supports3d = !0),
                                (this.rendererType = "html");
                        }
                        function HCompElement(t, e, r) {
                            (this.layers = t.layers),
                                (this.supports3d = !t.hasMask),
                                (this.completeLayers = !1),
                                (this.pendingElements = []),
                                (this.elements = this.layers ? createSizedArray(this.layers.length) : []),
                                this.initElement(t, e, r),
                                (this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this) : { _placeholder: !0 });
                        }
                        function HybridRenderer(t, e) {
                            (this.animationItem = t),
                                (this.layers = null),
                                (this.renderedFrame = -1),
                                (this.renderConfig = {
                                    className: (e && e.className) || "",
                                    imagePreserveAspectRatio: (e && e.imagePreserveAspectRatio) || "xMidYMid slice",
                                    hideOnTransparent: !(e && !1 === e.hideOnTransparent),
                                    filterSize: {
                                        width: (e && e.filterSize && e.filterSize.width) || "400%",
                                        height: (e && e.filterSize && e.filterSize.height) || "400%",
                                        x: (e && e.filterSize && e.filterSize.x) || "-100%",
                                        y: (e && e.filterSize && e.filterSize.y) || "-100%",
                                    },
                                    runExpressions: !e || void 0 === e.runExpressions || e.runExpressions,
                                }),
                                (this.globalData = { _mdf: !1, frameNum: -1, renderConfig: this.renderConfig }),
                                (this.pendingElements = []),
                                (this.elements = []),
                                (this.threeDElements = []),
                                (this.destroyed = !1),
                                (this.camera = null),
                                (this.supports3d = !0),
                                (this.rendererType = "html");
                        }
                        extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], SVGTextLottieElement),
                            (SVGTextLottieElement.prototype.createContent = function () {
                                this.data.singleShape && !this.globalData.fontManager.chars && (this.textContainer = createNS("text"));
                            }),
                            (SVGTextLottieElement.prototype.buildTextContents = function (t) {
                                for (var e = 0, r = t.length, i = [], n = ""; e < r; ) t[e] === String.fromCharCode(13) || t[e] === String.fromCharCode(3) ? (i.push(n), (n = "")) : (n += t[e]), (e += 1);
                                return i.push(n), i;
                            }),
                            (SVGTextLottieElement.prototype.buildShapeData = function (t, e) {
                                if (t.shapes && t.shapes.length) {
                                    var r = t.shapes[0];
                                    if (r.it) {
                                        var i = r.it[r.it.length - 1];
                                        i.s && ((i.s.k[0] = e), (i.s.k[1] = e));
                                    }
                                }
                                return t;
                            }),
                            (SVGTextLottieElement.prototype.buildNewText = function () {
                                var t, e;
                                this.addDynamicProperty(this);
                                var r = this.textProperty.currentData;
                                (this.renderedLetters = createSizedArray(r ? r.l.length : 0)),
                                    r.fc ? this.layerElement.setAttribute("fill", this.buildColor(r.fc)) : this.layerElement.setAttribute("fill", "rgba(0,0,0,0)"),
                                    r.sc && (this.layerElement.setAttribute("stroke", this.buildColor(r.sc)), this.layerElement.setAttribute("stroke-width", r.sw)),
                                    this.layerElement.setAttribute("font-size", r.finalSize);
                                var i = this.globalData.fontManager.getFontByName(r.f);
                                if (i.fClass) this.layerElement.setAttribute("class", i.fClass);
                                else {
                                    this.layerElement.setAttribute("font-family", i.fFamily);
                                    var n = r.fWeight,
                                        a = r.fStyle;
                                    this.layerElement.setAttribute("font-style", a), this.layerElement.setAttribute("font-weight", n);
                                }
                                this.layerElement.setAttribute("aria-label", r.t);
                                var s,
                                    o = r.l || [],
                                    l = !!this.globalData.fontManager.chars;
                                e = o.length;
                                var h = this.mHelper,
                                    c = this.data.singleShape,
                                    p = 0,
                                    u = 0,
                                    f = !0,
                                    d = 0.001 * r.tr * r.finalSize;
                                if (!c || l || r.sz) {
                                    var m,
                                        y = this.textSpans.length;
                                    for (t = 0; t < e; t += 1) {
                                        if ((this.textSpans[t] || (this.textSpans[t] = { span: null, childSpan: null, glyph: null }), !l || !c || 0 === t)) {
                                            if (((s = y > t ? this.textSpans[t].span : createNS(l ? "g" : "text")), y <= t)) {
                                                if ((s.setAttribute("stroke-linecap", "butt"), s.setAttribute("stroke-linejoin", "round"), s.setAttribute("stroke-miterlimit", "4"), (this.textSpans[t].span = s), l)) {
                                                    var v = createNS("g");
                                                    s.appendChild(v), (this.textSpans[t].childSpan = v);
                                                }
                                                (this.textSpans[t].span = s), this.layerElement.appendChild(s);
                                            }
                                            s.style.display = "inherit";
                                        }
                                        if ((h.reset(), c && (o[t].n && ((p = -d), (u += r.yOffset), (u += f ? 1 : 0), (f = !1)), this.applyTextPropertiesToMatrix(r, h, o[t].line, p, u), (p += o[t].l || 0), (p += d)), l)) {
                                            var g;
                                            if (1 === (m = this.globalData.fontManager.getCharData(r.finalText[t], i.fStyle, this.globalData.fontManager.getFontByName(r.f).fFamily)).t) g = new SVGCompElement(m.data, this.globalData, this);
                                            else {
                                                var _ = emptyShapeData;
                                                m.data && m.data.shapes && (_ = this.buildShapeData(m.data, r.finalSize)), (g = new SVGShapeElement(_, this.globalData, this));
                                            }
                                            if (this.textSpans[t].glyph) {
                                                var b = this.textSpans[t].glyph;
                                                this.textSpans[t].childSpan.removeChild(b.layerElement), b.destroy();
                                            }
                                            (this.textSpans[t].glyph = g),
                                                (g._debug = !0),
                                                g.prepareFrame(0),
                                                g.renderFrame(),
                                                this.textSpans[t].childSpan.appendChild(g.layerElement),
                                                1 === m.t && this.textSpans[t].childSpan.setAttribute("transform", "scale(" + r.finalSize / 100 + "," + r.finalSize / 100 + ")");
                                        } else
                                            c && s.setAttribute("transform", "translate(" + h.props[12] + "," + h.props[13] + ")"),
                                                (s.textContent = o[t].val),
                                                s.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
                                    }
                                    c && s && s.setAttribute("d", "");
                                } else {
                                    var E = this.textContainer,
                                        S = "start";
                                    switch (r.j) {
                                        case 1:
                                            S = "end";
                                            break;
                                        case 2:
                                            S = "middle";
                                            break;
                                        default:
                                            S = "start";
                                    }
                                    E.setAttribute("text-anchor", S), E.setAttribute("letter-spacing", d);
                                    var P = this.buildTextContents(r.finalText);
                                    for (e = P.length, u = r.ps ? r.ps[1] + r.ascent : 0, t = 0; t < e; t += 1)
                                        ((s = this.textSpans[t].span || createNS("tspan")).textContent = P[t]),
                                            s.setAttribute("x", 0),
                                            s.setAttribute("y", u),
                                            (s.style.display = "inherit"),
                                            E.appendChild(s),
                                            this.textSpans[t] || (this.textSpans[t] = { span: null, glyph: null }),
                                            (this.textSpans[t].span = s),
                                            (u += r.finalLineHeight);
                                    this.layerElement.appendChild(E);
                                }
                                for (; t < this.textSpans.length; ) (this.textSpans[t].span.style.display = "none"), (t += 1);
                                this._sizeChanged = !0;
                            }),
                            (SVGTextLottieElement.prototype.sourceRectAtTime = function () {
                                if ((this.prepareFrame(this.comp.renderedFrame - this.data.st), this.renderInnerContent(), this._sizeChanged)) {
                                    this._sizeChanged = !1;
                                    var t = this.layerElement.getBBox();
                                    this.bbox = { top: t.y, left: t.x, width: t.width, height: t.height };
                                }
                                return this.bbox;
                            }),
                            (SVGTextLottieElement.prototype.getValue = function () {
                                var t,
                                    e,
                                    r = this.textSpans.length;
                                for (this.renderedFrame = this.comp.renderedFrame, t = 0; t < r; t += 1) (e = this.textSpans[t].glyph) && (e.prepareFrame(this.comp.renderedFrame - this.data.st), e._mdf && (this._mdf = !0));
                            }),
                            (SVGTextLottieElement.prototype.renderInnerContent = function () {
                                if ((!this.data.singleShape || this._mdf) && (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)) {
                                    var t, e;
                                    this._sizeChanged = !0;
                                    var r,
                                        i,
                                        n,
                                        a = this.textAnimator.renderedLetters,
                                        s = this.textProperty.currentData.l;
                                    for (e = s.length, t = 0; t < e; t += 1)
                                        s[t].n ||
                                            ((r = a[t]),
                                            (i = this.textSpans[t].span),
                                            (n = this.textSpans[t].glyph) && n.renderFrame(),
                                            r._mdf.m && i.setAttribute("transform", r.m),
                                            r._mdf.o && i.setAttribute("opacity", r.o),
                                            r._mdf.sw && i.setAttribute("stroke-width", r.sw),
                                            r._mdf.sc && i.setAttribute("stroke", r.sc),
                                            r._mdf.fc && i.setAttribute("fill", r.fc));
                                }
                            }),
                            extendPrototype([IImageElement], ISolidElement),
                            (ISolidElement.prototype.createContent = function () {
                                var t = createNS("rect");
                                t.setAttribute("width", this.data.sw), t.setAttribute("height", this.data.sh), t.setAttribute("fill", this.data.sc), this.layerElement.appendChild(t);
                            }),
                            (NullElement.prototype.prepareFrame = function (t) {
                                this.prepareProperties(t, !0);
                            }),
                            (NullElement.prototype.renderFrame = function () {}),
                            (NullElement.prototype.getBaseElement = function () {
                                return null;
                            }),
                            (NullElement.prototype.destroy = function () {}),
                            (NullElement.prototype.sourceRectAtTime = function () {}),
                            (NullElement.prototype.hide = function () {}),
                            extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement], NullElement),
                            extendPrototype([BaseRenderer], SVGRendererBase),
                            (SVGRendererBase.prototype.createNull = function (t) {
                                return new NullElement(t, this.globalData, this);
                            }),
                            (SVGRendererBase.prototype.createShape = function (t) {
                                return new SVGShapeElement(t, this.globalData, this);
                            }),
                            (SVGRendererBase.prototype.createText = function (t) {
                                return new SVGTextLottieElement(t, this.globalData, this);
                            }),
                            (SVGRendererBase.prototype.createImage = function (t) {
                                return new IImageElement(t, this.globalData, this);
                            }),
                            (SVGRendererBase.prototype.createSolid = function (t) {
                                return new ISolidElement(t, this.globalData, this);
                            }),
                            (SVGRendererBase.prototype.configAnimation = function (t) {
                                this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg"),
                                    this.svgElement.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink"),
                                    this.renderConfig.viewBoxSize ? this.svgElement.setAttribute("viewBox", this.renderConfig.viewBoxSize) : this.svgElement.setAttribute("viewBox", "0 0 " + t.w + " " + t.h),
                                    this.renderConfig.viewBoxOnly ||
                                        (this.svgElement.setAttribute("width", t.w),
                                        this.svgElement.setAttribute("height", t.h),
                                        (this.svgElement.style.width = "100%"),
                                        (this.svgElement.style.height = "100%"),
                                        (this.svgElement.style.transform = "translate3d(0,0,0)"),
                                        (this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility)),
                                    this.renderConfig.width && this.svgElement.setAttribute("width", this.renderConfig.width),
                                    this.renderConfig.height && this.svgElement.setAttribute("height", this.renderConfig.height),
                                    this.renderConfig.className && this.svgElement.setAttribute("class", this.renderConfig.className),
                                    this.renderConfig.id && this.svgElement.setAttribute("id", this.renderConfig.id),
                                    void 0 !== this.renderConfig.focusable && this.svgElement.setAttribute("focusable", this.renderConfig.focusable),
                                    this.svgElement.setAttribute("preserveAspectRatio", this.renderConfig.preserveAspectRatio),
                                    this.animationItem.wrapper.appendChild(this.svgElement);
                                var e = this.globalData.defs;
                                this.setupGlobalData(t, e), (this.globalData.progressiveLoad = this.renderConfig.progressiveLoad), (this.data = t);
                                var r = createNS("clipPath"),
                                    i = createNS("rect");
                                i.setAttribute("width", t.w), i.setAttribute("height", t.h), i.setAttribute("x", 0), i.setAttribute("y", 0);
                                var n = createElementID();
                                r.setAttribute("id", n),
                                    r.appendChild(i),
                                    this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + n + ")"),
                                    e.appendChild(r),
                                    (this.layers = t.layers),
                                    (this.elements = createSizedArray(t.layers.length));
                            }),
                            (SVGRendererBase.prototype.destroy = function () {
                                var t;
                                this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), (this.layerElement = null), (this.globalData.defs = null);
                                var e = this.layers ? this.layers.length : 0;
                                for (t = 0; t < e; t += 1) this.elements[t] && this.elements[t].destroy();
                                (this.elements.length = 0), (this.destroyed = !0), (this.animationItem = null);
                            }),
                            (SVGRendererBase.prototype.updateContainerSize = function () {}),
                            (SVGRendererBase.prototype.findIndexByInd = function (t) {
                                var e = 0,
                                    r = this.layers.length;
                                for (e = 0; e < r; e += 1) if (this.layers[e].ind === t) return e;
                                return -1;
                            }),
                            (SVGRendererBase.prototype.buildItem = function (t) {
                                var e = this.elements;
                                if (!e[t] && 99 !== this.layers[t].ty) {
                                    e[t] = !0;
                                    var r = this.createItem(this.layers[t]);
                                    if (((e[t] = r), getExpressionsPlugin() && (0 === this.layers[t].ty && this.globalData.projectInterface.registerComposition(r), r.initExpressions()), this.appendElementInPos(r, t), this.layers[t].tt)) {
                                        var i = "tp" in this.layers[t] ? this.findIndexByInd(this.layers[t].tp) : t - 1;
                                        if (-1 === i) return;
                                        if (this.elements[i] && !0 !== this.elements[i]) {
                                            var n = e[i].getMatte(this.layers[t].tt);
                                            r.setMatte(n);
                                        } else this.buildItem(i), this.addPendingElement(r);
                                    }
                                }
                            }),
                            (SVGRendererBase.prototype.checkPendingElements = function () {
                                for (; this.pendingElements.length; ) {
                                    var t = this.pendingElements.pop();
                                    if ((t.checkParenting(), t.data.tt))
                                        for (var e = 0, r = this.elements.length; e < r; ) {
                                            if (this.elements[e] === t) {
                                                var i = "tp" in t.data ? this.findIndexByInd(t.data.tp) : e - 1,
                                                    n = this.elements[i].getMatte(this.layers[e].tt);
                                                t.setMatte(n);
                                                break;
                                            }
                                            e += 1;
                                        }
                                }
                            }),
                            (SVGRendererBase.prototype.renderFrame = function (t) {
                                if (this.renderedFrame !== t && !this.destroyed) {
                                    var e;
                                    null === t ? (t = this.renderedFrame) : (this.renderedFrame = t),
                                        (this.globalData.frameNum = t),
                                        (this.globalData.frameId += 1),
                                        (this.globalData.projectInterface.currentFrame = t),
                                        (this.globalData._mdf = !1);
                                    var r = this.layers.length;
                                    for (this.completeLayers || this.checkLayers(t), e = r - 1; e >= 0; e -= 1) (this.completeLayers || this.elements[e]) && this.elements[e].prepareFrame(t - this.layers[e].st);
                                    if (this.globalData._mdf) for (e = 0; e < r; e += 1) (this.completeLayers || this.elements[e]) && this.elements[e].renderFrame();
                                }
                            }),
                            (SVGRendererBase.prototype.appendElementInPos = function (t, e) {
                                var r = t.getBaseElement();
                                if (r) {
                                    for (var i, n = 0; n < e; ) this.elements[n] && !0 !== this.elements[n] && this.elements[n].getBaseElement() && (i = this.elements[n].getBaseElement()), (n += 1);
                                    i ? this.layerElement.insertBefore(r, i) : this.layerElement.appendChild(r);
                                }
                            }),
                            (SVGRendererBase.prototype.hide = function () {
                                this.layerElement.style.display = "none";
                            }),
                            (SVGRendererBase.prototype.show = function () {
                                this.layerElement.style.display = "block";
                            }),
                            extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement, RenderableDOMElement], ICompElement),
                            (ICompElement.prototype.initElement = function (t, e, r) {
                                this.initFrame(),
                                    this.initBaseData(t, e, r),
                                    this.initTransform(t, e, r),
                                    this.initRenderable(),
                                    this.initHierarchy(),
                                    this.initRendererElement(),
                                    this.createContainerElements(),
                                    this.createRenderableComponents(),
                                    (!this.data.xt && e.progressiveLoad) || this.buildAllItems(),
                                    this.hide();
                            }),
                            (ICompElement.prototype.prepareFrame = function (t) {
                                if (((this._mdf = !1), this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange), this.isInRange || this.data.xt)) {
                                    if (this.tm._placeholder) this.renderedFrame = t / this.data.sr;
                                    else {
                                        var e = this.tm.v;
                                        e === this.data.op && (e = this.data.op - 1), (this.renderedFrame = e);
                                    }
                                    var r,
                                        i = this.elements.length;
                                    for (this.completeLayers || this.checkLayers(this.renderedFrame), r = i - 1; r >= 0; r -= 1)
                                        (this.completeLayers || this.elements[r]) && (this.elements[r].prepareFrame(this.renderedFrame - this.layers[r].st), this.elements[r]._mdf && (this._mdf = !0));
                                }
                            }),
                            (ICompElement.prototype.renderInnerContent = function () {
                                var t,
                                    e = this.layers.length;
                                for (t = 0; t < e; t += 1) (this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
                            }),
                            (ICompElement.prototype.setElements = function (t) {
                                this.elements = t;
                            }),
                            (ICompElement.prototype.getElements = function () {
                                return this.elements;
                            }),
                            (ICompElement.prototype.destroyElements = function () {
                                var t,
                                    e = this.layers.length;
                                for (t = 0; t < e; t += 1) this.elements[t] && this.elements[t].destroy();
                            }),
                            (ICompElement.prototype.destroy = function () {
                                this.destroyElements(), this.destroyBaseElement();
                            }),
                            extendPrototype([SVGRendererBase, ICompElement, SVGBaseElement], SVGCompElement),
                            (SVGCompElement.prototype.createComp = function (t) {
                                return new SVGCompElement(t, this.globalData, this);
                            }),
                            extendPrototype([SVGRendererBase], SVGRenderer),
                            (SVGRenderer.prototype.createComp = function (t) {
                                return new SVGCompElement(t, this.globalData, this);
                            }),
                            (CVContextData.prototype.duplicate = function () {
                                var t = 2 * this._length,
                                    e = this.savedOp;
                                (this.savedOp = createTypedArray("float32", t)), this.savedOp.set(e);
                                var r = 0;
                                for (r = this._length; r < t; r += 1) this.saved[r] = createTypedArray("float32", 16);
                                this._length = t;
                            }),
                            (CVContextData.prototype.reset = function () {
                                (this.cArrPos = 0), this.cTr.reset(), (this.cO = 1);
                            }),
                            (ShapeTransformManager.prototype = {
                                addTransformSequence: function (t) {
                                    var e,
                                        r = t.length,
                                        i = "_";
                                    for (e = 0; e < r; e += 1) i += t[e].transform.key + "_";
                                    var n = this.sequences[i];
                                    return n || ((n = { transforms: [].concat(t), finalTransform: new Matrix(), _mdf: !1 }), (this.sequences[i] = n), this.sequenceList.push(n)), n;
                                },
                                processSequence: function (t, e) {
                                    for (var r, i = 0, n = t.transforms.length, a = e; i < n && !e; ) {
                                        if (t.transforms[i].transform.mProps._mdf) {
                                            a = !0;
                                            break;
                                        }
                                        i += 1;
                                    }
                                    if (a)
                                        for (t.finalTransform.reset(), i = n - 1; i >= 0; i -= 1)
                                            (r = t.transforms[i].transform.mProps.v.props), t.finalTransform.transform(r[0], r[1], r[2], r[3], r[4], r[5], r[6], r[7], r[8], r[9], r[10], r[11], r[12], r[13], r[14], r[15]);
                                    t._mdf = a;
                                },
                                processSequences: function (t) {
                                    var e,
                                        r = this.sequenceList.length;
                                    for (e = 0; e < r; e += 1) this.processSequence(this.sequenceList[e], t);
                                },
                                getNewKey: function () {
                                    return (this.transform_key_count += 1), "_" + this.transform_key_count;
                                },
                            }),
                            (CVEffects.prototype.renderFrame = function () {}),
                            (CVMaskElement.prototype.renderFrame = function () {
                                if (this.hasMasks) {
                                    var t,
                                        e,
                                        r,
                                        i,
                                        n = this.element.finalTransform.mat,
                                        a = this.element.canvasContext,
                                        s = this.masksProperties.length;
                                    for (a.beginPath(), t = 0; t < s; t += 1)
                                        if ("n" !== this.masksProperties[t].mode) {
                                            var o;
                                            this.masksProperties[t].inv &&
                                                (a.moveTo(0, 0),
                                                a.lineTo(this.element.globalData.compSize.w, 0),
                                                a.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h),
                                                a.lineTo(0, this.element.globalData.compSize.h),
                                                a.lineTo(0, 0)),
                                                (i = this.viewData[t].v),
                                                (e = n.applyToPointArray(i.v[0][0], i.v[0][1], 0)),
                                                a.moveTo(e[0], e[1]);
                                            var l = i._length;
                                            for (o = 1; o < l; o += 1) (r = n.applyToTriplePoints(i.o[o - 1], i.i[o], i.v[o])), a.bezierCurveTo(r[0], r[1], r[2], r[3], r[4], r[5]);
                                            (r = n.applyToTriplePoints(i.o[o - 1], i.i[0], i.v[0])), a.bezierCurveTo(r[0], r[1], r[2], r[3], r[4], r[5]);
                                        }
                                    this.element.globalData.renderer.save(!0), a.clip();
                                }
                            }),
                            (CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty),
                            (CVMaskElement.prototype.destroy = function () {
                                this.element = null;
                            }),
                            (CVBaseElement.prototype = {
                                createElements: function () {},
                                initRendererElement: function () {},
                                createContainerElements: function () {
                                    (this.canvasContext = this.globalData.canvasContext), (this.renderableEffectsManager = new CVEffects(this));
                                },
                                createContent: function () {},
                                setBlendMode: function () {
                                    var t = this.globalData;
                                    if (t.blendMode !== this.data.bm) {
                                        t.blendMode = this.data.bm;
                                        var e = getBlendMode(this.data.bm);
                                        t.canvasContext.globalCompositeOperation = e;
                                    }
                                },
                                createRenderableComponents: function () {
                                    this.maskManager = new CVMaskElement(this.data, this);
                                },
                                hideElement: function () {
                                    this.hidden || (this.isInRange && !this.isTransparent) || (this.hidden = !0);
                                },
                                showElement: function () {
                                    this.isInRange && !this.isTransparent && ((this.hidden = !1), (this._isFirstFrame = !0), (this.maskManager._isFirstFrame = !0));
                                },
                                renderFrame: function () {
                                    if (!this.hidden && !this.data.hd) {
                                        this.renderTransform(), this.renderRenderable(), this.setBlendMode();
                                        var t = 0 === this.data.ty;
                                        this.globalData.renderer.save(t),
                                            this.globalData.renderer.ctxTransform(this.finalTransform.mat.props),
                                            this.globalData.renderer.ctxOpacity(this.finalTransform.mProp.o.v),
                                            this.renderInnerContent(),
                                            this.globalData.renderer.restore(t),
                                            this.maskManager.hasMasks && this.globalData.renderer.restore(!0),
                                            this._isFirstFrame && (this._isFirstFrame = !1);
                                    }
                                },
                                destroy: function () {
                                    (this.canvasContext = null), (this.data = null), (this.globalData = null), this.maskManager.destroy();
                                },
                                mHelper: new Matrix(),
                            }),
                            (CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement),
                            (CVBaseElement.prototype.show = CVBaseElement.prototype.showElement),
                            (CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated),
                            extendPrototype([BaseElement, TransformElement, CVBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableElement], CVShapeElement),
                            (CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement),
                            (CVShapeElement.prototype.transformHelper = { opacity: 1, _opMdf: !1 }),
                            (CVShapeElement.prototype.dashResetter = []),
                            (CVShapeElement.prototype.createContent = function () {
                                this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []);
                            }),
                            (CVShapeElement.prototype.createStyleElement = function (t, e) {
                                var r = { data: t, type: t.ty, preTransforms: this.transformsManager.addTransformSequence(e), transforms: [], elements: [], closed: !0 === t.hd },
                                    i = {};
                                if (
                                    ("fl" === t.ty || "st" === t.ty
                                        ? ((i.c = PropertyFactory.getProp(this, t.c, 1, 255, this)), i.c.k || (r.co = "rgb(" + bmFloor(i.c.v[0]) + "," + bmFloor(i.c.v[1]) + "," + bmFloor(i.c.v[2]) + ")"))
                                        : ("gf" !== t.ty && "gs" !== t.ty) ||
                                          ((i.s = PropertyFactory.getProp(this, t.s, 1, null, this)),
                                          (i.e = PropertyFactory.getProp(this, t.e, 1, null, this)),
                                          (i.h = PropertyFactory.getProp(this, t.h || { k: 0 }, 0, 0.01, this)),
                                          (i.a = PropertyFactory.getProp(this, t.a || { k: 0 }, 0, degToRads, this)),
                                          (i.g = new GradientProperty(this, t.g, this))),
                                    (i.o = PropertyFactory.getProp(this, t.o, 0, 0.01, this)),
                                    "st" === t.ty || "gs" === t.ty)
                                ) {
                                    if (((r.lc = lineCapEnum[t.lc || 2]), (r.lj = lineJoinEnum[t.lj || 2]), 1 == t.lj && (r.ml = t.ml), (i.w = PropertyFactory.getProp(this, t.w, 0, null, this)), i.w.k || (r.wi = i.w.v), t.d)) {
                                        var n = new DashProperty(this, t.d, "canvas", this);
                                        (i.d = n), i.d.k || ((r.da = i.d.dashArray), (r.do = i.d.dashoffset[0]));
                                    }
                                } else r.r = 2 === t.r ? "evenodd" : "nonzero";
                                return this.stylesList.push(r), (i.style = r), i;
                            }),
                            (CVShapeElement.prototype.createGroupElement = function () {
                                return { it: [], prevViewData: [] };
                            }),
                            (CVShapeElement.prototype.createTransformElement = function (t) {
                                return {
                                    transform: { opacity: 1, _opMdf: !1, key: this.transformsManager.getNewKey(), op: PropertyFactory.getProp(this, t.o, 0, 0.01, this), mProps: TransformPropertyFactory.getTransformProperty(this, t, this) },
                                };
                            }),
                            (CVShapeElement.prototype.createShapeElement = function (t) {
                                var e = new CVShapeData(this, t, this.stylesList, this.transformsManager);
                                return this.shapes.push(e), this.addShapeToModifiers(e), e;
                            }),
                            (CVShapeElement.prototype.reloadShapes = function () {
                                var t;
                                this._isFirstFrame = !0;
                                var e = this.itemsData.length;
                                for (t = 0; t < e; t += 1) this.prevViewData[t] = this.itemsData[t];
                                for (this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []), e = this.dynamicProperties.length, t = 0; t < e; t += 1) this.dynamicProperties[t].getValue();
                                this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame);
                            }),
                            (CVShapeElement.prototype.addTransformToStyleList = function (t) {
                                var e,
                                    r = this.stylesList.length;
                                for (e = 0; e < r; e += 1) this.stylesList[e].closed || this.stylesList[e].transforms.push(t);
                            }),
                            (CVShapeElement.prototype.removeTransformFromStyleList = function () {
                                var t,
                                    e = this.stylesList.length;
                                for (t = 0; t < e; t += 1) this.stylesList[t].closed || this.stylesList[t].transforms.pop();
                            }),
                            (CVShapeElement.prototype.closeStyles = function (t) {
                                var e,
                                    r = t.length;
                                for (e = 0; e < r; e += 1) t[e].closed = !0;
                            }),
                            (CVShapeElement.prototype.searchShapes = function (t, e, r, i, n) {
                                var a,
                                    s,
                                    o,
                                    l,
                                    h,
                                    c,
                                    p = t.length - 1,
                                    u = [],
                                    f = [],
                                    d = [].concat(n);
                                for (a = p; a >= 0; a -= 1) {
                                    if (((l = this.searchProcessedElement(t[a])) ? (e[a] = r[l - 1]) : (t[a]._shouldRender = i), "fl" === t[a].ty || "st" === t[a].ty || "gf" === t[a].ty || "gs" === t[a].ty))
                                        l ? (e[a].style.closed = !1) : (e[a] = this.createStyleElement(t[a], d)), u.push(e[a].style);
                                    else if ("gr" === t[a].ty) {
                                        if (l) for (o = e[a].it.length, s = 0; s < o; s += 1) e[a].prevViewData[s] = e[a].it[s];
                                        else e[a] = this.createGroupElement(t[a]);
                                        this.searchShapes(t[a].it, e[a].it, e[a].prevViewData, i, d);
                                    } else
                                        "tr" === t[a].ty
                                            ? (l || ((c = this.createTransformElement(t[a])), (e[a] = c)), d.push(e[a]), this.addTransformToStyleList(e[a]))
                                            : "sh" === t[a].ty || "rc" === t[a].ty || "el" === t[a].ty || "sr" === t[a].ty
                                            ? l || (e[a] = this.createShapeElement(t[a]))
                                            : "tm" === t[a].ty || "rd" === t[a].ty || "pb" === t[a].ty || "zz" === t[a].ty || "op" === t[a].ty
                                            ? (l ? ((h = e[a]).closed = !1) : ((h = ShapeModifiers.getModifier(t[a].ty)).init(this, t[a]), (e[a] = h), this.shapeModifiers.push(h)), f.push(h))
                                            : "rp" === t[a].ty && (l ? ((h = e[a]).closed = !0) : ((h = ShapeModifiers.getModifier(t[a].ty)), (e[a] = h), h.init(this, t, a, e), this.shapeModifiers.push(h), (i = !1)), f.push(h));
                                    this.addProcessedElement(t[a], a + 1);
                                }
                                for (this.removeTransformFromStyleList(), this.closeStyles(u), p = f.length, a = 0; a < p; a += 1) f[a].closed = !0;
                            }),
                            (CVShapeElement.prototype.renderInnerContent = function () {
                                (this.transformHelper.opacity = 1),
                                    (this.transformHelper._opMdf = !1),
                                    this.renderModifiers(),
                                    this.transformsManager.processSequences(this._isFirstFrame),
                                    this.renderShape(this.transformHelper, this.shapesData, this.itemsData, !0);
                            }),
                            (CVShapeElement.prototype.renderShapeTransform = function (t, e) {
                                (t._opMdf || e.op._mdf || this._isFirstFrame) && ((e.opacity = t.opacity), (e.opacity *= e.op.v), (e._opMdf = !0));
                            }),
                            (CVShapeElement.prototype.drawLayer = function () {
                                var t,
                                    e,
                                    r,
                                    i,
                                    n,
                                    a,
                                    s,
                                    o,
                                    l,
                                    h = this.stylesList.length,
                                    c = this.globalData.renderer,
                                    p = this.globalData.canvasContext;
                                for (t = 0; t < h; t += 1)
                                    if ((("st" !== (o = (l = this.stylesList[t]).type) && "gs" !== o) || 0 !== l.wi) && l.data._shouldRender && 0 !== l.coOp && 0 !== this.globalData.currentGlobalAlpha) {
                                        for (
                                            c.save(),
                                                a = l.elements,
                                                "st" === o || "gs" === o
                                                    ? ((p.strokeStyle = "st" === o ? l.co : l.grd), (p.lineWidth = l.wi), (p.lineCap = l.lc), (p.lineJoin = l.lj), (p.miterLimit = l.ml || 0))
                                                    : (p.fillStyle = "fl" === o ? l.co : l.grd),
                                                c.ctxOpacity(l.coOp),
                                                "st" !== o && "gs" !== o && p.beginPath(),
                                                c.ctxTransform(l.preTransforms.finalTransform.props),
                                                r = a.length,
                                                e = 0;
                                            e < r;
                                            e += 1
                                        ) {
                                            for (("st" !== o && "gs" !== o) || (p.beginPath(), l.da && (p.setLineDash(l.da), (p.lineDashOffset = l.do))), n = (s = a[e].trNodes).length, i = 0; i < n; i += 1)
                                                "m" === s[i].t ? p.moveTo(s[i].p[0], s[i].p[1]) : "c" === s[i].t ? p.bezierCurveTo(s[i].pts[0], s[i].pts[1], s[i].pts[2], s[i].pts[3], s[i].pts[4], s[i].pts[5]) : p.closePath();
                                            ("st" !== o && "gs" !== o) || (p.stroke(), l.da && p.setLineDash(this.dashResetter));
                                        }
                                        "st" !== o && "gs" !== o && p.fill(l.r), c.restore();
                                    }
                            }),
                            (CVShapeElement.prototype.renderShape = function (t, e, r, i) {
                                var n, a;
                                for (a = t, n = e.length - 1; n >= 0; n -= 1)
                                    "tr" === e[n].ty
                                        ? ((a = r[n].transform), this.renderShapeTransform(t, a))
                                        : "sh" === e[n].ty || "el" === e[n].ty || "rc" === e[n].ty || "sr" === e[n].ty
                                        ? this.renderPath(e[n], r[n])
                                        : "fl" === e[n].ty
                                        ? this.renderFill(e[n], r[n], a)
                                        : "st" === e[n].ty
                                        ? this.renderStroke(e[n], r[n], a)
                                        : "gf" === e[n].ty || "gs" === e[n].ty
                                        ? this.renderGradientFill(e[n], r[n], a)
                                        : "gr" === e[n].ty
                                        ? this.renderShape(a, e[n].it, r[n].it)
                                        : e[n].ty;
                                i && this.drawLayer();
                            }),
                            (CVShapeElement.prototype.renderStyledShape = function (t, e) {
                                if (this._isFirstFrame || e._mdf || t.transforms._mdf) {
                                    var r,
                                        i,
                                        n,
                                        a = t.trNodes,
                                        s = e.paths,
                                        o = s._length;
                                    a.length = 0;
                                    var l = t.transforms.finalTransform;
                                    for (n = 0; n < o; n += 1) {
                                        var h = s.shapes[n];
                                        if (h && h.v) {
                                            for (i = h._length, r = 1; r < i; r += 1)
                                                1 === r && a.push({ t: "m", p: l.applyToPointArray(h.v[0][0], h.v[0][1], 0) }), a.push({ t: "c", pts: l.applyToTriplePoints(h.o[r - 1], h.i[r], h.v[r]) });
                                            1 === i && a.push({ t: "m", p: l.applyToPointArray(h.v[0][0], h.v[0][1], 0) }), h.c && i && (a.push({ t: "c", pts: l.applyToTriplePoints(h.o[r - 1], h.i[0], h.v[0]) }), a.push({ t: "z" }));
                                        }
                                    }
                                    t.trNodes = a;
                                }
                            }),
                            (CVShapeElement.prototype.renderPath = function (t, e) {
                                if (!0 !== t.hd && t._shouldRender) {
                                    var r,
                                        i = e.styledShapes.length;
                                    for (r = 0; r < i; r += 1) this.renderStyledShape(e.styledShapes[r], e.sh);
                                }
                            }),
                            (CVShapeElement.prototype.renderFill = function (t, e, r) {
                                var i = e.style;
                                (e.c._mdf || this._isFirstFrame) && (i.co = "rgb(" + bmFloor(e.c.v[0]) + "," + bmFloor(e.c.v[1]) + "," + bmFloor(e.c.v[2]) + ")"), (e.o._mdf || r._opMdf || this._isFirstFrame) && (i.coOp = e.o.v * r.opacity);
                            }),
                            (CVShapeElement.prototype.renderGradientFill = function (t, e, r) {
                                var i,
                                    n = e.style;
                                if (!n.grd || e.g._mdf || e.s._mdf || e.e._mdf || (1 !== t.t && (e.h._mdf || e.a._mdf))) {
                                    var a,
                                        s = this.globalData.canvasContext,
                                        o = e.s.v,
                                        l = e.e.v;
                                    if (1 === t.t) i = s.createLinearGradient(o[0], o[1], l[0], l[1]);
                                    else {
                                        var h = Math.sqrt(Math.pow(o[0] - l[0], 2) + Math.pow(o[1] - l[1], 2)),
                                            c = Math.atan2(l[1] - o[1], l[0] - o[0]),
                                            p = e.h.v;
                                        p >= 1 ? (p = 0.99) : p <= -1 && (p = -0.99);
                                        var u = h * p,
                                            f = Math.cos(c + e.a.v) * u + o[0],
                                            d = Math.sin(c + e.a.v) * u + o[1];
                                        i = s.createRadialGradient(f, d, 0, o[0], o[1], h);
                                    }
                                    var m = t.g.p,
                                        y = e.g.c,
                                        v = 1;
                                    for (a = 0; a < m; a += 1) e.g._hasOpacity && e.g._collapsable && (v = e.g.o[2 * a + 1]), i.addColorStop(y[4 * a] / 100, "rgba(" + y[4 * a + 1] + "," + y[4 * a + 2] + "," + y[4 * a + 3] + "," + v + ")");
                                    n.grd = i;
                                }
                                n.coOp = e.o.v * r.opacity;
                            }),
                            (CVShapeElement.prototype.renderStroke = function (t, e, r) {
                                var i = e.style,
                                    n = e.d;
                                n && (n._mdf || this._isFirstFrame) && ((i.da = n.dashArray), (i.do = n.dashoffset[0])),
                                    (e.c._mdf || this._isFirstFrame) && (i.co = "rgb(" + bmFloor(e.c.v[0]) + "," + bmFloor(e.c.v[1]) + "," + bmFloor(e.c.v[2]) + ")"),
                                    (e.o._mdf || r._opMdf || this._isFirstFrame) && (i.coOp = e.o.v * r.opacity),
                                    (e.w._mdf || this._isFirstFrame) && (i.wi = e.w.v);
                            }),
                            (CVShapeElement.prototype.destroy = function () {
                                (this.shapesData = null), (this.globalData = null), (this.canvasContext = null), (this.stylesList.length = 0), (this.itemsData.length = 0);
                            }),
                            extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement, ITextElement], CVTextElement),
                            (CVTextElement.prototype.tHelper = createTag("canvas").getContext("2d")),
                            (CVTextElement.prototype.buildNewText = function () {
                                var t = this.textProperty.currentData;
                                this.renderedLetters = createSizedArray(t.l ? t.l.length : 0);
                                var e = !1;
                                t.fc ? ((e = !0), (this.values.fill = this.buildColor(t.fc))) : (this.values.fill = "rgba(0,0,0,0)"), (this.fill = e);
                                var r = !1;
                                t.sc && ((r = !0), (this.values.stroke = this.buildColor(t.sc)), (this.values.sWidth = t.sw));
                                var i,
                                    n,
                                    a,
                                    s,
                                    o,
                                    l,
                                    h,
                                    c,
                                    p,
                                    u,
                                    f,
                                    d,
                                    m = this.globalData.fontManager.getFontByName(t.f),
                                    y = t.l,
                                    v = this.mHelper;
                                (this.stroke = r), (this.values.fValue = t.finalSize + "px " + this.globalData.fontManager.getFontByName(t.f).fFamily), (n = t.finalText.length);
                                var g = this.data.singleShape,
                                    _ = 0.001 * t.tr * t.finalSize,
                                    b = 0,
                                    E = 0,
                                    S = !0,
                                    P = 0;
                                for (i = 0; i < n; i += 1) {
                                    (s = ((a = this.globalData.fontManager.getCharData(t.finalText[i], m.fStyle, this.globalData.fontManager.getFontByName(t.f).fFamily)) && a.data) || {}),
                                        v.reset(),
                                        g && y[i].n && ((b = -_), (E += t.yOffset), (E += S ? 1 : 0), (S = !1)),
                                        (p = (h = s.shapes ? s.shapes[0].it : []).length),
                                        v.scale(t.finalSize / 100, t.finalSize / 100),
                                        g && this.applyTextPropertiesToMatrix(t, v, y[i].line, b, E),
                                        (f = createSizedArray(p - 1));
                                    var w = 0;
                                    for (c = 0; c < p; c += 1)
                                        if ("sh" === h[c].ty) {
                                            for (l = h[c].ks.k.i.length, u = h[c].ks.k, d = [], o = 1; o < l; o += 1)
                                                1 === o && d.push(v.applyToX(u.v[0][0], u.v[0][1], 0), v.applyToY(u.v[0][0], u.v[0][1], 0)),
                                                    d.push(
                                                        v.applyToX(u.o[o - 1][0], u.o[o - 1][1], 0),
                                                        v.applyToY(u.o[o - 1][0], u.o[o - 1][1], 0),
                                                        v.applyToX(u.i[o][0], u.i[o][1], 0),
                                                        v.applyToY(u.i[o][0], u.i[o][1], 0),
                                                        v.applyToX(u.v[o][0], u.v[o][1], 0),
                                                        v.applyToY(u.v[o][0], u.v[o][1], 0)
                                                    );
                                            d.push(
                                                v.applyToX(u.o[o - 1][0], u.o[o - 1][1], 0),
                                                v.applyToY(u.o[o - 1][0], u.o[o - 1][1], 0),
                                                v.applyToX(u.i[0][0], u.i[0][1], 0),
                                                v.applyToY(u.i[0][0], u.i[0][1], 0),
                                                v.applyToX(u.v[0][0], u.v[0][1], 0),
                                                v.applyToY(u.v[0][0], u.v[0][1], 0)
                                            ),
                                                (f[w] = d),
                                                (w += 1);
                                        }
                                    g && ((b += y[i].l), (b += _)), this.textSpans[P] ? (this.textSpans[P].elem = f) : (this.textSpans[P] = { elem: f }), (P += 1);
                                }
                            }),
                            (CVTextElement.prototype.renderInnerContent = function () {
                                var t,
                                    e,
                                    r,
                                    i,
                                    n,
                                    a,
                                    s = this.canvasContext;
                                (s.font = this.values.fValue), (s.lineCap = "butt"), (s.lineJoin = "miter"), (s.miterLimit = 4), this.data.singleShape || this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
                                var o,
                                    l = this.textAnimator.renderedLetters,
                                    h = this.textProperty.currentData.l;
                                e = h.length;
                                var c,
                                    p,
                                    u = null,
                                    f = null,
                                    d = null;
                                for (t = 0; t < e; t += 1)
                                    if (!h[t].n) {
                                        if (((o = l[t]) && (this.globalData.renderer.save(), this.globalData.renderer.ctxTransform(o.p), this.globalData.renderer.ctxOpacity(o.o)), this.fill)) {
                                            for (
                                                o && o.fc ? u !== o.fc && ((u = o.fc), (s.fillStyle = o.fc)) : u !== this.values.fill && ((u = this.values.fill), (s.fillStyle = this.values.fill)),
                                                    i = (c = this.textSpans[t].elem).length,
                                                    this.globalData.canvasContext.beginPath(),
                                                    r = 0;
                                                r < i;
                                                r += 1
                                            )
                                                for (a = (p = c[r]).length, this.globalData.canvasContext.moveTo(p[0], p[1]), n = 2; n < a; n += 6)
                                                    this.globalData.canvasContext.bezierCurveTo(p[n], p[n + 1], p[n + 2], p[n + 3], p[n + 4], p[n + 5]);
                                            this.globalData.canvasContext.closePath(), this.globalData.canvasContext.fill();
                                        }
                                        if (this.stroke) {
                                            for (
                                                o && o.sw ? d !== o.sw && ((d = o.sw), (s.lineWidth = o.sw)) : d !== this.values.sWidth && ((d = this.values.sWidth), (s.lineWidth = this.values.sWidth)),
                                                    o && o.sc ? f !== o.sc && ((f = o.sc), (s.strokeStyle = o.sc)) : f !== this.values.stroke && ((f = this.values.stroke), (s.strokeStyle = this.values.stroke)),
                                                    i = (c = this.textSpans[t].elem).length,
                                                    this.globalData.canvasContext.beginPath(),
                                                    r = 0;
                                                r < i;
                                                r += 1
                                            )
                                                for (a = (p = c[r]).length, this.globalData.canvasContext.moveTo(p[0], p[1]), n = 2; n < a; n += 6)
                                                    this.globalData.canvasContext.bezierCurveTo(p[n], p[n + 1], p[n + 2], p[n + 3], p[n + 4], p[n + 5]);
                                            this.globalData.canvasContext.closePath(), this.globalData.canvasContext.stroke();
                                        }
                                        o && this.globalData.renderer.restore();
                                    }
                            }),
                            extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVImageElement),
                            (CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement),
                            (CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame),
                            (CVImageElement.prototype.createContent = function () {
                                if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
                                    var t = createTag("canvas");
                                    (t.width = this.assetData.w), (t.height = this.assetData.h);
                                    var e,
                                        r,
                                        i = t.getContext("2d"),
                                        n = this.img.width,
                                        a = this.img.height,
                                        s = n / a,
                                        o = this.assetData.w / this.assetData.h,
                                        l = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
                                    (s > o && "xMidYMid slice" === l) || (s < o && "xMidYMid slice" !== l) ? (e = (r = a) * o) : (r = (e = n) / o),
                                        i.drawImage(this.img, (n - e) / 2, (a - r) / 2, e, r, 0, 0, this.assetData.w, this.assetData.h),
                                        (this.img = t);
                                }
                            }),
                            (CVImageElement.prototype.renderInnerContent = function () {
                                this.canvasContext.drawImage(this.img, 0, 0);
                            }),
                            (CVImageElement.prototype.destroy = function () {
                                this.img = null;
                            }),
                            extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVSolidElement),
                            (CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement),
                            (CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame),
                            (CVSolidElement.prototype.renderInnerContent = function () {
                                var t = this.canvasContext;
                                (t.fillStyle = this.data.sc), t.fillRect(0, 0, this.data.sw, this.data.sh);
                            }),
                            extendPrototype([BaseRenderer], CanvasRendererBase),
                            (CanvasRendererBase.prototype.createShape = function (t) {
                                return new CVShapeElement(t, this.globalData, this);
                            }),
                            (CanvasRendererBase.prototype.createText = function (t) {
                                return new CVTextElement(t, this.globalData, this);
                            }),
                            (CanvasRendererBase.prototype.createImage = function (t) {
                                return new CVImageElement(t, this.globalData, this);
                            }),
                            (CanvasRendererBase.prototype.createSolid = function (t) {
                                return new CVSolidElement(t, this.globalData, this);
                            }),
                            (CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull),
                            (CanvasRendererBase.prototype.ctxTransform = function (t) {
                                if (1 !== t[0] || 0 !== t[1] || 0 !== t[4] || 1 !== t[5] || 0 !== t[12] || 0 !== t[13])
                                    if (this.renderConfig.clearCanvas) {
                                        this.transformMat.cloneFromProps(t);
                                        var e = this.contextData.cTr.props;
                                        this.transformMat.transform(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15]), this.contextData.cTr.cloneFromProps(this.transformMat.props);
                                        var r = this.contextData.cTr.props;
                                        this.canvasContext.setTransform(r[0], r[1], r[4], r[5], r[12], r[13]);
                                    } else this.canvasContext.transform(t[0], t[1], t[4], t[5], t[12], t[13]);
                            }),
                            (CanvasRendererBase.prototype.ctxOpacity = function (t) {
                                if (!this.renderConfig.clearCanvas) return (this.canvasContext.globalAlpha *= t < 0 ? 0 : t), void (this.globalData.currentGlobalAlpha = this.contextData.cO);
                                (this.contextData.cO *= t < 0 ? 0 : t),
                                    this.globalData.currentGlobalAlpha !== this.contextData.cO && ((this.canvasContext.globalAlpha = this.contextData.cO), (this.globalData.currentGlobalAlpha = this.contextData.cO));
                            }),
                            (CanvasRendererBase.prototype.reset = function () {
                                this.renderConfig.clearCanvas ? this.contextData.reset() : this.canvasContext.restore();
                            }),
                            (CanvasRendererBase.prototype.save = function (t) {
                                if (this.renderConfig.clearCanvas) {
                                    t && this.canvasContext.save();
                                    var e,
                                        r = this.contextData.cTr.props;
                                    this.contextData._length <= this.contextData.cArrPos && this.contextData.duplicate();
                                    var i = this.contextData.saved[this.contextData.cArrPos];
                                    for (e = 0; e < 16; e += 1) i[e] = r[e];
                                    (this.contextData.savedOp[this.contextData.cArrPos] = this.contextData.cO), (this.contextData.cArrPos += 1);
                                } else this.canvasContext.save();
                            }),
                            (CanvasRendererBase.prototype.restore = function (t) {
                                if (this.renderConfig.clearCanvas) {
                                    t && (this.canvasContext.restore(), (this.globalData.blendMode = "source-over")), (this.contextData.cArrPos -= 1);
                                    var e,
                                        r = this.contextData.saved[this.contextData.cArrPos],
                                        i = this.contextData.cTr.props;
                                    for (e = 0; e < 16; e += 1) i[e] = r[e];
                                    this.canvasContext.setTransform(r[0], r[1], r[4], r[5], r[12], r[13]),
                                        (r = this.contextData.savedOp[this.contextData.cArrPos]),
                                        (this.contextData.cO = r),
                                        this.globalData.currentGlobalAlpha !== r && ((this.canvasContext.globalAlpha = r), (this.globalData.currentGlobalAlpha = r));
                                } else this.canvasContext.restore();
                            }),
                            (CanvasRendererBase.prototype.configAnimation = function (t) {
                                if (this.animationItem.wrapper) {
                                    this.animationItem.container = createTag("canvas");
                                    var e = this.animationItem.container.style;
                                    (e.width = "100%"), (e.height = "100%");
                                    var r = "0px 0px 0px";
                                    (e.transformOrigin = r),
                                        (e.mozTransformOrigin = r),
                                        (e.webkitTransformOrigin = r),
                                        (e["-webkit-transform"] = r),
                                        (e.contentVisibility = this.renderConfig.contentVisibility),
                                        this.animationItem.wrapper.appendChild(this.animationItem.container),
                                        (this.canvasContext = this.animationItem.container.getContext("2d")),
                                        this.renderConfig.className && this.animationItem.container.setAttribute("class", this.renderConfig.className),
                                        this.renderConfig.id && this.animationItem.container.setAttribute("id", this.renderConfig.id);
                                } else this.canvasContext = this.renderConfig.context;
                                (this.data = t),
                                    (this.layers = t.layers),
                                    (this.transformCanvas = { w: t.w, h: t.h, sx: 0, sy: 0, tx: 0, ty: 0 }),
                                    this.setupGlobalData(t, document.body),
                                    (this.globalData.canvasContext = this.canvasContext),
                                    (this.globalData.renderer = this),
                                    (this.globalData.isDashed = !1),
                                    (this.globalData.progressiveLoad = this.renderConfig.progressiveLoad),
                                    (this.globalData.transformCanvas = this.transformCanvas),
                                    (this.elements = createSizedArray(t.layers.length)),
                                    this.updateContainerSize();
                            }),
                            (CanvasRendererBase.prototype.updateContainerSize = function (t, e) {
                                var r, i, n, a;
                                if (
                                    (this.reset(),
                                    t
                                        ? ((r = t), (i = e), (this.canvasContext.canvas.width = r), (this.canvasContext.canvas.height = i))
                                        : (this.animationItem.wrapper && this.animationItem.container
                                              ? ((r = this.animationItem.wrapper.offsetWidth), (i = this.animationItem.wrapper.offsetHeight))
                                              : ((r = this.canvasContext.canvas.width), (i = this.canvasContext.canvas.height)),
                                          (this.canvasContext.canvas.width = r * this.renderConfig.dpr),
                                          (this.canvasContext.canvas.height = i * this.renderConfig.dpr)),
                                    -1 !== this.renderConfig.preserveAspectRatio.indexOf("meet") || -1 !== this.renderConfig.preserveAspectRatio.indexOf("slice"))
                                ) {
                                    var s = this.renderConfig.preserveAspectRatio.split(" "),
                                        o = s[1] || "meet",
                                        l = s[0] || "xMidYMid",
                                        h = l.substr(0, 4),
                                        c = l.substr(4);
                                    (n = r / i),
                                        ((a = this.transformCanvas.w / this.transformCanvas.h) > n && "meet" === o) || (a < n && "slice" === o)
                                            ? ((this.transformCanvas.sx = r / (this.transformCanvas.w / this.renderConfig.dpr)), (this.transformCanvas.sy = r / (this.transformCanvas.w / this.renderConfig.dpr)))
                                            : ((this.transformCanvas.sx = i / (this.transformCanvas.h / this.renderConfig.dpr)), (this.transformCanvas.sy = i / (this.transformCanvas.h / this.renderConfig.dpr))),
                                        (this.transformCanvas.tx =
                                            "xMid" === h && ((a < n && "meet" === o) || (a > n && "slice" === o))
                                                ? ((r - this.transformCanvas.w * (i / this.transformCanvas.h)) / 2) * this.renderConfig.dpr
                                                : "xMax" === h && ((a < n && "meet" === o) || (a > n && "slice" === o))
                                                ? (r - this.transformCanvas.w * (i / this.transformCanvas.h)) * this.renderConfig.dpr
                                                : 0),
                                        (this.transformCanvas.ty =
                                            "YMid" === c && ((a > n && "meet" === o) || (a < n && "slice" === o))
                                                ? ((i - this.transformCanvas.h * (r / this.transformCanvas.w)) / 2) * this.renderConfig.dpr
                                                : "YMax" === c && ((a > n && "meet" === o) || (a < n && "slice" === o))
                                                ? (i - this.transformCanvas.h * (r / this.transformCanvas.w)) * this.renderConfig.dpr
                                                : 0);
                                } else
                                    "none" === this.renderConfig.preserveAspectRatio
                                        ? ((this.transformCanvas.sx = r / (this.transformCanvas.w / this.renderConfig.dpr)),
                                          (this.transformCanvas.sy = i / (this.transformCanvas.h / this.renderConfig.dpr)),
                                          (this.transformCanvas.tx = 0),
                                          (this.transformCanvas.ty = 0))
                                        : ((this.transformCanvas.sx = this.renderConfig.dpr), (this.transformCanvas.sy = this.renderConfig.dpr), (this.transformCanvas.tx = 0), (this.transformCanvas.ty = 0));
                                (this.transformCanvas.props = [this.transformCanvas.sx, 0, 0, 0, 0, this.transformCanvas.sy, 0, 0, 0, 0, 1, 0, this.transformCanvas.tx, this.transformCanvas.ty, 0, 1]),
                                    this.ctxTransform(this.transformCanvas.props),
                                    this.canvasContext.beginPath(),
                                    this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h),
                                    this.canvasContext.closePath(),
                                    this.canvasContext.clip(),
                                    this.renderFrame(this.renderedFrame, !0);
                            }),
                            (CanvasRendererBase.prototype.destroy = function () {
                                var t;
                                for (this.renderConfig.clearCanvas && this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), t = (this.layers ? this.layers.length : 0) - 1; t >= 0; t -= 1)
                                    this.elements[t] && this.elements[t].destroy();
                                (this.elements.length = 0), (this.globalData.canvasContext = null), (this.animationItem.container = null), (this.destroyed = !0);
                            }),
                            (CanvasRendererBase.prototype.renderFrame = function (t, e) {
                                if ((this.renderedFrame !== t || !0 !== this.renderConfig.clearCanvas || e) && !this.destroyed && -1 !== t) {
                                    var r;
                                    (this.renderedFrame = t),
                                        (this.globalData.frameNum = t - this.animationItem._isFirstFrame),
                                        (this.globalData.frameId += 1),
                                        (this.globalData._mdf = !this.renderConfig.clearCanvas || e),
                                        (this.globalData.projectInterface.currentFrame = t);
                                    var i = this.layers.length;
                                    for (this.completeLayers || this.checkLayers(t), r = 0; r < i; r += 1) (this.completeLayers || this.elements[r]) && this.elements[r].prepareFrame(t - this.layers[r].st);
                                    if (this.globalData._mdf) {
                                        for (!0 === this.renderConfig.clearCanvas ? this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h) : this.save(), r = i - 1; r >= 0; r -= 1)
                                            (this.completeLayers || this.elements[r]) && this.elements[r].renderFrame();
                                        !0 !== this.renderConfig.clearCanvas && this.restore();
                                    }
                                }
                            }),
                            (CanvasRendererBase.prototype.buildItem = function (t) {
                                var e = this.elements;
                                if (!e[t] && 99 !== this.layers[t].ty) {
                                    var r = this.createItem(this.layers[t], this, this.globalData);
                                    (e[t] = r), r.initExpressions();
                                }
                            }),
                            (CanvasRendererBase.prototype.checkPendingElements = function () {
                                for (; this.pendingElements.length; ) this.pendingElements.pop().checkParenting();
                            }),
                            (CanvasRendererBase.prototype.hide = function () {
                                this.animationItem.container.style.display = "none";
                            }),
                            (CanvasRendererBase.prototype.show = function () {
                                this.animationItem.container.style.display = "block";
                            }),
                            extendPrototype([CanvasRendererBase, ICompElement, CVBaseElement], CVCompElement),
                            (CVCompElement.prototype.renderInnerContent = function () {
                                var t,
                                    e = this.canvasContext;
                                for (e.beginPath(), e.moveTo(0, 0), e.lineTo(this.data.w, 0), e.lineTo(this.data.w, this.data.h), e.lineTo(0, this.data.h), e.lineTo(0, 0), e.clip(), t = this.layers.length - 1; t >= 0; t -= 1)
                                    (this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
                            }),
                            (CVCompElement.prototype.destroy = function () {
                                var t;
                                for (t = this.layers.length - 1; t >= 0; t -= 1) this.elements[t] && this.elements[t].destroy();
                                (this.layers = null), (this.elements = null);
                            }),
                            (CVCompElement.prototype.createComp = function (t) {
                                return new CVCompElement(t, this.globalData, this);
                            }),
                            extendPrototype([CanvasRendererBase], CanvasRenderer),
                            (CanvasRenderer.prototype.createComp = function (t) {
                                return new CVCompElement(t, this.globalData, this);
                            }),
                            (HBaseElement.prototype = {
                                checkBlendMode: function () {},
                                initRendererElement: function () {
                                    (this.baseElement = createTag(this.data.tg || "div")),
                                        this.data.hasMask
                                            ? ((this.svgElement = createNS("svg")),
                                              (this.layerElement = createNS("g")),
                                              (this.maskedElement = this.layerElement),
                                              this.svgElement.appendChild(this.layerElement),
                                              this.baseElement.appendChild(this.svgElement))
                                            : (this.layerElement = this.baseElement),
                                        styleDiv(this.baseElement);
                                },
                                createContainerElements: function () {
                                    (this.renderableEffectsManager = new CVEffects(this)),
                                        (this.transformedElement = this.baseElement),
                                        (this.maskedElement = this.layerElement),
                                        this.data.ln && this.layerElement.setAttribute("id", this.data.ln),
                                        this.data.cl && this.layerElement.setAttribute("class", this.data.cl),
                                        0 !== this.data.bm && this.setBlendMode();
                                },
                                renderElement: function () {
                                    var t = this.transformedElement ? this.transformedElement.style : {};
                                    if (this.finalTransform._matMdf) {
                                        var e = this.finalTransform.mat.toCSS();
                                        (t.transform = e), (t.webkitTransform = e);
                                    }
                                    this.finalTransform._opMdf && (t.opacity = this.finalTransform.mProp.o.v);
                                },
                                renderFrame: function () {
                                    this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
                                },
                                destroy: function () {
                                    (this.layerElement = null), (this.transformedElement = null), this.matteElement && (this.matteElement = null), this.maskManager && (this.maskManager.destroy(), (this.maskManager = null));
                                },
                                createRenderableComponents: function () {
                                    this.maskManager = new MaskElement(this.data, this, this.globalData);
                                },
                                addEffects: function () {},
                                setMatte: function () {},
                            }),
                            (HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement),
                            (HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy),
                            (HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting),
                            extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], HSolidElement),
                            (HSolidElement.prototype.createContent = function () {
                                var t;
                                this.data.hasMask
                                    ? ((t = createNS("rect")).setAttribute("width", this.data.sw),
                                      t.setAttribute("height", this.data.sh),
                                      t.setAttribute("fill", this.data.sc),
                                      this.svgElement.setAttribute("width", this.data.sw),
                                      this.svgElement.setAttribute("height", this.data.sh))
                                    : (((t = createTag("div")).style.width = this.data.sw + "px"), (t.style.height = this.data.sh + "px"), (t.style.backgroundColor = this.data.sc)),
                                    this.layerElement.appendChild(t);
                            }),
                            extendPrototype([BaseElement, TransformElement, HSolidElement, SVGShapeElement, HBaseElement, HierarchyElement, FrameElement, RenderableElement], HShapeElement),
                            (HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent),
                            (HShapeElement.prototype.createContent = function () {
                                var t;
                                if (((this.baseElement.style.fontSize = 0), this.data.hasMask)) this.layerElement.appendChild(this.shapesContainer), (t = this.svgElement);
                                else {
                                    t = createNS("svg");
                                    var e = this.comp.data ? this.comp.data : this.globalData.compSize;
                                    t.setAttribute("width", e.w), t.setAttribute("height", e.h), t.appendChild(this.shapesContainer), this.layerElement.appendChild(t);
                                }
                                this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], !0), this.filterUniqueShapes(), (this.shapeCont = t);
                            }),
                            (HShapeElement.prototype.getTransformedPoint = function (t, e) {
                                var r,
                                    i = t.length;
                                for (r = 0; r < i; r += 1) e = t[r].mProps.v.applyToPointArray(e[0], e[1], 0);
                                return e;
                            }),
                            (HShapeElement.prototype.calculateShapeBoundingBox = function (t, e) {
                                var r,
                                    i,
                                    n,
                                    a,
                                    s,
                                    o = t.sh.v,
                                    l = t.transformers,
                                    h = o._length;
                                if (!(h <= 1)) {
                                    for (r = 0; r < h - 1; r += 1)
                                        (i = this.getTransformedPoint(l, o.v[r])),
                                            (n = this.getTransformedPoint(l, o.o[r])),
                                            (a = this.getTransformedPoint(l, o.i[r + 1])),
                                            (s = this.getTransformedPoint(l, o.v[r + 1])),
                                            this.checkBounds(i, n, a, s, e);
                                    o.c &&
                                        ((i = this.getTransformedPoint(l, o.v[r])),
                                        (n = this.getTransformedPoint(l, o.o[r])),
                                        (a = this.getTransformedPoint(l, o.i[0])),
                                        (s = this.getTransformedPoint(l, o.v[0])),
                                        this.checkBounds(i, n, a, s, e));
                                }
                            }),
                            (HShapeElement.prototype.checkBounds = function (t, e, r, i, n) {
                                this.getBoundsOfCurve(t, e, r, i);
                                var a = this.shapeBoundingBox;
                                (n.x = bmMin(a.left, n.x)), (n.xMax = bmMax(a.right, n.xMax)), (n.y = bmMin(a.top, n.y)), (n.yMax = bmMax(a.bottom, n.yMax));
                            }),
                            (HShapeElement.prototype.shapeBoundingBox = { left: 0, right: 0, top: 0, bottom: 0 }),
                            (HShapeElement.prototype.tempBoundingBox = { x: 0, xMax: 0, y: 0, yMax: 0, width: 0, height: 0 }),
                            (HShapeElement.prototype.getBoundsOfCurve = function (t, e, r, i) {
                                for (
                                    var n,
                                        a,
                                        s,
                                        o,
                                        l,
                                        h,
                                        c,
                                        p = [
                                            [t[0], i[0]],
                                            [t[1], i[1]],
                                        ],
                                        u = 0;
                                    u < 2;
                                    ++u
                                )
                                    (a = 6 * t[u] - 12 * e[u] + 6 * r[u]),
                                        (n = -3 * t[u] + 9 * e[u] - 9 * r[u] + 3 * i[u]),
                                        (s = 3 * e[u] - 3 * t[u]),
                                        (a |= 0),
                                        (s |= 0),
                                        (0 == (n |= 0) && 0 === a) ||
                                            (0 === n
                                                ? (o = -s / a) > 0 && o < 1 && p[u].push(this.calculateF(o, t, e, r, i, u))
                                                : (l = a * a - 4 * s * n) >= 0 &&
                                                  ((h = (-a + bmSqrt(l)) / (2 * n)) > 0 && h < 1 && p[u].push(this.calculateF(h, t, e, r, i, u)),
                                                  (c = (-a - bmSqrt(l)) / (2 * n)) > 0 && c < 1 && p[u].push(this.calculateF(c, t, e, r, i, u))));
                                (this.shapeBoundingBox.left = bmMin.apply(null, p[0])),
                                    (this.shapeBoundingBox.top = bmMin.apply(null, p[1])),
                                    (this.shapeBoundingBox.right = bmMax.apply(null, p[0])),
                                    (this.shapeBoundingBox.bottom = bmMax.apply(null, p[1]));
                            }),
                            (HShapeElement.prototype.calculateF = function (t, e, r, i, n, a) {
                                return bmPow(1 - t, 3) * e[a] + 3 * bmPow(1 - t, 2) * t * r[a] + 3 * (1 - t) * bmPow(t, 2) * i[a] + bmPow(t, 3) * n[a];
                            }),
                            (HShapeElement.prototype.calculateBoundingBox = function (t, e) {
                                var r,
                                    i = t.length;
                                for (r = 0; r < i; r += 1)
                                    t[r] && t[r].sh ? this.calculateShapeBoundingBox(t[r], e) : t[r] && t[r].it ? this.calculateBoundingBox(t[r].it, e) : t[r] && t[r].style && t[r].w && this.expandStrokeBoundingBox(t[r].w, e);
                            }),
                            (HShapeElement.prototype.expandStrokeBoundingBox = function (t, e) {
                                var r = 0;
                                if (t.keyframes) {
                                    for (var i = 0; i < t.keyframes.length; i += 1) {
                                        var n = t.keyframes[i].s;
                                        n > r && (r = n);
                                    }
                                    r *= t.mult;
                                } else r = t.v * t.mult;
                                (e.x -= r), (e.xMax += r), (e.y -= r), (e.yMax += r);
                            }),
                            (HShapeElement.prototype.currentBoxContains = function (t) {
                                return this.currentBBox.x <= t.x && this.currentBBox.y <= t.y && this.currentBBox.width + this.currentBBox.x >= t.x + t.width && this.currentBBox.height + this.currentBBox.y >= t.y + t.height;
                            }),
                            (HShapeElement.prototype.renderInnerContent = function () {
                                if ((this._renderShapeFrame(), !this.hidden && (this._isFirstFrame || this._mdf))) {
                                    var t = this.tempBoundingBox,
                                        e = 999999;
                                    if (
                                        ((t.x = e),
                                        (t.xMax = -e),
                                        (t.y = e),
                                        (t.yMax = -e),
                                        this.calculateBoundingBox(this.itemsData, t),
                                        (t.width = t.xMax < t.x ? 0 : t.xMax - t.x),
                                        (t.height = t.yMax < t.y ? 0 : t.yMax - t.y),
                                        this.currentBoxContains(t))
                                    )
                                        return;
                                    var r = !1;
                                    if (
                                        (this.currentBBox.w !== t.width && ((this.currentBBox.w = t.width), this.shapeCont.setAttribute("width", t.width), (r = !0)),
                                        this.currentBBox.h !== t.height && ((this.currentBBox.h = t.height), this.shapeCont.setAttribute("height", t.height), (r = !0)),
                                        r || this.currentBBox.x !== t.x || this.currentBBox.y !== t.y)
                                    ) {
                                        (this.currentBBox.w = t.width),
                                            (this.currentBBox.h = t.height),
                                            (this.currentBBox.x = t.x),
                                            (this.currentBBox.y = t.y),
                                            this.shapeCont.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h);
                                        var i = this.shapeCont.style,
                                            n = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
                                        (i.transform = n), (i.webkitTransform = n);
                                    }
                                }
                            }),
                            extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], HTextElement),
                            (HTextElement.prototype.createContent = function () {
                                if (((this.isMasked = this.checkMasks()), this.isMasked)) {
                                    (this.renderType = "svg"), (this.compW = this.comp.data.w), (this.compH = this.comp.data.h), this.svgElement.setAttribute("width", this.compW), this.svgElement.setAttribute("height", this.compH);
                                    var t = createNS("g");
                                    this.maskedElement.appendChild(t), (this.innerElem = t);
                                } else (this.renderType = "html"), (this.innerElem = this.layerElement);
                                this.checkParenting();
                            }),
                            (HTextElement.prototype.buildNewText = function () {
                                var t = this.textProperty.currentData;
                                this.renderedLetters = createSizedArray(t.l ? t.l.length : 0);
                                var e = this.innerElem.style,
                                    r = t.fc ? this.buildColor(t.fc) : "rgba(0,0,0,0)";
                                (e.fill = r), (e.color = r), t.sc && ((e.stroke = this.buildColor(t.sc)), (e.strokeWidth = t.sw + "px"));
                                var i,
                                    n,
                                    a = this.globalData.fontManager.getFontByName(t.f);
                                if (!this.globalData.fontManager.chars)
                                    if (((e.fontSize = t.finalSize + "px"), (e.lineHeight = t.finalSize + "px"), a.fClass)) this.innerElem.className = a.fClass;
                                    else {
                                        e.fontFamily = a.fFamily;
                                        var s = t.fWeight,
                                            o = t.fStyle;
                                        (e.fontStyle = o), (e.fontWeight = s);
                                    }
                                var l,
                                    h,
                                    c,
                                    p = t.l;
                                n = p.length;
                                var u,
                                    f = this.mHelper,
                                    d = "",
                                    m = 0;
                                for (i = 0; i < n; i += 1) {
                                    if (
                                        (this.globalData.fontManager.chars
                                            ? (this.textPaths[m]
                                                  ? (l = this.textPaths[m])
                                                  : ((l = createNS("path")).setAttribute("stroke-linecap", lineCapEnum[1]), l.setAttribute("stroke-linejoin", lineJoinEnum[2]), l.setAttribute("stroke-miterlimit", "4")),
                                              this.isMasked || (this.textSpans[m] ? (c = (h = this.textSpans[m]).children[0]) : (((h = createTag("div")).style.lineHeight = 0), (c = createNS("svg")).appendChild(l), styleDiv(h))))
                                            : this.isMasked
                                            ? (l = this.textPaths[m] ? this.textPaths[m] : createNS("text"))
                                            : this.textSpans[m]
                                            ? ((h = this.textSpans[m]), (l = this.textPaths[m]))
                                            : (styleDiv((h = createTag("span"))), styleDiv((l = createTag("span"))), h.appendChild(l)),
                                        this.globalData.fontManager.chars)
                                    ) {
                                        var y,
                                            v = this.globalData.fontManager.getCharData(t.finalText[i], a.fStyle, this.globalData.fontManager.getFontByName(t.f).fFamily);
                                        if (
                                            ((y = v ? v.data : null),
                                            f.reset(),
                                            y && y.shapes && y.shapes.length && ((u = y.shapes[0].it), f.scale(t.finalSize / 100, t.finalSize / 100), (d = this.createPathShape(f, u)), l.setAttribute("d", d)),
                                            this.isMasked)
                                        )
                                            this.innerElem.appendChild(l);
                                        else {
                                            if ((this.innerElem.appendChild(h), y && y.shapes)) {
                                                document.body.appendChild(c);
                                                var g = c.getBBox();
                                                c.setAttribute("width", g.width + 2), c.setAttribute("height", g.height + 2), c.setAttribute("viewBox", g.x - 1 + " " + (g.y - 1) + " " + (g.width + 2) + " " + (g.height + 2));
                                                var _ = c.style,
                                                    b = "translate(" + (g.x - 1) + "px," + (g.y - 1) + "px)";
                                                (_.transform = b), (_.webkitTransform = b), (p[i].yOffset = g.y - 1);
                                            } else c.setAttribute("width", 1), c.setAttribute("height", 1);
                                            h.appendChild(c);
                                        }
                                    } else if (((l.textContent = p[i].val), l.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), this.isMasked)) this.innerElem.appendChild(l);
                                    else {
                                        this.innerElem.appendChild(h);
                                        var E = l.style,
                                            S = "translate3d(0," + -t.finalSize / 1.2 + "px,0)";
                                        (E.transform = S), (E.webkitTransform = S);
                                    }
                                    this.isMasked ? (this.textSpans[m] = l) : (this.textSpans[m] = h), (this.textSpans[m].style.display = "block"), (this.textPaths[m] = l), (m += 1);
                                }
                                for (; m < this.textSpans.length; ) (this.textSpans[m].style.display = "none"), (m += 1);
                            }),
                            (HTextElement.prototype.renderInnerContent = function () {
                                var t;
                                if (this.data.singleShape) {
                                    if (!this._isFirstFrame && !this.lettersChangedFlag) return;
                                    if (this.isMasked && this.finalTransform._matMdf) {
                                        this.svgElement.setAttribute("viewBox", -this.finalTransform.mProp.p.v[0] + " " + -this.finalTransform.mProp.p.v[1] + " " + this.compW + " " + this.compH), (t = this.svgElement.style);
                                        var e = "translate(" + -this.finalTransform.mProp.p.v[0] + "px," + -this.finalTransform.mProp.p.v[1] + "px)";
                                        (t.transform = e), (t.webkitTransform = e);
                                    }
                                }
                                if ((this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)) {
                                    var r,
                                        i,
                                        n,
                                        a,
                                        s,
                                        o = 0,
                                        l = this.textAnimator.renderedLetters,
                                        h = this.textProperty.currentData.l;
                                    for (i = h.length, r = 0; r < i; r += 1)
                                        h[r].n
                                            ? (o += 1)
                                            : ((a = this.textSpans[r]),
                                              (s = this.textPaths[r]),
                                              (n = l[o]),
                                              (o += 1),
                                              n._mdf.m && (this.isMasked ? a.setAttribute("transform", n.m) : ((a.style.webkitTransform = n.m), (a.style.transform = n.m))),
                                              (a.style.opacity = n.o),
                                              n.sw && n._mdf.sw && s.setAttribute("stroke-width", n.sw),
                                              n.sc && n._mdf.sc && s.setAttribute("stroke", n.sc),
                                              n.fc && n._mdf.fc && (s.setAttribute("fill", n.fc), (s.style.color = n.fc)));
                                    if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
                                        var c = this.innerElem.getBBox();
                                        if (
                                            (this.currentBBox.w !== c.width && ((this.currentBBox.w = c.width), this.svgElement.setAttribute("width", c.width)),
                                            this.currentBBox.h !== c.height && ((this.currentBBox.h = c.height), this.svgElement.setAttribute("height", c.height)),
                                            this.currentBBox.w !== c.width + 2 || this.currentBBox.h !== c.height + 2 || this.currentBBox.x !== c.x - 1 || this.currentBBox.y !== c.y - 1)
                                        ) {
                                            (this.currentBBox.w = c.width + 2),
                                                (this.currentBBox.h = c.height + 2),
                                                (this.currentBBox.x = c.x - 1),
                                                (this.currentBBox.y = c.y - 1),
                                                this.svgElement.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h),
                                                (t = this.svgElement.style);
                                            var p = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
                                            (t.transform = p), (t.webkitTransform = p);
                                        }
                                    }
                                }
                            }),
                            extendPrototype([BaseElement, FrameElement, HierarchyElement], HCameraElement),
                            (HCameraElement.prototype.setup = function () {
                                var t,
                                    e,
                                    r,
                                    i,
                                    n = this.comp.threeDElements.length;
                                for (t = 0; t < n; t += 1)
                                    if ("3d" === (e = this.comp.threeDElements[t]).type) {
                                        (r = e.perspectiveElem.style), (i = e.container.style);
                                        var a = this.pe.v + "px",
                                            s = "0px 0px 0px",
                                            o = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
                                        (r.perspective = a), (r.webkitPerspective = a), (i.transformOrigin = s), (i.mozTransformOrigin = s), (i.webkitTransformOrigin = s), (r.transform = o), (r.webkitTransform = o);
                                    }
                            }),
                            (HCameraElement.prototype.createElements = function () {}),
                            (HCameraElement.prototype.hide = function () {}),
                            (HCameraElement.prototype.renderFrame = function () {
                                var t,
                                    e,
                                    r = this._isFirstFrame;
                                if (this.hierarchy) for (e = this.hierarchy.length, t = 0; t < e; t += 1) r = this.hierarchy[t].finalTransform.mProp._mdf || r;
                                if (r || this.pe._mdf || (this.p && this.p._mdf) || (this.px && (this.px._mdf || this.py._mdf || this.pz._mdf)) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || (this.a && this.a._mdf)) {
                                    if ((this.mat.reset(), this.hierarchy))
                                        for (t = e = this.hierarchy.length - 1; t >= 0; t -= 1) {
                                            var i = this.hierarchy[t].finalTransform.mProp;
                                            this.mat.translate(-i.p.v[0], -i.p.v[1], i.p.v[2]),
                                                this.mat.rotateX(-i.or.v[0]).rotateY(-i.or.v[1]).rotateZ(i.or.v[2]),
                                                this.mat.rotateX(-i.rx.v).rotateY(-i.ry.v).rotateZ(i.rz.v),
                                                this.mat.scale(1 / i.s.v[0], 1 / i.s.v[1], 1 / i.s.v[2]),
                                                this.mat.translate(i.a.v[0], i.a.v[1], i.a.v[2]);
                                        }
                                    if ((this.p ? this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]) : this.mat.translate(-this.px.v, -this.py.v, this.pz.v), this.a)) {
                                        var n;
                                        n = this.p ? [this.p.v[0] - this.a.v[0], this.p.v[1] - this.a.v[1], this.p.v[2] - this.a.v[2]] : [this.px.v - this.a.v[0], this.py.v - this.a.v[1], this.pz.v - this.a.v[2]];
                                        var a = Math.sqrt(Math.pow(n[0], 2) + Math.pow(n[1], 2) + Math.pow(n[2], 2)),
                                            s = [n[0] / a, n[1] / a, n[2] / a],
                                            o = Math.sqrt(s[2] * s[2] + s[0] * s[0]),
                                            l = Math.atan2(s[1], o),
                                            h = Math.atan2(s[0], -s[2]);
                                        this.mat.rotateY(h).rotateX(-l);
                                    }
                                    this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v),
                                        this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]),
                                        this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0),
                                        this.mat.translate(0, 0, this.pe.v);
                                    var c = !this._prevMat.equals(this.mat);
                                    if ((c || this.pe._mdf) && this.comp.threeDElements) {
                                        var p, u, f;
                                        for (e = this.comp.threeDElements.length, t = 0; t < e; t += 1)
                                            if ("3d" === (p = this.comp.threeDElements[t]).type) {
                                                if (c) {
                                                    var d = this.mat.toCSS();
                                                    ((f = p.container.style).transform = d), (f.webkitTransform = d);
                                                }
                                                this.pe._mdf && (((u = p.perspectiveElem.style).perspective = this.pe.v + "px"), (u.webkitPerspective = this.pe.v + "px"));
                                            }
                                        this.mat.clone(this._prevMat);
                                    }
                                }
                                this._isFirstFrame = !1;
                            }),
                            (HCameraElement.prototype.prepareFrame = function (t) {
                                this.prepareProperties(t, !0);
                            }),
                            (HCameraElement.prototype.destroy = function () {}),
                            (HCameraElement.prototype.getBaseElement = function () {
                                return null;
                            }),
                            extendPrototype([BaseElement, TransformElement, HBaseElement, HSolidElement, HierarchyElement, FrameElement, RenderableElement], HImageElement),
                            (HImageElement.prototype.createContent = function () {
                                var t = this.globalData.getAssetsPath(this.assetData),
                                    e = new Image();
                                this.data.hasMask
                                    ? ((this.imageElem = createNS("image")),
                                      this.imageElem.setAttribute("width", this.assetData.w + "px"),
                                      this.imageElem.setAttribute("height", this.assetData.h + "px"),
                                      this.imageElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", t),
                                      this.layerElement.appendChild(this.imageElem),
                                      this.baseElement.setAttribute("width", this.assetData.w),
                                      this.baseElement.setAttribute("height", this.assetData.h))
                                    : this.layerElement.appendChild(e),
                                    (e.crossOrigin = "anonymous"),
                                    (e.src = t),
                                    this.data.ln && this.baseElement.setAttribute("id", this.data.ln);
                            }),
                            extendPrototype([BaseRenderer], HybridRendererBase),
                            (HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem),
                            (HybridRendererBase.prototype.checkPendingElements = function () {
                                for (; this.pendingElements.length; ) this.pendingElements.pop().checkParenting();
                            }),
                            (HybridRendererBase.prototype.appendElementInPos = function (t, e) {
                                var r = t.getBaseElement();
                                if (r) {
                                    var i = this.layers[e];
                                    if (i.ddd && this.supports3d) this.addTo3dContainer(r, e);
                                    else if (this.threeDElements) this.addTo3dContainer(r, e);
                                    else {
                                        for (var n, a, s = 0; s < e; )
                                            this.elements[s] && !0 !== this.elements[s] && this.elements[s].getBaseElement && ((a = this.elements[s]), (n = (this.layers[s].ddd ? this.getThreeDContainerByPos(s) : a.getBaseElement()) || n)),
                                                (s += 1);
                                        n ? (i.ddd && this.supports3d) || this.layerElement.insertBefore(r, n) : (i.ddd && this.supports3d) || this.layerElement.appendChild(r);
                                    }
                                }
                            }),
                            (HybridRendererBase.prototype.createShape = function (t) {
                                return this.supports3d ? new HShapeElement(t, this.globalData, this) : new SVGShapeElement(t, this.globalData, this);
                            }),
                            (HybridRendererBase.prototype.createText = function (t) {
                                return this.supports3d ? new HTextElement(t, this.globalData, this) : new SVGTextLottieElement(t, this.globalData, this);
                            }),
                            (HybridRendererBase.prototype.createCamera = function (t) {
                                return (this.camera = new HCameraElement(t, this.globalData, this)), this.camera;
                            }),
                            (HybridRendererBase.prototype.createImage = function (t) {
                                return this.supports3d ? new HImageElement(t, this.globalData, this) : new IImageElement(t, this.globalData, this);
                            }),
                            (HybridRendererBase.prototype.createSolid = function (t) {
                                return this.supports3d ? new HSolidElement(t, this.globalData, this) : new ISolidElement(t, this.globalData, this);
                            }),
                            (HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull),
                            (HybridRendererBase.prototype.getThreeDContainerByPos = function (t) {
                                for (var e = 0, r = this.threeDElements.length; e < r; ) {
                                    if (this.threeDElements[e].startPos <= t && this.threeDElements[e].endPos >= t) return this.threeDElements[e].perspectiveElem;
                                    e += 1;
                                }
                                return null;
                            }),
                            (HybridRendererBase.prototype.createThreeDContainer = function (t, e) {
                                var r,
                                    i,
                                    n = createTag("div");
                                styleDiv(n);
                                var a = createTag("div");
                                if ((styleDiv(a), "3d" === e)) {
                                    ((r = n.style).width = this.globalData.compSize.w + "px"), (r.height = this.globalData.compSize.h + "px");
                                    var s = "50% 50%";
                                    (r.webkitTransformOrigin = s), (r.mozTransformOrigin = s), (r.transformOrigin = s);
                                    var o = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
                                    ((i = a.style).transform = o), (i.webkitTransform = o);
                                }
                                n.appendChild(a);
                                var l = { container: a, perspectiveElem: n, startPos: t, endPos: t, type: e };
                                return this.threeDElements.push(l), l;
                            }),
                            (HybridRendererBase.prototype.build3dContainers = function () {
                                var t,
                                    e,
                                    r = this.layers.length,
                                    i = "";
                                for (t = 0; t < r; t += 1)
                                    this.layers[t].ddd && 3 !== this.layers[t].ty
                                        ? ("3d" !== i && ((i = "3d"), (e = this.createThreeDContainer(t, "3d"))), (e.endPos = Math.max(e.endPos, t)))
                                        : ("2d" !== i && ((i = "2d"), (e = this.createThreeDContainer(t, "2d"))), (e.endPos = Math.max(e.endPos, t)));
                                for (t = (r = this.threeDElements.length) - 1; t >= 0; t -= 1) this.resizerElem.appendChild(this.threeDElements[t].perspectiveElem);
                            }),
                            (HybridRendererBase.prototype.addTo3dContainer = function (t, e) {
                                for (var r = 0, i = this.threeDElements.length; r < i; ) {
                                    if (e <= this.threeDElements[r].endPos) {
                                        for (var n, a = this.threeDElements[r].startPos; a < e; ) this.elements[a] && this.elements[a].getBaseElement && (n = this.elements[a].getBaseElement()), (a += 1);
                                        n ? this.threeDElements[r].container.insertBefore(t, n) : this.threeDElements[r].container.appendChild(t);
                                        break;
                                    }
                                    r += 1;
                                }
                            }),
                            (HybridRendererBase.prototype.configAnimation = function (t) {
                                var e = createTag("div"),
                                    r = this.animationItem.wrapper,
                                    i = e.style;
                                (i.width = t.w + "px"),
                                    (i.height = t.h + "px"),
                                    (this.resizerElem = e),
                                    styleDiv(e),
                                    (i.transformStyle = "flat"),
                                    (i.mozTransformStyle = "flat"),
                                    (i.webkitTransformStyle = "flat"),
                                    this.renderConfig.className && e.setAttribute("class", this.renderConfig.className),
                                    r.appendChild(e),
                                    (i.overflow = "hidden");
                                var n = createNS("svg");
                                n.setAttribute("width", "1"), n.setAttribute("height", "1"), styleDiv(n), this.resizerElem.appendChild(n);
                                var a = createNS("defs");
                                n.appendChild(a),
                                    (this.data = t),
                                    this.setupGlobalData(t, n),
                                    (this.globalData.defs = a),
                                    (this.layers = t.layers),
                                    (this.layerElement = this.resizerElem),
                                    this.build3dContainers(),
                                    this.updateContainerSize();
                            }),
                            (HybridRendererBase.prototype.destroy = function () {
                                var t;
                                this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), (this.animationItem.container = null), (this.globalData.defs = null);
                                var e = this.layers ? this.layers.length : 0;
                                for (t = 0; t < e; t += 1) this.elements[t].destroy();
                                (this.elements.length = 0), (this.destroyed = !0), (this.animationItem = null);
                            }),
                            (HybridRendererBase.prototype.updateContainerSize = function () {
                                var t,
                                    e,
                                    r,
                                    i,
                                    n = this.animationItem.wrapper.offsetWidth,
                                    a = this.animationItem.wrapper.offsetHeight,
                                    s = n / a;
                                this.globalData.compSize.w / this.globalData.compSize.h > s
                                    ? ((t = n / this.globalData.compSize.w), (e = n / this.globalData.compSize.w), (r = 0), (i = (a - this.globalData.compSize.h * (n / this.globalData.compSize.w)) / 2))
                                    : ((t = a / this.globalData.compSize.h), (e = a / this.globalData.compSize.h), (r = (n - this.globalData.compSize.w * (a / this.globalData.compSize.h)) / 2), (i = 0));
                                var o = this.resizerElem.style;
                                (o.webkitTransform = "matrix3d(" + t + ",0,0,0,0," + e + ",0,0,0,0,1,0," + r + "," + i + ",0,1)"), (o.transform = o.webkitTransform);
                            }),
                            (HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame),
                            (HybridRendererBase.prototype.hide = function () {
                                this.resizerElem.style.display = "none";
                            }),
                            (HybridRendererBase.prototype.show = function () {
                                this.resizerElem.style.display = "block";
                            }),
                            (HybridRendererBase.prototype.initItems = function () {
                                if ((this.buildAllItems(), this.camera)) this.camera.setup();
                                else {
                                    var t,
                                        e = this.globalData.compSize.w,
                                        r = this.globalData.compSize.h,
                                        i = this.threeDElements.length;
                                    for (t = 0; t < i; t += 1) {
                                        var n = this.threeDElements[t].perspectiveElem.style;
                                        (n.webkitPerspective = Math.sqrt(Math.pow(e, 2) + Math.pow(r, 2)) + "px"), (n.perspective = n.webkitPerspective);
                                    }
                                }
                            }),
                            (HybridRendererBase.prototype.searchExtraCompositions = function (t) {
                                var e,
                                    r = t.length,
                                    i = createTag("div");
                                for (e = 0; e < r; e += 1)
                                    if (t[e].xt) {
                                        var n = this.createComp(t[e], i, this.globalData.comp, null);
                                        n.initExpressions(), this.globalData.projectInterface.registerComposition(n);
                                    }
                            }),
                            extendPrototype([HybridRendererBase, ICompElement, HBaseElement], HCompElement),
                            (HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements),
                            (HCompElement.prototype.createContainerElements = function () {
                                this._createBaseContainerElements(),
                                    this.data.hasMask
                                        ? (this.svgElement.setAttribute("width", this.data.w), this.svgElement.setAttribute("height", this.data.h), (this.transformedElement = this.baseElement))
                                        : (this.transformedElement = this.layerElement);
                            }),
                            (HCompElement.prototype.addTo3dContainer = function (t, e) {
                                for (var r, i = 0; i < e; ) this.elements[i] && this.elements[i].getBaseElement && (r = this.elements[i].getBaseElement()), (i += 1);
                                r ? this.layerElement.insertBefore(t, r) : this.layerElement.appendChild(t);
                            }),
                            (HCompElement.prototype.createComp = function (t) {
                                return this.supports3d ? new HCompElement(t, this.globalData, this) : new SVGCompElement(t, this.globalData, this);
                            }),
                            extendPrototype([HybridRendererBase], HybridRenderer),
                            (HybridRenderer.prototype.createComp = function (t) {
                                return this.supports3d ? new HCompElement(t, this.globalData, this) : new SVGCompElement(t, this.globalData, this);
                            });
                        var CompExpressionInterface = function (t) {
                                function e(e) {
                                    for (var r = 0, i = t.layers.length; r < i; ) {
                                        if (t.layers[r].nm === e || t.layers[r].ind === e) return t.elements[r].layerInterface;
                                        r += 1;
                                    }
                                    return null;
                                }
                                return (
                                    Object.defineProperty(e, "_name", { value: t.data.nm }),
                                    (e.layer = e),
                                    (e.pixelAspect = 1),
                                    (e.height = t.data.h || t.globalData.compSize.h),
                                    (e.width = t.data.w || t.globalData.compSize.w),
                                    (e.pixelAspect = 1),
                                    (e.frameDuration = 1 / t.globalData.frameRate),
                                    (e.displayStartTime = 0),
                                    (e.numLayers = t.layers.length),
                                    e
                                );
                            },
                            Expressions = (function () {
                                var t = {
                                    initExpressions: function (t) {
                                        var e = 0,
                                            r = [];
                                        (t.renderer.compInterface = CompExpressionInterface(t.renderer)),
                                            t.renderer.globalData.projectInterface.registerComposition(t.renderer),
                                            (t.renderer.globalData.pushExpression = function () {
                                                e += 1;
                                            }),
                                            (t.renderer.globalData.popExpression = function () {
                                                0 == (e -= 1) &&
                                                    (function () {
                                                        var t,
                                                            e = r.length;
                                                        for (t = 0; t < e; t += 1) r[t].release();
                                                        r.length = 0;
                                                    })();
                                            }),
                                            (t.renderer.globalData.registerExpressionProperty = function (t) {
                                                -1 === r.indexOf(t) && r.push(t);
                                            });
                                    },
                                };
                                return t;
                            })(),
                            MaskManagerInterface = (function () {
                                function t(t, e) {
                                    (this._mask = t), (this._data = e);
                                }
                                return (
                                    Object.defineProperty(t.prototype, "maskPath", {
                                        get: function () {
                                            return this._mask.prop.k && this._mask.prop.getValue(), this._mask.prop;
                                        },
                                    }),
                                    Object.defineProperty(t.prototype, "maskOpacity", {
                                        get: function () {
                                            return this._mask.op.k && this._mask.op.getValue(), 100 * this._mask.op.v;
                                        },
                                    }),
                                    function (e) {
                                        var r,
                                            i = createSizedArray(e.viewData.length),
                                            n = e.viewData.length;
                                        for (r = 0; r < n; r += 1) i[r] = new t(e.viewData[r], e.masksProperties[r]);
                                        return function (t) {
                                            for (r = 0; r < n; ) {
                                                if (e.masksProperties[r].nm === t) return i[r];
                                                r += 1;
                                            }
                                            return null;
                                        };
                                    }
                                );
                            })(),
                            ExpressionPropertyInterface = (function () {
                                var t = { pv: 0, v: 0, mult: 1 },
                                    e = { pv: [0, 0, 0], v: [0, 0, 0], mult: 1 };
                                function r(t, e, r) {
                                    Object.defineProperty(t, "velocity", {
                                        get: function () {
                                            return e.getVelocityAtTime(e.comp.currentFrame);
                                        },
                                    }),
                                        (t.numKeys = e.keyframes ? e.keyframes.length : 0),
                                        (t.key = function (i) {
                                            if (!t.numKeys) return 0;
                                            var n;
                                            n = "s" in e.keyframes[i - 1] ? e.keyframes[i - 1].s : "e" in e.keyframes[i - 2] ? e.keyframes[i - 2].e : e.keyframes[i - 2].s;
                                            var a = "unidimensional" === r ? new Number(n) : Object.assign({}, n);
                                            return (a.time = e.keyframes[i - 1].t / e.elem.comp.globalData.frameRate), (a.value = "unidimensional" === r ? n[0] : n), a;
                                        }),
                                        (t.valueAtTime = e.getValueAtTime),
                                        (t.speedAtTime = e.getSpeedAtTime),
                                        (t.velocityAtTime = e.getVelocityAtTime),
                                        (t.propertyGroup = e.propertyGroup);
                                }
                                function i() {
                                    return t;
                                }
                                return function (n) {
                                    return n
                                        ? "unidimensional" === n.propType
                                            ? (function (e) {
                                                  (e && "pv" in e) || (e = t);
                                                  var i = 1 / e.mult,
                                                      n = e.pv * i,
                                                      a = new Number(n);
                                                  return (
                                                      (a.value = n),
                                                      r(a, e, "unidimensional"),
                                                      function () {
                                                          return e.k && e.getValue(), (n = e.v * i), a.value !== n && (((a = new Number(n)).value = n), r(a, e, "unidimensional")), a;
                                                      }
                                                  );
                                              })(n)
                                            : (function (t) {
                                                  (t && "pv" in t) || (t = e);
                                                  var i = 1 / t.mult,
                                                      n = (t.data && t.data.l) || t.pv.length,
                                                      a = createTypedArray("float32", n),
                                                      s = createTypedArray("float32", n);
                                                  return (
                                                      (a.value = s),
                                                      r(a, t, "multidimensional"),
                                                      function () {
                                                          t.k && t.getValue();
                                                          for (var e = 0; e < n; e += 1) (s[e] = t.v[e] * i), (a[e] = s[e]);
                                                          return a;
                                                      }
                                                  );
                                              })(n)
                                        : i;
                                };
                            })(),
                            TransformExpressionInterface = function (t) {
                                function e(t) {
                                    switch (t) {
                                        case "scale":
                                        case "Scale":
                                        case "ADBE Scale":
                                        case 6:
                                            return e.scale;
                                        case "rotation":
                                        case "Rotation":
                                        case "ADBE Rotation":
                                        case "ADBE Rotate Z":
                                        case 10:
                                            return e.rotation;
                                        case "ADBE Rotate X":
                                            return e.xRotation;
                                        case "ADBE Rotate Y":
                                            return e.yRotation;
                                        case "position":
                                        case "Position":
                                        case "ADBE Position":
                                        case 2:
                                            return e.position;
                                        case "ADBE Position_0":
                                            return e.xPosition;
                                        case "ADBE Position_1":
                                            return e.yPosition;
                                        case "ADBE Position_2":
                                            return e.zPosition;
                                        case "anchorPoint":
                                        case "AnchorPoint":
                                        case "Anchor Point":
                                        case "ADBE AnchorPoint":
                                        case 1:
                                            return e.anchorPoint;
                                        case "opacity":
                                        case "Opacity":
                                        case 11:
                                            return e.opacity;
                                        default:
                                            return null;
                                    }
                                }
                                var r, i, n, a;
                                return (
                                    Object.defineProperty(e, "rotation", { get: ExpressionPropertyInterface(t.r || t.rz) }),
                                    Object.defineProperty(e, "zRotation", { get: ExpressionPropertyInterface(t.rz || t.r) }),
                                    Object.defineProperty(e, "xRotation", { get: ExpressionPropertyInterface(t.rx) }),
                                    Object.defineProperty(e, "yRotation", { get: ExpressionPropertyInterface(t.ry) }),
                                    Object.defineProperty(e, "scale", { get: ExpressionPropertyInterface(t.s) }),
                                    t.p ? (a = ExpressionPropertyInterface(t.p)) : ((r = ExpressionPropertyInterface(t.px)), (i = ExpressionPropertyInterface(t.py)), t.pz && (n = ExpressionPropertyInterface(t.pz))),
                                    Object.defineProperty(e, "position", {
                                        get: function () {
                                            return t.p ? a() : [r(), i(), n ? n() : 0];
                                        },
                                    }),
                                    Object.defineProperty(e, "xPosition", { get: ExpressionPropertyInterface(t.px) }),
                                    Object.defineProperty(e, "yPosition", { get: ExpressionPropertyInterface(t.py) }),
                                    Object.defineProperty(e, "zPosition", { get: ExpressionPropertyInterface(t.pz) }),
                                    Object.defineProperty(e, "anchorPoint", { get: ExpressionPropertyInterface(t.a) }),
                                    Object.defineProperty(e, "opacity", { get: ExpressionPropertyInterface(t.o) }),
                                    Object.defineProperty(e, "skew", { get: ExpressionPropertyInterface(t.sk) }),
                                    Object.defineProperty(e, "skewAxis", { get: ExpressionPropertyInterface(t.sa) }),
                                    Object.defineProperty(e, "orientation", { get: ExpressionPropertyInterface(t.or) }),
                                    e
                                );
                            },
                            LayerExpressionInterface = (function () {
                                function t(t) {
                                    var e = new Matrix();
                                    return void 0 !== t ? this._elem.finalTransform.mProp.getValueAtTime(t).clone(e) : this._elem.finalTransform.mProp.applyToMatrix(e), e;
                                }
                                function e(t, e) {
                                    var r = this.getMatrix(e);
                                    return (r.props[12] = 0), (r.props[13] = 0), (r.props[14] = 0), this.applyPoint(r, t);
                                }
                                function r(t, e) {
                                    var r = this.getMatrix(e);
                                    return this.applyPoint(r, t);
                                }
                                function i(t, e) {
                                    var r = this.getMatrix(e);
                                    return (r.props[12] = 0), (r.props[13] = 0), (r.props[14] = 0), this.invertPoint(r, t);
                                }
                                function n(t, e) {
                                    var r = this.getMatrix(e);
                                    return this.invertPoint(r, t);
                                }
                                function a(t, e) {
                                    if (this._elem.hierarchy && this._elem.hierarchy.length) {
                                        var r,
                                            i = this._elem.hierarchy.length;
                                        for (r = 0; r < i; r += 1) this._elem.hierarchy[r].finalTransform.mProp.applyToMatrix(t);
                                    }
                                    return t.applyToPointArray(e[0], e[1], e[2] || 0);
                                }
                                function s(t, e) {
                                    if (this._elem.hierarchy && this._elem.hierarchy.length) {
                                        var r,
                                            i = this._elem.hierarchy.length;
                                        for (r = 0; r < i; r += 1) this._elem.hierarchy[r].finalTransform.mProp.applyToMatrix(t);
                                    }
                                    return t.inversePoint(e);
                                }
                                function o(t) {
                                    var e = new Matrix();
                                    if ((e.reset(), this._elem.finalTransform.mProp.applyToMatrix(e), this._elem.hierarchy && this._elem.hierarchy.length)) {
                                        var r,
                                            i = this._elem.hierarchy.length;
                                        for (r = 0; r < i; r += 1) this._elem.hierarchy[r].finalTransform.mProp.applyToMatrix(e);
                                        return e.inversePoint(t);
                                    }
                                    return e.inversePoint(t);
                                }
                                function l() {
                                    return [1, 1, 1, 1];
                                }
                                return function (h) {
                                    var c;
                                    function p(t) {
                                        switch (t) {
                                            case "ADBE Root Vectors Group":
                                            case "Contents":
                                            case 2:
                                                return p.shapeInterface;
                                            case 1:
                                            case 6:
                                            case "Transform":
                                            case "transform":
                                            case "ADBE Transform Group":
                                                return c;
                                            case 4:
                                            case "ADBE Effect Parade":
                                            case "effects":
                                            case "Effects":
                                                return p.effect;
                                            case "ADBE Text Properties":
                                                return p.textInterface;
                                            default:
                                                return null;
                                        }
                                    }
                                    (p.getMatrix = t),
                                        (p.invertPoint = s),
                                        (p.applyPoint = a),
                                        (p.toWorld = r),
                                        (p.toWorldVec = e),
                                        (p.fromWorld = n),
                                        (p.fromWorldVec = i),
                                        (p.toComp = r),
                                        (p.fromComp = o),
                                        (p.sampleImage = l),
                                        (p.sourceRectAtTime = h.sourceRectAtTime.bind(h)),
                                        (p._elem = h);
                                    var u = getDescriptor((c = TransformExpressionInterface(h.finalTransform.mProp)), "anchorPoint");
                                    return (
                                        Object.defineProperties(p, {
                                            hasParent: {
                                                get: function () {
                                                    return h.hierarchy.length;
                                                },
                                            },
                                            parent: {
                                                get: function () {
                                                    return h.hierarchy[0].layerInterface;
                                                },
                                            },
                                            rotation: getDescriptor(c, "rotation"),
                                            scale: getDescriptor(c, "scale"),
                                            position: getDescriptor(c, "position"),
                                            opacity: getDescriptor(c, "opacity"),
                                            anchorPoint: u,
                                            anchor_point: u,
                                            transform: {
                                                get: function () {
                                                    return c;
                                                },
                                            },
                                            active: {
                                                get: function () {
                                                    return h.isInRange;
                                                },
                                            },
                                        }),
                                        (p.startTime = h.data.st),
                                        (p.index = h.data.ind),
                                        (p.source = h.data.refId),
                                        (p.height = 0 === h.data.ty ? h.data.h : 100),
                                        (p.width = 0 === h.data.ty ? h.data.w : 100),
                                        (p.inPoint = h.data.ip / h.comp.globalData.frameRate),
                                        (p.outPoint = h.data.op / h.comp.globalData.frameRate),
                                        (p._name = h.data.nm),
                                        (p.registerMaskInterface = function (t) {
                                            p.mask = new MaskManagerInterface(t, h);
                                        }),
                                        (p.registerEffectsInterface = function (t) {
                                            p.effect = t;
                                        }),
                                        p
                                    );
                                };
                            })(),
                            propertyGroupFactory = function (t, e) {
                                return function (r) {
                                    return (r = void 0 === r ? 1 : r) <= 0 ? t : e(r - 1);
                                };
                            },
                            PropertyInterface = function (t, e) {
                                var r = { _name: t };
                                return function (t) {
                                    return (t = void 0 === t ? 1 : t) <= 0 ? r : e(t - 1);
                                };
                            },
                            EffectsExpressionInterface = (function () {
                                var t = {
                                    createEffectsInterface: function (t, r) {
                                        if (t.effectsManager) {
                                            var i,
                                                n = [],
                                                a = t.data.ef,
                                                s = t.effectsManager.effectElements.length;
                                            for (i = 0; i < s; i += 1) n.push(e(a[i], t.effectsManager.effectElements[i], r, t));
                                            var o = t.data.ef || [],
                                                l = function (t) {
                                                    for (i = 0, s = o.length; i < s; ) {
                                                        if (t === o[i].nm || t === o[i].mn || t === o[i].ix) return n[i];
                                                        i += 1;
                                                    }
                                                    return null;
                                                };
                                            return (
                                                Object.defineProperty(l, "numProperties", {
                                                    get: function () {
                                                        return o.length;
                                                    },
                                                }),
                                                l
                                            );
                                        }
                                        return null;
                                    },
                                };
                                function e(t, i, n, a) {
                                    function s(e) {
                                        for (var r = t.ef, i = 0, n = r.length; i < n; ) {
                                            if (e === r[i].nm || e === r[i].mn || e === r[i].ix) return 5 === r[i].ty ? h[i] : h[i]();
                                            i += 1;
                                        }
                                        throw new Error();
                                    }
                                    var o,
                                        l = propertyGroupFactory(s, n),
                                        h = [],
                                        c = t.ef.length;
                                    for (o = 0; o < c; o += 1) 5 === t.ef[o].ty ? h.push(e(t.ef[o], i.effectElements[o], i.effectElements[o].propertyGroup, a)) : h.push(r(i.effectElements[o], t.ef[o].ty, a, l));
                                    return (
                                        "ADBE Color Control" === t.mn &&
                                            Object.defineProperty(s, "color", {
                                                get: function () {
                                                    return h[0]();
                                                },
                                            }),
                                        Object.defineProperties(s, {
                                            numProperties: {
                                                get: function () {
                                                    return t.np;
                                                },
                                            },
                                            _name: { value: t.nm },
                                            propertyGroup: { value: l },
                                        }),
                                        (s.enabled = 0 !== t.en),
                                        (s.active = s.enabled),
                                        s
                                    );
                                }
                                function r(t, e, r, i) {
                                    var n = ExpressionPropertyInterface(t.p);
                                    return (
                                        t.p.setGroupProperty && t.p.setGroupProperty(PropertyInterface("", i)),
                                        function () {
                                            return 10 === e ? r.comp.compInterface(t.p.v) : n();
                                        }
                                    );
                                }
                                return t;
                            })(),
                            ShapePathInterface = function (t, e, r) {
                                var i = e.sh;
                                function n(t) {
                                    return "Shape" === t || "shape" === t || "Path" === t || "path" === t || "ADBE Vector Shape" === t || 2 === t ? n.path : null;
                                }
                                var a = propertyGroupFactory(n, r);
                                return (
                                    i.setGroupProperty(PropertyInterface("Path", a)),
                                    Object.defineProperties(n, {
                                        path: {
                                            get: function () {
                                                return i.k && i.getValue(), i;
                                            },
                                        },
                                        shape: {
                                            get: function () {
                                                return i.k && i.getValue(), i;
                                            },
                                        },
                                        _name: { value: t.nm },
                                        ix: { value: t.ix },
                                        propertyIndex: { value: t.ix },
                                        mn: { value: t.mn },
                                        propertyGroup: { value: r },
                                    }),
                                    n
                                );
                            },
                            ShapeExpressionInterface = (function () {
                                function t(t, s, u) {
                                    var f,
                                        d = [],
                                        m = t ? t.length : 0;
                                    for (f = 0; f < m; f += 1)
                                        "gr" === t[f].ty
                                            ? d.push(e(t[f], s[f], u))
                                            : "fl" === t[f].ty
                                            ? d.push(r(t[f], s[f], u))
                                            : "st" === t[f].ty
                                            ? d.push(n(t[f], s[f], u))
                                            : "tm" === t[f].ty
                                            ? d.push(a(t[f], s[f], u))
                                            : "tr" === t[f].ty ||
                                              ("el" === t[f].ty
                                                  ? d.push(o(t[f], s[f], u))
                                                  : "sr" === t[f].ty
                                                  ? d.push(l(t[f], s[f], u))
                                                  : "sh" === t[f].ty
                                                  ? d.push(ShapePathInterface(t[f], s[f], u))
                                                  : "rc" === t[f].ty
                                                  ? d.push(h(t[f], s[f], u))
                                                  : "rd" === t[f].ty
                                                  ? d.push(c(t[f], s[f], u))
                                                  : "rp" === t[f].ty
                                                  ? d.push(p(t[f], s[f], u))
                                                  : "gf" === t[f].ty
                                                  ? d.push(i(t[f], s[f], u))
                                                  : d.push(
                                                        (t[f],
                                                        s[f],
                                                        function () {
                                                            return null;
                                                        })
                                                    ));
                                    return d;
                                }
                                function e(e, r, i) {
                                    var n = function (t) {
                                        switch (t) {
                                            case "ADBE Vectors Group":
                                            case "Contents":
                                            case 2:
                                                return n.content;
                                            default:
                                                return n.transform;
                                        }
                                    };
                                    n.propertyGroup = propertyGroupFactory(n, i);
                                    var a = (function (e, r, i) {
                                            var n,
                                                a = function (t) {
                                                    for (var e = 0, r = n.length; e < r; ) {
                                                        if (n[e]._name === t || n[e].mn === t || n[e].propertyIndex === t || n[e].ix === t || n[e].ind === t) return n[e];
                                                        e += 1;
                                                    }
                                                    return "number" == typeof t ? n[t - 1] : null;
                                                };
                                            (a.propertyGroup = propertyGroupFactory(a, i)), (n = t(e.it, r.it, a.propertyGroup)), (a.numProperties = n.length);
                                            var o = s(e.it[e.it.length - 1], r.it[r.it.length - 1], a.propertyGroup);
                                            return (a.transform = o), (a.propertyIndex = e.cix), (a._name = e.nm), a;
                                        })(e, r, n.propertyGroup),
                                        o = s(e.it[e.it.length - 1], r.it[r.it.length - 1], n.propertyGroup);
                                    return (
                                        (n.content = a),
                                        (n.transform = o),
                                        Object.defineProperty(n, "_name", {
                                            get: function () {
                                                return e.nm;
                                            },
                                        }),
                                        (n.numProperties = e.np),
                                        (n.propertyIndex = e.ix),
                                        (n.nm = e.nm),
                                        (n.mn = e.mn),
                                        n
                                    );
                                }
                                function r(t, e, r) {
                                    function i(t) {
                                        return "Color" === t || "color" === t ? i.color : "Opacity" === t || "opacity" === t ? i.opacity : null;
                                    }
                                    return (
                                        Object.defineProperties(i, { color: { get: ExpressionPropertyInterface(e.c) }, opacity: { get: ExpressionPropertyInterface(e.o) }, _name: { value: t.nm }, mn: { value: t.mn } }),
                                        e.c.setGroupProperty(PropertyInterface("Color", r)),
                                        e.o.setGroupProperty(PropertyInterface("Opacity", r)),
                                        i
                                    );
                                }
                                function i(t, e, r) {
                                    function i(t) {
                                        return "Start Point" === t || "start point" === t ? i.startPoint : "End Point" === t || "end point" === t ? i.endPoint : "Opacity" === t || "opacity" === t ? i.opacity : null;
                                    }
                                    return (
                                        Object.defineProperties(i, {
                                            startPoint: { get: ExpressionPropertyInterface(e.s) },
                                            endPoint: { get: ExpressionPropertyInterface(e.e) },
                                            opacity: { get: ExpressionPropertyInterface(e.o) },
                                            type: {
                                                get: function () {
                                                    return "a";
                                                },
                                            },
                                            _name: { value: t.nm },
                                            mn: { value: t.mn },
                                        }),
                                        e.s.setGroupProperty(PropertyInterface("Start Point", r)),
                                        e.e.setGroupProperty(PropertyInterface("End Point", r)),
                                        e.o.setGroupProperty(PropertyInterface("Opacity", r)),
                                        i
                                    );
                                }
                                function n(t, e, r) {
                                    var i,
                                        n = propertyGroupFactory(h, r),
                                        a = propertyGroupFactory(l, n);
                                    function s(r) {
                                        Object.defineProperty(l, t.d[r].nm, { get: ExpressionPropertyInterface(e.d.dataProps[r].p) });
                                    }
                                    var o = t.d ? t.d.length : 0,
                                        l = {};
                                    for (i = 0; i < o; i += 1) s(i), e.d.dataProps[i].p.setGroupProperty(a);
                                    function h(t) {
                                        return "Color" === t || "color" === t ? h.color : "Opacity" === t || "opacity" === t ? h.opacity : "Stroke Width" === t || "stroke width" === t ? h.strokeWidth : null;
                                    }
                                    return (
                                        Object.defineProperties(h, {
                                            color: { get: ExpressionPropertyInterface(e.c) },
                                            opacity: { get: ExpressionPropertyInterface(e.o) },
                                            strokeWidth: { get: ExpressionPropertyInterface(e.w) },
                                            dash: {
                                                get: function () {
                                                    return l;
                                                },
                                            },
                                            _name: { value: t.nm },
                                            mn: { value: t.mn },
                                        }),
                                        e.c.setGroupProperty(PropertyInterface("Color", n)),
                                        e.o.setGroupProperty(PropertyInterface("Opacity", n)),
                                        e.w.setGroupProperty(PropertyInterface("Stroke Width", n)),
                                        h
                                    );
                                }
                                function a(t, e, r) {
                                    function i(e) {
                                        return e === t.e.ix || "End" === e || "end" === e ? i.end : e === t.s.ix ? i.start : e === t.o.ix ? i.offset : null;
                                    }
                                    var n = propertyGroupFactory(i, r);
                                    return (
                                        (i.propertyIndex = t.ix),
                                        e.s.setGroupProperty(PropertyInterface("Start", n)),
                                        e.e.setGroupProperty(PropertyInterface("End", n)),
                                        e.o.setGroupProperty(PropertyInterface("Offset", n)),
                                        (i.propertyIndex = t.ix),
                                        (i.propertyGroup = r),
                                        Object.defineProperties(i, {
                                            start: { get: ExpressionPropertyInterface(e.s) },
                                            end: { get: ExpressionPropertyInterface(e.e) },
                                            offset: { get: ExpressionPropertyInterface(e.o) },
                                            _name: { value: t.nm },
                                        }),
                                        (i.mn = t.mn),
                                        i
                                    );
                                }
                                function s(t, e, r) {
                                    function i(e) {
                                        return t.a.ix === e || "Anchor Point" === e
                                            ? i.anchorPoint
                                            : t.o.ix === e || "Opacity" === e
                                            ? i.opacity
                                            : t.p.ix === e || "Position" === e
                                            ? i.position
                                            : t.r.ix === e || "Rotation" === e || "ADBE Vector Rotation" === e
                                            ? i.rotation
                                            : t.s.ix === e || "Scale" === e
                                            ? i.scale
                                            : (t.sk && t.sk.ix === e) || "Skew" === e
                                            ? i.skew
                                            : (t.sa && t.sa.ix === e) || "Skew Axis" === e
                                            ? i.skewAxis
                                            : null;
                                    }
                                    var n = propertyGroupFactory(i, r);
                                    return (
                                        e.transform.mProps.o.setGroupProperty(PropertyInterface("Opacity", n)),
                                        e.transform.mProps.p.setGroupProperty(PropertyInterface("Position", n)),
                                        e.transform.mProps.a.setGroupProperty(PropertyInterface("Anchor Point", n)),
                                        e.transform.mProps.s.setGroupProperty(PropertyInterface("Scale", n)),
                                        e.transform.mProps.r.setGroupProperty(PropertyInterface("Rotation", n)),
                                        e.transform.mProps.sk && (e.transform.mProps.sk.setGroupProperty(PropertyInterface("Skew", n)), e.transform.mProps.sa.setGroupProperty(PropertyInterface("Skew Angle", n))),
                                        e.transform.op.setGroupProperty(PropertyInterface("Opacity", n)),
                                        Object.defineProperties(i, {
                                            opacity: { get: ExpressionPropertyInterface(e.transform.mProps.o) },
                                            position: { get: ExpressionPropertyInterface(e.transform.mProps.p) },
                                            anchorPoint: { get: ExpressionPropertyInterface(e.transform.mProps.a) },
                                            scale: { get: ExpressionPropertyInterface(e.transform.mProps.s) },
                                            rotation: { get: ExpressionPropertyInterface(e.transform.mProps.r) },
                                            skew: { get: ExpressionPropertyInterface(e.transform.mProps.sk) },
                                            skewAxis: { get: ExpressionPropertyInterface(e.transform.mProps.sa) },
                                            _name: { value: t.nm },
                                        }),
                                        (i.ty = "tr"),
                                        (i.mn = t.mn),
                                        (i.propertyGroup = r),
                                        i
                                    );
                                }
                                function o(t, e, r) {
                                    function i(e) {
                                        return t.p.ix === e ? i.position : t.s.ix === e ? i.size : null;
                                    }
                                    var n = propertyGroupFactory(i, r);
                                    i.propertyIndex = t.ix;
                                    var a = "tm" === e.sh.ty ? e.sh.prop : e.sh;
                                    return (
                                        a.s.setGroupProperty(PropertyInterface("Size", n)),
                                        a.p.setGroupProperty(PropertyInterface("Position", n)),
                                        Object.defineProperties(i, { size: { get: ExpressionPropertyInterface(a.s) }, position: { get: ExpressionPropertyInterface(a.p) }, _name: { value: t.nm } }),
                                        (i.mn = t.mn),
                                        i
                                    );
                                }
                                function l(t, e, r) {
                                    function i(e) {
                                        return t.p.ix === e
                                            ? i.position
                                            : t.r.ix === e
                                            ? i.rotation
                                            : t.pt.ix === e
                                            ? i.points
                                            : t.or.ix === e || "ADBE Vector Star Outer Radius" === e
                                            ? i.outerRadius
                                            : t.os.ix === e
                                            ? i.outerRoundness
                                            : !t.ir || (t.ir.ix !== e && "ADBE Vector Star Inner Radius" !== e)
                                            ? t.is && t.is.ix === e
                                                ? i.innerRoundness
                                                : null
                                            : i.innerRadius;
                                    }
                                    var n = propertyGroupFactory(i, r),
                                        a = "tm" === e.sh.ty ? e.sh.prop : e.sh;
                                    return (
                                        (i.propertyIndex = t.ix),
                                        a.or.setGroupProperty(PropertyInterface("Outer Radius", n)),
                                        a.os.setGroupProperty(PropertyInterface("Outer Roundness", n)),
                                        a.pt.setGroupProperty(PropertyInterface("Points", n)),
                                        a.p.setGroupProperty(PropertyInterface("Position", n)),
                                        a.r.setGroupProperty(PropertyInterface("Rotation", n)),
                                        t.ir && (a.ir.setGroupProperty(PropertyInterface("Inner Radius", n)), a.is.setGroupProperty(PropertyInterface("Inner Roundness", n))),
                                        Object.defineProperties(i, {
                                            position: { get: ExpressionPropertyInterface(a.p) },
                                            rotation: { get: ExpressionPropertyInterface(a.r) },
                                            points: { get: ExpressionPropertyInterface(a.pt) },
                                            outerRadius: { get: ExpressionPropertyInterface(a.or) },
                                            outerRoundness: { get: ExpressionPropertyInterface(a.os) },
                                            innerRadius: { get: ExpressionPropertyInterface(a.ir) },
                                            innerRoundness: { get: ExpressionPropertyInterface(a.is) },
                                            _name: { value: t.nm },
                                        }),
                                        (i.mn = t.mn),
                                        i
                                    );
                                }
                                function h(t, e, r) {
                                    function i(e) {
                                        return t.p.ix === e ? i.position : t.r.ix === e ? i.roundness : t.s.ix === e || "Size" === e || "ADBE Vector Rect Size" === e ? i.size : null;
                                    }
                                    var n = propertyGroupFactory(i, r),
                                        a = "tm" === e.sh.ty ? e.sh.prop : e.sh;
                                    return (
                                        (i.propertyIndex = t.ix),
                                        a.p.setGroupProperty(PropertyInterface("Position", n)),
                                        a.s.setGroupProperty(PropertyInterface("Size", n)),
                                        a.r.setGroupProperty(PropertyInterface("Rotation", n)),
                                        Object.defineProperties(i, {
                                            position: { get: ExpressionPropertyInterface(a.p) },
                                            roundness: { get: ExpressionPropertyInterface(a.r) },
                                            size: { get: ExpressionPropertyInterface(a.s) },
                                            _name: { value: t.nm },
                                        }),
                                        (i.mn = t.mn),
                                        i
                                    );
                                }
                                function c(t, e, r) {
                                    function i(e) {
                                        return t.r.ix === e || "Round Corners 1" === e ? i.radius : null;
                                    }
                                    var n = propertyGroupFactory(i, r),
                                        a = e;
                                    return (
                                        (i.propertyIndex = t.ix),
                                        a.rd.setGroupProperty(PropertyInterface("Radius", n)),
                                        Object.defineProperties(i, { radius: { get: ExpressionPropertyInterface(a.rd) }, _name: { value: t.nm } }),
                                        (i.mn = t.mn),
                                        i
                                    );
                                }
                                function p(t, e, r) {
                                    function i(e) {
                                        return t.c.ix === e || "Copies" === e ? i.copies : t.o.ix === e || "Offset" === e ? i.offset : null;
                                    }
                                    var n = propertyGroupFactory(i, r),
                                        a = e;
                                    return (
                                        (i.propertyIndex = t.ix),
                                        a.c.setGroupProperty(PropertyInterface("Copies", n)),
                                        a.o.setGroupProperty(PropertyInterface("Offset", n)),
                                        Object.defineProperties(i, { copies: { get: ExpressionPropertyInterface(a.c) }, offset: { get: ExpressionPropertyInterface(a.o) }, _name: { value: t.nm } }),
                                        (i.mn = t.mn),
                                        i
                                    );
                                }
                                return function (e, r, i) {
                                    var n;
                                    function a(t) {
                                        if ("number" == typeof t) return 0 === (t = void 0 === t ? 1 : t) ? i : n[t - 1];
                                        for (var e = 0, r = n.length; e < r; ) {
                                            if (n[e]._name === t) return n[e];
                                            e += 1;
                                        }
                                        return null;
                                    }
                                    return (
                                        (a.propertyGroup = propertyGroupFactory(a, function () {
                                            return i;
                                        })),
                                        (n = t(e, r, a.propertyGroup)),
                                        (a.numProperties = n.length),
                                        (a._name = "Contents"),
                                        a
                                    );
                                };
                            })(),
                            TextExpressionInterface = function (t) {
                                var e, r;
                                function i(t) {
                                    return "ADBE Text Document" === t ? i.sourceText : null;
                                }
                                return (
                                    Object.defineProperty(i, "sourceText", {
                                        get: function () {
                                            t.textProperty.getValue();
                                            var i = t.textProperty.currentData.t;
                                            return i !== e && ((t.textProperty.currentData.t = e), ((r = new String(i)).value = i || new String(i))), r;
                                        },
                                    }),
                                    i
                                );
                            };
                        function _typeof$2(t) {
                            return (
                                (_typeof$2 =
                                    "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                                        ? function (t) {
                                              return typeof t;
                                          }
                                        : function (t) {
                                              return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                                          }),
                                _typeof$2(t)
                            );
                        }
                        var FootageInterface =
                                ((dataInterfaceFactory = function (t) {
                                    function e(t) {
                                        return "Outline" === t ? e.outlineInterface() : null;
                                    }
                                    return (
                                        (e._name = "Outline"),
                                        (e.outlineInterface = (function (t) {
                                            var e = "",
                                                r = t.getFootageData();
                                            function i(t) {
                                                if (r[t]) return (e = t), "object" === _typeof$2((r = r[t])) ? i : r;
                                                var n = t.indexOf(e);
                                                if (-1 !== n) {
                                                    var a = parseInt(t.substr(n + e.length), 10);
                                                    return "object" === _typeof$2((r = r[a])) ? i : r;
                                                }
                                                return "";
                                            }
                                            return function () {
                                                return (e = ""), (r = t.getFootageData()), i;
                                            };
                                        })(t)),
                                        e
                                    );
                                }),
                                function (t) {
                                    function e(t) {
                                        return "Data" === t ? e.dataInterface : null;
                                    }
                                    return (e._name = "Data"), (e.dataInterface = dataInterfaceFactory(t)), e;
                                }),
                            dataInterfaceFactory,
                            interfaces = { layer: LayerExpressionInterface, effects: EffectsExpressionInterface, comp: CompExpressionInterface, shape: ShapeExpressionInterface, text: TextExpressionInterface, footage: FootageInterface };
                        function getInterface(t) {
                            return interfaces[t] || null;
                        }
                        function _typeof$1(t) {
                            return (
                                (_typeof$1 =
                                    "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                                        ? function (t) {
                                              return typeof t;
                                          }
                                        : function (t) {
                                              return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                                          }),
                                _typeof$1(t)
                            );
                        }
                        function seedRandom(t, e) {
                            var r = this,
                                i = 256,
                                n = e.pow(i, 6),
                                a = e.pow(2, 52),
                                s = 2 * a,
                                o = 255;
                            function l(t) {
                                var e,
                                    r = t.length,
                                    n = this,
                                    a = 0,
                                    s = (n.i = n.j = 0),
                                    l = (n.S = []);
                                for (r || (t = [r++]); a < i; ) l[a] = a++;
                                for (a = 0; a < i; a++) (l[a] = l[(s = o & (s + t[a % r] + (e = l[a])))]), (l[s] = e);
                                n.g = function (t) {
                                    for (var e, r = 0, a = n.i, s = n.j, l = n.S; t--; ) (e = l[(a = o & (a + 1))]), (r = r * i + l[o & ((l[a] = l[(s = o & (s + e))]) + (l[s] = e))]);
                                    return (n.i = a), (n.j = s), r;
                                };
                            }
                            function h(t, e) {
                                return (e.i = t.i), (e.j = t.j), (e.S = t.S.slice()), e;
                            }
                            function c(t, e) {
                                var r,
                                    i = [],
                                    n = _typeof$1(t);
                                if (e && "object" == n)
                                    for (r in t)
                                        try {
                                            i.push(c(t[r], e - 1));
                                        } catch (t) {}
                                return i.length ? i : "string" == n ? t : t + "\0";
                            }
                            function p(t, e) {
                                for (var r, i = t + "", n = 0; n < i.length; ) e[o & n] = o & ((r ^= 19 * e[o & n]) + i.charCodeAt(n++));
                                return u(e);
                            }
                            function u(t) {
                                return String.fromCharCode.apply(0, t);
                            }
                            (e.seedrandom = function (o, f, d) {
                                var m = [],
                                    y = p(
                                        c(
                                            (f = !0 === f ? { entropy: !0 } : f || {}).entropy
                                                ? [o, u(t)]
                                                : null === o
                                                ? (function () {
                                                      try {
                                                          var e = new Uint8Array(i);
                                                          return (r.crypto || r.msCrypto).getRandomValues(e), u(e);
                                                      } catch (e) {
                                                          var n = r.navigator,
                                                              a = n && n.plugins;
                                                          return [+new Date(), r, a, r.screen, u(t)];
                                                      }
                                                  })()
                                                : o,
                                            3
                                        ),
                                        m
                                    ),
                                    v = new l(m),
                                    g = function () {
                                        for (var t = v.g(6), e = n, r = 0; t < a; ) (t = (t + r) * i), (e *= i), (r = v.g(1));
                                        for (; t >= s; ) (t /= 2), (e /= 2), (r >>>= 1);
                                        return (t + r) / e;
                                    };
                                return (
                                    (g.int32 = function () {
                                        return 0 | v.g(4);
                                    }),
                                    (g.quick = function () {
                                        return v.g(4) / 4294967296;
                                    }),
                                    (g.double = g),
                                    p(u(v.S), t),
                                    (
                                        f.pass ||
                                        d ||
                                        function (t, r, i, n) {
                                            return (
                                                n &&
                                                    (n.S && h(n, v),
                                                    (t.state = function () {
                                                        return h(v, {});
                                                    })),
                                                i ? ((e.random = t), r) : t
                                            );
                                        }
                                    )(g, y, "global" in f ? f.global : this == e, f.state)
                                );
                            }),
                                p(e.random(), t);
                        }
                        function initialize$2(t) {
                            seedRandom([], t);
                        }
                        var propTypes = { SHAPE: "shape" };
                        function _typeof(t) {
                            return (
                                (_typeof =
                                    "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                                        ? function (t) {
                                              return typeof t;
                                          }
                                        : function (t) {
                                              return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                                          }),
                                _typeof(t)
                            );
                        }
                        var ExpressionManager = (function () {
                                var ob = {},
                                    Math = BMMath,
                                    window = null,
                                    document = null,
                                    XMLHttpRequest = null,
                                    fetch = null,
                                    frames = null;
                                function $bm_isInstanceOfArray(t) {
                                    return t.constructor === Array || t.constructor === Float32Array;
                                }
                                function isNumerable(t, e) {
                                    return "number" === t || "boolean" === t || "string" === t || e instanceof Number;
                                }
                                function $bm_neg(t) {
                                    var e = _typeof(t);
                                    if ("number" === e || "boolean" === e || t instanceof Number) return -t;
                                    if ($bm_isInstanceOfArray(t)) {
                                        var r,
                                            i = t.length,
                                            n = [];
                                        for (r = 0; r < i; r += 1) n[r] = -t[r];
                                        return n;
                                    }
                                    return t.propType ? t.v : -t;
                                }
                                initialize$2(BMMath);
                                var easeInBez = BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, "easeIn").get,
                                    easeOutBez = BezierFactory.getBezierEasing(0.167, 0.167, 0.667, 1, "easeOut").get,
                                    easeInOutBez = BezierFactory.getBezierEasing(0.33, 0, 0.667, 1, "easeInOut").get;
                                function sum(t, e) {
                                    var r = _typeof(t),
                                        i = _typeof(e);
                                    if ("string" === r || "string" === i) return t + e;
                                    if (isNumerable(r, t) && isNumerable(i, e)) return t + e;
                                    if ($bm_isInstanceOfArray(t) && isNumerable(i, e)) return ((t = t.slice(0))[0] += e), t;
                                    if (isNumerable(r, t) && $bm_isInstanceOfArray(e)) return ((e = e.slice(0))[0] = t + e[0]), e;
                                    if ($bm_isInstanceOfArray(t) && $bm_isInstanceOfArray(e)) {
                                        for (var n = 0, a = t.length, s = e.length, o = []; n < a || n < s; )
                                            ("number" == typeof t[n] || t[n] instanceof Number) && ("number" == typeof e[n] || e[n] instanceof Number) ? (o[n] = t[n] + e[n]) : (o[n] = void 0 === e[n] ? t[n] : t[n] || e[n]), (n += 1);
                                        return o;
                                    }
                                    return 0;
                                }
                                var add = sum;
                                function sub(t, e) {
                                    var r = _typeof(t),
                                        i = _typeof(e);
                                    if (isNumerable(r, t) && isNumerable(i, e)) return "string" === r && (t = parseInt(t, 10)), "string" === i && (e = parseInt(e, 10)), t - e;
                                    if ($bm_isInstanceOfArray(t) && isNumerable(i, e)) return ((t = t.slice(0))[0] -= e), t;
                                    if (isNumerable(r, t) && $bm_isInstanceOfArray(e)) return ((e = e.slice(0))[0] = t - e[0]), e;
                                    if ($bm_isInstanceOfArray(t) && $bm_isInstanceOfArray(e)) {
                                        for (var n = 0, a = t.length, s = e.length, o = []; n < a || n < s; )
                                            ("number" == typeof t[n] || t[n] instanceof Number) && ("number" == typeof e[n] || e[n] instanceof Number) ? (o[n] = t[n] - e[n]) : (o[n] = void 0 === e[n] ? t[n] : t[n] || e[n]), (n += 1);
                                        return o;
                                    }
                                    return 0;
                                }
                                function mul(t, e) {
                                    var r,
                                        i,
                                        n,
                                        a = _typeof(t),
                                        s = _typeof(e);
                                    if (isNumerable(a, t) && isNumerable(s, e)) return t * e;
                                    if ($bm_isInstanceOfArray(t) && isNumerable(s, e)) {
                                        for (n = t.length, r = createTypedArray("float32", n), i = 0; i < n; i += 1) r[i] = t[i] * e;
                                        return r;
                                    }
                                    if (isNumerable(a, t) && $bm_isInstanceOfArray(e)) {
                                        for (n = e.length, r = createTypedArray("float32", n), i = 0; i < n; i += 1) r[i] = t * e[i];
                                        return r;
                                    }
                                    return 0;
                                }
                                function div(t, e) {
                                    var r,
                                        i,
                                        n,
                                        a = _typeof(t),
                                        s = _typeof(e);
                                    if (isNumerable(a, t) && isNumerable(s, e)) return t / e;
                                    if ($bm_isInstanceOfArray(t) && isNumerable(s, e)) {
                                        for (n = t.length, r = createTypedArray("float32", n), i = 0; i < n; i += 1) r[i] = t[i] / e;
                                        return r;
                                    }
                                    if (isNumerable(a, t) && $bm_isInstanceOfArray(e)) {
                                        for (n = e.length, r = createTypedArray("float32", n), i = 0; i < n; i += 1) r[i] = t / e[i];
                                        return r;
                                    }
                                    return 0;
                                }
                                function mod(t, e) {
                                    return "string" == typeof t && (t = parseInt(t, 10)), "string" == typeof e && (e = parseInt(e, 10)), t % e;
                                }
                                var $bm_sum = sum,
                                    $bm_sub = sub,
                                    $bm_mul = mul,
                                    $bm_div = div,
                                    $bm_mod = mod;
                                function clamp(t, e, r) {
                                    if (e > r) {
                                        var i = r;
                                        (r = e), (e = i);
                                    }
                                    return Math.min(Math.max(t, e), r);
                                }
                                function radiansToDegrees(t) {
                                    return t / degToRads;
                                }
                                var radians_to_degrees = radiansToDegrees;
                                function degreesToRadians(t) {
                                    return t * degToRads;
                                }
                                var degrees_to_radians = radiansToDegrees,
                                    helperLengthArray = [0, 0, 0, 0, 0, 0];
                                function length(t, e) {
                                    if ("number" == typeof t || t instanceof Number) return (e = e || 0), Math.abs(t - e);
                                    var r;
                                    e || (e = helperLengthArray);
                                    var i = Math.min(t.length, e.length),
                                        n = 0;
                                    for (r = 0; r < i; r += 1) n += Math.pow(e[r] - t[r], 2);
                                    return Math.sqrt(n);
                                }
                                function normalize(t) {
                                    return div(t, length(t));
                                }
                                function rgbToHsl(t) {
                                    var e,
                                        r,
                                        i = t[0],
                                        n = t[1],
                                        a = t[2],
                                        s = Math.max(i, n, a),
                                        o = Math.min(i, n, a),
                                        l = (s + o) / 2;
                                    if (s === o) (e = 0), (r = 0);
                                    else {
                                        var h = s - o;
                                        switch (((r = l > 0.5 ? h / (2 - s - o) : h / (s + o)), s)) {
                                            case i:
                                                e = (n - a) / h + (n < a ? 6 : 0);
                                                break;
                                            case n:
                                                e = (a - i) / h + 2;
                                                break;
                                            case a:
                                                e = (i - n) / h + 4;
                                        }
                                        e /= 6;
                                    }
                                    return [e, r, l, t[3]];
                                }
                                function hue2rgb(t, e, r) {
                                    return r < 0 && (r += 1), r > 1 && (r -= 1), r < 1 / 6 ? t + 6 * (e - t) * r : r < 0.5 ? e : r < 2 / 3 ? t + (e - t) * (2 / 3 - r) * 6 : t;
                                }
                                function hslToRgb(t) {
                                    var e,
                                        r,
                                        i,
                                        n = t[0],
                                        a = t[1],
                                        s = t[2];
                                    if (0 === a) (e = s), (i = s), (r = s);
                                    else {
                                        var o = s < 0.5 ? s * (1 + a) : s + a - s * a,
                                            l = 2 * s - o;
                                        (e = hue2rgb(l, o, n + 1 / 3)), (r = hue2rgb(l, o, n)), (i = hue2rgb(l, o, n - 1 / 3));
                                    }
                                    return [e, r, i, t[3]];
                                }
                                function linear(t, e, r, i, n) {
                                    if (((void 0 !== i && void 0 !== n) || ((i = e), (n = r), (e = 0), (r = 1)), r < e)) {
                                        var a = r;
                                        (r = e), (e = a);
                                    }
                                    if (t <= e) return i;
                                    if (t >= r) return n;
                                    var s,
                                        o = r === e ? 0 : (t - e) / (r - e);
                                    if (!i.length) return i + (n - i) * o;
                                    var l = i.length,
                                        h = createTypedArray("float32", l);
                                    for (s = 0; s < l; s += 1) h[s] = i[s] + (n[s] - i[s]) * o;
                                    return h;
                                }
                                function random(t, e) {
                                    if ((void 0 === e && (void 0 === t ? ((t = 0), (e = 1)) : ((e = t), (t = void 0))), e.length)) {
                                        var r,
                                            i = e.length;
                                        t || (t = createTypedArray("float32", i));
                                        var n = createTypedArray("float32", i),
                                            a = BMMath.random();
                                        for (r = 0; r < i; r += 1) n[r] = t[r] + a * (e[r] - t[r]);
                                        return n;
                                    }
                                    return void 0 === t && (t = 0), t + BMMath.random() * (e - t);
                                }
                                function createPath(t, e, r, i) {
                                    var n,
                                        a = t.length,
                                        s = shapePool.newElement();
                                    s.setPathData(!!i, a);
                                    var o,
                                        l,
                                        h = [0, 0];
                                    for (n = 0; n < a; n += 1) (o = e && e[n] ? e[n] : h), (l = r && r[n] ? r[n] : h), s.setTripleAt(t[n][0], t[n][1], l[0] + t[n][0], l[1] + t[n][1], o[0] + t[n][0], o[1] + t[n][1], n, !0);
                                    return s;
                                }
                                function initiateExpression(elem, data, property) {
                                    function noOp(t) {
                                        return t;
                                    }
                                    if (!elem.globalData.renderConfig.runExpressions) return noOp;
                                    var val = data.x,
                                        needsVelocity = /velocity(?![\w\d])/.test(val),
                                        _needsRandom = -1 !== val.indexOf("random"),
                                        elemType = elem.data.ty,
                                        transform,
                                        $bm_transform,
                                        content,
                                        effect,
                                        thisProperty = property;
                                    (thisProperty.valueAtTime = thisProperty.getValueAtTime),
                                        Object.defineProperty(thisProperty, "value", {
                                            get: function () {
                                                return thisProperty.v;
                                            },
                                        }),
                                        (elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate),
                                        (elem.comp.displayStartTime = 0);
                                    var inPoint = elem.data.ip / elem.comp.globalData.frameRate,
                                        outPoint = elem.data.op / elem.comp.globalData.frameRate,
                                        width = elem.data.sw ? elem.data.sw : 0,
                                        height = elem.data.sh ? elem.data.sh : 0,
                                        name = elem.data.nm,
                                        loopIn,
                                        loop_in,
                                        loopOut,
                                        loop_out,
                                        smooth,
                                        toWorld,
                                        fromWorld,
                                        fromComp,
                                        toComp,
                                        fromCompToSurface,
                                        position,
                                        rotation,
                                        anchorPoint,
                                        scale,
                                        thisLayer,
                                        thisComp,
                                        mask,
                                        valueAtTime,
                                        velocityAtTime,
                                        scoped_bm_rt,
                                        expression_function = eval("[function _expression_function(){" + val + ";scoped_bm_rt=$bm_rt}]")[0],
                                        numKeys = property.kf ? data.k.length : 0,
                                        active = !this.data || !0 !== this.data.hd,
                                        wiggle = function (t, e) {
                                            var r,
                                                i,
                                                n = this.pv.length ? this.pv.length : 1,
                                                a = createTypedArray("float32", n),
                                                s = Math.floor(5 * time);
                                            for (r = 0, i = 0; r < s; ) {
                                                for (i = 0; i < n; i += 1) a[i] += -e + 2 * e * BMMath.random();
                                                r += 1;
                                            }
                                            var o = 5 * time,
                                                l = o - Math.floor(o),
                                                h = createTypedArray("float32", n);
                                            if (n > 1) {
                                                for (i = 0; i < n; i += 1) h[i] = this.pv[i] + a[i] + (-e + 2 * e * BMMath.random()) * l;
                                                return h;
                                            }
                                            return this.pv + a[0] + (-e + 2 * e * BMMath.random()) * l;
                                        }.bind(this);
                                    function loopInDuration(t, e) {
                                        return loopIn(t, e, !0);
                                    }
                                    function loopOutDuration(t, e) {
                                        return loopOut(t, e, !0);
                                    }
                                    thisProperty.loopIn && ((loopIn = thisProperty.loopIn.bind(thisProperty)), (loop_in = loopIn)),
                                        thisProperty.loopOut && ((loopOut = thisProperty.loopOut.bind(thisProperty)), (loop_out = loopOut)),
                                        thisProperty.smooth && (smooth = thisProperty.smooth.bind(thisProperty)),
                                        this.getValueAtTime && (valueAtTime = this.getValueAtTime.bind(this)),
                                        this.getVelocityAtTime && (velocityAtTime = this.getVelocityAtTime.bind(this));
                                    var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface),
                                        time,
                                        velocity,
                                        value,
                                        text,
                                        textIndex,
                                        textTotal,
                                        selectorValue;
                                    function lookAt(t, e) {
                                        var r = [e[0] - t[0], e[1] - t[1], e[2] - t[2]],
                                            i = Math.atan2(r[0], Math.sqrt(r[1] * r[1] + r[2] * r[2])) / degToRads;
                                        return [-Math.atan2(r[1], r[2]) / degToRads, i, 0];
                                    }
                                    function easeOut(t, e, r, i, n) {
                                        return applyEase(easeOutBez, t, e, r, i, n);
                                    }
                                    function easeIn(t, e, r, i, n) {
                                        return applyEase(easeInBez, t, e, r, i, n);
                                    }
                                    function ease(t, e, r, i, n) {
                                        return applyEase(easeInOutBez, t, e, r, i, n);
                                    }
                                    function applyEase(t, e, r, i, n, a) {
                                        void 0 === n ? ((n = r), (a = i)) : (e = (e - r) / (i - r)), e > 1 ? (e = 1) : e < 0 && (e = 0);
                                        var s = t(e);
                                        if ($bm_isInstanceOfArray(n)) {
                                            var o,
                                                l = n.length,
                                                h = createTypedArray("float32", l);
                                            for (o = 0; o < l; o += 1) h[o] = (a[o] - n[o]) * s + n[o];
                                            return h;
                                        }
                                        return (a - n) * s + n;
                                    }
                                    function nearestKey(t) {
                                        var e,
                                            r,
                                            i,
                                            n = data.k.length;
                                        if (data.k.length && "number" != typeof data.k[0])
                                            if (((r = -1), (t *= elem.comp.globalData.frameRate) < data.k[0].t)) (r = 1), (i = data.k[0].t);
                                            else {
                                                for (e = 0; e < n - 1; e += 1) {
                                                    if (t === data.k[e].t) {
                                                        (r = e + 1), (i = data.k[e].t);
                                                        break;
                                                    }
                                                    if (t > data.k[e].t && t < data.k[e + 1].t) {
                                                        t - data.k[e].t > data.k[e + 1].t - t ? ((r = e + 2), (i = data.k[e + 1].t)) : ((r = e + 1), (i = data.k[e].t));
                                                        break;
                                                    }
                                                }
                                                -1 === r && ((r = e + 1), (i = data.k[e].t));
                                            }
                                        else (r = 0), (i = 0);
                                        var a = {};
                                        return (a.index = r), (a.time = i / elem.comp.globalData.frameRate), a;
                                    }
                                    function key(t) {
                                        var e, r, i;
                                        if (!data.k.length || "number" == typeof data.k[0]) throw new Error("The property has no keyframe at index " + t);
                                        (t -= 1), (e = { time: data.k[t].t / elem.comp.globalData.frameRate, value: [] });
                                        var n = Object.prototype.hasOwnProperty.call(data.k[t], "s") ? data.k[t].s : data.k[t - 1].e;
                                        for (i = n.length, r = 0; r < i; r += 1) (e[r] = n[r]), (e.value[r] = n[r]);
                                        return e;
                                    }
                                    function framesToTime(t, e) {
                                        return e || (e = elem.comp.globalData.frameRate), t / e;
                                    }
                                    function timeToFrames(t, e) {
                                        return t || 0 === t || (t = time), e || (e = elem.comp.globalData.frameRate), t * e;
                                    }
                                    function seedRandom(t) {
                                        BMMath.seedrandom(randSeed + t);
                                    }
                                    function sourceRectAtTime() {
                                        return elem.sourceRectAtTime();
                                    }
                                    function substring(t, e) {
                                        return "string" == typeof value ? (void 0 === e ? value.substring(t) : value.substring(t, e)) : "";
                                    }
                                    function substr(t, e) {
                                        return "string" == typeof value ? (void 0 === e ? value.substr(t) : value.substr(t, e)) : "";
                                    }
                                    function posterizeTime(t) {
                                        (time = 0 === t ? 0 : Math.floor(time * t) / t), (value = valueAtTime(time));
                                    }
                                    var index = elem.data.ind,
                                        hasParent = !(!elem.hierarchy || !elem.hierarchy.length),
                                        parent,
                                        randSeed = Math.floor(1e6 * Math.random()),
                                        globalData = elem.globalData;
                                    function executeExpression(t) {
                                        return (
                                            (value = t),
                                            this.frameExpressionId === elem.globalData.frameId && "textSelector" !== this.propType
                                                ? value
                                                : ("textSelector" === this.propType && ((textIndex = this.textIndex), (textTotal = this.textTotal), (selectorValue = this.selectorValue)),
                                                  thisLayer ||
                                                      ((text = elem.layerInterface.text),
                                                      (thisLayer = elem.layerInterface),
                                                      (thisComp = elem.comp.compInterface),
                                                      (toWorld = thisLayer.toWorld.bind(thisLayer)),
                                                      (fromWorld = thisLayer.fromWorld.bind(thisLayer)),
                                                      (fromComp = thisLayer.fromComp.bind(thisLayer)),
                                                      (toComp = thisLayer.toComp.bind(thisLayer)),
                                                      (mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null),
                                                      (fromCompToSurface = fromComp)),
                                                  transform || ((transform = elem.layerInterface("ADBE Transform Group")), ($bm_transform = transform), transform && (anchorPoint = transform.anchorPoint)),
                                                  4 !== elemType || content || (content = thisLayer("ADBE Root Vectors Group")),
                                                  effect || (effect = thisLayer(4)),
                                                  (hasParent = !(!elem.hierarchy || !elem.hierarchy.length)) && !parent && (parent = elem.hierarchy[0].layerInterface),
                                                  (time = this.comp.renderedFrame / this.comp.globalData.frameRate),
                                                  _needsRandom && seedRandom(randSeed + time),
                                                  needsVelocity && (velocity = velocityAtTime(time)),
                                                  expression_function(),
                                                  (this.frameExpressionId = elem.globalData.frameId),
                                                  (scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt))
                                        );
                                    }
                                    return (
                                        (executeExpression.__preventDeadCodeRemoval = [
                                            $bm_transform,
                                            anchorPoint,
                                            time,
                                            velocity,
                                            inPoint,
                                            outPoint,
                                            width,
                                            height,
                                            name,
                                            loop_in,
                                            loop_out,
                                            smooth,
                                            toComp,
                                            fromCompToSurface,
                                            toWorld,
                                            fromWorld,
                                            mask,
                                            position,
                                            rotation,
                                            scale,
                                            thisComp,
                                            numKeys,
                                            active,
                                            wiggle,
                                            loopInDuration,
                                            loopOutDuration,
                                            comp,
                                            lookAt,
                                            easeOut,
                                            easeIn,
                                            ease,
                                            nearestKey,
                                            key,
                                            text,
                                            textIndex,
                                            textTotal,
                                            selectorValue,
                                            framesToTime,
                                            timeToFrames,
                                            sourceRectAtTime,
                                            substring,
                                            substr,
                                            posterizeTime,
                                            index,
                                            globalData,
                                        ]),
                                        executeExpression
                                    );
                                }
                                return (
                                    (ob.initiateExpression = initiateExpression),
                                    (ob.__preventDeadCodeRemoval = [
                                        window,
                                        document,
                                        XMLHttpRequest,
                                        fetch,
                                        frames,
                                        $bm_neg,
                                        add,
                                        $bm_sum,
                                        $bm_sub,
                                        $bm_mul,
                                        $bm_div,
                                        $bm_mod,
                                        clamp,
                                        radians_to_degrees,
                                        degreesToRadians,
                                        degrees_to_radians,
                                        normalize,
                                        rgbToHsl,
                                        hslToRgb,
                                        linear,
                                        random,
                                        createPath,
                                    ]),
                                    ob
                                );
                            })(),
                            expressionHelpers = {
                                searchExpressions: function (t, e, r) {
                                    e.x && ((r.k = !0), (r.x = !0), (r.initiateExpression = ExpressionManager.initiateExpression), r.effectsSequence.push(r.initiateExpression(t, e, r).bind(r)));
                                },
                                getSpeedAtTime: function (t) {
                                    var e = this.getValueAtTime(t),
                                        r = this.getValueAtTime(t + -0.01),
                                        i = 0;
                                    if (e.length) {
                                        var n;
                                        for (n = 0; n < e.length; n += 1) i += Math.pow(r[n] - e[n], 2);
                                        i = 100 * Math.sqrt(i);
                                    } else i = 0;
                                    return i;
                                },
                                getVelocityAtTime: function (t) {
                                    if (void 0 !== this.vel) return this.vel;
                                    var e,
                                        r,
                                        i = -0.001,
                                        n = this.getValueAtTime(t),
                                        a = this.getValueAtTime(t + i);
                                    if (n.length) for (e = createTypedArray("float32", n.length), r = 0; r < n.length; r += 1) e[r] = (a[r] - n[r]) / i;
                                    else e = (a - n) / i;
                                    return e;
                                },
                                getValueAtTime: function (t) {
                                    return (
                                        (t *= this.elem.globalData.frameRate),
                                        (t -= this.offsetTime) !== this._cachingAtTime.lastFrame &&
                                            ((this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < t ? this._cachingAtTime.lastIndex : 0),
                                            (this._cachingAtTime.value = this.interpolateValue(t, this._cachingAtTime)),
                                            (this._cachingAtTime.lastFrame = t)),
                                        this._cachingAtTime.value
                                    );
                                },
                                getStaticValueAtTime: function () {
                                    return this.pv;
                                },
                                setGroupProperty: function (t) {
                                    this.propertyGroup = t;
                                },
                            };
                        function addPropertyDecorator() {
                            function t(t, e, r) {
                                if (!this.k || !this.keyframes) return this.pv;
                                t = t ? t.toLowerCase() : "";
                                var i,
                                    n,
                                    a,
                                    s,
                                    o,
                                    l = this.comp.renderedFrame,
                                    h = this.keyframes,
                                    c = h[h.length - 1].t;
                                if (l <= c) return this.pv;
                                if (
                                    (r
                                        ? (n = c - (i = e ? Math.abs(c - this.elem.comp.globalData.frameRate * e) : Math.max(0, c - this.elem.data.ip)))
                                        : ((!e || e > h.length - 1) && (e = h.length - 1), (i = c - (n = h[h.length - 1 - e].t))),
                                    "pingpong" === t)
                                ) {
                                    if (Math.floor((l - n) / i) % 2 != 0) return this.getValueAtTime((i - ((l - n) % i) + n) / this.comp.globalData.frameRate, 0);
                                } else {
                                    if ("offset" === t) {
                                        var p = this.getValueAtTime(n / this.comp.globalData.frameRate, 0),
                                            u = this.getValueAtTime(c / this.comp.globalData.frameRate, 0),
                                            f = this.getValueAtTime((((l - n) % i) + n) / this.comp.globalData.frameRate, 0),
                                            d = Math.floor((l - n) / i);
                                        if (this.pv.length) {
                                            for (s = (o = new Array(p.length)).length, a = 0; a < s; a += 1) o[a] = (u[a] - p[a]) * d + f[a];
                                            return o;
                                        }
                                        return (u - p) * d + f;
                                    }
                                    if ("continue" === t) {
                                        var m = this.getValueAtTime(c / this.comp.globalData.frameRate, 0),
                                            y = this.getValueAtTime((c - 0.001) / this.comp.globalData.frameRate, 0);
                                        if (this.pv.length) {
                                            for (s = (o = new Array(m.length)).length, a = 0; a < s; a += 1) o[a] = m[a] + ((m[a] - y[a]) * ((l - c) / this.comp.globalData.frameRate)) / 5e-4;
                                            return o;
                                        }
                                        return m + ((l - c) / 0.001) * (m - y);
                                    }
                                }
                                return this.getValueAtTime((((l - n) % i) + n) / this.comp.globalData.frameRate, 0);
                            }
                            function e(t, e, r) {
                                if (!this.k) return this.pv;
                                t = t ? t.toLowerCase() : "";
                                var i,
                                    n,
                                    a,
                                    s,
                                    o,
                                    l = this.comp.renderedFrame,
                                    h = this.keyframes,
                                    c = h[0].t;
                                if (l >= c) return this.pv;
                                if (
                                    (r ? (n = c + (i = e ? Math.abs(this.elem.comp.globalData.frameRate * e) : Math.max(0, this.elem.data.op - c))) : ((!e || e > h.length - 1) && (e = h.length - 1), (i = (n = h[e].t) - c)),
                                    "pingpong" === t)
                                ) {
                                    if (Math.floor((c - l) / i) % 2 == 0) return this.getValueAtTime((((c - l) % i) + c) / this.comp.globalData.frameRate, 0);
                                } else {
                                    if ("offset" === t) {
                                        var p = this.getValueAtTime(c / this.comp.globalData.frameRate, 0),
                                            u = this.getValueAtTime(n / this.comp.globalData.frameRate, 0),
                                            f = this.getValueAtTime((i - ((c - l) % i) + c) / this.comp.globalData.frameRate, 0),
                                            d = Math.floor((c - l) / i) + 1;
                                        if (this.pv.length) {
                                            for (s = (o = new Array(p.length)).length, a = 0; a < s; a += 1) o[a] = f[a] - (u[a] - p[a]) * d;
                                            return o;
                                        }
                                        return f - (u - p) * d;
                                    }
                                    if ("continue" === t) {
                                        var m = this.getValueAtTime(c / this.comp.globalData.frameRate, 0),
                                            y = this.getValueAtTime((c + 0.001) / this.comp.globalData.frameRate, 0);
                                        if (this.pv.length) {
                                            for (s = (o = new Array(m.length)).length, a = 0; a < s; a += 1) o[a] = m[a] + ((m[a] - y[a]) * (c - l)) / 0.001;
                                            return o;
                                        }
                                        return m + ((m - y) * (c - l)) / 0.001;
                                    }
                                }
                                return this.getValueAtTime((i - (((c - l) % i) + c)) / this.comp.globalData.frameRate, 0);
                            }
                            function r(t, e) {
                                if (!this.k) return this.pv;
                                if (((t = 0.5 * (t || 0.4)), (e = Math.floor(e || 5)) <= 1)) return this.pv;
                                var r,
                                    i,
                                    n = this.comp.renderedFrame / this.comp.globalData.frameRate,
                                    a = n - t,
                                    s = e > 1 ? (n + t - a) / (e - 1) : 1,
                                    o = 0,
                                    l = 0;
                                for (r = this.pv.length ? createTypedArray("float32", this.pv.length) : 0; o < e; ) {
                                    if (((i = this.getValueAtTime(a + o * s)), this.pv.length)) for (l = 0; l < this.pv.length; l += 1) r[l] += i[l];
                                    else r += i;
                                    o += 1;
                                }
                                if (this.pv.length) for (l = 0; l < this.pv.length; l += 1) r[l] /= e;
                                else r /= e;
                                return r;
                            }
                            function i(t) {
                                this._transformCachingAtTime || (this._transformCachingAtTime = { v: new Matrix() });
                                var e = this._transformCachingAtTime.v;
                                if ((e.cloneFromProps(this.pre.props), this.appliedTransformations < 1)) {
                                    var r = this.a.getValueAtTime(t);
                                    e.translate(-r[0] * this.a.mult, -r[1] * this.a.mult, r[2] * this.a.mult);
                                }
                                if (this.appliedTransformations < 2) {
                                    var i = this.s.getValueAtTime(t);
                                    e.scale(i[0] * this.s.mult, i[1] * this.s.mult, i[2] * this.s.mult);
                                }
                                if (this.sk && this.appliedTransformations < 3) {
                                    var n = this.sk.getValueAtTime(t),
                                        a = this.sa.getValueAtTime(t);
                                    e.skewFromAxis(-n * this.sk.mult, a * this.sa.mult);
                                }
                                if (this.r && this.appliedTransformations < 4) {
                                    var s = this.r.getValueAtTime(t);
                                    e.rotate(-s * this.r.mult);
                                } else if (!this.r && this.appliedTransformations < 4) {
                                    var o = this.rz.getValueAtTime(t),
                                        l = this.ry.getValueAtTime(t),
                                        h = this.rx.getValueAtTime(t),
                                        c = this.or.getValueAtTime(t);
                                    e.rotateZ(-o * this.rz.mult)
                                        .rotateY(l * this.ry.mult)
                                        .rotateX(h * this.rx.mult)
                                        .rotateZ(-c[2] * this.or.mult)
                                        .rotateY(c[1] * this.or.mult)
                                        .rotateX(c[0] * this.or.mult);
                                }
                                if (this.data.p && this.data.p.s) {
                                    var p = this.px.getValueAtTime(t),
                                        u = this.py.getValueAtTime(t);
                                    if (this.data.p.z) {
                                        var f = this.pz.getValueAtTime(t);
                                        e.translate(p * this.px.mult, u * this.py.mult, -f * this.pz.mult);
                                    } else e.translate(p * this.px.mult, u * this.py.mult, 0);
                                } else {
                                    var d = this.p.getValueAtTime(t);
                                    e.translate(d[0] * this.p.mult, d[1] * this.p.mult, -d[2] * this.p.mult);
                                }
                                return e;
                            }
                            function n() {
                                return this.v.clone(new Matrix());
                            }
                            var a = TransformPropertyFactory.getTransformProperty;
                            TransformPropertyFactory.getTransformProperty = function (t, e, r) {
                                var s = a(t, e, r);
                                return s.dynamicProperties.length ? (s.getValueAtTime = i.bind(s)) : (s.getValueAtTime = n.bind(s)), (s.setGroupProperty = expressionHelpers.setGroupProperty), s;
                            };
                            var s = PropertyFactory.getProp;
                            PropertyFactory.getProp = function (i, n, a, o, l) {
                                var h = s(i, n, a, o, l);
                                h.kf ? (h.getValueAtTime = expressionHelpers.getValueAtTime.bind(h)) : (h.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(h)),
                                    (h.setGroupProperty = expressionHelpers.setGroupProperty),
                                    (h.loopOut = t),
                                    (h.loopIn = e),
                                    (h.smooth = r),
                                    (h.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(h)),
                                    (h.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(h)),
                                    (h.numKeys = 1 === n.a ? n.k.length : 0),
                                    (h.propertyIndex = n.ix);
                                var c = 0;
                                return (
                                    0 !== a && (c = createTypedArray("float32", 1 === n.a ? n.k[0].s.length : n.k.length)),
                                    (h._cachingAtTime = { lastFrame: initialDefaultFrame, lastIndex: 0, value: c }),
                                    expressionHelpers.searchExpressions(i, n, h),
                                    h.k && l.addDynamicProperty(h),
                                    h
                                );
                            };
                            var o = ShapePropertyFactory.getConstructorFunction(),
                                l = ShapePropertyFactory.getKeyframedConstructorFunction();
                            function h() {}
                            (h.prototype = {
                                vertices: function (t, e) {
                                    this.k && this.getValue();
                                    var r,
                                        i = this.v;
                                    void 0 !== e && (i = this.getValueAtTime(e, 0));
                                    var n = i._length,
                                        a = i[t],
                                        s = i.v,
                                        o = createSizedArray(n);
                                    for (r = 0; r < n; r += 1) o[r] = "i" === t || "o" === t ? [a[r][0] - s[r][0], a[r][1] - s[r][1]] : [a[r][0], a[r][1]];
                                    return o;
                                },
                                points: function (t) {
                                    return this.vertices("v", t);
                                },
                                inTangents: function (t) {
                                    return this.vertices("i", t);
                                },
                                outTangents: function (t) {
                                    return this.vertices("o", t);
                                },
                                isClosed: function () {
                                    return this.v.c;
                                },
                                pointOnPath: function (t, e) {
                                    var r = this.v;
                                    void 0 !== e && (r = this.getValueAtTime(e, 0)), this._segmentsLength || (this._segmentsLength = bez.getSegmentsLength(r));
                                    for (var i, n = this._segmentsLength, a = n.lengths, s = n.totalLength * t, o = 0, l = a.length, h = 0; o < l; ) {
                                        if (h + a[o].addedLength > s) {
                                            var c = o,
                                                p = r.c && o === l - 1 ? 0 : o + 1,
                                                u = (s - h) / a[o].addedLength;
                                            i = bez.getPointInSegment(r.v[c], r.v[p], r.o[c], r.i[p], u, a[o]);
                                            break;
                                        }
                                        (h += a[o].addedLength), (o += 1);
                                    }
                                    return i || (i = r.c ? [r.v[0][0], r.v[0][1]] : [r.v[r._length - 1][0], r.v[r._length - 1][1]]), i;
                                },
                                vectorOnPath: function (t, e, r) {
                                    1 == t ? (t = this.v.c) : 0 == t && (t = 0.999);
                                    var i = this.pointOnPath(t, e),
                                        n = this.pointOnPath(t + 0.001, e),
                                        a = n[0] - i[0],
                                        s = n[1] - i[1],
                                        o = Math.sqrt(Math.pow(a, 2) + Math.pow(s, 2));
                                    return 0 === o ? [0, 0] : "tangent" === r ? [a / o, s / o] : [-s / o, a / o];
                                },
                                tangentOnPath: function (t, e) {
                                    return this.vectorOnPath(t, e, "tangent");
                                },
                                normalOnPath: function (t, e) {
                                    return this.vectorOnPath(t, e, "normal");
                                },
                                setGroupProperty: expressionHelpers.setGroupProperty,
                                getValueAtTime: expressionHelpers.getStaticValueAtTime,
                            }),
                                extendPrototype([h], o),
                                extendPrototype([h], l),
                                (l.prototype.getValueAtTime = function (t) {
                                    return (
                                        this._cachingAtTime || (this._cachingAtTime = { shapeValue: shapePool.clone(this.pv), lastIndex: 0, lastTime: initialDefaultFrame }),
                                        (t *= this.elem.globalData.frameRate),
                                        (t -= this.offsetTime) !== this._cachingAtTime.lastTime &&
                                            ((this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < t ? this._caching.lastIndex : 0),
                                            (this._cachingAtTime.lastTime = t),
                                            this.interpolateShape(t, this._cachingAtTime.shapeValue, this._cachingAtTime)),
                                        this._cachingAtTime.shapeValue
                                    );
                                }),
                                (l.prototype.initiateExpression = ExpressionManager.initiateExpression);
                            var c = ShapePropertyFactory.getShapeProp;
                            ShapePropertyFactory.getShapeProp = function (t, e, r, i, n) {
                                var a = c(t, e, r, i, n);
                                return (a.propertyIndex = e.ix), (a.lock = !1), 3 === r ? expressionHelpers.searchExpressions(t, e.pt, a) : 4 === r && expressionHelpers.searchExpressions(t, e.ks, a), a.k && t.addDynamicProperty(a), a;
                            };
                        }
                        function initialize$1() {
                            addPropertyDecorator();
                        }
                        function addDecorator() {
                            (TextProperty.prototype.getExpressionValue = function (t, e) {
                                var r = this.calculateExpression(e);
                                if (t.t !== r) {
                                    var i = {};
                                    return this.copyData(i, t), (i.t = r.toString()), (i.__complete = !1), i;
                                }
                                return t;
                            }),
                                (TextProperty.prototype.searchProperty = function () {
                                    var t = this.searchKeyframes(),
                                        e = this.searchExpressions();
                                    return (this.kf = t || e), this.kf;
                                }),
                                (TextProperty.prototype.searchExpressions = function () {
                                    return this.data.d.x ? ((this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this)), this.addEffect(this.getExpressionValue.bind(this)), !0) : null;
                                });
                        }
                        function initialize() {
                            addDecorator();
                        }
                        function SVGComposableEffect() {}
                        function SVGTintFilter(t, e, r, i, n) {
                            this.filterManager = e;
                            var a = createNS("feColorMatrix");
                            a.setAttribute("type", "matrix"),
                                a.setAttribute("color-interpolation-filters", "linearRGB"),
                                a.setAttribute("values", "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"),
                                a.setAttribute("result", i + "_tint_1"),
                                t.appendChild(a),
                                (a = createNS("feColorMatrix")).setAttribute("type", "matrix"),
                                a.setAttribute("color-interpolation-filters", "sRGB"),
                                a.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"),
                                a.setAttribute("result", i + "_tint_2"),
                                t.appendChild(a),
                                (this.matrixFilter = a);
                            var s = this.createMergeNode(i, [n, i + "_tint_1", i + "_tint_2"]);
                            t.appendChild(s);
                        }
                        function SVGFillFilter(t, e, r, i) {
                            this.filterManager = e;
                            var n = createNS("feColorMatrix");
                            n.setAttribute("type", "matrix"),
                                n.setAttribute("color-interpolation-filters", "sRGB"),
                                n.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"),
                                n.setAttribute("result", i),
                                t.appendChild(n),
                                (this.matrixFilter = n);
                        }
                        function SVGStrokeEffect(t, e, r) {
                            (this.initialized = !1), (this.filterManager = e), (this.elem = r), (this.paths = []);
                        }
                        function SVGTritoneFilter(t, e, r, i) {
                            this.filterManager = e;
                            var n = createNS("feColorMatrix");
                            n.setAttribute("type", "matrix"),
                                n.setAttribute("color-interpolation-filters", "linearRGB"),
                                n.setAttribute("values", "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"),
                                t.appendChild(n);
                            var a = createNS("feComponentTransfer");
                            a.setAttribute("color-interpolation-filters", "sRGB"), a.setAttribute("result", i), (this.matrixFilter = a);
                            var s = createNS("feFuncR");
                            s.setAttribute("type", "table"), a.appendChild(s), (this.feFuncR = s);
                            var o = createNS("feFuncG");
                            o.setAttribute("type", "table"), a.appendChild(o), (this.feFuncG = o);
                            var l = createNS("feFuncB");
                            l.setAttribute("type", "table"), a.appendChild(l), (this.feFuncB = l), t.appendChild(a);
                        }
                        function SVGProLevelsFilter(t, e, r, i) {
                            this.filterManager = e;
                            var n = this.filterManager.effectElements,
                                a = createNS("feComponentTransfer");
                            (n[10].p.k || 0 !== n[10].p.v || n[11].p.k || 1 !== n[11].p.v || n[12].p.k || 1 !== n[12].p.v || n[13].p.k || 0 !== n[13].p.v || n[14].p.k || 1 !== n[14].p.v) && (this.feFuncR = this.createFeFunc("feFuncR", a)),
                                (n[17].p.k || 0 !== n[17].p.v || n[18].p.k || 1 !== n[18].p.v || n[19].p.k || 1 !== n[19].p.v || n[20].p.k || 0 !== n[20].p.v || n[21].p.k || 1 !== n[21].p.v) &&
                                    (this.feFuncG = this.createFeFunc("feFuncG", a)),
                                (n[24].p.k || 0 !== n[24].p.v || n[25].p.k || 1 !== n[25].p.v || n[26].p.k || 1 !== n[26].p.v || n[27].p.k || 0 !== n[27].p.v || n[28].p.k || 1 !== n[28].p.v) &&
                                    (this.feFuncB = this.createFeFunc("feFuncB", a)),
                                (n[31].p.k || 0 !== n[31].p.v || n[32].p.k || 1 !== n[32].p.v || n[33].p.k || 1 !== n[33].p.v || n[34].p.k || 0 !== n[34].p.v || n[35].p.k || 1 !== n[35].p.v) &&
                                    (this.feFuncA = this.createFeFunc("feFuncA", a)),
                                (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) && (a.setAttribute("color-interpolation-filters", "sRGB"), t.appendChild(a)),
                                (n[3].p.k || 0 !== n[3].p.v || n[4].p.k || 1 !== n[4].p.v || n[5].p.k || 1 !== n[5].p.v || n[6].p.k || 0 !== n[6].p.v || n[7].p.k || 1 !== n[7].p.v) &&
                                    ((a = createNS("feComponentTransfer")).setAttribute("color-interpolation-filters", "sRGB"),
                                    a.setAttribute("result", i),
                                    t.appendChild(a),
                                    (this.feFuncRComposed = this.createFeFunc("feFuncR", a)),
                                    (this.feFuncGComposed = this.createFeFunc("feFuncG", a)),
                                    (this.feFuncBComposed = this.createFeFunc("feFuncB", a)));
                        }
                        function SVGDropShadowEffect(t, e, r, i, n) {
                            var a = e.container.globalData.renderConfig.filterSize,
                                s = e.data.fs || a;
                            t.setAttribute("x", s.x || a.x), t.setAttribute("y", s.y || a.y), t.setAttribute("width", s.width || a.width), t.setAttribute("height", s.height || a.height), (this.filterManager = e);
                            var o = createNS("feGaussianBlur");
                            o.setAttribute("in", "SourceAlpha"), o.setAttribute("result", i + "_drop_shadow_1"), o.setAttribute("stdDeviation", "0"), (this.feGaussianBlur = o), t.appendChild(o);
                            var l = createNS("feOffset");
                            l.setAttribute("dx", "25"), l.setAttribute("dy", "0"), l.setAttribute("in", i + "_drop_shadow_1"), l.setAttribute("result", i + "_drop_shadow_2"), (this.feOffset = l), t.appendChild(l);
                            var h = createNS("feFlood");
                            h.setAttribute("flood-color", "#00ff00"), h.setAttribute("flood-opacity", "1"), h.setAttribute("result", i + "_drop_shadow_3"), (this.feFlood = h), t.appendChild(h);
                            var c = createNS("feComposite");
                            c.setAttribute("in", i + "_drop_shadow_3"), c.setAttribute("in2", i + "_drop_shadow_2"), c.setAttribute("operator", "in"), c.setAttribute("result", i + "_drop_shadow_4"), t.appendChild(c);
                            var p = this.createMergeNode(i, [i + "_drop_shadow_4", n]);
                            t.appendChild(p);
                        }
                        (SVGComposableEffect.prototype = {
                            createMergeNode: function (t, e) {
                                var r,
                                    i,
                                    n = createNS("feMerge");
                                for (n.setAttribute("result", t), i = 0; i < e.length; i += 1) (r = createNS("feMergeNode")).setAttribute("in", e[i]), n.appendChild(r), n.appendChild(r);
                                return n;
                            },
                        }),
                            extendPrototype([SVGComposableEffect], SVGTintFilter),
                            (SVGTintFilter.prototype.renderFrame = function (t) {
                                if (t || this.filterManager._mdf) {
                                    var e = this.filterManager.effectElements[0].p.v,
                                        r = this.filterManager.effectElements[1].p.v,
                                        i = this.filterManager.effectElements[2].p.v / 100;
                                    this.matrixFilter.setAttribute("values", r[0] - e[0] + " 0 0 0 " + e[0] + " " + (r[1] - e[1]) + " 0 0 0 " + e[1] + " " + (r[2] - e[2]) + " 0 0 0 " + e[2] + " 0 0 0 " + i + " 0");
                                }
                            }),
                            (SVGFillFilter.prototype.renderFrame = function (t) {
                                if (t || this.filterManager._mdf) {
                                    var e = this.filterManager.effectElements[2].p.v,
                                        r = this.filterManager.effectElements[6].p.v;
                                    this.matrixFilter.setAttribute("values", "0 0 0 0 " + e[0] + " 0 0 0 0 " + e[1] + " 0 0 0 0 " + e[2] + " 0 0 0 " + r + " 0");
                                }
                            }),
                            (SVGStrokeEffect.prototype.initialize = function () {
                                var t,
                                    e,
                                    r,
                                    i,
                                    n = this.elem.layerElement.children || this.elem.layerElement.childNodes;
                                for (
                                    1 === this.filterManager.effectElements[1].p.v ? ((i = this.elem.maskManager.masksProperties.length), (r = 0)) : (i = 1 + (r = this.filterManager.effectElements[0].p.v - 1)),
                                        (e = createNS("g")).setAttribute("fill", "none"),
                                        e.setAttribute("stroke-linecap", "round"),
                                        e.setAttribute("stroke-dashoffset", 1);
                                    r < i;
                                    r += 1
                                )
                                    (t = createNS("path")), e.appendChild(t), this.paths.push({ p: t, m: r });
                                if (3 === this.filterManager.effectElements[10].p.v) {
                                    var a = createNS("mask"),
                                        s = createElementID();
                                    a.setAttribute("id", s), a.setAttribute("mask-type", "alpha"), a.appendChild(e), this.elem.globalData.defs.appendChild(a);
                                    var o = createNS("g");
                                    for (o.setAttribute("mask", "url(" + getLocationHref() + "#" + s + ")"); n[0]; ) o.appendChild(n[0]);
                                    this.elem.layerElement.appendChild(o), (this.masker = a), e.setAttribute("stroke", "#fff");
                                } else if (1 === this.filterManager.effectElements[10].p.v || 2 === this.filterManager.effectElements[10].p.v) {
                                    if (2 === this.filterManager.effectElements[10].p.v) for (n = this.elem.layerElement.children || this.elem.layerElement.childNodes; n.length; ) this.elem.layerElement.removeChild(n[0]);
                                    this.elem.layerElement.appendChild(e), this.elem.layerElement.removeAttribute("mask"), e.setAttribute("stroke", "#fff");
                                }
                                (this.initialized = !0), (this.pathMasker = e);
                            }),
                            (SVGStrokeEffect.prototype.renderFrame = function (t) {
                                var e;
                                this.initialized || this.initialize();
                                var r,
                                    i,
                                    n = this.paths.length;
                                for (e = 0; e < n; e += 1)
                                    if (
                                        -1 !== this.paths[e].m &&
                                        ((r = this.elem.maskManager.viewData[this.paths[e].m]),
                                        (i = this.paths[e].p),
                                        (t || this.filterManager._mdf || r.prop._mdf) && i.setAttribute("d", r.lastPath),
                                        t ||
                                            this.filterManager.effectElements[9].p._mdf ||
                                            this.filterManager.effectElements[4].p._mdf ||
                                            this.filterManager.effectElements[7].p._mdf ||
                                            this.filterManager.effectElements[8].p._mdf ||
                                            r.prop._mdf)
                                    ) {
                                        var a;
                                        if (0 !== this.filterManager.effectElements[7].p.v || 100 !== this.filterManager.effectElements[8].p.v) {
                                            var s = 0.01 * Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v),
                                                o = 0.01 * Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v),
                                                l = i.getTotalLength();
                                            a = "0 0 0 " + l * s + " ";
                                            var h,
                                                c = l * (o - s),
                                                p = 1 + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * 0.01,
                                                u = Math.floor(c / p);
                                            for (h = 0; h < u; h += 1) a += "1 " + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * 0.01 + " ";
                                            a += "0 " + 10 * l + " 0 0";
                                        } else a = "1 " + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * 0.01;
                                        i.setAttribute("stroke-dasharray", a);
                                    }
                                if (
                                    ((t || this.filterManager.effectElements[4].p._mdf) && this.pathMasker.setAttribute("stroke-width", 2 * this.filterManager.effectElements[4].p.v),
                                    (t || this.filterManager.effectElements[6].p._mdf) && this.pathMasker.setAttribute("opacity", this.filterManager.effectElements[6].p.v),
                                    (1 === this.filterManager.effectElements[10].p.v || 2 === this.filterManager.effectElements[10].p.v) && (t || this.filterManager.effectElements[3].p._mdf))
                                ) {
                                    var f = this.filterManager.effectElements[3].p.v;
                                    this.pathMasker.setAttribute("stroke", "rgb(" + bmFloor(255 * f[0]) + "," + bmFloor(255 * f[1]) + "," + bmFloor(255 * f[2]) + ")");
                                }
                            }),
                            (SVGTritoneFilter.prototype.renderFrame = function (t) {
                                if (t || this.filterManager._mdf) {
                                    var e = this.filterManager.effectElements[0].p.v,
                                        r = this.filterManager.effectElements[1].p.v,
                                        i = this.filterManager.effectElements[2].p.v,
                                        n = i[0] + " " + r[0] + " " + e[0],
                                        a = i[1] + " " + r[1] + " " + e[1],
                                        s = i[2] + " " + r[2] + " " + e[2];
                                    this.feFuncR.setAttribute("tableValues", n), this.feFuncG.setAttribute("tableValues", a), this.feFuncB.setAttribute("tableValues", s);
                                }
                            }),
                            (SVGProLevelsFilter.prototype.createFeFunc = function (t, e) {
                                var r = createNS(t);
                                return r.setAttribute("type", "table"), e.appendChild(r), r;
                            }),
                            (SVGProLevelsFilter.prototype.getTableValue = function (t, e, r, i, n) {
                                for (var a, s, o = 0, l = Math.min(t, e), h = Math.max(t, e), c = Array.call(null, { length: 256 }), p = 0, u = n - i, f = e - t; o <= 256; )
                                    (s = (a = o / 256) <= l ? (f < 0 ? n : i) : a >= h ? (f < 0 ? i : n) : i + u * Math.pow((a - t) / f, 1 / r)), (c[p] = s), (p += 1), (o += 256 / 255);
                                return c.join(" ");
                            }),
                            (SVGProLevelsFilter.prototype.renderFrame = function (t) {
                                if (t || this.filterManager._mdf) {
                                    var e,
                                        r = this.filterManager.effectElements;
                                    this.feFuncRComposed &&
                                        (t || r[3].p._mdf || r[4].p._mdf || r[5].p._mdf || r[6].p._mdf || r[7].p._mdf) &&
                                        ((e = this.getTableValue(r[3].p.v, r[4].p.v, r[5].p.v, r[6].p.v, r[7].p.v)),
                                        this.feFuncRComposed.setAttribute("tableValues", e),
                                        this.feFuncGComposed.setAttribute("tableValues", e),
                                        this.feFuncBComposed.setAttribute("tableValues", e)),
                                        this.feFuncR &&
                                            (t || r[10].p._mdf || r[11].p._mdf || r[12].p._mdf || r[13].p._mdf || r[14].p._mdf) &&
                                            ((e = this.getTableValue(r[10].p.v, r[11].p.v, r[12].p.v, r[13].p.v, r[14].p.v)), this.feFuncR.setAttribute("tableValues", e)),
                                        this.feFuncG &&
                                            (t || r[17].p._mdf || r[18].p._mdf || r[19].p._mdf || r[20].p._mdf || r[21].p._mdf) &&
                                            ((e = this.getTableValue(r[17].p.v, r[18].p.v, r[19].p.v, r[20].p.v, r[21].p.v)), this.feFuncG.setAttribute("tableValues", e)),
                                        this.feFuncB &&
                                            (t || r[24].p._mdf || r[25].p._mdf || r[26].p._mdf || r[27].p._mdf || r[28].p._mdf) &&
                                            ((e = this.getTableValue(r[24].p.v, r[25].p.v, r[26].p.v, r[27].p.v, r[28].p.v)), this.feFuncB.setAttribute("tableValues", e)),
                                        this.feFuncA &&
                                            (t || r[31].p._mdf || r[32].p._mdf || r[33].p._mdf || r[34].p._mdf || r[35].p._mdf) &&
                                            ((e = this.getTableValue(r[31].p.v, r[32].p.v, r[33].p.v, r[34].p.v, r[35].p.v)), this.feFuncA.setAttribute("tableValues", e));
                                }
                            }),
                            extendPrototype([SVGComposableEffect], SVGDropShadowEffect),
                            (SVGDropShadowEffect.prototype.renderFrame = function (t) {
                                if (t || this.filterManager._mdf) {
                                    if (
                                        ((t || this.filterManager.effectElements[4].p._mdf) && this.feGaussianBlur.setAttribute("stdDeviation", this.filterManager.effectElements[4].p.v / 4), t || this.filterManager.effectElements[0].p._mdf)
                                    ) {
                                        var e = this.filterManager.effectElements[0].p.v;
                                        this.feFlood.setAttribute("flood-color", rgbToHex(Math.round(255 * e[0]), Math.round(255 * e[1]), Math.round(255 * e[2])));
                                    }
                                    if (
                                        ((t || this.filterManager.effectElements[1].p._mdf) && this.feFlood.setAttribute("flood-opacity", this.filterManager.effectElements[1].p.v / 255),
                                        t || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf)
                                    ) {
                                        var r = this.filterManager.effectElements[3].p.v,
                                            i = (this.filterManager.effectElements[2].p.v - 90) * degToRads,
                                            n = r * Math.cos(i),
                                            a = r * Math.sin(i);
                                        this.feOffset.setAttribute("dx", n), this.feOffset.setAttribute("dy", a);
                                    }
                                }
                            });
                        var _svgMatteSymbols = [];
                        function SVGMatte3Effect(t, e, r) {
                            (this.initialized = !1),
                                (this.filterManager = e),
                                (this.filterElem = t),
                                (this.elem = r),
                                (r.matteElement = createNS("g")),
                                r.matteElement.appendChild(r.layerElement),
                                r.matteElement.appendChild(r.transformedElement),
                                (r.baseElement = r.matteElement);
                        }
                        function SVGGaussianBlurEffect(t, e, r, i) {
                            t.setAttribute("x", "-100%"), t.setAttribute("y", "-100%"), t.setAttribute("width", "300%"), t.setAttribute("height", "300%"), (this.filterManager = e);
                            var n = createNS("feGaussianBlur");
                            n.setAttribute("result", i), t.appendChild(n), (this.feGaussianBlur = n);
                        }
                        return (
                            (SVGMatte3Effect.prototype.findSymbol = function (t) {
                                for (var e = 0, r = _svgMatteSymbols.length; e < r; ) {
                                    if (_svgMatteSymbols[e] === t) return _svgMatteSymbols[e];
                                    e += 1;
                                }
                                return null;
                            }),
                            (SVGMatte3Effect.prototype.replaceInParent = function (t, e) {
                                var r = t.layerElement.parentNode;
                                if (r) {
                                    for (var i, n = r.children, a = 0, s = n.length; a < s && n[a] !== t.layerElement; ) a += 1;
                                    a <= s - 2 && (i = n[a + 1]);
                                    var o = createNS("use");
                                    o.setAttribute("href", "#" + e), i ? r.insertBefore(o, i) : r.appendChild(o);
                                }
                            }),
                            (SVGMatte3Effect.prototype.setElementAsMask = function (t, e) {
                                if (!this.findSymbol(e)) {
                                    var r = createElementID(),
                                        i = createNS("mask");
                                    i.setAttribute("id", e.layerId), i.setAttribute("mask-type", "alpha"), _svgMatteSymbols.push(e);
                                    var n = t.globalData.defs;
                                    n.appendChild(i);
                                    var a = createNS("symbol");
                                    a.setAttribute("id", r), this.replaceInParent(e, r), a.appendChild(e.layerElement), n.appendChild(a);
                                    var s = createNS("use");
                                    s.setAttribute("href", "#" + r), i.appendChild(s), (e.data.hd = !1), e.show();
                                }
                                t.setMatte(e.layerId);
                            }),
                            (SVGMatte3Effect.prototype.initialize = function () {
                                for (var t = this.filterManager.effectElements[0].p.v, e = this.elem.comp.elements, r = 0, i = e.length; r < i; ) e[r] && e[r].data.ind === t && this.setElementAsMask(this.elem, e[r]), (r += 1);
                                this.initialized = !0;
                            }),
                            (SVGMatte3Effect.prototype.renderFrame = function () {
                                this.initialized || this.initialize();
                            }),
                            (SVGGaussianBlurEffect.prototype.renderFrame = function (t) {
                                if (t || this.filterManager._mdf) {
                                    var e = 0.3 * this.filterManager.effectElements[0].p.v,
                                        r = this.filterManager.effectElements[1].p.v,
                                        i = 3 == r ? 0 : e,
                                        n = 2 == r ? 0 : e;
                                    this.feGaussianBlur.setAttribute("stdDeviation", i + " " + n);
                                    var a = 1 == this.filterManager.effectElements[2].p.v ? "wrap" : "duplicate";
                                    this.feGaussianBlur.setAttribute("edgeMode", a);
                                }
                            }),
                            registerRenderer("canvas", CanvasRenderer),
                            registerRenderer("html", HybridRenderer),
                            registerRenderer("svg", SVGRenderer),
                            ShapeModifiers.registerModifier("tm", TrimModifier),
                            ShapeModifiers.registerModifier("pb", PuckerAndBloatModifier),
                            ShapeModifiers.registerModifier("rp", RepeaterModifier),
                            ShapeModifiers.registerModifier("rd", RoundCornersModifier),
                            ShapeModifiers.registerModifier("zz", ZigZagModifier),
                            ShapeModifiers.registerModifier("op", OffsetPathModifier),
                            setExpressionsPlugin(Expressions),
                            setExpressionInterfaces(getInterface),
                            initialize$1(),
                            initialize(),
                            registerEffect(20, SVGTintFilter, !0),
                            registerEffect(21, SVGFillFilter, !0),
                            registerEffect(22, SVGStrokeEffect, !1),
                            registerEffect(23, SVGTritoneFilter, !0),
                            registerEffect(24, SVGProLevelsFilter, !0),
                            registerEffect(25, SVGDropShadowEffect, !0),
                            registerEffect(28, SVGMatte3Effect, !1),
                            registerEffect(29, SVGGaussianBlurEffect, !0),
                            lottie
                        );
                    }),
                    (module.exports = factory()));
            })(lottie$1, lottie$1.exports);
            var lottie = lottie$1.exports,
                _templateObject$1,
                styles = r$3(
                    _templateObject$1 ||
                        (_templateObject$1 = _taggedTemplateLiteral([
                            "\n  * {\n    box-sizing: border-box;\n  }\n\n  :host {\n    --lottie-player-toolbar-height: 35px;\n    --lottie-player-toolbar-background-color: transparent;\n    --lottie-player-toolbar-icon-color: #999;\n    --lottie-player-toolbar-icon-hover-color: #222;\n    --lottie-player-toolbar-icon-active-color: #555;\n    --lottie-player-seeker-track-color: #ccc;\n    --lottie-player-seeker-thumb-color: rgba(0, 107, 120, 0.8);\n    --lottie-player-seeker-display: block;\n\n    display: block;\n    width: 100%;\n    height: 100%;\n  }\n\n  .main {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    width: 100%;\n  }\n\n  .animation {\n    width: 100%;\n    height: 100%;\n    display: flex;\n  }\n  .animation.controls {\n    height: calc(100% - 35px);\n  }\n\n  .toolbar {\n    display: flex;\n    align-items: center;\n    justify-items: center;\n    background-color: var(--lottie-player-toolbar-background-color);\n    margin: 0 5px;\n    height: 35px;\n  }\n\n  .toolbar button {\n    cursor: pointer;\n    fill: var(--lottie-player-toolbar-icon-color);\n    display: flex;\n    background: none;\n    border: 0;\n    padding: 0;\n    outline: none;\n    height: 100%;\n  }\n\n  .toolbar button:hover {\n    fill: var(--lottie-player-toolbar-icon-hover-color);\n  }\n\n  .toolbar button.active {\n    fill: var(--lottie-player-toolbar-icon-active-color);\n  }\n\n  .toolbar button.active:hover {\n    fill: var(--lottie-player-toolbar-icon-hover-color);\n  }\n\n  .toolbar button:focus {\n    outline: 1px dotted var(--lottie-player-toolbar-icon-active-color);\n  }\n\n  .toolbar button svg {\n  }\n\n  .toolbar button.disabled svg {\n    display: none;\n  }\n\n  .seeker {\n    -webkit-appearance: none;\n    width: 95%;\n    outline: none;\n    background-color: var(--lottie-player-toolbar-background-color);\n    display: var(--lottie-player-seeker-display);\n  }\n\n  .seeker::-webkit-slider-runnable-track {\n    width: 100%;\n    height: 5px;\n    cursor: pointer;\n    background: var(--lottie-player-seeker-track-color);\n    border-radius: 3px;\n  }\n  .seeker::-webkit-slider-thumb {\n    height: 15px;\n    width: 15px;\n    border-radius: 50%;\n    background: var(--lottie-player-seeker-thumb-color);\n    cursor: pointer;\n    -webkit-appearance: none;\n    margin-top: -5px;\n  }\n  .seeker:focus::-webkit-slider-runnable-track {\n    background: #999;\n  }\n  .seeker::-moz-range-track {\n    width: 100%;\n    height: 5px;\n    cursor: pointer;\n    background: var(--lottie-player-seeker-track-color);\n    border-radius: 3px;\n  }\n  .seeker::-moz-range-thumb {\n    height: 15px;\n    width: 15px;\n    border-radius: 50%;\n    background: var(--lottie-player-seeker-thumb-color);\n    cursor: pointer;\n  }\n  .seeker::-ms-track {\n    width: 100%;\n    height: 5px;\n    cursor: pointer;\n    background: transparent;\n    border-color: transparent;\n    color: transparent;\n  }\n  .seeker::-ms-fill-lower {\n    background: var(--lottie-player-seeker-track-color);\n    border-radius: 3px;\n  }\n  .seeker::-ms-fill-upper {\n    background: var(--lottie-player-seeker-track-color);\n    border-radius: 3px;\n  }\n  .seeker::-ms-thumb {\n    border: 0;\n    height: 15px;\n    width: 15px;\n    border-radius: 50%;\n    background: var(--lottie-player-seeker-thumb-color);\n    cursor: pointer;\n  }\n  .seeker:focus::-ms-fill-lower {\n    background: var(--lottie-player-seeker-track-color);\n  }\n  .seeker:focus::-ms-fill-upper {\n    background: var(--lottie-player-seeker-track-color);\n  }\n\n  .error {\n    display: flex;\n    justify-content: center;\n    height: 100%;\n    align-items: center;\n  }\n",
                        ]))
                ),
                LOTTIE_PLAYER_VERSION = "1.7.1",
                LOTTIE_WEB_VERSION = "^5.10.0",
                _templateObject,
                _templateObject2,
                _templateObject3,
                _templateObject4,
                _templateObject5,
                PlayerState,
                PlayMode,
                PlayerEvents;
            function parseSrc(t) {
                if ("object" == typeof t) return t;
                try {
                    return JSON.parse(t);
                } catch (e) {
                    return new URL(t, window.location.href).toString();
                }
            }
            function isLottie(t) {
                return ["v", "ip", "op", "layers", "fr", "w", "h"].every((e) => Object.prototype.hasOwnProperty.call(t, e));
            }
            function fromURL(t) {
                return _fromURL.apply(this, arguments);
            }
            function _fromURL() {
                return (_fromURL = _asyncToGenerator(function* (t) {
                    if ("string" != typeof t) throw new Error("The url value must be a string");
                    var e;
                    try {
                        var r = new URL(t),
                            i = yield fetch(r.toString());
                        e = yield i.json();
                    } catch (t) {
                        throw new Error("An error occurred while trying to load the Lottie file from URL");
                    }
                    return e;
                })).apply(this, arguments);
            }
            !(function (t) {
                (t.Destroyed = "destroyed"), (t.Error = "error"), (t.Frozen = "frozen"), (t.Loading = "loading"), (t.Paused = "paused"), (t.Playing = "playing"), (t.Stopped = "stopped");
            })(PlayerState || (PlayerState = {})),
                (function (t) {
                    (t.Bounce = "bounce"), (t.Normal = "normal");
                })(PlayMode || (PlayMode = {})),
                (function (t) {
                    (t.Complete = "complete"),
                        (t.Destroyed = "destroyed"),
                        (t.Error = "error"),
                        (t.Frame = "frame"),
                        (t.Freeze = "freeze"),
                        (t.Load = "load"),
                        (t.Loop = "loop"),
                        (t.Pause = "pause"),
                        (t.Play = "play"),
                        (t.Ready = "ready"),
                        (t.Rendered = "rendered"),
                        (t.Stop = "stop");
                })(PlayerEvents || (PlayerEvents = {}));
            var LottiePlayer = class extends s {
                constructor() {
                    super(...arguments),
                        (this.autoplay = !1),
                        (this.background = "transparent"),
                        (this.controls = !1),
                        (this.currentState = PlayerState.Loading),
                        (this.description = "Lottie animation"),
                        (this.direction = 1),
                        (this.disableCheck = !1),
                        (this.disableShadowDOM = !1),
                        (this.hover = !1),
                        (this.intermission = 1),
                        (this.loop = !1),
                        (this.mode = PlayMode.Normal),
                        (this.preserveAspectRatio = "xMidYMid meet"),
                        (this.renderer = "svg"),
                        (this.speed = 1),
                        (this._io = void 0),
                        (this._counter = 1);
                }
                load(t) {
                    var e = this;
                    return _asyncToGenerator(function* () {
                        var r = {
                            container: e.container,
                            loop: !1,
                            autoplay: !1,
                            renderer: e.renderer,
                            rendererSettings: Object.assign({ preserveAspectRatio: e.preserveAspectRatio, clearCanvas: !1, progressiveLoad: !0, hideOnTransparent: !0 }, e.viewBoxSize && { viewBoxSize: e.viewBoxSize }),
                        };
                        try {
                            var i = parseSrc(t),
                                n = {},
                                a = "string" == typeof i ? "path" : "animationData";
                            e._lottie && e._lottie.destroy(),
                                e.webworkers && lottie$1.exports.useWebWorker(!0),
                                (e._lottie = lottie$1.exports.loadAnimation(Object.assign(Object.assign({}, r), { [a]: i }))),
                                e._attachEventListeners(),
                                e.disableCheck || ("path" === a ? ((n = yield fromURL(i)), (a = "animationData")) : (n = i), isLottie(n) || ((e.currentState = PlayerState.Error), e.dispatchEvent(new CustomEvent(PlayerEvents.Error))));
                        } catch (t) {
                            (e.currentState = PlayerState.Error), e.dispatchEvent(new CustomEvent(PlayerEvents.Error));
                        }
                    })();
                }
                getLottie() {
                    return this._lottie;
                }
                getVersions() {
                    return { lottieWebVersion: LOTTIE_WEB_VERSION, lottiePlayerVersion: LOTTIE_PLAYER_VERSION };
                }
                play() {
                    this._lottie && (this._lottie.play(), (this.currentState = PlayerState.Playing), this.dispatchEvent(new CustomEvent(PlayerEvents.Play)));
                }
                pause() {
                    this._lottie && (this._lottie.pause(), (this.currentState = PlayerState.Paused), this.dispatchEvent(new CustomEvent(PlayerEvents.Pause)));
                }
                stop() {
                    this._lottie && ((this._counter = 1), this._lottie.stop(), (this.currentState = PlayerState.Stopped), this.dispatchEvent(new CustomEvent(PlayerEvents.Stop)));
                }
                destroy() {
                    this._lottie && (this._lottie.destroy(), (this._lottie = null), (this.currentState = PlayerState.Destroyed), this.dispatchEvent(new CustomEvent(PlayerEvents.Destroyed)), this.remove());
                }
                seek(t) {
                    if (this._lottie) {
                        var e = /^(\d+)(%?)$/.exec(t.toString());
                        if (e) {
                            var r = "%" === e[2] ? (this._lottie.totalFrames * Number(e[1])) / 100 : Number(e[1]);
                            (this.seeker = r), this.currentState === PlayerState.Playing ? this._lottie.goToAndPlay(r, !0) : (this._lottie.goToAndStop(r, !0), this._lottie.pause());
                        }
                    }
                }
                snapshot() {
                    var t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                    if (this.shadowRoot) {
                        var e = this.shadowRoot.querySelector(".animation svg"),
                            r = new XMLSerializer().serializeToString(e);
                        if (t) {
                            var i = document.createElement("a");
                            (i.href = "data:image/svg+xml;charset=utf-8,".concat(encodeURIComponent(r))), (i.download = "download_".concat(this.seeker, ".svg")), document.body.appendChild(i), i.click(), document.body.removeChild(i);
                        }
                        return r;
                    }
                }
                setSpeed() {
                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
                    this._lottie && this._lottie.setSpeed(t);
                }
                setDirection(t) {
                    this._lottie && this._lottie.setDirection(t);
                }
                setLooping(t) {
                    this._lottie && ((this.loop = t), (this._lottie.loop = t));
                }
                togglePlay() {
                    return this.currentState === PlayerState.Playing ? this.pause() : this.play();
                }
                toggleLooping() {
                    this.setLooping(!this.loop);
                }
                resize() {
                    this._lottie && this._lottie.resize();
                }
                static get styles() {
                    return styles;
                }
                disconnectedCallback() {
                    this.isConnected || (this._io && (this._io.disconnect(), (this._io = void 0)), document.removeEventListener("visibilitychange", () => this._onVisibilityChange()), this.destroy());
                }
                render() {
                    var t = this.controls ? "main controls" : "main",
                        e = this.controls ? "animation controls" : "animation";
                    return $(
                        _templateObject ||
                            (_templateObject = _taggedTemplateLiteral([
                                ' <div\n      id="animation-container"\n      class=',
                                '\n      lang="en"\n      aria-label=',
                                '\n      role="img"\n    >\n      <div\n        id="animation"\n        class=',
                                '\n        style="background:',
                                ';"\n      >\n        ',
                                "\n      </div>\n      ",
                                "\n    </div>",
                            ])),
                        t,
                        this.description,
                        e,
                        this.background,
                        this.currentState === PlayerState.Error ? $(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(['<div class="error">⚠️</div>']))) : void 0,
                        this.controls && !this.disableShadowDOM ? this.renderControls() : void 0
                    );
                }
                createRenderRoot() {
                    return this.disableShadowDOM && (this.style.display = "block"), this.disableShadowDOM ? this : super.createRenderRoot();
                }
                firstUpdated() {
                    "IntersectionObserver" in window &&
                        ((this._io = new IntersectionObserver((t) => {
                            t[0].isIntersecting ? this.currentState === PlayerState.Frozen && this.play() : this.currentState === PlayerState.Playing && this.freeze();
                        })),
                        this._io.observe(this.container)),
                        void 0 !== document.hidden && document.addEventListener("visibilitychange", () => this._onVisibilityChange()),
                        this.src && this.load(this.src),
                        this.dispatchEvent(new CustomEvent(PlayerEvents.Rendered));
                }
                renderControls() {
                    var t = this.currentState === PlayerState.Playing,
                        e = this.currentState === PlayerState.Paused,
                        r = this.currentState === PlayerState.Stopped;
                    return $(
                        _templateObject3 ||
                            (_templateObject3 = _taggedTemplateLiteral([
                                '\n      <div\n        id="lottie-controls"\n        aria-label="lottie-animation-controls"\n        class="toolbar"\n      >\n        <button\n          id="lottie-play-button"\n          @click=',
                                "\n          class=",
                                '\n          style="align-items:center;"\n          tabindex="0"\n          aria-label="play-pause"\n        >\n          ',
                                '\n        </button>\n        <button\n          id="lottie-stop-button"\n          @click=',
                                "\n          class=",
                                '\n          style="align-items:center;"\n          tabindex="0"\n          aria-label="stop"\n        >\n          <svg width="24" height="24" aria-hidden="true" focusable="false">\n            <path d="M6 6h12v12H6V6z" />\n          </svg>\n        </button>\n        <input\n          id="lottie-seeker-input"\n          class="seeker"\n          type="range"\n          min="0"\n          step="1"\n          max="100"\n          .value=',
                                "\n          @input=",
                                "\n          @mousedown=",
                                "\n          @mouseup=",
                                '\n          aria-valuemin="1"\n          aria-valuemax="100"\n          role="slider"\n          aria-valuenow=',
                                '\n          tabindex="0"\n          aria-label="lottie-seek-input"\n        />\n        <button\n          id="lottie-loop-toggle"\n          @click=',
                                "\n          class=",
                                '\n          style="align-items:center;"\n          tabindex="0"\n          aria-label="loop-toggle"\n        >\n          <svg width="24" height="24" aria-hidden="true" focusable="false">\n            <path\n              d="M17.016 17.016v-4.031h1.969v6h-12v3l-3.984-3.984 3.984-3.984v3h10.031zM6.984 6.984v4.031H5.015v-6h12v-3l3.984 3.984-3.984 3.984v-3H6.984z"\n            />\n          </svg>\n        </button>\n      </div>\n    ',
                            ])),
                        this.togglePlay,
                        t || e ? "active" : "",
                        $(
                            t
                                ? _templateObject4 ||
                                      (_templateObject4 = _taggedTemplateLiteral([
                                          '<svg\n                width="24"\n                height="24"\n                aria-hidden="true"\n                focusable="false"\n              >\n                <path\n                  d="M14.016 5.016H18v13.969h-3.984V5.016zM6 18.984V5.015h3.984v13.969H6z"\n                />\n              </svg>',
                                      ]))
                                : _templateObject5 ||
                                      (_templateObject5 = _taggedTemplateLiteral([
                                          '<svg\n                width="24"\n                height="24"\n                aria-hidden="true"\n                focusable="false"\n              >\n                <path d="M8.016 5.016L18.985 12 8.016 18.984V5.015z" />\n              </svg>',
                                      ]))
                        ),
                        this.stop,
                        r ? "active" : "",
                        this.seeker,
                        this._handleSeekChange,
                        () => {
                            (this._prevState = this.currentState), this.freeze();
                        },
                        () => {
                            this._prevState === PlayerState.Playing && this.play();
                        },
                        this.seeker,
                        this.toggleLooping,
                        this.loop ? "active" : ""
                    );
                }
                _onVisibilityChange() {
                    !0 === document.hidden && this.currentState === PlayerState.Playing ? this.freeze() : this.currentState === PlayerState.Frozen && this.play();
                }
                _handleSeekChange(t) {
                    if (this._lottie && !isNaN(t.target.value)) {
                        var e = (t.target.value / 100) * this._lottie.totalFrames;
                        this.seek(e);
                    }
                }
                _attachEventListeners() {
                    this._lottie.addEventListener("enterFrame", () => {
                        (this.seeker = (this._lottie.currentFrame / this._lottie.totalFrames) * 100), this.dispatchEvent(new CustomEvent(PlayerEvents.Frame, { detail: { frame: this._lottie.currentFrame, seeker: this.seeker } }));
                    }),
                        this._lottie.addEventListener("complete", () => {
                            if (this.currentState === PlayerState.Playing) {
                                if (!this.loop || (this.count && this._counter >= this.count)) {
                                    if ((this.dispatchEvent(new CustomEvent(PlayerEvents.Complete)), this.mode !== PlayMode.Bounce)) return;
                                    if (0 === this._lottie.currentFrame) return;
                                }
                                this.mode === PlayMode.Bounce
                                    ? (this.count && (this._counter += 0.5),
                                      setTimeout(() => {
                                          this.dispatchEvent(new CustomEvent(PlayerEvents.Loop)), this.currentState === PlayerState.Playing && (this._lottie.setDirection(-1 * this._lottie.playDirection), this._lottie.play());
                                      }, this.intermission))
                                    : (this.count && (this._counter += 1),
                                      window.setTimeout(() => {
                                          this.dispatchEvent(new CustomEvent(PlayerEvents.Loop)),
                                              this.currentState === PlayerState.Playing && (-1 === this.direction ? (this.seek("99%"), this.play()) : (this._lottie.stop(), this._lottie.play()));
                                      }, this.intermission));
                            } else this.dispatchEvent(new CustomEvent(PlayerEvents.Complete));
                        }),
                        this._lottie.addEventListener("DOMLoaded", () => {
                            this.setSpeed(this.speed), this.setDirection(this.direction), this.autoplay && (-1 === this.direction && this.seek("100%"), this.play()), this.dispatchEvent(new CustomEvent(PlayerEvents.Ready));
                        }),
                        this._lottie.addEventListener("data_ready", () => {
                            this.dispatchEvent(new CustomEvent(PlayerEvents.Load));
                        }),
                        this._lottie.addEventListener("data_failed", () => {
                            (this.currentState = PlayerState.Error), this.dispatchEvent(new CustomEvent(PlayerEvents.Error));
                        }),
                        this.container.addEventListener("mouseenter", () => {
                            this.hover && this.currentState !== PlayerState.Playing && this.play();
                        }),
                        this.container.addEventListener("mouseleave", () => {
                            this.hover && this.currentState === PlayerState.Playing && this.stop();
                        });
                }
                freeze() {
                    this._lottie && (this._lottie.pause(), (this.currentState = PlayerState.Frozen), this.dispatchEvent(new CustomEvent(PlayerEvents.Freeze)));
                }
            };
            __decorate([e$5({ type: Boolean })], LottiePlayer.prototype, "autoplay", void 0),
                __decorate([e$5({ type: String, reflect: !0 })], LottiePlayer.prototype, "background", void 0),
                __decorate([e$5({ type: Boolean })], LottiePlayer.prototype, "controls", void 0),
                __decorate([e$5({ type: Number })], LottiePlayer.prototype, "count", void 0),
                __decorate([e$5({ type: String })], LottiePlayer.prototype, "currentState", void 0),
                __decorate([e$5({ type: String })], LottiePlayer.prototype, "description", void 0),
                __decorate([e$5({ type: Number })], LottiePlayer.prototype, "direction", void 0),
                __decorate([e$5({ type: Boolean })], LottiePlayer.prototype, "disableCheck", void 0),
                __decorate([e$5({ type: Boolean })], LottiePlayer.prototype, "disableShadowDOM", void 0),
                __decorate([e$5({ type: Boolean })], LottiePlayer.prototype, "hover", void 0),
                __decorate([e$5()], LottiePlayer.prototype, "intermission", void 0),
                __decorate([e$5({ type: Boolean, reflect: !0 })], LottiePlayer.prototype, "loop", void 0),
                __decorate([e$5()], LottiePlayer.prototype, "mode", void 0),
                __decorate([e$5({ type: String })], LottiePlayer.prototype, "preserveAspectRatio", void 0),
                __decorate([e$5({ type: String })], LottiePlayer.prototype, "renderer", void 0),
                __decorate([e$5({ type: String })], LottiePlayer.prototype, "viewBoxSize", void 0),
                __decorate([e$5()], LottiePlayer.prototype, "seeker", void 0),
                __decorate([e$5({ type: Number })], LottiePlayer.prototype, "speed", void 0),
                __decorate([e$5({ type: String })], LottiePlayer.prototype, "src", void 0),
                __decorate([e$5({ type: Boolean })], LottiePlayer.prototype, "webworkers", void 0),
                __decorate([i(".animation")], LottiePlayer.prototype, "container", void 0),
                (LottiePlayer = __decorate([n$1("lottie-player")], LottiePlayer));
        },
        9582: function (t, e, r) {
            "use strict";
            var i =
                (this && this.__awaiter) ||
                function (t, e, r, i) {
                    return new (r || (r = Promise))(function (n, a) {
                        function s(t) {
                            try {
                                l(i.next(t));
                            } catch (t) {
                                a(t);
                            }
                        }
                        function o(t) {
                            try {
                                l(i.throw(t));
                            } catch (t) {
                                a(t);
                            }
                        }
                        function l(t) {
                            var e;
                            t.done
                                ? n(t.value)
                                : ((e = t.value),
                                  e instanceof r
                                      ? e
                                      : new r(function (t) {
                                            t(e);
                                        })).then(s, o);
                        }
                        l((i = i.apply(t, e || [])).next());
                    });
                };
            Object.defineProperty(e, "__esModule", { value: !0 }), (e.cartAdd = void 0);
            const n = r(5982),
                a = r(6592),
                s = r(6730);
            class o extends a.SlateCustomEvent {
                constructor(t) {
                    super(n.ON_ITEM_ADDED, { bubbles: !0, cancelable: !1, detail: { items: t } });
                }
            }
            e.cartAdd = (t) =>
                (0, n.cartQueue)(() =>
                    i(void 0, void 0, void 0, function* () {
                        try {
                            const e = yield fetch((0, s.cartBundledSectionGetQueryParams)("/cart/add.js"), { method: "POST", body: JSON.stringify(t), headers: { "Content-Type": "application/json" } }).then((t) => t.json());
                            return (0, n.cartQueueNext)({ fetched: !1, sections: !0, response: e, strEvent: n.ON_ITEM_ADDED, event: new o(e.items) });
                        } catch (t) {
                            throw ((0, n.cartQueueError)(t), t);
                        }
                    })
                );
        },
        4735: function (t, e, r) {
            "use strict";
            var i =
                (this && this.__awaiter) ||
                function (t, e, r, i) {
                    return new (r || (r = Promise))(function (n, a) {
                        function s(t) {
                            try {
                                l(i.next(t));
                            } catch (t) {
                                a(t);
                            }
                        }
                        function o(t) {
                            try {
                                l(i.throw(t));
                            } catch (t) {
                                a(t);
                            }
                        }
                        function l(t) {
                            var e;
                            t.done
                                ? n(t.value)
                                : ((e = t.value),
                                  e instanceof r
                                      ? e
                                      : new r(function (t) {
                                            t(e);
                                        })).then(s, o);
                        }
                        l((i = i.apply(t, e || [])).next());
                    });
                };
            Object.defineProperty(e, "__esModule", { value: !0 }), (e.cartChange = e.EventCartChanged = void 0);
            const n = r(5982),
                a = r(6592),
                s = r(6730);
            class o extends a.SlateCustomEvent {
                constructor(t) {
                    super(n.ON_ITEM_CHANGED, { bubbles: !0, cancelable: !1, detail: { cart: t } });
                }
            }
            e.EventCartChanged = o;
            e.cartChange = (t) =>
                (0, n.cartQueue)(() =>
                    i(void 0, void 0, void 0, function* () {
                        try {
                          console.log('t==>',t)
                            const e = yield fetch((0, s.cartBundledSectionGetQueryParams)("/cart/change.js"), { method: "POST", body: JSON.stringify(t), headers: { "Content-Type": "application/json" } }).then((t) => t.json());
                            return (0, n.cartQueueNext)({ fetched: !0, sections: !0, response: e, strEvent: n.ON_ITEM_CHANGED, event: new o(e) });
                        } catch (t) {
                            throw ((0, n.cartQueueError)(t), t);
                        }
                    })
                );
        },
        6874: function (t, e, r) {
            "use strict";
            var i =
                (this && this.__awaiter) ||
                function (t, e, r, i) {
                    return new (r || (r = Promise))(function (n, a) {
                        function s(t) {
                            try {
                                l(i.next(t));
                            } catch (t) {
                                a(t);
                            }
                        }
                        function o(t) {
                            try {
                                l(i.throw(t));
                            } catch (t) {
                                a(t);
                            }
                        }
                        function l(t) {
                            var e;
                            t.done
                                ? n(t.value)
                                : ((e = t.value),
                                  e instanceof r
                                      ? e
                                      : new r(function (t) {
                                            t(e);
                                        })).then(s, o);
                        }
                        l((i = i.apply(t, e || [])).next());
                    });
                };
            Object.defineProperty(e, "__esModule", { value: !0 }), (e.cartClear = void 0);
            const n = r(5982),
                a = r(6592),
                s = r(6730);
            class o extends a.SlateCustomEvent {
                constructor(t) {
                    super(n.ON_CART_CLEARED, { bubbles: !0, cancelable: !1, detail: { cart: t } });
                }
            }
            e.cartClear = () =>
                (0, n.cartQueue)(() =>
                    i(void 0, void 0, void 0, function* () {
                        try {
                            const t = yield fetch((0, s.cartBundledSectionGetQueryParams)("/cart/clear.js"), { method: "POST", headers: { "Content-Type": "application/json" } }).then((t) => t.json());
                            return (0, n.cartQueueNext)({ fetched: !0, sections: !0, response: t, strEvent: n.ON_CART_CLEARED, event: new o(t) });
                        } catch (t) {
                            throw ((0, n.cartQueueError)(t), t);
                        }
                    })
                );
        },
        4726: function (t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", { value: !0 }), (e.cartGetQuantityOfVariant = e.cartGetCountOfVariant = e.cartGetVariant = void 0);
            const i = r(9719);
            e.cartGetVariant = (t) => (0, i.cartGetCurrent)().items.filter((e) => e.variant_id === t);
            e.cartGetCountOfVariant = (t) => (0, e.cartGetVariant)(t).length;
            e.cartGetQuantityOfVariant = (t) => (0, e.cartGetVariant)(t).reduce((t, e) => t + e.quantity, 0);
        },
        8505: function (t, e) {
            "use strict";
            Object.defineProperty(e, "__esModule", { value: !0 }),
                (e.ON_ITEM_CHANGED = e.ON_ITEM_REMOVED = e.ON_ITEM_ADDED = e.ON_CART_SECTION_FETCHED = e.ON_CART_CLEARED = e.ON_CART_FETCHED = e.ON_CART_UPDATED = e.ON_CART_PENDING = e.ON_CART_FINISHED = void 0),
                (e.ON_CART_FINISHED = "onCartFinished"),
                (e.ON_CART_PENDING = "onCartPending"),
                (e.ON_CART_UPDATED = "onCartUpdated"),
                (e.ON_CART_FETCHED = "onCartFetched"),
                (e.ON_CART_CLEARED = "onCartCleared"),
                (e.ON_CART_SECTION_FETCHED = "onCartSectionFetched"),
                (e.ON_ITEM_ADDED = "onCartAdded"),
                (e.ON_ITEM_REMOVED = "onItemRemoved"),
                (e.ON_ITEM_CHANGED = "onItemChanged");
        },
        9719: function (t, e, r) {
            "use strict";
            var i =
                (this && this.__awaiter) ||
                function (t, e, r, i) {
                    return new (r || (r = Promise))(function (n, a) {
                        function s(t) {
                            try {
                                l(i.next(t));
                            } catch (t) {
                                a(t);
                            }
                        }
                        function o(t) {
                            try {
                                l(i.throw(t));
                            } catch (t) {
                                a(t);
                            }
                        }
                        function l(t) {
                            var e;
                            t.done
                                ? n(t.value)
                                : ((e = t.value),
                                  e instanceof r
                                      ? e
                                      : new r(function (t) {
                                            t(e);
                                        })).then(s, o);
                        }
                        l((i = i.apply(t, e || [])).next());
                    });
                };
            Object.defineProperty(e, "__esModule", { value: !0 }), (e.cartGetCurrent = e.cartGet = e.EventCartFetched = void 0);
            const n = r(5982),
                a = r(6592);
            class s extends a.SlateCustomEvent {
                constructor(t) {
                    super(n.ON_CART_FETCHED, { bubbles: !0, cancelable: !1, detail: { cart: t } });
                }
            }
            e.EventCartFetched = s;
            e.cartGet = () =>
                (0, n.cartQueue)(() =>
                    i(void 0, void 0, void 0, function* () {
                        try {
                            const t = yield fetch("/cart.js", { method: "GET", headers: { "Content-Type": "application/json" } }).then((t) => t.json());
                            return (0, n.cartQueueNext)({ fetched: !0, sections: !1, response: t, strEvent: null, event: null });
                        } catch (t) {
                            throw ((0, n.cartQueueError)(t), t);
                        }
                    })
                );
            e.cartGetCurrent = () => a.GLOBAL_SELF.Cart.data;
        },
        5982: function (t, e, r) {
            "use strict";
            var i =
                    (this && this.__createBinding) ||
                    (Object.create
                        ? function (t, e, r, i) {
                              void 0 === i && (i = r);
                              var n = Object.getOwnPropertyDescriptor(e, r);
                              (n && !("get" in n ? !e.__esModule : n.writable || n.configurable)) ||
                                  (n = {
                                      enumerable: !0,
                                      get: function () {
                                          return e[r];
                                      },
                                  }),
                                  Object.defineProperty(t, i, n);
                          }
                        : function (t, e, r, i) {
                              void 0 === i && (i = r), (t[i] = e[r]);
                          }),
                n =
                    (this && this.__exportStar) ||
                    function (t, e) {
                        for (var r in t) "default" === r || Object.prototype.hasOwnProperty.call(e, r) || i(e, t, r);
                    };
            Object.defineProperty(e, "__esModule", { value: !0 }), n(r(8505), e), n(r(5751), e), n(r(9582), e), n(r(4735), e), n(r(6874), e), n(r(4726), e), n(r(9719), e), n(r(4089), e), n(r(1959), e), n(r(6730), e);
        },
        5751: function (t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", { value: !0 }), (e.cartQueueError = e.cartQueueNext = e.cartQueue = e.EventCartSectionsFetched = e.EventCartQueueStarted = e.EventCartQueueFinished = void 0);
            const i = r(5982),
                n = r(6592),
                a = r(8505);
            (n.GLOBAL_SELF.Cart = n.GLOBAL_SELF.Cart || {}), (n.GLOBAL_SELF.Cart.queue = n.GLOBAL_SELF.Cart.queue || {}), (n.GLOBAL_SELF.Cart.queue.items = n.GLOBAL_SELF.Cart.queue.items || []);
            class s extends n.SlateCustomEvent {
                constructor(t) {
                    super(i.ON_CART_FINISHED, { bubbles: !0, cancelable: !1, detail: { cart: t } });
                }
            }
            e.EventCartQueueFinished = s;
            class o extends n.SlateCustomEvent {
                constructor() {
                    super(i.ON_CART_PENDING, { bubbles: !0, cancelable: !1, detail: {} });
                }
            }
            e.EventCartQueueStarted = o;
            class l extends n.SlateCustomEvent {
                constructor(t) {
                    super(a.ON_CART_SECTION_FETCHED, { bubbles: !0, cancelable: !1, detail: { sections: t } });
                }
            }
            e.EventCartSectionsFetched = l;
            e.cartQueue = (t) => {
                const e = { callable: t };
                n.GLOBAL_SELF.Cart.queue.items.push(e);
                const r = new Promise((t, r) => {
                    (e.resolver = t), (e.rejecter = r);
                });
                if (1 === n.GLOBAL_SELF.Cart.queue.items.length) {
                    n.GLOBAL_SELF.Cart.queue.needsFetching = !1;
                    const t = n.GLOBAL_SELF.Cart.queue.items[0];
                    t.callable().then(t.resolver).catch(t.rejecter), n.jQuery && (0, n.jQuery)(document).trigger(i.ON_CART_PENDING), document.dispatchEvent(new o());
                }
                return r;
            };
            e.cartQueueNext = (t) => {
                const { strEvent: e, response: r, event: o } = t,
                    h = r;
                if (h && h.status) throw h.description || h.message || h;
                if ((n.GLOBAL_SELF.Cart.queue.items.splice(0, 1), e && n.jQuery && (0, n.jQuery)(document).trigger(e, r), o && document.dispatchEvent(o), void 0 !== r.sections)) {
                    const t = r;
                    n.jQuery && (0, n.jQuery)(document).trigger(a.ON_CART_SECTION_FETCHED, { sections: t.sections }), document.dispatchEvent(new l(t.sections));
                }
                if (
                    (t.fetched
                        ? (n.jQuery && (0, n.jQuery)(document).trigger(i.ON_CART_FETCHED, r), document.dispatchEvent(new i.EventCartFetched(t.response)), (n.GLOBAL_SELF.Cart.data = t.response))
                        : (n.GLOBAL_SELF.Cart.queue.needsFetching = !0),
                    n.GLOBAL_SELF.Cart.queue.items.length)
                ) {
                    const t = n.GLOBAL_SELF.Cart.queue.items[0];
                    return t.callable().then(t.resolver).catch(t.rejecter), r;
                }
                return n.GLOBAL_SELF.Cart.queue.needsFetching
                    ? ((0, i.cartGet)().catch(console.error), r)
                    : (n.jQuery && (0, n.jQuery)(document).trigger(i.ON_CART_FINISHED, n.GLOBAL_SELF.Cart.data), document.dispatchEvent(new s(n.GLOBAL_SELF.Cart.data)), r);
            };
            e.cartQueueError = (t) => {
                console.error(t),
                    n.GLOBAL_SELF.Cart.queue.items.forEach((e) => {
                        e.rejecter && e.rejecter(t);
                    }),
                    (n.GLOBAL_SELF.Cart.queue.items = []),
                    (0, i.cartGet)();
            };
        },
        4089: function (t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", { value: !0 }), (e.cartRemoveLines = e.cartRemove = void 0);
            const i = r(5982);
            e.cartRemove = (t) => (0, i.cartChange)({ line: t, quantity: 0 });
            e.cartRemoveLines = (t) => (0, i.cartUpdate)({ updates: (0, i.cartGetCurrent)().items.reduce((e, r, i) => (t.some((t) => t === i) ? e.push(0) : e.push(r.quantity), e), []) });
        },
        6730: function (t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", { value: !0 }), (e.cartBundledSectionGetQueryParams = e.cartBundledSectionRemove = e.cartBundledSectionAdd = e.cartBundledSectionsSet = e.cartBundledSectionsGet = void 0);
            const i = r(2561);
            e.cartBundledSectionsGet = () => window.CART_BUNDLED_SECTIONS || [];
            e.cartBundledSectionsSet = (t) => {
                window.CART_BUNDLED_SECTIONS = t;
            };
            e.cartBundledSectionAdd = (t) => {
                const r = (0, e.cartBundledSectionsGet)();
                -1 === r.indexOf(t) && (r.push(t), (0, e.cartBundledSectionsSet)(r));
            };
            e.cartBundledSectionRemove = (t) => {
                const r = (0, e.cartBundledSectionsGet)(),
                    i = r.indexOf(t);
                -1 !== i && (r.splice(i, 1), (0, e.cartBundledSectionsSet)(r));
            };
            e.cartBundledSectionGetQueryParams = (t) => `${t}?${(0, i.queryEncodeString)({ sections: (0, e.cartBundledSectionsGet)() })}`;
        },
        1959: function (t, e, r) {
            "use strict";
            var i =
                (this && this.__awaiter) ||
                function (t, e, r, i) {
                    return new (r || (r = Promise))(function (n, a) {
                        function s(t) {
                            try {
                                l(i.next(t));
                            } catch (t) {
                                a(t);
                            }
                        }
                        function o(t) {
                            try {
                                l(i.throw(t));
                            } catch (t) {
                                a(t);
                            }
                        }
                        function l(t) {
                            var e;
                            t.done
                                ? n(t.value)
                                : ((e = t.value),
                                  e instanceof r
                                      ? e
                                      : new r(function (t) {
                                            t(e);
                                        })).then(s, o);
                        }
                        l((i = i.apply(t, e || [])).next());
                    });
                };
            Object.defineProperty(e, "__esModule", { value: !0 }), (e.cartUpdate = void 0);
            const n = r(5982),
                a = r(6592),
                s = r(6730);
            class o extends a.SlateCustomEvent {
                constructor(t) {
                    super(n.ON_CART_UPDATED, { bubbles: !0, cancelable: !1, detail: { cart: t } });
                }
            }
            e.cartUpdate = (t) =>
                (0, n.cartQueue)(() =>
                    i(void 0, void 0, void 0, function* () {
                        try {
                            const e = yield fetch((0, s.cartBundledSectionGetQueryParams)("/cart/update.js"), { method: "POST", body: JSON.stringify(t), headers: { "Content-Type": "application/json" } }).then((t) => t.json());
                            return (0, n.cartQueueNext)({ fetched: !0, sections: !0, response: e, strEvent: n.ON_CART_UPDATED, event: new o(e) });
                        } catch (t) {
                            throw ((0, n.cartQueueError)(t), t);
                        }
                    })
                );
        },
        3585: function (t, e) {
            "use strict";
            Object.defineProperty(e, "__esModule", { value: !0 }), (e.refreshCheckout = void 0);
            e.refreshCheckout = () =>
                new Promise((t, e) => {
                    try {
                        window.OrderSummaryUpdater.prototype.refresh(() => {
                            t();
                        });
                    } catch (t) {
                        e(t);
                    }
                });
        },
        5493: function (t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", { value: !0 }),
                (e.convert = e.setUserCurrency = e.getUserCurrency = e.getShopCurrency = e.currencyConvert = e.currencySetUser = e.currencyGetUser = e.currencyGetShop = e.ON_CURRENCY_CHANGE = e.CURRENCY_COOKIE_NAME = void 0);
            const i = r(6112),
                n = r(6592);
            (e.CURRENCY_COOKIE_NAME = "currency"), (e.ON_CURRENCY_CHANGE = "onCurrencyChange");
            e.currencyGetShop = () => {
                let t = n.GLOBAL_SELF.Currency;
                if (!t || !t.currency) throw new Error("You have not defined your shops currency onto window.Currency.currency!");
                return t.currency;
            };
            e.currencyGetUser = () => (i.get(e.CURRENCY_COOKIE_NAME) ? i.get(e.CURRENCY_COOKIE_NAME) : (0, e.currencyGetShop)());
            e.currencySetUser = (t) => {
                if ((0, e.currencyGetUser)() === t) return;
                i.set(e.CURRENCY_COOKIE_NAME, t), n.jQuery && (0, n.jQuery)(document).trigger(e.ON_CURRENCY_CHANGE, t);
                const r = new n.SlateCustomEvent(e.ON_CURRENCY_CHANGE);
                document.dispatchEvent(r);
            };
            e.currencyConvert = (t) => {
                let { money: r, from: i, to: a } = t,
                    s = n.GLOBAL_SELF.Currency;
                if (((i = i || (0, e.currencyGetShop)()), (a = a || (0, e.currencyGetUser)()), i === a)) return r;
                if (!s || !s.convert) throw new Error("You havent imported the Shopify currencies script in your header scripts!");
                return s.convert(r, i, a);
            };
            e.getShopCurrency = () => (0, e.currencyGetShop)();
            e.getUserCurrency = () => (0, e.currencyGetUser)();
            e.setUserCurrency = (t) => (0, e.currencySetUser)(t);
            e.convert = (t, r, i) => (0, e.currencyConvert)({ money: t, from: r, to: i });
        },
        837: function (t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", { value: !0 }), (e.currencyPrintMoney = e.printMoney = e.getFormat = e.formatMoney = void 0);
            const i = r(6592),
                n = r(5493),
                a = r(546);
            e.formatMoney = (t, e) => {
                if (i.GLOBAL_SELF.Shopify && i.GLOBAL_SELF.Shopify.formatMoney) return i.GLOBAL_SELF.Shopify.formatMoney(t, e);
                "string" == typeof t && (t = t.replace(".", ""));
                let r = "",
                    n = /\{\{\s*(\w+)\s*\}\}/,
                    a = e || "${{amount}}",
                    s = (t, e = 2, r = ",", i = ".") => {
                        let n = parseFloat(t);
                        if (isNaN(n) || null == t) return "0";
                        let a = (t = (n / 100).toFixed(e)).split(".");
                        return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + r) + (a[1] ? i + a[1] : "");
                    };
                const o = a.match(n);
                if (!o) return r;
                switch (o[1]) {
                    case "amount":
                        r = s(t.toString(), 2);
                        break;
                    case "amount_no_decimals":
                        r = s(t.toString(), 0);
                        break;
                    case "amount_with_comma_separator":
                        r = s(t.toString(), 2, ".", ",");
                        break;
                    case "amount_no_decimals_with_comma_separator":
                        r = s(t.toString(), 0, ".", ",");
                }
                return a.replace(n, r);
            };
            e.getFormat = (t, e) => {
                let r = t || (0, n.currencyGetUser)();
                if (!e) {
                    let t = i.GLOBAL_SELF.Currency ? i.GLOBAL_SELF.Currency : null;
                    if (r != (0, n.getShopCurrency)()) e = t && t.convertedFormat ? t.convertedFormat : "money_with_currency_format";
                    else {
                        if (t && t.shopFormat && r == (0, n.currencyGetShop)()) return t.shopFormat;
                        if (t && t.format) return t.format;
                        e = "money_format";
                    }
                }
                let s = a.MONEY_FORMATS[r];
                return s[e] ? s[e] : s.money_with_currency_format;
            };
            e.printMoney = (t, r, i) => (0, e.currencyPrintMoney)({ money: t, format: r, currency: i });
            e.currencyPrintMoney = (t) => {
                let { currency: r, format: i, money: a } = t;
                r = r || (0, n.currencyGetUser)();
                let s = (0, e.getFormat)(r, i),
                    o = (0, n.currencyConvert)({ money: a, to: r });
                return (0, e.formatMoney)(o, s);
            };
        },
        546: function (t, e) {
            "use strict";
            Object.defineProperty(e, "__esModule", { value: !0 }),
                (e.MONEY_FORMATS = void 0),
                (e.MONEY_FORMATS = {
                    USD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} USD" },
                    EUR: { money_format: "&euro;{{amount}}", money_with_currency_format: "&euro;{{amount}} EUR" },
                    GBP: { money_format: "&pound;{{amount}}", money_with_currency_format: "&pound;{{amount}} GBP" },
                    CAD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} CAD" },
                    ALL: { money_format: "Lek {{amount}}", money_with_currency_format: "Lek {{amount}} ALL" },
                    DZD: { money_format: "DA {{amount}}", money_with_currency_format: "DA {{amount}} DZD" },
                    AOA: { money_format: "Kz{{amount}}", money_with_currency_format: "Kz{{amount}} AOA" },
                    ARS: { money_format: "${{amount_with_comma_separator}}", money_with_currency_format: "${{amount_with_comma_separator}} ARS" },
                    AMD: { money_format: "{{amount}} AMD", money_with_currency_format: "{{amount}} AMD" },
                    AWG: { money_format: "Afl{{amount}}", money_with_currency_format: "Afl{{amount}} AWG" },
                    AUD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} AUD" },
                    BBD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} Bds" },
                    AZN: { money_format: "m.{{amount}}", money_with_currency_format: "m.{{amount}} AZN" },
                    BDT: { money_format: "Tk {{amount}}", money_with_currency_format: "Tk {{amount}} BDT" },
                    BSD: { money_format: "BS${{amount}}", money_with_currency_format: "BS${{amount}} BSD" },
                    BHD: { money_format: "{{amount}}0 BD", money_with_currency_format: "{{amount}}0 BHD" },
                    BYR: { money_format: "Br {{amount}}", money_with_currency_format: "Br {{amount}} BYR" },
                    BZD: { money_format: "BZ${{amount}}", money_with_currency_format: "BZ${{amount}} BZD" },
                    BTN: { money_format: "Nu {{amount}}", money_with_currency_format: "Nu {{amount}} BTN" },
                    BAM: { money_format: "KM {{amount_with_comma_separator}}", money_with_currency_format: "KM {{amount_with_comma_separator}} BAM" },
                    BRL: { money_format: "R$ {{amount_with_comma_separator}}", money_with_currency_format: "R$ {{amount_with_comma_separator}} BRL" },
                    BOB: { money_format: "Bs{{amount_with_comma_separator}}", money_with_currency_format: "Bs{{amount_with_comma_separator}} BOB" },
                    BWP: { money_format: "P{{amount}}", money_with_currency_format: "P{{amount}} BWP" },
                    BND: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} BND" },
                    BGN: { money_format: "{{amount}} Ð»Ð²", money_with_currency_format: "{{amount}} Ð»Ð² BGN" },
                    MMK: { money_format: "K{{amount}}", money_with_currency_format: "K{{amount}} MMK" },
                    KHR: { money_format: "KHR{{amount}}", money_with_currency_format: "KHR{{amount}}" },
                    KYD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} KYD" },
                    XAF: { money_format: "FCFA{{amount}}", money_with_currency_format: "FCFA{{amount}} XAF" },
                    CLP: { money_format: "${{amount_no_decimals}}", money_with_currency_format: "${{amount_no_decimals}} CLP" },
                    CNY: { money_format: "&#165;{{amount}}", money_with_currency_format: "&#165;{{amount}} CNY" },
                    COP: { money_format: "${{amount_with_comma_separator}}", money_with_currency_format: "${{amount_with_comma_separator}} COP" },
                    CRC: { money_format: "&#8353; {{amount_with_comma_separator}}", money_with_currency_format: "&#8353; {{amount_with_comma_separator}} CRC" },
                    HRK: { money_format: "{{amount_with_comma_separator}} kn", money_with_currency_format: "{{amount_with_comma_separator}} kn HRK" },
                    CZK: { money_format: "{{amount_with_comma_separator}} K&#269;", money_with_currency_format: "{{amount_with_comma_separator}} K&#269;" },
                    DKK: { money_format: "{{amount_with_comma_separator}}", money_with_currency_format: "kr.{{amount_with_comma_separator}}" },
                    DOP: { money_format: "RD$ {{amount}}", money_with_currency_format: "RD$ {{amount}}" },
                    XCD: { money_format: "${{amount}}", money_with_currency_format: "EC${{amount}}" },
                    EGP: { money_format: "LE {{amount}}", money_with_currency_format: "LE {{amount}} EGP" },
                    ETB: { money_format: "Br{{amount}}", money_with_currency_format: "Br{{amount}} ETB" },
                    XPF: { money_format: "{{amount_no_decimals_with_comma_separator}} XPF", money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} XPF" },
                    FJD: { money_format: "${{amount}}", money_with_currency_format: "FJ${{amount}}" },
                    GMD: { money_format: "D {{amount}}", money_with_currency_format: "D {{amount}} GMD" },
                    GHS: { money_format: "GH&#8373;{{amount}}", money_with_currency_format: "GH&#8373;{{amount}}" },
                    GTQ: { money_format: "Q{{amount}}", money_with_currency_format: "{{amount}} GTQ" },
                    GYD: { money_format: "G${{amount}}", money_with_currency_format: "${{amount}} GYD" },
                    GEL: { money_format: "{{amount}} GEL", money_with_currency_format: "{{amount}} GEL" },
                    HNL: { money_format: "L {{amount}}", money_with_currency_format: "L {{amount}} HNL" },
                    HKD: { money_format: "${{amount}}", money_with_currency_format: "HK${{amount}}" },
                    HUF: { money_format: "{{amount_no_decimals_with_comma_separator}}", money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} Ft" },
                    ISK: { money_format: "{{amount_no_decimals}} kr", money_with_currency_format: "{{amount_no_decimals}} kr ISK" },
                    INR: { money_format: "Rs. {{amount}}", money_with_currency_format: "Rs. {{amount}}" },
                    IDR: { money_format: "{{amount_with_comma_separator}}", money_with_currency_format: "Rp {{amount_with_comma_separator}}" },
                    ILS: { money_format: "{{amount}} NIS", money_with_currency_format: "{{amount}} NIS" },
                    JMD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} JMD" },
                    JPY: { money_format: "&#165;{{amount_no_decimals}}", money_with_currency_format: "&#165;{{amount_no_decimals}} JPY" },
                    JEP: { money_format: "&pound;{{amount}}", money_with_currency_format: "&pound;{{amount}} JEP" },
                    JOD: { money_format: "{{amount}}0 JD", money_with_currency_format: "{{amount}}0 JOD" },
                    KZT: { money_format: "{{amount}} KZT", money_with_currency_format: "{{amount}} KZT" },
                    KES: { money_format: "KSh{{amount}}", money_with_currency_format: "KSh{{amount}}" },
                    KWD: { money_format: "{{amount}}0 KD", money_with_currency_format: "{{amount}}0 KWD" },
                    KGS: { money_format: "Ð»Ð²{{amount}}", money_with_currency_format: "Ð»Ð²{{amount}}" },
                    LVL: { money_format: "Ls {{amount}}", money_with_currency_format: "Ls {{amount}} LVL" },
                    LBP: { money_format: "L&pound;{{amount}}", money_with_currency_format: "L&pound;{{amount}} LBP" },
                    LTL: { money_format: "{{amount}} Lt", money_with_currency_format: "{{amount}} Lt" },
                    MGA: { money_format: "Ar {{amount}}", money_with_currency_format: "Ar {{amount}} MGA" },
                    MKD: { money_format: "Ð´ÐµÐ½ {{amount}}", money_with_currency_format: "Ð´ÐµÐ½ {{amount}} MKD" },
                    MOP: { money_format: "MOP${{amount}}", money_with_currency_format: "MOP${{amount}}" },
                    MVR: { money_format: "Rf{{amount}}", money_with_currency_format: "Rf{{amount}} MRf" },
                    MXN: { money_format: "$ {{amount}}", money_with_currency_format: "$ {{amount}} MXN" },
                    MYR: { money_format: "RM{{amount}} MYR", money_with_currency_format: "RM{{amount}} MYR" },
                    MUR: { money_format: "Rs {{amount}}", money_with_currency_format: "Rs {{amount}} MUR" },
                    MDL: { money_format: "{{amount}} MDL", money_with_currency_format: "{{amount}} MDL" },
                    MAD: { money_format: "{{amount}} dh", money_with_currency_format: "Dh {{amount}} MAD" },
                    MNT: { money_format: "{{amount_no_decimals}} &#8366", money_with_currency_format: "{{amount_no_decimals}} MNT" },
                    MZN: { money_format: "{{amount}} Mt", money_with_currency_format: "Mt {{amount}} MZN" },
                    NAD: { money_format: "N${{amount}}", money_with_currency_format: "N${{amount}} NAD" },
                    NPR: { money_format: "Rs{{amount}}", money_with_currency_format: "Rs{{amount}} NPR" },
                    ANG: { money_format: "&fnof;{{amount}}", money_with_currency_format: "{{amount}} NA&fnof;" },
                    NZD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} NZD" },
                    NIO: { money_format: "C${{amount}}", money_with_currency_format: "C${{amount}} NIO" },
                    NGN: { money_format: "&#8358;{{amount}}", money_with_currency_format: "&#8358;{{amount}} NGN" },
                    NOK: { money_format: "kr {{amount_with_comma_separator}}", money_with_currency_format: "kr {{amount_with_comma_separator}} NOK" },
                    OMR: { money_format: "{{amount_with_comma_separator}} OMR", money_with_currency_format: "{{amount_with_comma_separator}} OMR" },
                    PKR: { money_format: "Rs.{{amount}}", money_with_currency_format: "Rs.{{amount}} PKR" },
                    PGK: { money_format: "K {{amount}}", money_with_currency_format: "K {{amount}} PGK" },
                    PYG: { money_format: "Gs. {{amount_no_decimals_with_comma_separator}}", money_with_currency_format: "Gs. {{amount_no_decimals_with_comma_separator}} PYG" },
                    PEN: { money_format: "S/. {{amount}}", money_with_currency_format: "S/. {{amount}} PEN" },
                    PHP: { money_format: "&#8369;{{amount}}", money_with_currency_format: "&#8369;{{amount}} PHP" },
                    PLN: { money_format: "{{amount_with_comma_separator}} zl", money_with_currency_format: "{{amount_with_comma_separator}} zl PLN" },
                    QAR: { money_format: "QAR {{amount_with_comma_separator}}", money_with_currency_format: "QAR {{amount_with_comma_separator}}" },
                    RON: { money_format: "{{amount_with_comma_separator}} lei", money_with_currency_format: "{{amount_with_comma_separator}} lei RON" },
                    RUB: { money_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}", money_with_currency_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB" },
                    RWF: { money_format: "{{amount_no_decimals}} RF", money_with_currency_format: "{{amount_no_decimals}} RWF" },
                    WST: { money_format: "WS$ {{amount}}", money_with_currency_format: "WS$ {{amount}} WST" },
                    SAR: { money_format: "{{amount}} SR", money_with_currency_format: "{{amount}} SAR" },
                    STD: { money_format: "Db {{amount}}", money_with_currency_format: "Db {{amount}} STD" },
                    RSD: { money_format: "{{amount}} RSD", money_with_currency_format: "{{amount}} RSD" },
                    SCR: { money_format: "Rs {{amount}}", money_with_currency_format: "Rs {{amount}} SCR" },
                    SGD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} SGD" },
                    SYP: { money_format: "S&pound;{{amount}}", money_with_currency_format: "S&pound;{{amount}} SYP" },
                    ZAR: { money_format: "R {{amount}}", money_with_currency_format: "R {{amount}} ZAR" },
                    KRW: { money_format: "&#8361;{{amount_no_decimals}}", money_with_currency_format: "&#8361;{{amount_no_decimals}} KRW" },
                    LKR: { money_format: "Rs {{amount}}", money_with_currency_format: "Rs {{amount}} LKR" },
                    SEK: { money_format: "{{amount_no_decimals}} kr", money_with_currency_format: "{{amount_no_decimals}} kr SEK" },
                    CHF: { money_format: "SFr. {{amount}}", money_with_currency_format: "SFr. {{amount}} CHF" },
                    TWD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} TWD" },
                    THB: { money_format: "{{amount}} &#xe3f;", money_with_currency_format: "{{amount}} &#xe3f; THB" },
                    TZS: { money_format: "{{amount}} TZS", money_with_currency_format: "{{amount}} TZS" },
                    TTD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} TTD" },
                    TND: { money_format: "{{amount}}", money_with_currency_format: "{{amount}} DT" },
                    TRY: { money_format: "{{amount}}TL", money_with_currency_format: "{{amount}}TL" },
                    UGX: { money_format: "Ush {{amount_no_decimals}}", money_with_currency_format: "Ush {{amount_no_decimals}} UGX" },
                    UAH: { money_format: "â‚´{{amount}}", money_with_currency_format: "â‚´{{amount}} UAH" },
                    AED: { money_format: "Dhs. {{amount}}", money_with_currency_format: "Dhs. {{amount}} AED" },
                    UYU: { money_format: "${{amount_with_comma_separator}}", money_with_currency_format: "${{amount_with_comma_separator}} UYU" },
                    VUV: { money_format: "${{amount}}", money_with_currency_format: "${{amount}}VT" },
                    VEF: { money_format: "Bs. {{amount_with_comma_separator}}", money_with_currency_format: "Bs. {{amount_with_comma_separator}} VEF" },
                    VND: { money_format: "{{amount_no_decimals_with_comma_separator}}&#8363;", money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} VND" },
                    XBT: { money_format: "{{amount_no_decimals}} BTC", money_with_currency_format: "{{amount_no_decimals}} BTC" },
                    XOF: { money_format: "CFA{{amount}}", money_with_currency_format: "CFA{{amount}} XOF" },
                    ZMW: { money_format: "K{{amount_no_decimals_with_comma_separator}}", money_with_currency_format: "ZMW{{amount_no_decimals_with_comma_separator}}" },
                });
        },
        5261: function (t, e, r) {
            "use strict";
            var i =
                    (this && this.__createBinding) ||
                    (Object.create
                        ? function (t, e, r, i) {
                              void 0 === i && (i = r);
                              var n = Object.getOwnPropertyDescriptor(e, r);
                              (n && !("get" in n ? !e.__esModule : n.writable || n.configurable)) ||
                                  (n = {
                                      enumerable: !0,
                                      get: function () {
                                          return e[r];
                                      },
                                  }),
                                  Object.defineProperty(t, i, n);
                          }
                        : function (t, e, r, i) {
                              void 0 === i && (i = r), (t[i] = e[r]);
                          }),
                n =
                    (this && this.__exportStar) ||
                    function (t, e) {
                        for (var r in t) "default" === r || Object.prototype.hasOwnProperty.call(e, r) || i(e, t, r);
                    };
            Object.defineProperty(e, "__esModule", { value: !0 }), n(r(5493), e), n(r(546), e), n(r(837), e);
        },
        8785: function (t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", { value: !0 }), (e.customerGet = void 0);
            const i = r(6592);
            e.customerGet = () => {
                if (!i.GLOBAL_SELF || void 0 === i.GLOBAL_SELF.Customer) throw new Error("Customer is undefined... probably because you haven't set window.Customer to a JSON formatted Customer object!");
                return i.GLOBAL_SELF.Customer;
            };
        },
        8183: function (t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", { value: !0 }), (e.geoFetchData = e.geoSetRequestFunction = void 0);
            const i = r(6112),
                n = "GeoDataCache";
            e.geoSetRequestFunction = (t) => {
                (window.Geo = window.Geo || {}), (window.Geo.requester = t);
            };
            e.geoFetchData = () =>
                new Promise((t, e) => {
                    if (((window.Geo = window.Geo || {}), window.Geo.requester))
                        if (window.Geo.cache) t(window.Geo.cache);
                        else {
                            try {
                                let e = i.get(n);
                                if (("string" == typeof e && (e = JSON.parse(e)), !e || !e.country_code)) throw "Invalid cache";
                                return (window.Geo.cache = e), void t(e);
                            } catch (t) {
                                console.error("Failed to parse GeoData, not a huge issue", t);
                            }
                            if (window.Geo.isFetching) return (window.Geo.listeners = window.Geo.listeners || []), void window.Geo.listeners.push(e);
                            (window.Geo.isFetching = !0),
                                window.Geo.requester()
                                    .then((e) => {
                                        var r;
                                        if (!e || !e.country_code) throw "Invalid Geo Data";
                                        (window.Geo = window.Geo || {}), (window.Geo.isFetching = !1);
                                        try {
                                            i.set(n, JSON.stringify(e), { expires: 1 });
                                        } catch (t) {
                                            console.error("Failed to cache geo data, not a major issue", t);
                                        }
                                        null === (r = window.Geo.listeners) || void 0 === r || r.forEach((t) => t(e)), t(e);
                                    })
                                    .catch((t) => {
                                        console.error("Geo fetch failed", t), e(t);
                                    });
                        }
                    else e("Missing a requester function, make sure you geoSetRequestFunction.");
                });
        },
        9796: function (t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", { value: !0 }), (e.offArReady = e.onArReady = void 0);
            const i = r(6592);
            e.onArReady = (t) => {
                i.GLOBAL_SELF.arListeners || (i.GLOBAL_SELF.arListeners = []), i.GLOBAL_SELF.arListeners.push(t), i.GLOBAL_SELF.arLoaded ? t(i.GLOBAL_SELF.ShopifyXR) : a();
            };
            e.offArReady = (t) => {
                if (!i.GLOBAL_SELF.arListeners) return;
                const e = i.GLOBAL_SELF.arListeners.indexOf(t);
                -1 !== e && i.GLOBAL_SELF.arListeners.splice(e, 1);
            };
            const n = () => {
                    let t = setInterval(() => {
                        if (i.GLOBAL_SELF.arLoaded) return clearInterval(t);
                        i.GLOBAL_SELF.ShopifyXR &&
                            ((i.GLOBAL_SELF.arLoaded = !0),
                            document.documentElement.classList.add("has-ar"),
                            i.GLOBAL_SELF.arListeners &&
                                i.GLOBAL_SELF.arListeners.forEach((t) => {
                                    try {
                                        t(i.GLOBAL_SELF.ShopifyXR);
                                    } catch (t) {
                                        console.error(t);
                                    }
                                }));
                    }, 32);
                },
                a = () => {
                    i.GLOBAL_SELF.Shopify &&
                        i.GLOBAL_SELF.Shopify.loadFeatures &&
                        (i.GLOBAL_SELF.arLoadRequested || ((i.GLOBAL_SELF.arLoadRequested = !0), i.GLOBAL_SELF.Shopify.loadFeatures([{ name: "shopify-xr", version: "1.0", onLoad: n }])));
                };
        },
        7413: function (t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", { value: !0 }), (e.iconGet = void 0);
            const i = r(6592);
            e.iconGet = (t) => (i.GLOBAL_SELF.Icons && i.GLOBAL_SELF.Icons[t] ? i.GLOBAL_SELF.Icons[t] : (console.error("Tried to get icon", t, "but it was not defined on GLOBAL_SELF.Icons!"), "<svg></svg>"));
        },
        8863: function (t, e, r) {
            "use strict";
            var i =
                    (this && this.__createBinding) ||
                    (Object.create
                        ? function (t, e, r, i) {
                              void 0 === i && (i = r);
                              var n = Object.getOwnPropertyDescriptor(e, r);
                              (n && !("get" in n ? !e.__esModule : n.writable || n.configurable)) ||
                                  (n = {
                                      enumerable: !0,
                                      get: function () {
                                          return e[r];
                                      },
                                  }),
                                  Object.defineProperty(t, i, n);
                          }
                        : function (t, e, r, i) {
                              void 0 === i && (i = r), (t[i] = e[r]);
                          }),
                n =
                    (this && this.__exportStar) ||
                    function (t, e) {
                        for (var r in t) "default" === r || Object.prototype.hasOwnProperty.call(e, r) || i(e, t, r);
                    };
            Object.defineProperty(e, "__esModule", { value: !0 }), n(r(9796), e), n(r(7413), e), n(r(9555), e);
        },
        9555: function (t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", { value: !0 }), (e.pictureGenerateElement = e.pictureGenerate = e.SHOPIFY_VALID_IMG_SIZE_NAMES = void 0);
            const i = r(7670);
            e.SHOPIFY_VALID_IMG_SIZE_NAMES = ["master", "large", "medium", "small"];
            e.pictureGenerate = (t) => {
                var e;
                const r = [1, 2];
                let n = "<picture>";
                void 0 !== t.cloudinarySrc && (t.src = t.cloudinarySrc);
                let [a, s] = t.src.split("?");
                const o = null === (e = a.split("_")[1]) || void 0 === e ? void 0 : e.split(".")[0];
                (a = a.replace(`_${o}`, "")), (a = `${a}?${s}`), (t.src = a);
                const l = 0 == t.cache ? Math.floor(1e9 * Math.random()) : "",
                    h = [...(t.sizes || [])];
                if (h.length > 1) {
                    const e = h[h.length - 1];
                    h.push(e),
                        h.forEach((e, a) => {
                            const s = a === t.sizes.length - 1;
                            if (((n += '<source media="'), "string" == typeof e.screen)) n += e.screen;
                            else {
                                let t = e.screen || ("number" == typeof e.size ? e.size : null);
                                if (!t) return;
                                n += `(${s ? "min" : "max"}-width:${t}px)`;
                            }
                            (n += `" ${t.lazy && t.lazy.dataSrc ? "data-src" : "src"}="`),
                                r.forEach((a, s) => {
                                    let o = e.size;
                                    "number" == typeof e.size && (o = e.size * a), (n += (0, i.getImageUrl)(t.src, o)), (n += "" + (l ? `?v=${l}` : "")), 1 != a && (n += ` ${a}x`), s < r.length - 1 && (n += ", ");
                                }),
                                (n += '"'),
                                t.alt && (n += `alt="${t.alt}" `),
                                t.lazy && t.lazy.dataSizes && (n += 'data-sizes="auto" '),
                                (n += "/>");
                        });
                }
                const c = {};
                return (
                    (c[t.lazy && t.lazy.dataSrc ? "data-src" : "src"] = `${(0, i.getImageUrl)(t.src, t.srcSize)}${l ? `?v=${l}` : ""}`),
                    (c.class = [t.class, t.lazy && t.lazy.class ? t.lazy.className || "lazyload" : null].filter((t) => t).join(" ")),
                    t.alt && (c.alt = (0, i.escapeString)(t.alt)),
                    t.lazy && t.lazy.dataExpand && (c["data-expand"] = t.lazy.dataExpand + ""),
                    (n += `<img ${Object.keys(c).reduce((t, e) => `${t} ${e}="${c[e]}"`, "")} ${t.attributes || ""} />`),
                    (n += "</picture>"),
                    n
                );
            };
            e.pictureGenerateElement = (t) => {
                let r = document.createElement("div");
                return (r.innerHTML = (0, e.pictureGenerate)(t)), r.querySelector("picture");
            };
        },
        7670: function (t, e, r) {
            "use strict";
            var i =
                    (this && this.__createBinding) ||
                    (Object.create
                        ? function (t, e, r, i) {
                              void 0 === i && (i = r);
                              var n = Object.getOwnPropertyDescriptor(e, r);
                              (n && !("get" in n ? !e.__esModule : n.writable || n.configurable)) ||
                                  (n = {
                                      enumerable: !0,
                                      get: function () {
                                          return e[r];
                                      },
                                  }),
                                  Object.defineProperty(t, i, n);
                          }
                        : function (t, e, r, i) {
                              void 0 === i && (i = r), (t[i] = e[r]);
                          }),
                n =
                    (this && this.__exportStar) ||
                    function (t, e) {
                        for (var r in t) "default" === r || Object.prototype.hasOwnProperty.call(e, r) || i(e, t, r);
                    };
            Object.defineProperty(e, "__esModule", { value: !0 });
            const a = r(6592);
            n(r(5982), e), n(r(3585), e), n(r(5261), e), n(r(8785), e), n(r(8183), e), n(r(8863), e), n(r(815), e), n(r(7715), e), n(r(2561), e), n(r(3075), e), n(r(3463), e), (a.GLOBAL_SELF.pcSlateTools = t.exports);
        },
        3621: function (t, e) {
            "use strict";
            Object.defineProperty(e, "__esModule", { value: !0 }), (e.productFetch = void 0);
            e.productFetch = (t) => fetch(`/products/${t}.js`, { method: "GET", headers: { "Content-Type": "application/json" } }).then((t) => t.json());
        },
        3793: function (t, e) {
            "use strict";
            Object.defineProperty(e, "__esModule", { value: !0 }), (e.collectionGetUrlFromHandle = e.collectionGetUrl = void 0);
            e.collectionGetUrl = (t) => (0, e.collectionGetUrlFromHandle)(t.collection);
            e.collectionGetUrlFromHandle = (t) => `/collections/${t.handle}`;
        },
        815: function (t, e, r) {
            "use strict";
            var i =
                    (this && this.__createBinding) ||
                    (Object.create
                        ? function (t, e, r, i) {
                              void 0 === i && (i = r);
                              var n = Object.getOwnPropertyDescriptor(e, r);
                              (n && !("get" in n ? !e.__esModule : n.writable || n.configurable)) ||
                                  (n = {
                                      enumerable: !0,
                                      get: function () {
                                          return e[r];
                                      },
                                  }),
                                  Object.defineProperty(t, i, n);
                          }
                        : function (t, e, r, i) {
                              void 0 === i && (i = r), (t[i] = e[r]);
                          }),
                n =
                    (this && this.__exportStar) ||
                    function (t, e) {
                        for (var r in t) "default" === r || Object.prototype.hasOwnProperty.call(e, r) || i(e, t, r);
                    };
            Object.defineProperty(e, "__esModule", { value: !0 }), n(r(3621), e), n(r(3793), e), n(r(2888), e), n(r(6204), e), n(r(1127), e), n(r(5905), e);
        },
        2888: function (t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", { value: !0 }),
                (e.productGetOptionsWithValues = e.productGetUrlFromHandle = e.productGetUrl = e.productOptionDoesMatchSet = e.productDoesOptionMatch = e.productGetOptionIndex = e.OPTIONS_SIZE = e.OPTIONS_COLOR = void 0);
            const i = r(815),
                n = r(7670);
            (e.OPTIONS_COLOR = ["color", "colour"]), (e.OPTIONS_SIZE = ["size"]);
            e.productGetOptionIndex = (t) => t.product.options.findIndex((r) => t.options.some((t) => (0, e.productDoesOptionMatch)(t, r)));
            e.productDoesOptionMatch = (t, e) => (0, n.handlize)(t) === (0, n.handlize)(e);
            e.productOptionDoesMatchSet = (t, r) => r.some((r) => (0, e.productDoesOptionMatch)(t, r));
            e.productGetUrl = (t) => [t.collection ? (0, i.collectionGetUrlFromHandle)(t.collection) : "", (0, e.productGetUrlFromHandle)(t.product)].join("");
            e.productGetUrlFromHandle = (t) => `/products/${t.handle}`;
            e.productGetOptionsWithValues = (t) => {
                const e = {};
                return (
                    t.variants.forEach((r) => {
                        t.options.forEach((t, i) => {
                            const n = r.options[i],
                                a = (e[t] = e[t] || []);
                            -1 === a.indexOf(n) && a.push(n);
                        });
                    }),
                    e
                );
            };
        },
        6204: function (t, e, r) {
            "use strict";
            var i =
                (this && this.__awaiter) ||
                function (t, e, r, i) {
                    return new (r || (r = Promise))(function (n, a) {
                        function s(t) {
                            try {
                                l(i.next(t));
                            } catch (t) {
                                a(t);
                            }
                        }
                        function o(t) {
                            try {
                                l(i.throw(t));
                            } catch (t) {
                                a(t);
                            }
                        }
                        function l(t) {
                            var e;
                            t.done
                                ? n(t.value)
                                : ((e = t.value),
                                  e instanceof r
                                      ? e
                                      : new r(function (t) {
                                            t(e);
                                        })).then(s, o);
                        }
                        l((i = i.apply(t, e || [])).next());
                    });
                };
            Object.defineProperty(e, "__esModule", { value: !0 }), (e.recentlyViewedFetch = e.recentlyViewedAdd = e.recentlyViewedSet = e.recentlyViewedClear = e.recentlyViewedGet = void 0);
            const n = r(6112),
                a = r(3621),
                s = "recently-viewed";
            e.recentlyViewedGet = () => {
                try {
                    let t = (n.get(s) || "")
                        .toString()
                        .split(",")
                        .map((t) => t.trim())
                        .filter((t) => t.length);
                    return (t = t.filter((e, r) => t.indexOf(e) === r)), t.map((t) => ({ handle: t }));
                } catch (t) {
                    console.error(t);
                }
                return [];
            };
            e.recentlyViewedClear = () => {
                try {
                    n.set(s, ""), n.remove(s);
                } catch (t) {
                    console.error(t);
                }
            };
            e.recentlyViewedSet = (t) => {
                let r = t.filter((t) => t && t.handle && t.handle.length);
                if (((r = r.filter((t, e) => r.indexOf(t) === e)), (r = r.slice(0, 12)), !r.length)) return (0, e.recentlyViewedClear)();
                try {
                    n.set(s, r.map((t) => t.handle).join(","));
                } catch (t) {
                    console.error(t);
                }
            };
            e.recentlyViewedAdd = (t) => {
                const r = (0, e.recentlyViewedGet)();
                return r.reverse(), r.push({ handle: t }), r.reverse(), (0, e.recentlyViewedSet)(r);
            };
            e.recentlyViewedFetch = (t) =>
                i(void 0, void 0, void 0, function* () {
                    const r = (0, e.recentlyViewedGet)();
                    if (!r.length) return null;
                    t || (t = o);
                    const i = r.map((t) => t.handle),
                        n = yield t(i);
                    return n.length ? (n.sort((t, e) => i.indexOf(t.handle) - i.indexOf(e.handle)), n) : null;
                });
            const o = (t) =>
                i(void 0, void 0, void 0, function* () {
                    const e = [];
                    return (
                        yield Promise.all(
                            t.map((t) =>
                                i(void 0, void 0, void 0, function* () {
                                    try {
                                        const r = yield (0, a.productFetch)(t);
                                        if (!r) return null;
                                        e.push(r);
                                    } catch (t) {
                                        console.error(t);
                                    }
                                })
                            )
                        ),
                        e
                    );
                });
        },
        5905: function (t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", { value: !0 }), (e.fetchRelatedSection = e.recommendedGetRelated = void 0);
            const i = r(7670);
            e.recommendedGetRelated = (t, e = 4) => fetch("/recommendations/products.json", { method: "GET", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ product_id: t, limit: e }) }).then((t) => t.json());
            e.fetchRelatedSection = (t, e, r, n) => fetch(e + "?" + (0, i.queryEncodeString)({ product_id: r, section_id: t, limit: n }), { method: "GET" }).then((t) => t.text());
        },
        1127: function (t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", { value: !0 }),
                (e.variantBackendToFrontend = e.variantGetUrl = e.variantDoesHaveOption = e.variantGetFromOptions = e.variantSelectedOrFirstAvailable = e.variantFirstAvailableOrDefault = e.variantFirstAvailable = void 0);
            const i = r(2888),
                n = r(2561),
                a = ["option1", "option2", "option3"];
            e.variantFirstAvailable = ({ variants: t }) => t.find((t) => t.available);
            e.variantFirstAvailableOrDefault = (t) => (0, e.variantFirstAvailable)(t) || t.variants[0];
            e.variantSelectedOrFirstAvailable = (t) => {
                let r = null;
                return t.selected && (r = t.selected.id ? t.variants.find((e) => e.id === t.selected.id) : t.variants.find((e) => e.id === t.selected)), r || (0, e.variantFirstAvailableOrDefault)(t);
            };
            e.variantGetFromOptions = (t) => t.product.variants.find((r) => (0, e.variantDoesHaveOption)(Object.assign(Object.assign({}, t), { variant: r })));
            e.variantDoesHaveOption = (t) => t.options.every((e, r) => (0, n.handlize)(t.variant.options[r]) === (0, n.handlize)(e));
            e.variantGetUrl = (t) => `${(0, i.productGetUrl)(t)}?variant=${t.variant.id}`;
            e.variantBackendToFrontend = (t) => {
                const e = "shopify" !== t.inventory_management || "deny" !== t.inventory_policy || t.inventory_quantity > 0,
                    r = a.map((e) => t[e]).filter((t) => t),
                    i = null === t.compare_at_price ? null : Math.round(100 * parseFloat(t.compare_at_price)),
                    n = Math.round(100 * parseFloat(t.price));
                return Object.assign(Object.assign({}, t), { available: e, options: r, compare_at_price: i, price: n, featured_image: null, featured_media: null, location_data: null, selling_plan_allocations: [], name: t.title });
            };
        },
        7715: function (t, e, r) {
            "use strict";
            var i =
                (this && this.__awaiter) ||
                function (t, e, r, i) {
                    return new (r || (r = Promise))(function (n, a) {
                        function s(t) {
                            try {
                                l(i.next(t));
                            } catch (t) {
                                a(t);
                            }
                        }
                        function o(t) {
                            try {
                                l(i.throw(t));
                            } catch (t) {
                                a(t);
                            }
                        }
                        function l(t) {
                            var e;
                            t.done
                                ? n(t.value)
                                : ((e = t.value),
                                  e instanceof r
                                      ? e
                                      : new r(function (t) {
                                            t(e);
                                        })).then(s, o);
                        }
                        l((i = i.apply(t, e || [])).next());
                    });
                };
            Object.defineProperty(e, "__esModule", { value: !0 }), (e.estimateShippingCosts = e.estimateShippingCostsForLines = e.getCurrentShippingCosts = void 0);
            const n = r(7670);
            e.getCurrentShippingCosts = (t, e, r) => fetch("/cart/shipping_rates.json", { method: "GET", body: JSON.stringify({ shipping_address: { zip: t, country: e, province: r } }) }).then((t) => t.json());
            e.estimateShippingCostsForLines = (t, r, a, s) =>
                i(void 0, void 0, void 0, function* () {
                    const i = (0, n.cartGetCurrent)();
                    i.items.length && (yield (0, n.cartClear)()),
                        yield (0, n.cartAdd)(
                            Object.assign(Object.assign({}, t), { items: t.items.map((t) => Object.assign(Object.assign({}, t), { properties: Object.assign(Object.assign({}, t.properties || {}), { _shipping_calc: "Y" }) })) })
                        );
                    const o = yield (0, e.getCurrentShippingCosts)(r, a, s);
                    return yield (0, n.cartClear)(), yield (0, n.cartAdd)(i), o;
                });
            e.estimateShippingCosts = (t, r, i, n, a) => (0, e.estimateShippingCostsForLines)({ items: [{ id: t, quantity: r }] }, i, n, a);
        },
        2561: function (t, e, r) {
            "use strict";
            var i =
                    (this && this.__createBinding) ||
                    (Object.create
                        ? function (t, e, r, i) {
                              void 0 === i && (i = r);
                              var n = Object.getOwnPropertyDescriptor(e, r);
                              (n && !("get" in n ? !e.__esModule : n.writable || n.configurable)) ||
                                  (n = {
                                      enumerable: !0,
                                      get: function () {
                                          return e[r];
                                      },
                                  }),
                                  Object.defineProperty(t, i, n);
                          }
                        : function (t, e, r, i) {
                              void 0 === i && (i = r), (t[i] = e[r]);
                          }),
                n =
                    (this && this.__exportStar) ||
                    function (t, e) {
                        for (var r in t) "default" === r || Object.prototype.hasOwnProperty.call(e, r) || i(e, t, r);
                    };
            Object.defineProperty(e, "__esModule", { value: !0 }), (e.t = e.getLanguageKey = e.liquid = e.liquidToDate = e.handlize = e.unescapeString = e.escapeString = void 0);
            const a = r(6592);
            n(r(9643), e);
            const s = document.createTextNode("test"),
                o = document.createElement("span"),
                l = document.createElement("span");
            o.appendChild(s);
            e.escapeString = (t) => {
                s.nodeValue = t;
                return o.innerHTML.replace(/"/g, "&quot;");
            };
            e.unescapeString = (t) => ((l.innerHTML = t), l.textContent || "");
            e.handlize = (t) => {
                let e = t.toLowerCase();
                for (['"', "'", "\\", "(", ")", "[", "]"].forEach((t) => (e = e.replace(t, ""))), e = e.replace(/\W+/g, "-"); e.startsWith("-"); ) e = e.substr(1);
                for (; e.endsWith("-"); ) e = e.slice(0, -1);
                return e;
            };
            e.liquidToDate = (t) => {
                let [e, r, i] = t.split(" "),
                    [n, a, s] = e.split("-").map((t) => parseInt(t)),
                    [o, l, h] = r.split(":").map((t) => parseInt(t));
                return new Date(n, a - 1, s, o, l, h);
            };
            e.liquid = (t, e = {}) => {
                let r = Object.keys(e),
                    i = r.map((t) => t.toLowerCase());
                return t.replace(/({)?{{[^{}]*}}(?!})/g, function (t, n) {
                    let a = t.replace(/[\{|\s|\}]/g, "");
                    if (!a) return t;
                    a = a.toLowerCase();
                    let s = i.findIndex((t) => t == a);
                    return -1 === s ? t : e[r[s]];
                });
            };
            (e.getLanguageKey = (t, r = {}) => {
                let i = null;
                return a.GLOBAL_SELF.Language && a.GLOBAL_SELF.Language.strings && (i = a.GLOBAL_SELF.Language.strings[t]), i && i.length ? (0, e.liquid)(i, r) : `translation missing: ${t}`;
            }),
                (e.t = e.getLanguageKey);
        },
        9643: function (t, e) {
            "use strict";
            Object.defineProperty(e, "__esModule", { value: !0 }), (e.queryReplaceParam = e.queryDecodeString = e.queryEncodeString = void 0);
            e.queryEncodeString = (t) =>
                Object.entries(t).reduce(
                    (t, e) => (
                        null === e[1] ||
                            void 0 === e[1] ||
                            (t.length && (t += "&"), Array.isArray(e[1]) ? (t += e[1].map((t) => encodeURIComponent(e[0]) + "=" + encodeURIComponent(t)).join("&")) : (t += encodeURIComponent(e[0]) + "=" + encodeURIComponent(e[1]))),
                        t
                    ),
                    ""
                );
            e.queryDecodeString = (t) => {
                t || (t = location.search), t.startsWith("?") && (t = t.substr(1));
                const e = {},
                    r = t.split("&").map((t) => {
                        const e = t.split("=").map((t) => decodeURIComponent(t));
                        return { key: e[0], value: e[1] || "" };
                    });
                return (
                    r.forEach((t, i) => {
                        const { key: n, value: a } = t;
                        r.some((t, e) => t.key === n && e !== i) ? ((e[n] = e[n] || []), e[n].push(a)) : (e[n] = !a.length || a);
                    }),
                    e
                );
            };
            e.queryReplaceParam = (t, r) => {
                const i = (0, e.queryDecodeString)();
                null === r ? delete i[t] : (i[t] = r);
                try {
                    history.pushState(null, "", "?" + (0, e.queryEncodeString)(i));
                } catch (t) {
                    console.error(t);
                }
            };
        },
        6592: function (t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", { value: !0 }), (e.jQuery = e.SlateCustomEvent = e.GLOBAL_SELF = void 0), (e.GLOBAL_SELF = "undefined" != typeof window ? window : globalThis || r.g || this || String || {});
            class i extends CustomEvent {}
            (e.SlateCustomEvent = i), (e.jQuery = e.GLOBAL_SELF.$ || e.GLOBAL_SELF.jQuery || e.GLOBAL_SELF.jquery || (e.GLOBAL_SELF.Checkout && (e.GLOBAL_SELF.Checkout.jQuery || e.GLOBAL_SELF.Checkout.$)) || null);
        },
        288: function (t, e) {
            "use strict";
            Object.defineProperty(e, "__esModule", { value: !0 });
        },
        5892: function (t, e) {
            "use strict";
            Object.defineProperty(e, "__esModule", { value: !0 });
        },
        7453: function (t, e) {
            "use strict";
            Object.defineProperty(e, "__esModule", { value: !0 });
        },
        3463: function (t, e, r) {
            "use strict";
            var i =
                    (this && this.__createBinding) ||
                    (Object.create
                        ? function (t, e, r, i) {
                              void 0 === i && (i = r);
                              var n = Object.getOwnPropertyDescriptor(e, r);
                              (n && !("get" in n ? !e.__esModule : n.writable || n.configurable)) ||
                                  (n = {
                                      enumerable: !0,
                                      get: function () {
                                          return e[r];
                                      },
                                  }),
                                  Object.defineProperty(t, i, n);
                          }
                        : function (t, e, r, i) {
                              void 0 === i && (i = r), (t[i] = e[r]);
                          }),
                n =
                    (this && this.__exportStar) ||
                    function (t, e) {
                        for (var r in t) "default" === r || Object.prototype.hasOwnProperty.call(e, r) || i(e, t, r);
                    };
            Object.defineProperty(e, "__esModule", { value: !0 }), r(7453), n(r(288), e), n(r(5892), e), n(r(1684), e), n(r(8163), e), n(r(8058), e), n(r(4396), e), n(r(5993), e);
        },
        1684: function (t, e) {
            "use strict";
            Object.defineProperty(e, "__esModule", { value: !0 });
        },
        8163: function (t, e) {
            "use strict";
            Object.defineProperty(e, "__esModule", { value: !0 });
        },
        8058: function (t, e) {
            "use strict";
            Object.defineProperty(e, "__esModule", { value: !0 });
        },
        5993: function (t, e) {
            "use strict";
            Object.defineProperty(e, "__esModule", { value: !0 });
        },
        4396: function (t, e) {
            "use strict";
            Object.defineProperty(e, "__esModule", { value: !0 });
        },
        3075: function (t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", { value: !0 }), (e.getImageUrl = e.getCdnUrl = e.getAssetUrl = void 0);
            const i = r(8863),
                n = r(6592),
                a = "//cdn.shopify.com";
            e.getAssetUrl = (t) => {
                if (!n.GLOBAL_SELF.Asset) throw new Error("You have not setup a same asset url for the script to use! Ensure window.Asset has been set with any asset url!");
                let e = n.GLOBAL_SELF.Asset.split("/"),
                    r = e[e.length - 1];
                if (r.includes("?v=")) {
                    let i = r.split("?");
                    const n = i[i.length - 1];
                    return e.splice(-1, 1), e.push(t), `${e.join("/")}?${n}`;
                }
                return e.splice(-1, 1), e.push(t), e.join("/");
            };
            e.getCdnUrl = () => {
                let t = (0, e.getAssetUrl)("").split("/");
                return t.splice(t.length - 4, t.length), t.join("/");
            };
            e.getImageUrl = (t, e) => {
                if (!t) return `${a}/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif`;
                let r = Array.isArray(t) ? t[0] : t;
                if (void 0 !== r.cloudinary_src) {
                    let t = r;
                    return e ? t.cloudinary_src + "w_" + e : t.original_src;
                }
                let n = t ? ("string" == typeof t ? t : t.src) : "",
                    s = (t) => {
                        let e = t.replace(/http(s)?:/, "");
                        if ((e.startsWith(a) || (e = `${a}${e}`), -1 !== e.indexOf("?"))) {
                            let t = e.split("?");
                            t.pop(), (e = t.join("?"));
                        }
                        return e;
                    },
                    o = e ? `${e}` : null;
                if (!o) return s(n);
                if ((i.SHOPIFY_VALID_IMG_SIZE_NAMES.some((t) => o == t) || o.endsWith("x") || (o += "x"), -1 !== n.indexOf("."))) {
                    let t = s(n).split("."),
                        e = t.pop(),
                        r = t.pop();
                    if (r && r.length) {
                        let a = r.split("/"),
                            s = a.pop().split("_"),
                            o = s.pop();
                        (i.SHOPIFY_VALID_IMG_SIZE_NAMES.some((t) => o === t) || (o.endsWith("x") && 1 === o.replace(/\d/g, "").length)) &&
                            (n = [t.join("."), t.length ? "." : "", a.join("/"), a.length ? "/" : "", s.filter((t) => t && t.length).join("_"), `.${e}`].join(""));
                    }
                }
                let l = n.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
                if (!l) return null;
                let h = n.split(l[0]),
                    c = l[0];
                return s([[h[0].trim(), "master" === e ? null : o.trim()].filter((t) => t).join("_"), c].filter((t) => t && t.length).join(""));
            };
        },
        6112: function (t) {
            t.exports = (function () {
                "use strict";
                function t(t) {
                    for (var e = 1; e < arguments.length; e++) {
                        var r = arguments[e];
                        for (var i in r) t[i] = r[i];
                    }
                    return t;
                }
                function e(r, i) {
                    function n(e, n, a) {
                        if ("undefined" != typeof document) {
                            "number" == typeof (a = t({}, i, a)).expires && (a.expires = new Date(Date.now() + 864e5 * a.expires)),
                                a.expires && (a.expires = a.expires.toUTCString()),
                                (e = encodeURIComponent(e)
                                    .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
                                    .replace(/[()]/g, escape));
                            var s = "";
                            for (var o in a) a[o] && ((s += "; " + o), !0 !== a[o] && (s += "=" + a[o].split(";")[0]));
                            return (document.cookie = e + "=" + r.write(n, e) + s);
                        }
                    }
                    function a(t) {
                        if ("undefined" != typeof document && (!arguments.length || t)) {
                            for (var e = document.cookie ? document.cookie.split("; ") : [], i = {}, n = 0; n < e.length; n++) {
                                var a = e[n].split("="),
                                    s = a.slice(1).join("=");
                                try {
                                    var o = decodeURIComponent(a[0]);
                                    if (((i[o] = r.read(s, o)), t === o)) break;
                                } catch (t) {}
                            }
                            return t ? i[t] : i;
                        }
                    }
                    return Object.create(
                        {
                            set: n,
                            get: a,
                            remove: function (e, r) {
                                n(e, "", t({}, r, { expires: -1 }));
                            },
                            withAttributes: function (r) {
                                return e(this.converter, t({}, this.attributes, r));
                            },
                            withConverter: function (r) {
                                return e(t({}, this.converter, r), this.attributes);
                            },
                        },
                        { attributes: { value: Object.freeze(i) }, converter: { value: Object.freeze(r) } }
                    );
                }
                return e(
                    {
                        read: function (t) {
                            return '"' === t[0] && (t = t.slice(1, -1)), t.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
                        },
                        write: function (t) {
                            return encodeURIComponent(t).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
                        },
                    },
                    { path: "/" }
                );
            })();
        },
        5202: function () {
            !(function () {
                "use strict";
                function t(t) {
                    var e = !0,
                        r = !1,
                        i = null,
                        n = { text: !0, search: !0, url: !0, tel: !0, email: !0, password: !0, number: !0, date: !0, month: !0, week: !0, time: !0, datetime: !0, "datetime-local": !0 };
                    function a(t) {
                        return !!(t && t !== document && "HTML" !== t.nodeName && "BODY" !== t.nodeName && "classList" in t && "contains" in t.classList);
                    }
                    function s(t) {
                        var e = t.type,
                            r = t.tagName;
                        return !("INPUT" !== r || !n[e] || t.readOnly) || ("TEXTAREA" === r && !t.readOnly) || !!t.isContentEditable;
                    }
                    function o(t) {
                        t.classList.contains("focus-visible") || (t.classList.add("focus-visible"), t.setAttribute("data-focus-visible-added", ""));
                    }
                    function l(t) {
                        t.hasAttribute("data-focus-visible-added") && (t.classList.remove("focus-visible"), t.removeAttribute("data-focus-visible-added"));
                    }
                    function h(r) {
                        r.metaKey || r.altKey || r.ctrlKey || (a(t.activeElement) && o(t.activeElement), (e = !0));
                    }
                    function c(t) {
                        e = !1;
                    }
                    function p(t) {
                        a(t.target) && (e || s(t.target)) && o(t.target);
                    }
                    function u(t) {
                        a(t.target) &&
                            (t.target.classList.contains("focus-visible") || t.target.hasAttribute("data-focus-visible-added")) &&
                            ((r = !0),
                            window.clearTimeout(i),
                            (i = window.setTimeout(function () {
                                r = !1;
                            }, 100)),
                            l(t.target));
                    }
                    function f(t) {
                        "hidden" === document.visibilityState && (r && (e = !0), d());
                    }
                    function d() {
                        document.addEventListener("mousemove", y),
                            document.addEventListener("mousedown", y),
                            document.addEventListener("mouseup", y),
                            document.addEventListener("pointermove", y),
                            document.addEventListener("pointerdown", y),
                            document.addEventListener("pointerup", y),
                            document.addEventListener("touchmove", y),
                            document.addEventListener("touchstart", y),
                            document.addEventListener("touchend", y);
                    }
                    function m() {
                        document.removeEventListener("mousemove", y),
                            document.removeEventListener("mousedown", y),
                            document.removeEventListener("mouseup", y),
                            document.removeEventListener("pointermove", y),
                            document.removeEventListener("pointerdown", y),
                            document.removeEventListener("pointerup", y),
                            document.removeEventListener("touchmove", y),
                            document.removeEventListener("touchstart", y),
                            document.removeEventListener("touchend", y);
                    }
                    function y(t) {
                        (t.target.nodeName && "html" === t.target.nodeName.toLowerCase()) || ((e = !1), m());
                    }
                    document.addEventListener("keydown", h, !0),
                        document.addEventListener("mousedown", c, !0),
                        document.addEventListener("pointerdown", c, !0),
                        document.addEventListener("touchstart", c, !0),
                        document.addEventListener("visibilitychange", f, !0),
                        d(),
                        t.addEventListener("focus", p, !0),
                        t.addEventListener("blur", u, !0),
                        t.nodeType === Node.DOCUMENT_FRAGMENT_NODE && t.host
                            ? t.host.setAttribute("data-js-focus-visible", "")
                            : t.nodeType === Node.DOCUMENT_NODE && (document.documentElement.classList.add("js-focus-visible"), document.documentElement.setAttribute("data-js-focus-visible", ""));
                }
                if ("undefined" != typeof window && "undefined" != typeof document) {
                    var e;
                    window.applyFocusVisiblePolyfill = t;
                    try {
                        e = new CustomEvent("focus-visible-polyfill-ready");
                    } catch (t) {
                        (e = document.createEvent("CustomEvent")).initCustomEvent("focus-visible-polyfill-ready", !1, !1, {});
                    }
                    window.dispatchEvent(e);
                }
                "undefined" != typeof document && t(document);
            })();
        },
        5787: function () {
            var t;
            (t = window.lazyvidsConfig || {}),
                window.NodeList && !NodeList.prototype.forEach && (NodeList.prototype.forEach = Array.prototype.forEach),
                document.addEventListener("DOMContentLoaded", () => {
                    var e, r, i, n, a, s;
                    const o = null != (e = null == t ? void 0 : t.logLevel) ? e : "silent",
                        l = null != (r = null == t ? void 0 : t.ignoreHidden) && r,
                        h = (null == t ? void 0 : t.minBandwidth) ? Number(t.minBandwidth) : 0,
                        c = null != (i = null == t ? void 0 : t.reduceData) && i,
                        p = (t, e = "") => {
                            "silent" !== o && window.console.warn(`lazyvids: ${t}`, e);
                        },
                        u = "function" == typeof window.IntersectionObserver;
                    let f;
                    if (c && h && ((null == (n = navigator.connection) ? void 0 : n.downlink) < h || (null == (a = navigator.connection) ? void 0 : a.saveData)))
                        return void p(`Slow connection (${null == (s = navigator.connection) ? void 0 : s.downlink}mbps). Lazy autoplay disabled.`);
                    const d = (t) => {
                            (t.muted = !0),
                                (t.autoplay = !0),
                                void 0 !== t.play()
                                    ? t
                                          .play()
                                          .then(() => (t.dataset.lazyvids = "loaded"))
                                          .catch((e) => p("Autoplay blocked by browser for:", t))
                                    : (t.dataset.lazyvids = "loaded");
                        },
                        m = (t) => {
                            var e, r;
                            if ("none" === (null == (e = t.style) ? void 0 : e.display) || (l && "hidden" === (null == (r = t.style) ? void 0 : r.visibility))) return !1;
                            const i = getComputedStyle(t);
                            return !("none" === i.getPropertyValue("display") || (l && "hidden" === i.getPropertyValue("visibility"))) && (!t.parentNode || t.parentNode === document || m(t.parentNode));
                        };
                    u &&
                        (f = new IntersectionObserver((t, e) => {
                            t.forEach((t) => {
                                window.requestAnimationFrame(() => {
                                    const r = t.target;
                                    !1 !== t.isIntersecting && !1 !== m(r) && (d(r), e.unobserve(r));
                                });
                            });
                        }));
                    const y = (t) => {
                            if (!1 === u) return d(t), void p("Unsupported browser. Lazy autoplay disabled.");
                            (t.dataset.lazyvids = "unloaded"), f.observe(t);
                        },
                        v = "video[data-lazyvids]:not([data-lazyvids=loaded]):not([data-lazyvids=false])",
                        g = document.querySelectorAll(v);
                    ((t, e = "") => {
                        "verbose" === o && window.console.log(`lazyvids: ${t}`, e);
                    })(`Initialised — ${g.length} ${1 === g.length ? "video" : "videos"} detected`),
                        g.forEach((t) => y(t)),
                        new MutationObserver((t) => {
                            t.forEach((t) => {
                                t.addedNodes.forEach((t) => {
                                    "VIDEO" !== t.tagName || void 0 === t.dataset.lazyvids || "loaded" === t.dataset.lazyvids || "false" === t.dataset.lazyvids ? !1 !== t.hasChildNodes() && t.querySelectorAll(v).forEach((t) => y(t)) : y(t);
                                });
                            });
                        }).observe(document, { childList: !0, subtree: !0 });
                });
        },
        509: function (t, e, r) {
            "use strict";
            var i = r(9985),
                n = r(3691),
                a = TypeError;
            t.exports = function (t) {
                if (i(t)) return t;
                throw new a(n(t) + " is not a function");
            };
        },
        3550: function (t, e, r) {
            "use strict";
            var i = r(598),
                n = String,
                a = TypeError;
            t.exports = function (t) {
                if (i(t)) return t;
                throw new a("Can't set " + n(t) + " as a prototype");
            };
        },
        7370: function (t, e, r) {
            "use strict";
            var i = r(4201),
                n = r(5391),
                a = r(2560).f,
                s = i("unscopables"),
                o = Array.prototype;
            void 0 === o[s] && a(o, s, { configurable: !0, value: n(null) }),
                (t.exports = function (t) {
                    o[s][t] = !0;
                });
        },
        1514: function (t, e, r) {
            "use strict";
            var i = r(730).charAt;
            t.exports = function (t, e, r) {
                return e + (r ? i(t, e).length : 1);
            };
        },
        767: function (t, e, r) {
            "use strict";
            var i = r(3622),
                n = TypeError;
            t.exports = function (t, e) {
                if (i(e, t)) return t;
                throw new n("Incorrect invocation");
            };
        },
        5027: function (t, e, r) {
            "use strict";
            var i = r(8999),
                n = String,
                a = TypeError;
            t.exports = function (t) {
                if (i(t)) return t;
                throw new a(n(t) + " is not an object");
            };
        },
        4328: function (t, e, r) {
            "use strict";
            var i = r(5290),
                n = r(7578),
                a = r(6310),
                s = function (t) {
                    return function (e, r, s) {
                        var o = i(e),
                            l = a(o);
                        if (0 === l) return !t && -1;
                        var h,
                            c = n(s, l);
                        if (t && r != r) {
                            for (; l > c; ) if ((h = o[c++]) != h) return !0;
                        } else for (; l > c; c++) if ((t || c in o) && o[c] === r) return t || c || 0;
                        return !t && -1;
                    };
                };
            t.exports = { includes: s(!0), indexOf: s(!1) };
        },
        6004: function (t, e, r) {
            "use strict";
            var i = r(8844);
            t.exports = i([].slice);
        },
        382: function (t, e, r) {
            "use strict";
            var i = r(6004),
                n = Math.floor,
                a = function (t, e) {
                    var r = t.length;
                    if (r < 8)
                        for (var s, o, l = 1; l < r; ) {
                            for (o = l, s = t[l]; o && e(t[o - 1], s) > 0; ) t[o] = t[--o];
                            o !== l++ && (t[o] = s);
                        }
                    else
                        for (var h = n(r / 2), c = a(i(t, 0, h), e), p = a(i(t, h), e), u = c.length, f = p.length, d = 0, m = 0; d < u || m < f; )
                            t[d + m] = d < u && m < f ? (e(c[d], p[m]) <= 0 ? c[d++] : p[m++]) : d < u ? c[d++] : p[m++];
                    return t;
                };
            t.exports = a;
        },
        6648: function (t, e, r) {
            "use strict";
            var i = r(8844),
                n = i({}.toString),
                a = i("".slice);
            t.exports = function (t) {
                return a(n(t), 8, -1);
            };
        },
        926: function (t, e, r) {
            "use strict";
            var i = r(3043),
                n = r(9985),
                a = r(6648),
                s = r(4201)("toStringTag"),
                o = Object,
                l =
                    "Arguments" ===
                    a(
                        (function () {
                            return arguments;
                        })()
                    );
            t.exports = i
                ? a
                : function (t) {
                      var e, r, i;
                      return void 0 === t
                          ? "Undefined"
                          : null === t
                          ? "Null"
                          : "string" ==
                            typeof (r = (function (t, e) {
                                try {
                                    return t[e];
                                } catch (t) {}
                            })((e = o(t)), s))
                          ? r
                          : l
                          ? a(e)
                          : "Object" === (i = a(e)) && n(e.callee)
                          ? "Arguments"
                          : i;
                  };
        },
        8758: function (t, e, r) {
            "use strict";
            var i = r(6812),
                n = r(9152),
                a = r(2474),
                s = r(2560);
            t.exports = function (t, e, r) {
                for (var o = n(e), l = s.f, h = a.f, c = 0; c < o.length; c++) {
                    var p = o[c];
                    i(t, p) || (r && i(r, p)) || l(t, p, h(e, p));
                }
            };
        },
        1748: function (t, e, r) {
            "use strict";
            var i = r(3689);
            t.exports = !i(function () {
                function t() {}
                return (t.prototype.constructor = null), Object.getPrototypeOf(new t()) !== t.prototype;
            });
        },
        7807: function (t) {
            "use strict";
            t.exports = function (t, e) {
                return { value: t, done: e };
            };
        },
        5773: function (t, e, r) {
            "use strict";
            var i = r(7697),
                n = r(2560),
                a = r(5684);
            t.exports = i
                ? function (t, e, r) {
                      return n.f(t, e, a(1, r));
                  }
                : function (t, e, r) {
                      return (t[e] = r), t;
                  };
        },
        5684: function (t) {
            "use strict";
            t.exports = function (t, e) {
                return { enumerable: !(1 & t), configurable: !(2 & t), writable: !(4 & t), value: e };
            };
        },
        2148: function (t, e, r) {
            "use strict";
            var i = r(8702),
                n = r(2560);
            t.exports = function (t, e, r) {
                return r.get && i(r.get, e, { getter: !0 }), r.set && i(r.set, e, { setter: !0 }), n.f(t, e, r);
            };
        },
        1880: function (t, e, r) {
            "use strict";
            var i = r(9985),
                n = r(2560),
                a = r(8702),
                s = r(5014);
            t.exports = function (t, e, r, o) {
                o || (o = {});
                var l = o.enumerable,
                    h = void 0 !== o.name ? o.name : e;
                if ((i(r) && a(r, h, o), o.global)) l ? (t[e] = r) : s(e, r);
                else {
                    try {
                        o.unsafe ? t[e] && (l = !0) : delete t[e];
                    } catch (t) {}
                    l ? (t[e] = r) : n.f(t, e, { value: r, enumerable: !1, configurable: !o.nonConfigurable, writable: !o.nonWritable });
                }
                return t;
            };
        },
        6045: function (t, e, r) {
            "use strict";
            var i = r(1880);
            t.exports = function (t, e, r) {
                for (var n in e) i(t, n, e[n], r);
                return t;
            };
        },
        5014: function (t, e, r) {
            "use strict";
            var i = r(9037),
                n = Object.defineProperty;
            t.exports = function (t, e) {
                try {
                    n(i, t, { value: e, configurable: !0, writable: !0 });
                } catch (r) {
                    i[t] = e;
                }
                return e;
            };
        },
        7697: function (t, e, r) {
            "use strict";
            var i = r(3689);
            t.exports = !i(function () {
                return (
                    7 !==
                    Object.defineProperty({}, 1, {
                        get: function () {
                            return 7;
                        },
                    })[1]
                );
            });
        },
        6420: function (t, e, r) {
            "use strict";
            var i = r(9037),
                n = r(8999),
                a = i.document,
                s = n(a) && n(a.createElement);
            t.exports = function (t) {
                return s ? a.createElement(t) : {};
            };
        },
        6338: function (t) {
            "use strict";
            t.exports = {
                CSSRuleList: 0,
                CSSStyleDeclaration: 0,
                CSSValueList: 0,
                ClientRectList: 0,
                DOMRectList: 0,
                DOMStringList: 0,
                DOMTokenList: 1,
                DataTransferItemList: 0,
                FileList: 0,
                HTMLAllCollection: 0,
                HTMLCollection: 0,
                HTMLFormElement: 0,
                HTMLSelectElement: 0,
                MediaList: 0,
                MimeTypeArray: 0,
                NamedNodeMap: 0,
                NodeList: 1,
                PaintRequestList: 0,
                Plugin: 0,
                PluginArray: 0,
                SVGLengthList: 0,
                SVGNumberList: 0,
                SVGPathSegList: 0,
                SVGPointList: 0,
                SVGStringList: 0,
                SVGTransformList: 0,
                SourceBufferList: 0,
                StyleSheetList: 0,
                TextTrackCueList: 0,
                TextTrackList: 0,
                TouchList: 0,
            };
        },
        3265: function (t, e, r) {
            "use strict";
            var i = r(6420)("span").classList,
                n = i && i.constructor && i.constructor.prototype;
            t.exports = n === Object.prototype ? void 0 : n;
        },
        71: function (t) {
            "use strict";
            t.exports = ("undefined" != typeof navigator && String(navigator.userAgent)) || "";
        },
        3615: function (t, e, r) {
            "use strict";
            var i,
                n,
                a = r(9037),
                s = r(71),
                o = a.process,
                l = a.Deno,
                h = (o && o.versions) || (l && l.version),
                c = h && h.v8;
            c && (n = (i = c.split("."))[0] > 0 && i[0] < 4 ? 1 : +(i[0] + i[1])), !n && s && (!(i = s.match(/Edge\/(\d+)/)) || i[1] >= 74) && (i = s.match(/Chrome\/(\d+)/)) && (n = +i[1]), (t.exports = n);
        },
        2739: function (t) {
            "use strict";
            t.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
        },
        9989: function (t, e, r) {
            "use strict";
            var i = r(9037),
                n = r(2474).f,
                a = r(5773),
                s = r(1880),
                o = r(5014),
                l = r(8758),
                h = r(5266);
            t.exports = function (t, e) {
                var r,
                    c,
                    p,
                    u,
                    f,
                    d = t.target,
                    m = t.global,
                    y = t.stat;
                if ((r = m ? i : y ? i[d] || o(d, {}) : i[d] && i[d].prototype))
                    for (c in e) {
                        if (((u = e[c]), (p = t.dontCallGetSet ? (f = n(r, c)) && f.value : r[c]), !h(m ? c : d + (y ? "." : "#") + c, t.forced) && void 0 !== p)) {
                            if (typeof u == typeof p) continue;
                            l(u, p);
                        }
                        (t.sham || (p && p.sham)) && a(u, "sham", !0), s(r, c, u, t);
                    }
            };
        },
        3689: function (t) {
            "use strict";
            t.exports = function (t) {
                try {
                    return !!t();
                } catch (t) {
                    return !0;
                }
            };
        },
        8678: function (t, e, r) {
            "use strict";
            r(4043);
            var i = r(2615),
                n = r(1880),
                a = r(6308),
                s = r(3689),
                o = r(4201),
                l = r(5773),
                h = o("species"),
                c = RegExp.prototype;
            t.exports = function (t, e, r, p) {
                var u = o(t),
                    f = !s(function () {
                        var e = {};
                        return (
                            (e[u] = function () {
                                return 7;
                            }),
                            7 !== ""[t](e)
                        );
                    }),
                    d =
                        f &&
                        !s(function () {
                            var e = !1,
                                r = /a/;
                            return (
                                "split" === t &&
                                    (((r = {}).constructor = {}),
                                    (r.constructor[h] = function () {
                                        return r;
                                    }),
                                    (r.flags = ""),
                                    (r[u] = /./[u])),
                                (r.exec = function () {
                                    return (e = !0), null;
                                }),
                                r[u](""),
                                !e
                            );
                        });
                if (!f || !d || r) {
                    var m = /./[u],
                        y = e(u, ""[t], function (t, e, r, n, s) {
                            var o = e.exec;
                            return o === a || o === c.exec ? (f && !s ? { done: !0, value: i(m, e, r, n) } : { done: !0, value: i(t, r, e, n) }) : { done: !1 };
                        });
                    n(String.prototype, t, y[0]), n(c, u, y[1]);
                }
                p && l(c[u], "sham", !0);
            };
        },
        1735: function (t, e, r) {
            "use strict";
            var i = r(7215),
                n = Function.prototype,
                a = n.apply,
                s = n.call;
            t.exports =
                ("object" == typeof Reflect && Reflect.apply) ||
                (i
                    ? s.bind(a)
                    : function () {
                          return s.apply(a, arguments);
                      });
        },
        4071: function (t, e, r) {
            "use strict";
            var i = r(6576),
                n = r(509),
                a = r(7215),
                s = i(i.bind);
            t.exports = function (t, e) {
                return (
                    n(t),
                    void 0 === e
                        ? t
                        : a
                        ? s(t, e)
                        : function () {
                              return t.apply(e, arguments);
                          }
                );
            };
        },
        7215: function (t, e, r) {
            "use strict";
            var i = r(3689);
            t.exports = !i(function () {
                var t = function () {}.bind();
                return "function" != typeof t || t.hasOwnProperty("prototype");
            });
        },
        2615: function (t, e, r) {
            "use strict";
            var i = r(7215),
                n = Function.prototype.call;
            t.exports = i
                ? n.bind(n)
                : function () {
                      return n.apply(n, arguments);
                  };
        },
        1236: function (t, e, r) {
            "use strict";
            var i = r(7697),
                n = r(6812),
                a = Function.prototype,
                s = i && Object.getOwnPropertyDescriptor,
                o = n(a, "name"),
                l = o && "something" === function () {}.name,
                h = o && (!i || (i && s(a, "name").configurable));
            t.exports = { EXISTS: o, PROPER: l, CONFIGURABLE: h };
        },
        2743: function (t, e, r) {
            "use strict";
            var i = r(8844),
                n = r(509);
            t.exports = function (t, e, r) {
                try {
                    return i(n(Object.getOwnPropertyDescriptor(t, e)[r]));
                } catch (t) {}
            };
        },
        6576: function (t, e, r) {
            "use strict";
            var i = r(6648),
                n = r(8844);
            t.exports = function (t) {
                if ("Function" === i(t)) return n(t);
            };
        },
        8844: function (t, e, r) {
            "use strict";
            var i = r(7215),
                n = Function.prototype,
                a = n.call,
                s = i && n.bind.bind(a, a);
            t.exports = i
                ? s
                : function (t) {
                      return function () {
                          return a.apply(t, arguments);
                      };
                  };
        },
        6058: function (t, e, r) {
            "use strict";
            var i = r(9037),
                n = r(9985);
            t.exports = function (t, e) {
                return arguments.length < 2 ? ((r = i[t]), n(r) ? r : void 0) : i[t] && i[t][e];
                var r;
            };
        },
        1664: function (t, e, r) {
            "use strict";
            var i = r(926),
                n = r(4849),
                a = r(981),
                s = r(9478),
                o = r(4201)("iterator");
            t.exports = function (t) {
                if (!a(t)) return n(t, o) || n(t, "@@iterator") || s[i(t)];
            };
        },
        5185: function (t, e, r) {
            "use strict";
            var i = r(2615),
                n = r(509),
                a = r(5027),
                s = r(3691),
                o = r(1664),
                l = TypeError;
            t.exports = function (t, e) {
                var r = arguments.length < 2 ? o(t) : e;
                if (n(r)) return a(i(r, t));
                throw new l(s(t) + " is not iterable");
            };
        },
        4849: function (t, e, r) {
            "use strict";
            var i = r(509),
                n = r(981);
            t.exports = function (t, e) {
                var r = t[e];
                return n(r) ? void 0 : i(r);
            };
        },
        7017: function (t, e, r) {
            "use strict";
            var i = r(8844),
                n = r(690),
                a = Math.floor,
                s = i("".charAt),
                o = i("".replace),
                l = i("".slice),
                h = /\$([$&'`]|\d{1,2}|<[^>]*>)/g,
                c = /\$([$&'`]|\d{1,2})/g;
            t.exports = function (t, e, r, i, p, u) {
                var f = r + t.length,
                    d = i.length,
                    m = c;
                return (
                    void 0 !== p && ((p = n(p)), (m = h)),
                    o(u, m, function (n, o) {
                        var h;
                        switch (s(o, 0)) {
                            case "$":
                                return "$";
                            case "&":
                                return t;
                            case "`":
                                return l(e, 0, r);
                            case "'":
                                return l(e, f);
                            case "<":
                                h = p[l(o, 1, -1)];
                                break;
                            default:
                                var c = +o;
                                if (0 === c) return n;
                                if (c > d) {
                                    var u = a(c / 10);
                                    return 0 === u ? n : u <= d ? (void 0 === i[u - 1] ? s(o, 1) : i[u - 1] + s(o, 1)) : n;
                                }
                                h = i[c - 1];
                        }
                        return void 0 === h ? "" : h;
                    })
                );
            };
        },
        9037: function (t, e, r) {
            "use strict";
            var i = function (t) {
                return t && t.Math === Math && t;
            };
            t.exports =
                i("object" == typeof globalThis && globalThis) ||
                i("object" == typeof window && window) ||
                i("object" == typeof self && self) ||
                i("object" == typeof r.g && r.g) ||
                i("object" == typeof this && this) ||
                (function () {
                    return this;
                })() ||
                Function("return this")();
        },
        6812: function (t, e, r) {
            "use strict";
            var i = r(8844),
                n = r(690),
                a = i({}.hasOwnProperty);
            t.exports =
                Object.hasOwn ||
                function (t, e) {
                    return a(n(t), e);
                };
        },
        7248: function (t) {
            "use strict";
            t.exports = {};
        },
        2688: function (t, e, r) {
            "use strict";
            var i = r(6058);
            t.exports = i("document", "documentElement");
        },
        8506: function (t, e, r) {
            "use strict";
            var i = r(7697),
                n = r(3689),
                a = r(6420);
            t.exports =
                !i &&
                !n(function () {
                    return (
                        7 !==
                        Object.defineProperty(a("div"), "a", {
                            get: function () {
                                return 7;
                            },
                        }).a
                    );
                });
        },
        4413: function (t, e, r) {
            "use strict";
            var i = r(8844),
                n = r(3689),
                a = r(6648),
                s = Object,
                o = i("".split);
            t.exports = n(function () {
                return !s("z").propertyIsEnumerable(0);
            })
                ? function (t) {
                      return "String" === a(t) ? o(t, "") : s(t);
                  }
                : s;
        },
        6738: function (t, e, r) {
            "use strict";
            var i = r(8844),
                n = r(9985),
                a = r(4091),
                s = i(Function.toString);
            n(a.inspectSource) ||
                (a.inspectSource = function (t) {
                    return s(t);
                }),
                (t.exports = a.inspectSource);
        },
        618: function (t, e, r) {
            "use strict";
            var i,
                n,
                a,
                s = r(9834),
                o = r(9037),
                l = r(8999),
                h = r(5773),
                c = r(6812),
                p = r(4091),
                u = r(2713),
                f = r(7248),
                d = "Object already initialized",
                m = o.TypeError,
                y = o.WeakMap;
            if (s || p.state) {
                var v = p.state || (p.state = new y());
                (v.get = v.get),
                    (v.has = v.has),
                    (v.set = v.set),
                    (i = function (t, e) {
                        if (v.has(t)) throw new m(d);
                        return (e.facade = t), v.set(t, e), e;
                    }),
                    (n = function (t) {
                        return v.get(t) || {};
                    }),
                    (a = function (t) {
                        return v.has(t);
                    });
            } else {
                var g = u("state");
                (f[g] = !0),
                    (i = function (t, e) {
                        if (c(t, g)) throw new m(d);
                        return (e.facade = t), h(t, g, e), e;
                    }),
                    (n = function (t) {
                        return c(t, g) ? t[g] : {};
                    }),
                    (a = function (t) {
                        return c(t, g);
                    });
            }
            t.exports = {
                set: i,
                get: n,
                has: a,
                enforce: function (t) {
                    return a(t) ? n(t) : i(t, {});
                },
                getterFor: function (t) {
                    return function (e) {
                        var r;
                        if (!l(e) || (r = n(e)).type !== t) throw new m("Incompatible receiver, " + t + " required");
                        return r;
                    };
                },
            };
        },
        9985: function (t) {
            "use strict";
            var e = "object" == typeof document && document.all;
            t.exports =
                void 0 === e && void 0 !== e
                    ? function (t) {
                          return "function" == typeof t || t === e;
                      }
                    : function (t) {
                          return "function" == typeof t;
                      };
        },
        5266: function (t, e, r) {
            "use strict";
            var i = r(3689),
                n = r(9985),
                a = /#|\.prototype\./,
                s = function (t, e) {
                    var r = l[o(t)];
                    return r === c || (r !== h && (n(e) ? i(e) : !!e));
                },
                o = (s.normalize = function (t) {
                    return String(t).replace(a, ".").toLowerCase();
                }),
                l = (s.data = {}),
                h = (s.NATIVE = "N"),
                c = (s.POLYFILL = "P");
            t.exports = s;
        },
        981: function (t) {
            "use strict";
            t.exports = function (t) {
                return null == t;
            };
        },
        8999: function (t, e, r) {
            "use strict";
            var i = r(9985);
            t.exports = function (t) {
                return "object" == typeof t ? null !== t : i(t);
            };
        },
        598: function (t, e, r) {
            "use strict";
            var i = r(8999);
            t.exports = function (t) {
                return i(t) || null === t;
            };
        },
        3931: function (t) {
            "use strict";
            t.exports = !1;
        },
        734: function (t, e, r) {
            "use strict";
            var i = r(6058),
                n = r(9985),
                a = r(3622),
                s = r(9525),
                o = Object;
            t.exports = s
                ? function (t) {
                      return "symbol" == typeof t;
                  }
                : function (t) {
                      var e = i("Symbol");
                      return n(e) && a(e.prototype, o(t));
                  };
        },
        974: function (t, e, r) {
            "use strict";
            var i = r(2013).IteratorPrototype,
                n = r(5391),
                a = r(5684),
                s = r(5997),
                o = r(9478),
                l = function () {
                    return this;
                };
            t.exports = function (t, e, r, h) {
                var c = e + " Iterator";
                return (t.prototype = n(i, { next: a(+!h, r) })), s(t, c, !1, !0), (o[c] = l), t;
            };
        },
        1934: function (t, e, r) {
            "use strict";
            var i = r(9989),
                n = r(2615),
                a = r(3931),
                s = r(1236),
                o = r(9985),
                l = r(974),
                h = r(1868),
                c = r(9385),
                p = r(5997),
                u = r(5773),
                f = r(1880),
                d = r(4201),
                m = r(9478),
                y = r(2013),
                v = s.PROPER,
                g = s.CONFIGURABLE,
                _ = y.IteratorPrototype,
                b = y.BUGGY_SAFARI_ITERATORS,
                E = d("iterator"),
                S = "keys",
                P = "values",
                w = "entries",
                x = function () {
                    return this;
                };
            t.exports = function (t, e, r, s, d, y, A) {
                l(r, e, s);
                var C,
                    T,
                    k,
                    D = function (t) {
                        if (t === d && O) return O;
                        if (!b && t && t in F) return F[t];
                        switch (t) {
                            case S:
                            case P:
                            case w:
                                return function () {
                                    return new r(this, t);
                                };
                        }
                        return function () {
                            return new r(this);
                        };
                    },
                    M = e + " Iterator",
                    I = !1,
                    F = t.prototype,
                    L = F[E] || F["@@iterator"] || (d && F[d]),
                    O = (!b && L) || D(d),
                    R = ("Array" === e && F.entries) || L;
                if (
                    (R && (C = h(R.call(new t()))) !== Object.prototype && C.next && (a || h(C) === _ || (c ? c(C, _) : o(C[E]) || f(C, E, x)), p(C, M, !0, !0), a && (m[M] = x)),
                    v &&
                        d === P &&
                        L &&
                        L.name !== P &&
                        (!a && g
                            ? u(F, "name", P)
                            : ((I = !0),
                              (O = function () {
                                  return n(L, this);
                              }))),
                    d)
                )
                    if (((T = { values: D(P), keys: y ? O : D(S), entries: D(w) }), A)) for (k in T) (b || I || !(k in F)) && f(F, k, T[k]);
                    else i({ target: e, proto: !0, forced: b || I }, T);
                return (a && !A) || F[E] === O || f(F, E, O, { name: d }), (m[e] = O), T;
            };
        },
        2013: function (t, e, r) {
            "use strict";
            var i,
                n,
                a,
                s = r(3689),
                o = r(9985),
                l = r(8999),
                h = r(5391),
                c = r(1868),
                p = r(1880),
                u = r(4201),
                f = r(3931),
                d = u("iterator"),
                m = !1;
            [].keys && ("next" in (a = [].keys()) ? (n = c(c(a))) !== Object.prototype && (i = n) : (m = !0)),
                !l(i) ||
                s(function () {
                    var t = {};
                    return i[d].call(t) !== t;
                })
                    ? (i = {})
                    : f && (i = h(i)),
                o(i[d]) ||
                    p(i, d, function () {
                        return this;
                    }),
                (t.exports = { IteratorPrototype: i, BUGGY_SAFARI_ITERATORS: m });
        },
        9478: function (t) {
            "use strict";
            t.exports = {};
        },
        6310: function (t, e, r) {
            "use strict";
            var i = r(3126);
            t.exports = function (t) {
                return i(t.length);
            };
        },
        8702: function (t, e, r) {
            "use strict";
            var i = r(8844),
                n = r(3689),
                a = r(9985),
                s = r(6812),
                o = r(7697),
                l = r(1236).CONFIGURABLE,
                h = r(6738),
                c = r(618),
                p = c.enforce,
                u = c.get,
                f = String,
                d = Object.defineProperty,
                m = i("".slice),
                y = i("".replace),
                v = i([].join),
                g =
                    o &&
                    !n(function () {
                        return 8 !== d(function () {}, "length", { value: 8 }).length;
                    }),
                _ = String(String).split("String"),
                b = (t.exports = function (t, e, r) {
                    "Symbol(" === m(f(e), 0, 7) && (e = "[" + y(f(e), /^Symbol\(([^)]*)\).*$/, "$1") + "]"),
                        r && r.getter && (e = "get " + e),
                        r && r.setter && (e = "set " + e),
                        (!s(t, "name") || (l && t.name !== e)) && (o ? d(t, "name", { value: e, configurable: !0 }) : (t.name = e)),
                        g && r && s(r, "arity") && t.length !== r.arity && d(t, "length", { value: r.arity });
                    try {
                        r && s(r, "constructor") && r.constructor ? o && d(t, "prototype", { writable: !1 }) : t.prototype && (t.prototype = void 0);
                    } catch (t) {}
                    var i = p(t);
                    return s(i, "source") || (i.source = v(_, "string" == typeof e ? e : "")), t;
                });
            Function.prototype.toString = b(function () {
                return (a(this) && u(this).source) || h(this);
            }, "toString");
        },
        8828: function (t) {
            "use strict";
            var e = Math.ceil,
                r = Math.floor;
            t.exports =
                Math.trunc ||
                function (t) {
                    var i = +t;
                    return (i > 0 ? r : e)(i);
                };
        },
        5391: function (t, e, r) {
            "use strict";
            var i,
                n = r(5027),
                a = r(8920),
                s = r(2739),
                o = r(7248),
                l = r(2688),
                h = r(6420),
                c = r(2713),
                p = "prototype",
                u = "script",
                f = c("IE_PROTO"),
                d = function () {},
                m = function (t) {
                    return "<" + u + ">" + t + "</" + u + ">";
                },
                y = function (t) {
                    t.write(m("")), t.close();
                    var e = t.parentWindow.Object;
                    return (t = null), e;
                },
                v = function () {
                    try {
                        i = new ActiveXObject("htmlfile");
                    } catch (t) {}
                    var t, e, r;
                    v =
                        "undefined" != typeof document
                            ? document.domain && i
                                ? y(i)
                                : ((e = h("iframe")), (r = "java" + u + ":"), (e.style.display = "none"), l.appendChild(e), (e.src = String(r)), (t = e.contentWindow.document).open(), t.write(m("document.F=Object")), t.close(), t.F)
                            : y(i);
                    for (var n = s.length; n--; ) delete v[p][s[n]];
                    return v();
                };
            (o[f] = !0),
                (t.exports =
                    Object.create ||
                    function (t, e) {
                        var r;
                        return null !== t ? ((d[p] = n(t)), (r = new d()), (d[p] = null), (r[f] = t)) : (r = v()), void 0 === e ? r : a.f(r, e);
                    });
        },
        8920: function (t, e, r) {
            "use strict";
            var i = r(7697),
                n = r(5648),
                a = r(2560),
                s = r(5027),
                o = r(5290),
                l = r(300);
            e.f =
                i && !n
                    ? Object.defineProperties
                    : function (t, e) {
                          s(t);
                          for (var r, i = o(e), n = l(e), h = n.length, c = 0; h > c; ) a.f(t, (r = n[c++]), i[r]);
                          return t;
                      };
        },
        2560: function (t, e, r) {
            "use strict";
            var i = r(7697),
                n = r(8506),
                a = r(5648),
                s = r(5027),
                o = r(8360),
                l = TypeError,
                h = Object.defineProperty,
                c = Object.getOwnPropertyDescriptor,
                p = "enumerable",
                u = "configurable",
                f = "writable";
            e.f = i
                ? a
                    ? function (t, e, r) {
                          if ((s(t), (e = o(e)), s(r), "function" == typeof t && "prototype" === e && "value" in r && f in r && !r[f])) {
                              var i = c(t, e);
                              i && i[f] && ((t[e] = r.value), (r = { configurable: u in r ? r[u] : i[u], enumerable: p in r ? r[p] : i[p], writable: !1 }));
                          }
                          return h(t, e, r);
                      }
                    : h
                : function (t, e, r) {
                      if ((s(t), (e = o(e)), s(r), n))
                          try {
                              return h(t, e, r);
                          } catch (t) {}
                      if ("get" in r || "set" in r) throw new l("Accessors not supported");
                      return "value" in r && (t[e] = r.value), t;
                  };
        },
        2474: function (t, e, r) {
            "use strict";
            var i = r(7697),
                n = r(2615),
                a = r(9556),
                s = r(5684),
                o = r(5290),
                l = r(8360),
                h = r(6812),
                c = r(8506),
                p = Object.getOwnPropertyDescriptor;
            e.f = i
                ? p
                : function (t, e) {
                      if (((t = o(t)), (e = l(e)), c))
                          try {
                              return p(t, e);
                          } catch (t) {}
                      if (h(t, e)) return s(!n(a.f, t, e), t[e]);
                  };
        },
        2741: function (t, e, r) {
            "use strict";
            var i = r(4948),
                n = r(2739).concat("length", "prototype");
            e.f =
                Object.getOwnPropertyNames ||
                function (t) {
                    return i(t, n);
                };
        },
        7518: function (t, e) {
            "use strict";
            e.f = Object.getOwnPropertySymbols;
        },
        1868: function (t, e, r) {
            "use strict";
            var i = r(6812),
                n = r(9985),
                a = r(690),
                s = r(2713),
                o = r(1748),
                l = s("IE_PROTO"),
                h = Object,
                c = h.prototype;
            t.exports = o
                ? h.getPrototypeOf
                : function (t) {
                      var e = a(t);
                      if (i(e, l)) return e[l];
                      var r = e.constructor;
                      return n(r) && e instanceof r ? r.prototype : e instanceof h ? c : null;
                  };
        },
        3622: function (t, e, r) {
            "use strict";
            var i = r(8844);
            t.exports = i({}.isPrototypeOf);
        },
        4948: function (t, e, r) {
            "use strict";
            var i = r(8844),
                n = r(6812),
                a = r(5290),
                s = r(4328).indexOf,
                o = r(7248),
                l = i([].push);
            t.exports = function (t, e) {
                var r,
                    i = a(t),
                    h = 0,
                    c = [];
                for (r in i) !n(o, r) && n(i, r) && l(c, r);
                for (; e.length > h; ) n(i, (r = e[h++])) && (~s(c, r) || l(c, r));
                return c;
            };
        },
        300: function (t, e, r) {
            "use strict";
            var i = r(4948),
                n = r(2739);
            t.exports =
                Object.keys ||
                function (t) {
                    return i(t, n);
                };
        },
        9556: function (t, e) {
            "use strict";
            var r = {}.propertyIsEnumerable,
                i = Object.getOwnPropertyDescriptor,
                n = i && !r.call({ 1: 2 }, 1);
            e.f = n
                ? function (t) {
                      var e = i(this, t);
                      return !!e && e.enumerable;
                  }
                : r;
        },
        9385: function (t, e, r) {
            "use strict";
            var i = r(2743),
                n = r(8999),
                a = r(4684),
                s = r(3550);
            t.exports =
                Object.setPrototypeOf ||
                ("__proto__" in {}
                    ? (function () {
                          var t,
                              e = !1,
                              r = {};
                          try {
                              (t = i(Object.prototype, "__proto__", "set"))(r, []), (e = r instanceof Array);
                          } catch (t) {}
                          return function (r, i) {
                              return a(r), s(i), n(r) ? (e ? t(r, i) : (r.__proto__ = i), r) : r;
                          };
                      })()
                    : void 0);
        },
        5899: function (t, e, r) {
            "use strict";
            var i = r(2615),
                n = r(9985),
                a = r(8999),
                s = TypeError;
            t.exports = function (t, e) {
                var r, o;
                if ("string" === e && n((r = t.toString)) && !a((o = i(r, t)))) return o;
                if (n((r = t.valueOf)) && !a((o = i(r, t)))) return o;
                if ("string" !== e && n((r = t.toString)) && !a((o = i(r, t)))) return o;
                throw new s("Can't convert object to primitive value");
            };
        },
        9152: function (t, e, r) {
            "use strict";
            var i = r(6058),
                n = r(8844),
                a = r(2741),
                s = r(7518),
                o = r(5027),
                l = n([].concat);
            t.exports =
                i("Reflect", "ownKeys") ||
                function (t) {
                    var e = a.f(o(t)),
                        r = s.f;
                    return r ? l(e, r(t)) : e;
                };
        },
        6100: function (t, e, r) {
            "use strict";
            var i = r(2615),
                n = r(5027),
                a = r(9985),
                s = r(6648),
                o = r(6308),
                l = TypeError;
            t.exports = function (t, e) {
                var r = t.exec;
                if (a(r)) {
                    var h = i(r, t, e);
                    return null !== h && n(h), h;
                }
                if ("RegExp" === s(t)) return i(o, t, e);
                throw new l("RegExp#exec called on incompatible receiver");
            };
        },
        6308: function (t, e, r) {
            "use strict";
            var i,
                n,
                a = r(2615),
                s = r(8844),
                o = r(4327),
                l = r(9633),
                h = r(7901),
                c = r(3430),
                p = r(5391),
                u = r(618).get,
                f = r(2100),
                d = r(6422),
                m = c("native-string-replace", String.prototype.replace),
                y = RegExp.prototype.exec,
                v = y,
                g = s("".charAt),
                _ = s("".indexOf),
                b = s("".replace),
                E = s("".slice),
                S = ((n = /b*/g), a(y, (i = /a/), "a"), a(y, n, "a"), 0 !== i.lastIndex || 0 !== n.lastIndex),
                P = h.BROKEN_CARET,
                w = void 0 !== /()??/.exec("")[1];
            (S || w || P || f || d) &&
                (v = function (t) {
                    var e,
                        r,
                        i,
                        n,
                        s,
                        h,
                        c,
                        f = this,
                        d = u(f),
                        x = o(t),
                        A = d.raw;
                    if (A) return (A.lastIndex = f.lastIndex), (e = a(v, A, x)), (f.lastIndex = A.lastIndex), e;
                    var C = d.groups,
                        T = P && f.sticky,
                        k = a(l, f),
                        D = f.source,
                        M = 0,
                        I = x;
                    if (
                        (T &&
                            ((k = b(k, "y", "")),
                            -1 === _(k, "g") && (k += "g"),
                            (I = E(x, f.lastIndex)),
                            f.lastIndex > 0 && (!f.multiline || (f.multiline && "\n" !== g(x, f.lastIndex - 1))) && ((D = "(?: " + D + ")"), (I = " " + I), M++),
                            (r = new RegExp("^(?:" + D + ")", k))),
                        w && (r = new RegExp("^" + D + "$(?!\\s)", k)),
                        S && (i = f.lastIndex),
                        (n = a(y, T ? r : f, I)),
                        T ? (n ? ((n.input = E(n.input, M)), (n[0] = E(n[0], M)), (n.index = f.lastIndex), (f.lastIndex += n[0].length)) : (f.lastIndex = 0)) : S && n && (f.lastIndex = f.global ? n.index + n[0].length : i),
                        w &&
                            n &&
                            n.length > 1 &&
                            a(m, n[0], r, function () {
                                for (s = 1; s < arguments.length - 2; s++) void 0 === arguments[s] && (n[s] = void 0);
                            }),
                        n && C)
                    )
                        for (n.groups = h = p(null), s = 0; s < C.length; s++) h[(c = C[s])[0]] = n[c[1]];
                    return n;
                }),
                (t.exports = v);
        },
        9633: function (t, e, r) {
            "use strict";
            var i = r(5027);
            t.exports = function () {
                var t = i(this),
                    e = "";
                return t.hasIndices && (e += "d"), t.global && (e += "g"), t.ignoreCase && (e += "i"), t.multiline && (e += "m"), t.dotAll && (e += "s"), t.unicode && (e += "u"), t.unicodeSets && (e += "v"), t.sticky && (e += "y"), e;
            };
        },
        7901: function (t, e, r) {
            "use strict";
            var i = r(3689),
                n = r(9037).RegExp,
                a = i(function () {
                    var t = n("a", "y");
                    return (t.lastIndex = 2), null !== t.exec("abcd");
                }),
                s =
                    a ||
                    i(function () {
                        return !n("a", "y").sticky;
                    }),
                o =
                    a ||
                    i(function () {
                        var t = n("^r", "gy");
                        return (t.lastIndex = 2), null !== t.exec("str");
                    });
            t.exports = { BROKEN_CARET: o, MISSED_STICKY: s, UNSUPPORTED_Y: a };
        },
        2100: function (t, e, r) {
            "use strict";
            var i = r(3689),
                n = r(9037).RegExp;
            t.exports = i(function () {
                var t = n(".", "s");
                return !(t.dotAll && t.test("\n") && "s" === t.flags);
            });
        },
        6422: function (t, e, r) {
            "use strict";
            var i = r(3689),
                n = r(9037).RegExp;
            t.exports = i(function () {
                var t = n("(?<a>b)", "g");
                return "b" !== t.exec("b").groups.a || "bc" !== "b".replace(t, "$<a>c");
            });
        },
        4684: function (t, e, r) {
            "use strict";
            var i = r(981),
                n = TypeError;
            t.exports = function (t) {
                if (i(t)) throw new n("Can't call method on " + t);
                return t;
            };
        },
        517: function (t, e, r) {
            "use strict";
            var i = r(9037),
                n = r(7697),
                a = Object.getOwnPropertyDescriptor;
            t.exports = function (t) {
                if (!n) return i[t];
                var e = a(i, t);
                return e && e.value;
            };
        },
        5997: function (t, e, r) {
            "use strict";
            var i = r(2560).f,
                n = r(6812),
                a = r(4201)("toStringTag");
            t.exports = function (t, e, r) {
                t && !r && (t = t.prototype), t && !n(t, a) && i(t, a, { configurable: !0, value: e });
            };
        },
        2713: function (t, e, r) {
            "use strict";
            var i = r(3430),
                n = r(4630),
                a = i("keys");
            t.exports = function (t) {
                return a[t] || (a[t] = n(t));
            };
        },
        4091: function (t, e, r) {
            "use strict";
            var i = r(3931),
                n = r(9037),
                a = r(5014),
                s = "__core-js_shared__",
                o = (t.exports = n[s] || a(s, {}));
            (o.versions || (o.versions = [])).push({
                version: "3.37.1",
                mode: i ? "pure" : "global",
                copyright: "© 2014-2024 Denis Pushkarev (zloirock.ru)",
                license: "https://github.com/zloirock/core-js/blob/v3.37.1/LICENSE",
                source: "https://github.com/zloirock/core-js",
            });
        },
        3430: function (t, e, r) {
            "use strict";
            var i = r(4091);
            t.exports = function (t, e) {
                return i[t] || (i[t] = e || {});
            };
        },
        730: function (t, e, r) {
            "use strict";
            var i = r(8844),
                n = r(8700),
                a = r(4327),
                s = r(4684),
                o = i("".charAt),
                l = i("".charCodeAt),
                h = i("".slice),
                c = function (t) {
                    return function (e, r) {
                        var i,
                            c,
                            p = a(s(e)),
                            u = n(r),
                            f = p.length;
                        return u < 0 || u >= f
                            ? t
                                ? ""
                                : void 0
                            : (i = l(p, u)) < 55296 || i > 56319 || u + 1 === f || (c = l(p, u + 1)) < 56320 || c > 57343
                            ? t
                                ? o(p, u)
                                : i
                            : t
                            ? h(p, u, u + 2)
                            : c - 56320 + ((i - 55296) << 10) + 65536;
                    };
                };
            t.exports = { codeAt: c(!1), charAt: c(!0) };
        },
        146: function (t, e, r) {
            "use strict";
            var i = r(3615),
                n = r(3689),
                a = r(9037).String;
            t.exports =
                !!Object.getOwnPropertySymbols &&
                !n(function () {
                    var t = Symbol("symbol detection");
                    return !a(t) || !(Object(t) instanceof Symbol) || (!Symbol.sham && i && i < 41);
                });
        },
        7578: function (t, e, r) {
            "use strict";
            var i = r(8700),
                n = Math.max,
                a = Math.min;
            t.exports = function (t, e) {
                var r = i(t);
                return r < 0 ? n(r + e, 0) : a(r, e);
            };
        },
        5290: function (t, e, r) {
            "use strict";
            var i = r(4413),
                n = r(4684);
            t.exports = function (t) {
                return i(n(t));
            };
        },
        8700: function (t, e, r) {
            "use strict";
            var i = r(8828);
            t.exports = function (t) {
                var e = +t;
                return e != e || 0 === e ? 0 : i(e);
            };
        },
        3126: function (t, e, r) {
            "use strict";
            var i = r(8700),
                n = Math.min;
            t.exports = function (t) {
                var e = i(t);
                return e > 0 ? n(e, 9007199254740991) : 0;
            };
        },
        690: function (t, e, r) {
            "use strict";
            var i = r(4684),
                n = Object;
            t.exports = function (t) {
                return n(i(t));
            };
        },
        8732: function (t, e, r) {
            "use strict";
            var i = r(2615),
                n = r(8999),
                a = r(734),
                s = r(4849),
                o = r(5899),
                l = r(4201),
                h = TypeError,
                c = l("toPrimitive");
            t.exports = function (t, e) {
                if (!n(t) || a(t)) return t;
                var r,
                    l = s(t, c);
                if (l) {
                    if ((void 0 === e && (e = "default"), (r = i(l, t, e)), !n(r) || a(r))) return r;
                    throw new h("Can't convert object to primitive value");
                }
                return void 0 === e && (e = "number"), o(t, e);
            };
        },
        8360: function (t, e, r) {
            "use strict";
            var i = r(8732),
                n = r(734);
            t.exports = function (t) {
                var e = i(t, "string");
                return n(e) ? e : e + "";
            };
        },
        3043: function (t, e, r) {
            "use strict";
            var i = {};
            (i[r(4201)("toStringTag")] = "z"), (t.exports = "[object z]" === String(i));
        },
        4327: function (t, e, r) {
            "use strict";
            var i = r(926),
                n = String;
            t.exports = function (t) {
                if ("Symbol" === i(t)) throw new TypeError("Cannot convert a Symbol value to a string");
                return n(t);
            };
        },
        3691: function (t) {
            "use strict";
            var e = String;
            t.exports = function (t) {
                try {
                    return e(t);
                } catch (t) {
                    return "Object";
                }
            };
        },
        4630: function (t, e, r) {
            "use strict";
            var i = r(8844),
                n = 0,
                a = Math.random(),
                s = i((1).toString);
            t.exports = function (t) {
                return "Symbol(" + (void 0 === t ? "" : t) + ")_" + s(++n + a, 36);
            };
        },
        6837: function (t, e, r) {
            "use strict";
            var i = r(3689),
                n = r(4201),
                a = r(7697),
                s = r(3931),
                o = n("iterator");
            t.exports = !i(function () {
                var t = new URL("b?a=1&b=2&c=3", "http://a"),
                    e = t.searchParams,
                    r = new URLSearchParams("a=1&a=2&b=3"),
                    i = "";
                return (
                    (t.pathname = "c%20d"),
                    e.forEach(function (t, r) {
                        e.delete("b"), (i += r + t);
                    }),
                    r.delete("a", 2),
                    r.delete("b", void 0),
                    (s && (!t.toJSON || !r.has("a", 1) || r.has("a", 2) || !r.has("a", void 0) || r.has("b"))) ||
                        (!e.size && (s || !a)) ||
                        !e.sort ||
                        "http://a/c%20d?a=1&c=3" !== t.href ||
                        "3" !== e.get("c") ||
                        "a=1" !== String(new URLSearchParams("?a=1")) ||
                        !e[o] ||
                        "a" !== new URL("https://a@b").username ||
                        "b" !== new URLSearchParams(new URLSearchParams("a=b")).get("a") ||
                        "xn--e1aybc" !== new URL("http://тест").host ||
                        "#%D0%B1" !== new URL("http://a#б").hash ||
                        "a1c3" !== i ||
                        "x" !== new URL("http://x", void 0).host
                );
            });
        },
        9525: function (t, e, r) {
            "use strict";
            var i = r(146);
            t.exports = i && !Symbol.sham && "symbol" == typeof Symbol.iterator;
        },
        5648: function (t, e, r) {
            "use strict";
            var i = r(7697),
                n = r(3689);
            t.exports =
                i &&
                n(function () {
                    return 42 !== Object.defineProperty(function () {}, "prototype", { value: 42, writable: !1 }).prototype;
                });
        },
        1500: function (t) {
            "use strict";
            var e = TypeError;
            t.exports = function (t, r) {
                if (t < r) throw new e("Not enough arguments");
                return t;
            };
        },
        9834: function (t, e, r) {
            "use strict";
            var i = r(9037),
                n = r(9985),
                a = i.WeakMap;
            t.exports = n(a) && /native code/.test(String(a));
        },
        4201: function (t, e, r) {
            "use strict";
            var i = r(9037),
                n = r(3430),
                a = r(6812),
                s = r(4630),
                o = r(146),
                l = r(9525),
                h = i.Symbol,
                c = n("wks"),
                p = l ? h.for || h : (h && h.withoutSetter) || s;
            t.exports = function (t) {
                return a(c, t) || (c[t] = o && a(h, t) ? h[t] : p("Symbol." + t)), c[t];
            };
        },
        752: function (t, e, r) {
            "use strict";
            var i = r(5290),
                n = r(7370),
                a = r(9478),
                s = r(618),
                o = r(2560).f,
                l = r(1934),
                h = r(7807),
                c = r(3931),
                p = r(7697),
                u = "Array Iterator",
                f = s.set,
                d = s.getterFor(u);
            t.exports = l(
                Array,
                "Array",
                function (t, e) {
                    f(this, { type: u, target: i(t), index: 0, kind: e });
                },
                function () {
                    var t = d(this),
                        e = t.target,
                        r = t.index++;
                    if (!e || r >= e.length) return (t.target = void 0), h(void 0, !0);
                    switch (t.kind) {
                        case "keys":
                            return h(r, !1);
                        case "values":
                            return h(e[r], !1);
                    }
                    return h([r, e[r]], !1);
                },
                "values"
            );
            var m = (a.Arguments = a.Array);
            if ((n("keys"), n("values"), n("entries"), !c && p && "values" !== m.name))
                try {
                    o(m, "name", { value: "values" });
                } catch (t) {}
        },
        4043: function (t, e, r) {
            "use strict";
            var i = r(9989),
                n = r(6308);
            i({ target: "RegExp", proto: !0, forced: /./.exec !== n }, { exec: n });
        },
        7267: function (t, e, r) {
            "use strict";
            var i = r(1735),
                n = r(2615),
                a = r(8844),
                s = r(8678),
                o = r(3689),
                l = r(5027),
                h = r(9985),
                c = r(981),
                p = r(8700),
                u = r(3126),
                f = r(4327),
                d = r(4684),
                m = r(1514),
                y = r(4849),
                v = r(7017),
                g = r(6100),
                _ = r(4201)("replace"),
                b = Math.max,
                E = Math.min,
                S = a([].concat),
                P = a([].push),
                w = a("".indexOf),
                x = a("".slice),
                A = "$0" === "a".replace(/./, "$0"),
                C = !!/./[_] && "" === /./[_]("a", "$0");
            s(
                "replace",
                function (t, e, r) {
                    var a = C ? "$" : "$0";
                    return [
                        function (t, r) {
                            var i = d(this),
                                a = c(t) ? void 0 : y(t, _);
                            return a ? n(a, t, i, r) : n(e, f(i), t, r);
                        },
                        function (t, n) {
                            var s = l(this),
                                o = f(t);
                            if ("string" == typeof n && -1 === w(n, a) && -1 === w(n, "$<")) {
                                var c = r(e, s, o, n);
                                if (c.done) return c.value;
                            }
                            var d = h(n);
                            d || (n = f(n));
                            var y,
                                _ = s.global;
                            _ && ((y = s.unicode), (s.lastIndex = 0));
                            for (var A, C = []; null !== (A = g(s, o)) && (P(C, A), _); ) {
                                "" === f(A[0]) && (s.lastIndex = m(o, u(s.lastIndex), y));
                            }
                            for (var T, k = "", D = 0, M = 0; M < C.length; M++) {
                                for (var I, F = f((A = C[M])[0]), L = b(E(p(A.index), o.length), 0), O = [], R = 1; R < A.length; R++) P(O, void 0 === (T = A[R]) ? T : String(T));
                                var B = A.groups;
                                if (d) {
                                    var G = S([F], O, L, o);
                                    void 0 !== B && P(G, B), (I = f(i(n, void 0, G)));
                                } else I = v(F, o, L, O, B, n);
                                L >= D && ((k += x(o, D, L) + I), (D = L + F.length));
                            }
                            return k + x(o, D);
                        },
                    ];
                },
                !!o(function () {
                    var t = /./;
                    return (
                        (t.exec = function () {
                            var t = [];
                            return (t.groups = { a: "7" }), t;
                        }),
                        "7" !== "".replace(t, "$<a>")
                    );
                }) ||
                    !A ||
                    C
            );
        },
        6265: function (t, e, r) {
            "use strict";
            var i = r(9037),
                n = r(6338),
                a = r(3265),
                s = r(752),
                o = r(5773),
                l = r(5997),
                h = r(4201)("iterator"),
                c = s.values,
                p = function (t, e) {
                    if (t) {
                        if (t[h] !== c)
                            try {
                                o(t, h, c);
                            } catch (e) {
                                t[h] = c;
                            }
                        if ((l(t, e, !0), n[e]))
                            for (var r in s)
                                if (t[r] !== s[r])
                                    try {
                                        o(t, r, s[r]);
                                    } catch (e) {
                                        t[r] = s[r];
                                    }
                    }
                };
            for (var u in n) p(i[u] && i[u].prototype, u);
            p(a, "DOMTokenList");
        },
        2625: function (t, e, r) {
            "use strict";
            r(752);
            var i = r(9989),
                n = r(9037),
                a = r(517),
                s = r(2615),
                o = r(8844),
                l = r(7697),
                h = r(6837),
                c = r(1880),
                p = r(2148),
                u = r(6045),
                f = r(5997),
                d = r(974),
                m = r(618),
                y = r(767),
                v = r(9985),
                g = r(6812),
                _ = r(4071),
                b = r(926),
                E = r(5027),
                S = r(8999),
                P = r(4327),
                w = r(5391),
                x = r(5684),
                A = r(5185),
                C = r(1664),
                T = r(7807),
                k = r(1500),
                D = r(4201),
                M = r(382),
                I = D("iterator"),
                F = "URLSearchParams",
                L = F + "Iterator",
                O = m.set,
                R = m.getterFor(F),
                B = m.getterFor(L),
                G = a("fetch"),
                V = a("Request"),
                N = a("Headers"),
                $ = V && V.prototype,
                j = N && N.prototype,
                z = n.RegExp,
                H = n.TypeError,
                q = n.decodeURIComponent,
                U = n.encodeURIComponent,
                W = o("".charAt),
                Y = o([].join),
                K = o([].push),
                Z = o("".replace),
                X = o([].shift),
                Q = o([].splice),
                J = o("".split),
                tt = o("".slice),
                et = /\+/g,
                rt = Array(4),
                it = function (t) {
                    return rt[t - 1] || (rt[t - 1] = z("((?:%[\\da-f]{2}){" + t + "})", "gi"));
                },
                nt = function (t) {
                    try {
                        return q(t);
                    } catch (e) {
                        return t;
                    }
                },
                at = function (t) {
                    var e = Z(t, et, " "),
                        r = 4;
                    try {
                        return q(e);
                    } catch (t) {
                        for (; r; ) e = Z(e, it(r--), nt);
                        return e;
                    }
                },
                st = /[!'()~]|%20/g,
                ot = { "!": "%21", "'": "%27", "(": "%28", ")": "%29", "~": "%7E", "%20": "+" },
                lt = function (t) {
                    return ot[t];
                },
                ht = function (t) {
                    return Z(U(t), st, lt);
                },
                ct = d(
                    function (t, e) {
                        O(this, { type: L, target: R(t).entries, index: 0, kind: e });
                    },
                    F,
                    function () {
                        var t = B(this),
                            e = t.target,
                            r = t.index++;
                        if (!e || r >= e.length) return (t.target = void 0), T(void 0, !0);
                        var i = e[r];
                        switch (t.kind) {
                            case "keys":
                                return T(i.key, !1);
                            case "values":
                                return T(i.value, !1);
                        }
                        return T([i.key, i.value], !1);
                    },
                    !0
                ),
                pt = function (t) {
                    (this.entries = []), (this.url = null), void 0 !== t && (S(t) ? this.parseObject(t) : this.parseQuery("string" == typeof t ? ("?" === W(t, 0) ? tt(t, 1) : t) : P(t)));
                };
            pt.prototype = {
                type: F,
                bindURL: function (t) {
                    (this.url = t), this.update();
                },
                parseObject: function (t) {
                    var e,
                        r,
                        i,
                        n,
                        a,
                        o,
                        l,
                        h = this.entries,
                        c = C(t);
                    if (c)
                        for (r = (e = A(t, c)).next; !(i = s(r, e)).done; ) {
                            if (((a = (n = A(E(i.value))).next), (o = s(a, n)).done || (l = s(a, n)).done || !s(a, n).done)) throw new H("Expected sequence with length 2");
                            K(h, { key: P(o.value), value: P(l.value) });
                        }
                    else for (var p in t) g(t, p) && K(h, { key: p, value: P(t[p]) });
                },
                parseQuery: function (t) {
                    if (t) for (var e, r, i = this.entries, n = J(t, "&"), a = 0; a < n.length; ) (e = n[a++]).length && ((r = J(e, "=")), K(i, { key: at(X(r)), value: at(Y(r, "=")) }));
                },
                serialize: function () {
                    for (var t, e = this.entries, r = [], i = 0; i < e.length; ) (t = e[i++]), K(r, ht(t.key) + "=" + ht(t.value));
                    return Y(r, "&");
                },
                update: function () {
                    (this.entries.length = 0), this.parseQuery(this.url.query);
                },
                updateURL: function () {
                    this.url && this.url.update();
                },
            };
            var ut = function () {
                    y(this, ft);
                    var t = O(this, new pt(arguments.length > 0 ? arguments[0] : void 0));
                    l || (this.size = t.entries.length);
                },
                ft = ut.prototype;
            if (
                (u(
                    ft,
                    {
                        append: function (t, e) {
                            var r = R(this);
                            k(arguments.length, 2), K(r.entries, { key: P(t), value: P(e) }), l || this.length++, r.updateURL();
                        },
                        delete: function (t) {
                            for (var e = R(this), r = k(arguments.length, 1), i = e.entries, n = P(t), a = r < 2 ? void 0 : arguments[1], s = void 0 === a ? a : P(a), o = 0; o < i.length; ) {
                                var h = i[o];
                                if (h.key !== n || (void 0 !== s && h.value !== s)) o++;
                                else if ((Q(i, o, 1), void 0 !== s)) break;
                            }
                            l || (this.size = i.length), e.updateURL();
                        },
                        get: function (t) {
                            var e = R(this).entries;
                            k(arguments.length, 1);
                            for (var r = P(t), i = 0; i < e.length; i++) if (e[i].key === r) return e[i].value;
                            return null;
                        },
                        getAll: function (t) {
                            var e = R(this).entries;
                            k(arguments.length, 1);
                            for (var r = P(t), i = [], n = 0; n < e.length; n++) e[n].key === r && K(i, e[n].value);
                            return i;
                        },
                        has: function (t) {
                            for (var e = R(this).entries, r = k(arguments.length, 1), i = P(t), n = r < 2 ? void 0 : arguments[1], a = void 0 === n ? n : P(n), s = 0; s < e.length; ) {
                                var o = e[s++];
                                if (o.key === i && (void 0 === a || o.value === a)) return !0;
                            }
                            return !1;
                        },
                        set: function (t, e) {
                            var r = R(this);
                            k(arguments.length, 1);
                            for (var i, n = r.entries, a = !1, s = P(t), o = P(e), h = 0; h < n.length; h++) (i = n[h]).key === s && (a ? Q(n, h--, 1) : ((a = !0), (i.value = o)));
                            a || K(n, { key: s, value: o }), l || (this.size = n.length), r.updateURL();
                        },
                        sort: function () {
                            var t = R(this);
                            M(t.entries, function (t, e) {
                                return t.key > e.key ? 1 : -1;
                            }),
                                t.updateURL();
                        },
                        forEach: function (t) {
                            for (var e, r = R(this).entries, i = _(t, arguments.length > 1 ? arguments[1] : void 0), n = 0; n < r.length; ) i((e = r[n++]).value, e.key, this);
                        },
                        keys: function () {
                            return new ct(this, "keys");
                        },
                        values: function () {
                            return new ct(this, "values");
                        },
                        entries: function () {
                            return new ct(this, "entries");
                        },
                    },
                    { enumerable: !0 }
                ),
                c(ft, I, ft.entries, { name: "entries" }),
                c(
                    ft,
                    "toString",
                    function () {
                        return R(this).serialize();
                    },
                    { enumerable: !0 }
                ),
                l &&
                    p(ft, "size", {
                        get: function () {
                            return R(this).entries.length;
                        },
                        configurable: !0,
                        enumerable: !0,
                    }),
                f(ut, F),
                i({ global: !0, constructor: !0, forced: !h }, { URLSearchParams: ut }),
                !h && v(N))
            ) {
                var dt = o(j.has),
                    mt = o(j.set),
                    yt = function (t) {
                        if (S(t)) {
                            var e,
                                r = t.body;
                            if (b(r) === F)
                                return (e = t.headers ? new N(t.headers) : new N()), dt(e, "content-type") || mt(e, "content-type", "application/x-www-form-urlencoded;charset=UTF-8"), w(t, { body: x(0, P(r)), headers: x(0, e) });
                        }
                        return t;
                    };
                if (
                    (v(G) &&
                        i(
                            { global: !0, enumerable: !0, dontCallGetSet: !0, forced: !0 },
                            {
                                fetch: function (t) {
                                    return G(t, arguments.length > 1 ? yt(arguments[1]) : {});
                                },
                            }
                        ),
                    v(V))
                ) {
                    var vt = function (t) {
                        return y(this, $), new V(t, arguments.length > 1 ? yt(arguments[1]) : {});
                    };
                    ($.constructor = vt), (vt.prototype = $), i({ global: !0, constructor: !0, dontCallGetSet: !0, forced: !0 }, { Request: vt });
                }
            }
            t.exports = { URLSearchParams: ut, getState: R };
        },
        9307: function (t, e, r) {
            "use strict";
            r(2625);
        },
        9093: function (t, e, r) {
            "use strict";
            r.d(e, {
                C_: function () {
                    return n;
                },
                Td: function () {
                    return a;
                },
                hj: function () {
                    return s;
                },
            });
            class i {
                slider;
                constructor() {
                    this.slider = null;
                }
            }
            class n extends (8214 == r.j ? i : null) {
                intervalDuration;
                timeoutDuration;
                debounceId;
                interval;
                events;
                constructor(t = 3141, e = 6282, r = ["touchmove", "wheel"]) {
                    super(), (this.intervalDuration = t), (this.timeoutDuration = e), (this.interval = null), (this.events = r);
                }
                get id() {
                    return "ScrollSnapAutoplay";
                }
                enable = () => {
                    this.debounceId && window.clearTimeout(this.debounceId), (this.debounceId = null), (this.interval = window.setInterval(this.onInterval, this.intervalDuration));
                    for (const t of this.events) this.slider.addEventListener(t, this.disableTemporarily, { passive: !0 });
                };
                disable() {
                    for (const t of this.events) this.slider.removeEventListener(t, this.disableTemporarily);
                    this.interval && window.clearInterval(this.interval), (this.interval = null), this.debounceId && window.clearTimeout(this.debounceId), (this.debounceId = null);
                }
                disableTemporarily = () => {
                    this.interval && (window.clearInterval(this.interval), (this.interval = null), this.debounceId && window.clearTimeout(this.debounceId), (this.debounceId = window.setTimeout(this.enable, this.timeoutDuration)));
                };
                onInterval = () => {
                    if (this.slider.plugins.has("ScrollSnapLoop")) return void this.slider.slideTo(this.slider.slide + 1);
                    const { scrollLeft: t, offsetWidth: e, scrollWidth: r } = this.slider.element,
                        i = t + e === r ? 0 : this.slider.slide + 1;
                    this.slider.slideTo(i);
                };
            }
            class a extends (8214 == r.j ? i : null) {
                get id() {
                    return "ScrollSnapLoop";
                }
                enable() {
                    this.slider.addEventListener("slide-pass", this.loopSlides), this.slider.addEventListener("slide-stop", this.loopSlides), this.loopSlides();
                }
                disable() {
                    this.slider.removeEventListener("slide-pass", this.loopSlides), this.slider.removeEventListener("slide-stop", this.loopSlides);
                    const t = this.slider.element.querySelectorAll("[data-index]"),
                        e = Array.from(t).sort(this.sortFunction);
                    Element.prototype.append.apply(this.slider.element, e);
                }
                removeSnapping() {
                    this.slider.detachListeners(), (this.slider.element.style.scrollBehavior = "auto"), (this.slider.element.style.scrollSnapStop = "unset"), (this.slider.element.style.scrollSnapType = "none");
                }
                addSnapping() {
                    (this.slider.element.style.scrollBehavior = ""), (this.slider.element.style.scrollSnapStop = ""), (this.slider.element.style.scrollSnapType = ""), this.slider.attachListeners(), window.setTimeout(this.slider.update, 0);
                }
                loopEndToStart() {
                    this.removeSnapping(), this.slider.element.prepend(this.slider.element.children[this.slider.element.children.length - 1]), (this.slider.element.scrollLeft += this.slider.itemSize), this.addSnapping();
                }
                loopStartToEnd() {
                    this.removeSnapping(), this.slider.element.append(this.slider.element.children[0]), (this.slider.element.scrollLeft -= this.slider.itemSize), this.addSnapping();
                }
                loopSlides = () => {
                    if (this.slider.element.children.length < 3) return;
                    const { scrollLeft: t, offsetWidth: e, scrollWidth: r } = this.slider.element;
                    t < 5 ? this.loopEndToStart() : r - t - e < 5 && this.loopStartToEnd();
                };
                sortFunction(t, e) {
                    return parseInt(t.dataset.index, 10) - parseInt(e.dataset.index, 10);
                }
            }
            class s {
                element;
                plugins;
                removeEventListener;
                addEventListener;
                roundingMethod;
                scrollTimeout;
                itemSize;
                sizingMethod;
                slide;
                resizeObserver;
                scrollTimeoutId;
                slideScrollLeft;
                constructor(t) {
                    Object.assign(this, { scrollTimeout: 100, roundingMethod: Math.round, sizingMethod: (t) => t.element.firstElementChild.offsetWidth, ...t }),
                        (this.scrollTimeoutId = null),
                        (this.itemSize = this.sizingMethod(this)),
                        this.update(),
                        (this.addEventListener = this.element.addEventListener.bind(this.element)),
                        (this.removeEventListener = this.element.removeEventListener.bind(this.element)),
                        (this.plugins = new window.Map()),
                        (this.resizeObserver = new ResizeObserver(this.onSlideResize)),
                        this.resizeObserver.observe(this.element);
                    for (const t of this.element.children) this.resizeObserver.observe(t);
                    this.attachListeners();
                }
                with(t, e = !0) {
                    for (const r of t) (r.slider = this), this.plugins.set(r.id, r), e && r.enable();
                    return this;
                }
                attachListeners() {
                    this.addEventListener("scroll", this.onScroll, { passive: !0 });
                }
                detachListeners() {
                    this.removeEventListener("scroll", this.onScroll), this.scrollTimeoutId && window.clearTimeout(this.scrollTimeoutId);
                }
                slideTo = (t) => {
                    this.element.scrollTo({ left: t * this.itemSize });
                };
                destroy() {
                    this.scrollTimeoutId && window.clearTimeout(this.scrollTimeoutId), this.detachListeners();
                    for (const [t, e] of this.plugins) e.disable(), (e.slider = null), this.plugins.delete(t);
                }
                update = () => {
                    (this.slide = this.calculateSlide()), (this.slideScrollLeft = this.slide * this.itemSize);
                };
                calculateSlide() {
                    return this.roundingMethod(this.element.scrollLeft / this.itemSize);
                }
                onScrollEnd = () => {
                    (this.scrollTimeoutId = null), this.update(), this.dispatch("slide-stop", this.slide);
                };
                onSlideResize = (t) => {
                    this.itemSize = this.sizingMethod(this, t);
                };
                dispatch(t, e) {
                    return this.element.dispatchEvent(new window.CustomEvent(t, { detail: e }));
                }
                onScroll = () => {
                    if (null === this.scrollTimeoutId) {
                        const t = this.element.scrollLeft > this.slideScrollLeft ? 1 : -1;
                        this.dispatch("slide-start", this.slide + t);
                    }
                    this.calculateSlide() !== this.slide && (this.update(), this.dispatch("slide-pass", this.slide)),
                        this.scrollTimeoutId && window.clearTimeout(this.scrollTimeoutId),
                        (this.scrollTimeoutId = window.setTimeout(this.onScrollEnd, this.scrollTimeout));
                };
            }
        },
    },
]);
// Vendor End
// Theme Layout
!(function () {
    "use strict";
    var t,
        e = {
            7230: function () {},
            7118: function (t, e, n) {
                n(5202), n(5787);
                var i = {
                    short: ".2s",
                    med: ".6s",
                    slow: "1s",
                    xslow: "2s",
                    timeDefault: ".2s",
                    easeIn: "cubic-bezier(.7,0,.84,0)",
                    easeOut: "cubic-bezier(.16,1,.3,1)",
                    easeInOut: "cubic-bezier(.87,0,.13,1)",
                    easeDefault: "cubic-bezier(.25,.01,.25,1)",
                };
                const s = (t) => (t.endsWith("ms") ? parseFloat(t) : t.endsWith("s") ? 1e3 * parseFloat(t) : 200),
                    o = { ...i, durationDefault: s(i.timeDefault), durationMedium: s(i.med), durationShort: s(i.short), durationSlow: s(i.slow) };
                n(6265);
                const a = (t, e) => {
                    if (!t.target || !(t.target instanceof HTMLElement || t.target instanceof SVGElement) || void 0 === t.target.matches) return;
                    return t.target.matches(e) ? t.target : t.target.closest(e);
                };
                function r(t, e, n) {
                    return (
                        (e = (function (t) {
                            var e = (function (t, e) {
                                if ("object" != typeof t || null === t) return t;
                                var n = t[Symbol.toPrimitive];
                                if (void 0 !== n) {
                                    var i = n.call(t, e || "default");
                                    if ("object" != typeof i) return i;
                                    throw new TypeError("@@toPrimitive must return a primitive value.");
                                }
                                return ("string" === e ? String : Number)(t);
                            })(t, "string");
                            return "symbol" == typeof e ? e : String(e);
                        })(e)) in t
                            ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 })
                            : (t[e] = n),
                        t
                    );
                }
                const l = "is-light-box-open",
                    d = document.createElement("template");
                d.innerHTML = "\n  <style>\n    * { box-sizing: border-box; }\n\n    .container {\n      display: none;\n      justify-content: stretch;\n      align-items: stretch;\n    }\n\n    .background {\n      position: fixed;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      opacity: 0;\n      transition: all "
                    .concat(o.timeDefault, " ")
                    .concat(
                        o.easeOut,
                        ";\n    }\n\n    .wrapper {\n      position: fixed;\n      left: 0;\n      top: 0;\n      width: 100%;\n      height: 100%;\n      z-index: 1;\n      overflow-y: auto;\n      display: flex;\n    }\n\n    .inner {\n      padding: 1rem;\n      width: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n    .popup {\n      box-sizing: border-box;\n      position: relative;\n      width: 100%;\n      max-width: 62.5rem;\n      margin: 0 auto;\n      padding: 0.5rem;\n      opacity: 0;\n      transform: translateY(-2rem);\n      transition: all "
                    )
                    .concat(o.timeDefault, " ")
                    .concat(
                        o.easeOut,
                        ';\n    }\n\n    .close-btn{\n      background-color:transparent;\n      border:none;\n      cursor: pointer;\n      display:flex;\n      margin-left:auto;\n      padding: .5rem;\n    }\n\n    .close-btn-icon{\n      height:1.125rem;\n      width:1.125rem;\n    }\n\n    .popup.compact { \n      max-width: 35rem;\n      border-radius: 1.25rem!important;\n    }\n    .popup.compact .close-btn,\n    .popup.media-zoom .close-btn {\n      position: absolute;\n      top: 8px;\n      right: 8px;\n      z-index: 1;\n    }\n    .popup.media-zoom .close-btn {\n      top: 16px;\n      right: 16px;\n      background-color: rgba(255,255,255,.5);\n      border-radius: 50%;\n      padding: 10px;\n    }\n    .popup.media-zoom svg {\n      width: 20px;\n      height: 20px;\n    }\n    .popup.media-zoom path {\n      stroke: rgba(255,255,255,1);\n    }\n\n    .popup.small { max-width: 30rem; }\n    .popup.large { max-width: 80rem; }\n    .container.is-visible { display: block; }\n\n    .is-closing .popup { transform: translateY(2rem); }\n    .is-open .background { opacity: 1; }\n    .is-open .popup {\n      opacity: 1;\n      transform: translateY(0);\n    }\n\n    .popup.media-zoom {\n      max-width: 750px;\n      padding: 0!important; \n    }\n\n    @media only screen and (max-width: 46.81rem) {\n      .popup.mobile-bottom {\n        align-self: flex-end;\n        margin-bottom: -1rem;\n        border-bottom-left-radius: 0!important;\n        border-bottom-right-radius: 0!important;\n        margin-left: -1rem;\n        margin-right: -1rem;\n        width: 100vw;\n        transform: translateY(2rem);\n        padding-top: 2rem;\n      }\n      \n      .is-open .popup.mobile-bottom {\n        transform: translateY(0);\n      }\n    }\n\n    @media only screen and (min-width: 68.75rem) {\n      .close-btn{\n        padding: 1.5rem;\n      }\n\n      .close-btn-icon{\n        height:2rem;\n        width:2rem;\n      }\n\n      .popup.compact .close-btn {\n        padding: .5rem;\n        top: 16px;\n        right: 16px;\n      }\n\n      .popup.media-zoom {\n        padding: 0; \n      }\n    }\n  </style>\n\n  <div part="root" class="container">\n    <div part="background" class="background"></div>\n    <div part="wrapper" class="wrapper">\n      <div part="inner" class="inner">\n        <div part="popup" class="popup">\n          <button class="close-btn">\n            <svg class="close-btn-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n              <path d="M18.75 5.25L5.25 18.75" stroke="#15151F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M18.75 18.75L5.25 5.25" stroke="#15151F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>\n            </svg>\n          </button>\n          <slot></slot>\n        </div>\n      </div>\n    </div>\n  </div>\n'
                    );
                class c extends HTMLElement {
                    static get observedAttributes() {
                        return ["visible", "closable", "size", "displaystyle"];
                    }
                    get visible() {
                        return "true" == this.getAttribute("visible");
                    }
                    set visible(t) {
                        this.setAttribute("visible", t + ""), this.updateVisible(), this.dispatchEvent(new CustomEvent("visibility-set"));
                    }
                    get closable() {
                        return !this.hasAttribute("closable") || "true" == this.getAttribute("closable");
                    }
                    set closable(t) {
                        this.setAttribute("closable", t + "");
                    }
                    get size() {
                        return this.getAttribute("size") || "medium";
                    }
                    set size(t) {
                        this.setAttribute("size", t), this.updateSize();
                    }
                    get displayStyle() {
                        return this.getAttribute("displaystyle") || "";
                    }
                    set displayStyle(t) {
                        this.setAttribute("displaystyle", t), this.updateDisplayStyle();
                    }
                    get padded() {
                        return !this.hasAttribute("padded") || "true" == this.getAttribute("padded");
                    }
                    set padded(t) {
                        this.setAttribute("padded", t + ""), this.updatePadded();
                    }
                    constructor() {
                        super(),
                            r(this, "onKeyPress", (t) => {
                                this.closable && "Escape" == t.key && (this.visible = !1);
                            }),
                            r(this, "onCloseClick", (t) => {
                                this.visible = !1;
                            }),
                            r(this, "onBackgroundClick", (t) => {
                                t.target === this.inner && this.closable && (this.visible = !1);
                            }),
                            r(this, "onDocumentClick", (t, e) => {
                                const n = e.getAttribute("data-light-box-trigger");
                                n && this.matches(n) && (t.preventDefault(), (this.visible = !this.closable || !this.visible));
                            }),
                            (this.timeout = null);
                        const t = this.attachShadow({ mode: "open" });
                        t.appendChild(d.content.cloneNode(!0)),
                            (this.root = t.querySelector(".container")),
                            (this.inner = t.querySelector(".inner")),
                            (this.popup = t.querySelector(".popup")),
                            (this.closeBtn = t.querySelector(".close-btn")),
                            (this.parent = this.parentElement || null),
                            document.addEventListener("keydown", this.onKeyPress),
                            ((t) => {
                                const { element: e, selector: n, event: i, callback: s, events: o } = t,
                                    r = (t) => {
                                        let e = a(t, n);
                                        e && s(t, e);
                                    };
                                let l = "string" == typeof e ? document.querySelector(e) : e.documentElement ? e.documentElement : e;
                                if (!l) return null;
                                const d = [];
                                i && d.push(i), o && d.push(...o), d.map((t) => l.addEventListener(t, r));
                            })({ callback: this.onDocumentClick, selector: "[data-light-box-trigger]", element: document, event: "click" }),
                            this.inner.addEventListener("click", this.onBackgroundClick),
                            this.closeBtn.addEventListener("click", this.onCloseClick),
                            this.updateVisible();
                    }
                    updateVisible() {
                        this.timeout && clearTimeout(this.timeout),
                            this.visible
                                ? (document.body.classList.add(l),
                                  this.root.classList.add("is-visible"),
                                  this.root.classList.remove("is-closing"),
                                  document.body.appendChild(this),
                                  (this.timeout = setTimeout(() => this.root.classList.add("is-open"), 16)),
                                  this.root.part.add("visible"))
                                : (document.body.classList.remove(l),
                                  (this.parent || document.body).appendChild(this),
                                  setTimeout(() => {
                                      this.root.classList.remove("is-open"), this.root.classList.add("is-closing");
                                  }, 16),
                                  (this.timeout = setTimeout(() => {
                                      this.root.classList.remove("is-visible"), this.root.classList.remove("is-closing");
                                  }, o.durationDefault)),
                                  this.root.part.remove("visible"));
                    }
                    updateSize() {
                        switch ((this.popup.classList.remove("compact"), this.popup.classList.remove("small"), this.popup.classList.remove("large"), this.size)) {
                            case "compact":
                                this.popup.classList.add("compact");
                                break;
                            case "small":
                                this.popup.classList.add("small");
                                break;
                            case "large":
                                this.popup.classList.add("large");
                        }
                    }
                    updateDisplayStyle() {
                        switch ((this.popup.classList.remove("media-zoom"), this.popup.classList.remove("mobile-bottom"), this.displayStyle)) {
                            case "media-zoom":
                                this.popup.classList.add("media-zoom");
                                break;
                            case "mobile-bottom":
                                this.popup.classList.add("mobile-bottom");
                        }
                    }
                    updatePadded() {
                        this.padded ? this.popup.part.remove("unpadded") : this.popup.part.add("unpadded");
                    }
                    attributeChangedCallback(t, e, n) {
                        switch (t) {
                            case "visible":
                                this.updateVisible();
                                break;
                            case "size":
                                this.updateSize();
                                break;
                            case "padded":
                                this.updatePadded();
                                break;
                            case "displaystyle":
                                this.updateDisplayStyle();
                        }
                    }
                }
                function p() {
                    document.documentElement.style.setProperty("--scrollbar-width", window.innerWidth - document.documentElement.clientWidth + "px");
                }
                r(c, "confirm", (t) => {
                    const e = new c();
                    document.body.appendChild(e), e.classList.add("o-light-box__confirm"), (e.size = "small"), (e.displayStyle = "");
                    const n = document.createElement("div");
                    n.classList.add("o-light-box__buttons");
                    const i = document.createElement("button");
                    (i.type = "button"), i.classList.add("o-btn"), (i.textContent = t.yes);
                    const s = document.createElement("button");
                    (s.type = "button"), s.classList.add("o-btn"), (s.textContent = t.no);
                    const a = document.createElement("h2");
                    (a.textContent = t.title), e.appendChild(a), e.appendChild(n), n.appendChild(i), n.appendChild(s), (e.visible = !0);
                    const r = () => {
                        (i.disabled = !0), i.classList.add("is-disabled"), (s.disabled = !0), s.classList.add("is-disabled"), (e.visible = !1), setTimeout(() => e.remove(), o.durationDefault);
                    };
                    return new Promise((t, e) => {
                        i.addEventListener("click", () => {
                            t(!0), r();
                        }),
                            s.addEventListener("click", () => {
                                t(!1), r();
                            });
                    });
                }),
                    customElements.get("light-box") || customElements.define("light-box", c),
                    (function () {
                        const t = ["o-heading", "o-heading--1", "o-heading--2", "o-heading--3", "o-heading--4", "o-heading--5", "o-heading--6", "o-heading--7", "o-heading--8"];
                        Array.from(document.querySelectorAll("h1, h2, h3, h4, h5, h6"))
                            .filter((e) => Array.from(e.classList).some((e) => t.includes(e)))
                            .forEach((t) => {
                                if (t.textContent) {
                                    if ("." === t.textContent[t.textContent.length - 1]) {
                                        const e = t.textContent.substring(0, t.textContent.length - 1);
                                        (t.textContent = e), t.classList.add("o-heading--with-dot");
                                    }
                                }
                            });
                    })(),
                    window.addEventListener("resize", p, !1),
                    document.addEventListener("DOMContentLoaded", p, !1),
                    window.addEventListener("load", p),
                    document.documentElement.classList.remove("js-unavailable"),
                    document.documentElement.classList.add("js-available");
            },
        },
        n = {};
    function i(t) {
        var s = n[t];
        if (void 0 !== s) return s.exports;
        var o = (n[t] = { exports: {} });
        return e[t].call(o.exports, o, o.exports, i), o.exports;
    }
    (i.m = e),
        (t = []),
        (i.O = function (e, n, s, o) {
            if (!n) {
                var a = 1 / 0;
                for (c = 0; c < t.length; c++) {
                    (n = t[c][0]), (s = t[c][1]), (o = t[c][2]);
                    for (var r = !0, l = 0; l < n.length; l++)
                        (!1 & o || a >= o) &&
                        Object.keys(i.O).every(function (t) {
                            return i.O[t](n[l]);
                        })
                            ? n.splice(l--, 1)
                            : ((r = !1), o < a && (a = o));
                    if (r) {
                        t.splice(c--, 1);
                        var d = s();
                        void 0 !== d && (e = d);
                    }
                }
                return e;
            }
            o = o || 0;
            for (var c = t.length; c > 0 && t[c - 1][2] > o; c--) t[c] = t[c - 1];
            t[c] = [n, s, o];
        }),
        (i.d = function (t, e) {
            for (var n in e) i.o(e, n) && !i.o(t, n) && Object.defineProperty(t, n, { enumerable: !0, get: e[n] });
        }),
        (i.g = (function () {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (t) {
                if ("object" == typeof window) return window;
            }
        })()),
        (i.o = function (t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }),
        (i.j = 9731),
        (function () {
            var t = { 9731: 0 };
            i.O.j = function (e) {
                return 0 === t[e];
            };
            var e = function (e, n) {
                    var s,
                        o,
                        a = n[0],
                        r = n[1],
                        l = n[2],
                        d = 0;
                    if (
                        a.some(function (e) {
                            return 0 !== t[e];
                        })
                    ) {
                        for (s in r) i.o(r, s) && (i.m[s] = r[s]);
                        if (l) var c = l(i);
                    }
                    for (e && e(n); d < a.length; d++) (o = a[d]), i.o(t, o) && t[o] && t[o][0](), (t[o] = 0);
                    return i.O(c);
                },
                n = (self.webpackChunkrollie = self.webpackChunkrollie || []);
            n.forEach(e.bind(null, 0)), (n.push = e.bind(null, n.push.bind(n)));
        })(),
        i.O(void 0, [4736], function () {
            return i(7118);
        });
    var s = i.O(void 0, [4736], function () {
        return i(7230);
    });
    s = i.O(s);
})();
// Theme Layout End
